var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/abi/AssetRegistry.json
var AssetRegistry_default = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "curRate",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "verified",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "stable",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    name: "AssetRegistryUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "assets",
    outputs: [
      {
        internalType: "uint256",
        name: "curRate",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "stable",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "get",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "curRate",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "feeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "feeFixed",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "verified",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "stable",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "sharable",
            type: "bool"
          }
        ],
        internalType: "struct Info",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "curRate",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "stable",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    name: "set",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      }
    ],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "rate",
        type: "uint256"
      }
    ],
    name: "setRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    name: "setSharable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "stable",
        type: "bool"
      }
    ],
    name: "setStable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool"
      }
    ],
    name: "setVerified",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "toCur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/BadgeManager.json
var BadgeManager_default = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coIssuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      }
    ],
    name: "AddedCoIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "AddedIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "BadgeMetaUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "BadgeOwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "address",
        name: "grantee",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    name: "GrantedBadge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "grantee",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "GranteeBadgeMetaUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "PathRegistered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coIssuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      }
    ],
    name: "RemovedCoIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldIssuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newIssuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      }
    ],
    name: "ReplacedIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "address",
        name: "grantee",
        type: "address"
      }
    ],
    name: "RevokedBadge",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "badgeCoIssuers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "badgeIssuer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "badgeMetadata",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "badgeMetadataKeys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "badgePaths",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getGrantId",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getGranteeMetaKeys",
    outputs: [
      {
        internalType: "string[]",
        name: "",
        type: "string[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      }
    ],
    name: "getGranteeMetaValue",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      }
    ],
    name: "getMetaKeys",
    outputs: [
      {
        internalType: "string[]",
        name: "",
        type: "string[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      }
    ],
    name: "getMetaValue",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      }
    ],
    name: "getPathId",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "grantBadge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "string[]",
        name: "metaKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metaValues",
        type: "string[]"
      },
      {
        internalType: "uint256",
        name: "sigExpireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "grantBadgeBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "granted",
    outputs: [
      {
        internalType: "uint256",
        name: "grantedAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "granteeMetadata",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "granteeMetadataKeys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      }
    ],
    name: "hasBadge",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "issuerBadge",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "pathMetadata",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "pathMetadataKeys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "address",
        name: "coIssuer",
        type: "address"
      }
    ],
    name: "registerCoIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "registerIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "registerPath",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "address",
        name: "coIssuer",
        type: "address"
      }
    ],
    name: "removeCoIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "address",
        name: "newIssuer",
        type: "address"
      }
    ],
    name: "replaceIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "revokeBadge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "revokeBadgeBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferBadgeOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "upsertGranteeMeta",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "upsertGranteeMetaBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "upsertMeta",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "usedSig",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/BondCurveDistro.json
var BondCurveDistro_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_airdropAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_bondingCurveAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devFeeBp",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowBuyTransfer",
        type: "bool"
      }
    ],
    name: "AllowBuyTransfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowClaim",
        type: "bool"
      }
    ],
    name: "AllowClaim",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowSell",
        type: "bool"
      }
    ],
    name: "AllowSell",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowTrade",
        type: "bool"
      }
    ],
    name: "AllowTrade",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowWithdraw",
        type: "bool"
      }
    ],
    name: "AllowWithdraw",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "input",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "output",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "Buy",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newSigner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oldSigner",
        type: "address"
      }
    ],
    name: "ClaimSignerUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ClaimWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "claimId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "allocation",
        type: "uint256"
      }
    ],
    name: "Claimed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "airdropAlloc",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "devAlloc",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bondingCurveAlloc",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "devFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "k",
        type: "uint256"
      }
    ],
    name: "ReInitialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "input",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "output",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "Sell",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "devFeeBp",
        type: "uint256"
      }
    ],
    name: "UpdatedDevFeeBp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnDevFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnEth",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnToken",
    type: "event"
  },
  {
    inputs: [],
    name: "airdropAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowBuyTransfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowClaim",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowSell",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowTrade",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowWithdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bondingCurveAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bondingCurveEthBal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "maxPrice",
        type: "uint256"
      }
    ],
    name: "buy",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "supply",
        type: "uint256"
      }
    ],
    name: "buyPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "circulatingSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "claimId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "signatures",
        type: "bytes[]"
      },
      {
        internalType: "uint256[]",
        name: "claimIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "nonces",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "allocations",
        type: "uint256[]"
      }
    ],
    name: "claimMulti",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "claimSigner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "claimedBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "claims",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devFeeBp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devFeeEthBal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialBondingCurveAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "k",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_airdropAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_bondingCurveAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_k",
        type: "uint256"
      }
    ],
    name: "reInit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "minPrice",
        type: "uint256"
      }
    ],
    name: "sell",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "supply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountToSell",
        type: "uint256"
      }
    ],
    name: "sellPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_claimSigner",
        type: "address"
      }
    ],
    name: "setClaimSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_devFeeBp",
        type: "uint256"
      }
    ],
    name: "setDevFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowBuyTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowSell",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowTrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "usedClaimNonces",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawDevFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawEth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];

// src/abi/Core.json
var Core_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_minTimeToPay",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_orderGraceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxOpenOrders",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxOpenDisputes",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "finalizer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "action",
        type: "uint256"
      }
    ],
    name: "FinalizedByManagerSig",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bp",
        type: "uint256"
      }
    ],
    name: "NFTDiscountUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "offerer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expireDuration",
        type: "uint256"
      }
    ],
    name: "NewOffer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "acceptor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executeAt",
        type: "uint256"
      }
    ],
    name: "OfferAccepted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "canceller",
        type: "address"
      }
    ],
    name: "OfferCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "executor",
        type: "address"
      }
    ],
    name: "OfferExecuted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "unacceptor",
        type: "address"
      }
    ],
    name: "OfferUnaccepted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "offerer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "execDelayDur",
        type: "uint256"
      }
    ],
    name: "OfferUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "canceller",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bool",
        name: "byDispute",
        type: "bool"
      }
    ],
    name: "OrderCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "inventor",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shared",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      }
    ],
    name: "ProtocolFeeSplitUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "instantSwapFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "synthSwapFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableSwapFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedSynthSwapFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedNFTSwapFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "instantNFTSwapFeeBp",
        type: "uint256"
      }
    ],
    name: "ProtocolFeeUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "mid",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "swapper",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "releaser",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[6]",
        name: "numTypeInfo",
        type: "uint256[6]"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "byDispute",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromProvider",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromTaker",
        type: "uint256[]"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "mid",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "swapper",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[7]",
        name: "numTypeInfo",
        type: "uint256[7]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromProvider",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromTaker",
        type: "uint256[]"
      }
    ],
    name: "SwapOrder",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeDelayDur",
        type: "uint256"
      }
    ],
    name: "SwapOrderPaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "TogglePause",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TransferInventorBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TransferOperatorBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "convAsset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "convAmount",
        type: "uint256"
      }
    ],
    name: "TransferredToFeePool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "swapRouter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "ethErc20Addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "UpdatedAMMInfo",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "input",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "output",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "UpdatedAMMPoolInfo",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedAssetRegistry",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedDisputeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedFeePool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "interval",
        type: "uint256"
      }
    ],
    name: "UpdatedFeePoolConfig",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedFeePurse",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liq",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minSwap",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxSwap",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeToPay",
        type: "uint256"
      }
    ],
    name: "UpdatedFungibleLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedInventor",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oldManager",
        type: "address"
      }
    ],
    name: "UpdatedLiquidityManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "market",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liq",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "UpdatedLiquiditySwapBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMarketCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxOpenDisputes",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxOpenOrders",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedMinTimeToPay",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMinerRegistry",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNFT",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeToPay",
        type: "uint256"
      }
    ],
    name: "UpdatedNonFungibleLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedOperator",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedOrderGraceDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "UpdatedPrice",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "delay",
        type: "uint256"
      }
    ],
    name: "acceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canCreateDispute",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      }
    ],
    name: "cancelOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelOrderByDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "cancelOrderByManagerSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "mid",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "taker",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "orderAmt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "orderPrice",
        type: "uint256"
      }
    ],
    name: "computeSwapFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256"
      }
    ],
    name: "configureFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      }
    ],
    name: "createOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "txDeadline",
        type: "uint256"
      }
    ],
    name: "executeOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address"
      }
    ],
    name: "feeBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getFeeBPs",
    outputs: [
      {
        internalType: "uint256[3]",
        name: "",
        type: "uint256[3]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mid",
        type: "address"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_lid",
        type: "uint256"
      }
    ],
    name: "getLiquidity",
    outputs: [
      {
        components: [
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minSwap",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxSwap",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "timeToPay",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "openOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "openDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "protoFeePurseId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "mktCreatorFeePurseId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "protoFeeRate",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "mktCreatorFeeRate",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "wantOrIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "wantAndIds",
            type: "uint256[]"
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool"
          },
          {
            internalType: "address",
            name: "target",
            type: "address"
          }
        ],
        internalType: "struct Structs.Liquidity",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      }
    ],
    name: "getLiquidityManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "getMarket",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numLiquidity",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "commission",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "disputeDelayDur",
                type: "uint256"
              }
            ],
            internalType: "struct Structs.MarketDur",
            name: "dur",
            type: "tuple"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "manager",
            type: "address"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "base",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "quote",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "put",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "swap",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "offerOnly",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "allowZeroOfferPrice",
                type: "bool"
              }
            ],
            internalType: "struct Structs.MarketPerms",
            name: "perms",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Market",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getOffer",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "liq",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "execAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "accepted",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "cancelled",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "executed",
            type: "bool"
          }
        ],
        internalType: "struct Structs.Offer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getOrder",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "taker",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "address",
            name: "finalizer",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "payDeadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "cancelAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "disputeFrom",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "offerId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "takerIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "providerIds",
            type: "uint256[]"
          },
          {
            internalType: "bool",
            name: "paid",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "released",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "disputed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "cancelled",
            type: "bool"
          }
        ],
        internalType: "struct Structs.Order",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getReqSwapBadges",
    outputs: [
      {
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mid",
        type: "address"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_lid",
        type: "uint256"
      }
    ],
    name: "hasLiquidity",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "hasOrder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "inventorBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "isVerified",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "markAsDisputed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "markOrderAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "markOrderAsPaidByManagerSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "operatorBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "releaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "releaseOrderByDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "releaseOrderByManagerSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "swapRouter",
        type: "address"
      },
      {
        internalType: "address",
        name: "ethErc20Addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "setAmmInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "input",
        type: "address"
      },
      {
        internalType: "address",
        name: "out",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "setAmmPoolInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setAssetRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "setBadgeMgr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bp",
        type: "uint256"
      }
    ],
    name: "setDiscountForNFTHolder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setDisputeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "setFeePurse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setInventor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "manager",
        type: "address"
      }
    ],
    name: "setLiquidityManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMarketCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setMaxOpenDisputes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setMaxOpenOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setMinTimeToPay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMinerRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setOrderGraceDur",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_instantSwapFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_synthSwapFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_stableSwapFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fixedSynthSwapFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fixedNFTSwapFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_instantNFTSwapFeeBp",
        type: "uint256"
      }
    ],
    name: "setProtoFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "inventorBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "sharedBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "operatorBP",
        type: "uint256"
      }
    ],
    name: "setProtoFeeSplit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "string[2][]",
        name: "badgeIds",
        type: "string[2][]"
      }
    ],
    name: "setSwapBadgeForLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "shareablesBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "state",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "instantSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "synthSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stableSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "instantNFTSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "fixedSynthSwapFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "fixedNFTSwapFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxOpenOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxOpenDisputes",
            type: "uint256"
          }
        ],
        internalType: "struct StructsLib.IntSlotState",
        name: "ints",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "minTimeToPay",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "orderGraceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numOrders",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feePoolTxInterval",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "inventor",
        type: "address"
      },
      {
        internalType: "address",
        name: "ammSwapRouter",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "state2",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "nftDiscountBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "ammEthPoolFee",
            type: "uint256"
          }
        ],
        internalType: "struct StructsLib.UintSlotState2",
        name: "ints",
        type: "tuple"
      },
      {
        internalType: "address",
        name: "disputeManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "nft",
        type: "address"
      },
      {
        internalType: "address",
        name: "ammEth",
        type: "address"
      },
      {
        internalType: "contract IAssetRegistry",
        name: "assetReg",
        type: "address"
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address"
      },
      {
        internalType: "contract IMarketCore",
        name: "marketCore",
        type: "address"
      },
      {
        internalType: "contract IFeePool",
        name: "feePool",
        type: "address"
      },
      {
        internalType: "contract IFeePurse",
        name: "feePurse",
        type: "address"
      },
      {
        internalType: "contract IBadge",
        name: "badge",
        type: "address"
      },
      {
        internalType: "contract IOperator",
        name: "operatorMgr",
        type: "address"
      },
      {
        internalType: "contract IMinerRegistry",
        name: "minerReg",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxPrice",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "txDeadline",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      }
    ],
    name: "swapQuoteForBase",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    name: "togglePause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "transferToFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      }
    ],
    name: "unacceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "amountAndPrice",
        type: "uint256[2]"
      },
      {
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[5]",
        name: "limits",
        type: "uint256[5]"
      }
    ],
    name: "updateFungibleLiquidity",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_expireAt",
        type: "uint256"
      }
    ],
    name: "updateLiquidityPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[3]",
        name: "limits",
        type: "uint256[3]"
      }
    ],
    name: "updateNonFungibleLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "updateOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "incr",
        type: "bool"
      }
    ],
    name: "updateOpenDisputesCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "withdrawFeeBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "withdrawInventorBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "withdrawOperatorBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/DisputeManager.json
var DisputeManager_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      },
      {
        internalType: "address",
        name: "_core",
        type: "address"
      },
      {
        internalType: "address",
        name: "_medMgrAddr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_predictDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_evidenceDur",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "committer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketIdx",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "Committed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "executor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "abandoned",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bytes1",
        name: "winningVote",
        type: "bytes1"
      }
    ],
    name: "DecisionExecuted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "wantRelease",
        type: "bool"
      }
    ],
    name: "DisputeCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "drafter",
        type: "address"
      }
    ],
    name: "Drafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "mediator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "drafter",
        type: "address"
      }
    ],
    name: "DraftedMediator",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "revealer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketIdx",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes1",
        name: "vote",
        type: "bytes1"
      }
    ],
    name: "Revealed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "slashed",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "address",
        name: "undrafter",
        type: "address"
      }
    ],
    name: "Undrafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedEvidenceDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMarketCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMediatorManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMinerRegistry",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedPredictDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "dest",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amt",
        type: "uint256"
      }
    ],
    name: "WithdrawnBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "claimer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnReward",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketIdx",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      }
    ],
    name: "commitVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "countDisputes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "wantRelease",
        type: "bool"
      }
    ],
    name: "createDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "disputes",
    outputs: [
      {
        internalType: "uint256",
        name: "commitEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "predictEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "evidenceEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "nRelease",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "nCancel",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "undrafted",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "address",
        name: "defendant",
        type: "address"
      },
      {
        internalType: "bool",
        name: "executed",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "wantRelease",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "abandoned",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "draftMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "evidenceDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dispIdx",
        type: "uint256"
      }
    ],
    name: "executeDecision",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dispIdx",
        type: "uint256"
      }
    ],
    name: "getDispute",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "commitEndAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "predictEndAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "evidenceEndAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "nRelease",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "nCancel",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "undrafted",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ticketIndexes",
            type: "uint256[]"
          },
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "defendant",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "ticketOwners",
            type: "address[]"
          },
          {
            internalType: "bool",
            name: "executed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "wantRelease",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "abandoned",
            type: "bool"
          }
        ],
        internalType: "struct Dispute",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "marketCore",
    outputs: [
      {
        internalType: "contract IMarketCore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mediatorMgr",
    outputs: [
      {
        internalType: "contract IMediatorManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minerReg",
    outputs: [
      {
        internalType: "contract IMinerRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "predictDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "predictions",
    outputs: [
      {
        internalType: "bool",
        name: "revealed",
        type: "bool"
      },
      {
        internalType: "bytes32",
        name: "committed",
        type: "bytes32"
      },
      {
        internalType: "bytes1",
        name: "vote",
        type: "bytes1"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketIdx",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "_vote",
        type: "string"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      }
    ],
    name: "revealVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "rewardBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "seenCommits",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setEvidenceDur",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMarketCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMediatorManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMinerRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setPredictDur",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dispIdx",
        type: "uint256"
      }
    ],
    name: "undraftMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address"
      }
    ],
    name: "withdrawBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/ERC20.json
var ERC20_default = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/ERC721.json
var ERC721_default = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/Energon.json
var Energon_default = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_initialSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AddRecipient",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "AddedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "AllocationDisabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      }
    ],
    name: "Claimed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "RemovedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedAllocator",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]"
      }
    ],
    name: "addMinters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "addRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "allocDisabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allocator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      },
      {
        internalType: "uint8",
        name: "_sigNonce",
        type: "uint8"
      }
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "disableAllocation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "disableRecipientBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "minters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numMinters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "recipientsAllowlist",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "recipientsBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setAllocator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    name: "usedNonce",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/FeePool.json
var FeePool_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenPool",
        type: "address"
      },
      {
        internalType: "address",
        name: "_notifier",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Recovered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardNFTWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "StakedNFT",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadgeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNFT",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNotifier",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "UpdatedReqBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "dur",
        type: "uint256"
      }
    ],
    name: "UpdatedRewardDuration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedTokenPool",
    type: "event"
  },
  {
    inputs: [],
    name: "badge",
    outputs: [
      {
        internalType: "contract IBadge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canStake",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getAddressOfNFT",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "getRewardForDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nft",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "nftBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "nftEarned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "notifier",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "notifyFeeDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "notifyStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "notifyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requiredBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewardRates",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setBadgeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNotifier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "setRequiredBadges",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dur",
        type: "uint256"
      }
    ],
    name: "setRewardDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setTokenPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "stakeNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "tokenBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawNFTReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/LPPool.json
var LPPool_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_poolToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Locked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Recovered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Unlocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRewardForDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_rewardAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_rewardsDuration",
        type: "uint256"
      }
    ],
    name: "notifyRewardDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "poolToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setPoolToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/MarketCore.json
var MarketCore_default = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_defaultDisputeDelayDur",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AllowedPut",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AllowedSwap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "EnabledZeroOfferPrice",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "base",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "quote",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum Structs.AssetType",
        name: "baseType",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "enum Structs.AssetType",
        name: "quoteType",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "permPut",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "permSwap",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "commission",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mediatePoolId",
        type: "uint256"
      }
    ],
    name: "NewMarket",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "OfferOnlyEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "RenouncedMarket",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "RevokedPut",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "RevokedSwap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "TransferredOwnership",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadgeAddr",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedCommission",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedDefaultDisputeDelayDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeDelayDur",
        type: "uint256"
      }
    ],
    name: "UpdatedDisputeDelayDuration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      },
      {
        indexed: false,
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      }
    ],
    name: "UpdatedMarketBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "mgr",
        type: "address"
      }
    ],
    name: "UpdatedMarketManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMediatorManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNativeAssetAddr",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "added",
        type: "bool"
      }
    ],
    name: "WriterUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "allowZeroOfferPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "badge",
    outputs: [
      {
        internalType: "contract IBadge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "base",
        type: "address"
      },
      {
        internalType: "address",
        name: "quote",
        type: "address"
      },
      {
        internalType: "enum Structs.AssetType",
        name: "baseType",
        type: "uint8"
      },
      {
        internalType: "enum Structs.AssetType",
        name: "quoteType",
        type: "uint8"
      },
      {
        internalType: "bool",
        name: "permPut",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "permSwap",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "commission",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "mediatePoolId",
        type: "uint256"
      }
    ],
    name: "createMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultDisputeDelayDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "getMarket",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numLiquidity",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "commission",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "disputeDelayDur",
                type: "uint256"
              }
            ],
            internalType: "struct Structs.MarketDur",
            name: "dur",
            type: "tuple"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "manager",
            type: "address"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "base",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "quote",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "put",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "swap",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "offerOnly",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "allowZeroOfferPrice",
                type: "bool"
              }
            ],
            internalType: "struct Structs.MarketPerms",
            name: "perms",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Market",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNativeAssetAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "getReqBadges",
    outputs: [
      {
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      },
      {
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "hasMarket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "isPutPermitted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "isSwapPermitted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "markAsOfferOnly",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "markets",
    outputs: [
      {
        internalType: "uint256",
        name: "createdAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numOrders",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numDisputes",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numLiquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "commission",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "disputeDelayDur",
            type: "uint256"
          }
        ],
        internalType: "struct Structs.MarketDur",
        name: "dur",
        type: "tuple"
      },
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "base",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "quote",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "put",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "swap",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "offerOnly",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "allowZeroOfferPrice",
            type: "bool"
          }
        ],
        internalType: "struct Structs.MarketPerms",
        name: "perms",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mediatorManager",
    outputs: [
      {
        internalType: "contract IMediatorManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nativeAssetAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "permitPut",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "permitSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "putAllowList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "renouncedMarkets",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "reqPutBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "reqSwapBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "revokePut",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "revokeSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setBadgeMgr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setCommission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "bool",
        name: "numOrders",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "numDisputes",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "numLiquidity",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "setCounters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setDefaultDisputeDelayDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "setDisputeDelayDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "mgr",
        type: "address"
      }
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numLiquidity",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "commission",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "disputeDelayDur",
                type: "uint256"
              }
            ],
            internalType: "struct Structs.MarketDur",
            name: "dur",
            type: "tuple"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "manager",
            type: "address"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "base",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "quote",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "put",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "swap",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "offerOnly",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "allowZeroOfferPrice",
                type: "bool"
              }
            ],
            internalType: "struct Structs.MarketPerms",
            name: "perms",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Market",
        name: "upd",
        type: "tuple"
      }
    ],
    name: "setMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMediatorManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNativeAssetAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "string[2][]",
        name: "put",
        type: "string[2][]"
      },
      {
        internalType: "string[2][]",
        name: "swap",
        type: "string[2][]"
      }
    ],
    name: "setRequiredBadges",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "swapAllowList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "updateWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "writers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/MarketManager.json
var MarketManager_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      },
      {
        internalType: "address",
        name: "_payRouter",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "core",
        type: "address"
      }
    ],
    name: "CoreUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "payRouter",
        type: "address"
      }
    ],
    name: "PayRouterUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestPaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestReleased",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "TransferredRequestBond",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "TransferredRequestSource",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isDelegate",
        type: "bool"
      }
    ],
    name: "UpdatedDelegate",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "addDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxPrice",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "expireAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "marketMgrData",
            type: "bytes"
          }
        ],
        internalType: "struct StructsLib.SwapQuoteForBaseParams",
        name: "params",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "afterSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxPrice",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "expireAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "marketMgrData",
            type: "bytes"
          }
        ],
        internalType: "struct StructsLib.SwapQuoteForBaseParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "beforeSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "delegates",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "markOrderAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "onCancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "onPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "onRelease",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "payRouter",
    outputs: [
      {
        internalType: "contract IPayRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "releaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "removeDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requestInfo",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      }
    ],
    name: "setCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_payRouter",
        type: "address"
      }
    ],
    name: "setPayRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      }
    ],
    name: "setRequesterFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "setRequesterValueLockDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "transferRequestBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawRequesterFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/MediatorManager.json
var MediatorManager_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      },
      {
        internalType: "address",
        name: "_randAddr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_ticketCancelDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketMatureDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketExpireDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketPauseDur",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "drafter",
        type: "address"
      }
    ],
    name: "Drafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "JoinedPool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "PoolMarketApproval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "PoolMediatorApproval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "blocked",
        type: "bool"
      }
    ],
    name: "TicketBlocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "TicketCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TicketDrained",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pauseDur",
        type: "uint256"
      }
    ],
    name: "TicketPaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "matureAt",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "joinBy",
        type: "uint256"
      }
    ],
    name: "TicketPurchased",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "voted",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "winSide",
        type: "bool"
      }
    ],
    name: "TicketSlashed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TicketSlashedByOwner",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "slashed",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "address",
        name: "undrafter",
        type: "address"
      }
    ],
    name: "Undrafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "UpdatedDisputeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "UpdatedMarketCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "maxPause",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxPause",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "UpdatedRandomnessProvider",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketCancelDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketMatureDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketExpireDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketPauseDur",
        type: "uint256"
      }
    ],
    name: "UpdatedTicketDurations",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "baseTicketPrice",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "windowDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketsPerWindow",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseTicketSupply",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "priceSupplyDeltaBP",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minInactiveWindowBeforeReset",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "soldOutBP",
        type: "uint256"
      }
    ],
    name: "UpdatedTicketParams",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reqBond",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "draftReward",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "winReward",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "noVoteSlashBP",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "loseVoteSlashBP",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "numDraftees",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "evidenceDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "predictDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approvedMediatorOnly",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approvedMarketOnly",
        type: "bool"
      }
    ],
    name: "UpdatedTicketPool",
    type: "event"
  },
  {
    inputs: [],
    name: "baseTicketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "disputeManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "disputeID",
        type: "uint256"
      }
    ],
    name: "draft",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "idx",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bond",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "matureAt",
            type: "uint256"
          },
          {
            internalType: "int256",
            name: "poolIdx",
            type: "int256"
          },
          {
            internalType: "uint256",
            name: "cancelAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "joinBy",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numPaused",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "drafted",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "joined",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "blocked",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "slashed",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "paused",
                type: "bool"
              }
            ],
            internalType: "struct Structs.TicketStatus",
            name: "status",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Ticket",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "drainTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getTicket",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "idx",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bond",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "matureAt",
            type: "uint256"
          },
          {
            internalType: "int256",
            name: "poolIdx",
            type: "int256"
          },
          {
            internalType: "uint256",
            name: "cancelAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "joinBy",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numPaused",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "drafted",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "joined",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "blocked",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "slashed",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "paused",
                type: "bool"
              }
            ],
            internalType: "struct Structs.TicketStatus",
            name: "status",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Ticket",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      }
    ],
    name: "getTicketPool",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "exists",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "approvedMediatorOnly",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "approvedMarketOnly",
            type: "bool"
          },
          {
            internalType: "uint256",
            name: "reqBond",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "draftReward",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "winReward",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "noVoteSlashBP",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "loseVoteSlashBP",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDraftees",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "evidenceDur",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "predictDur",
            type: "uint256"
          }
        ],
        internalType: "struct Structs.TicketPool",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTicketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "marketAddr",
        type: "address"
      }
    ],
    name: "isApprovedMarket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "isApprovedMediator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "join",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "marketCore",
    outputs: [
      {
        internalType: "contract IMarketCore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxPause",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minInactiveWindowBeforeReset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numWindows",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "poolApprovals",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      }
    ],
    name: "poolExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "poolMarketApprovals",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "poolOwners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "poolTickets",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "pools",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "approvedMediatorOnly",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "approvedMarketOnly",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "reqBond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "draftReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "winReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "noVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "loseVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numDraftees",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "evidenceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "predictDur",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "priceSupplyDeltaBP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      }
    ],
    name: "purchaseTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "randomness",
    outputs: [
      {
        internalType: "contract IRandomness",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_disputeManager",
        type: "address"
      }
    ],
    name: "setDisputeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      }
    ],
    name: "setMarketCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxPause",
        type: "uint256"
      }
    ],
    name: "setMaxPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "provider",
        type: "address"
      }
    ],
    name: "setRandomnessProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_ticketCancelDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketMatureDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketExpireDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketPauseDur",
        type: "uint256"
      }
    ],
    name: "setTicketDurations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_baseTicketPrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_windowDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketsPerWindow",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_baseTicketSupply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_priceSupplyDeltaBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minInactiveWindowBeforeReset",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_soldOutBP",
        type: "uint256"
      }
    ],
    name: "setTicketMarketParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "slash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "soldOutBP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketCancelDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketExpireDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketMatureDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketPauseDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketSold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "tickets",
    outputs: [
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "matureAt",
        type: "uint256"
      },
      {
        internalType: "int256",
        name: "poolIdx",
        type: "int256"
      },
      {
        internalType: "uint256",
        name: "cancelAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "joinBy",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numPaused",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "drafted",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "joined",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "blocked",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "slashed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool"
          }
        ],
        internalType: "struct Structs.TicketStatus",
        name: "status",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketsPerWindow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "marketAddr",
        type: "address"
      }
    ],
    name: "toggleApproveMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "toggleApproveMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "toggleBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "togglePause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "voted",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "winSide",
        type: "bool"
      }
    ],
    name: "undraft",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reqBond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "draftReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "winReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "noVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "loseVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numDraftees",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "evidenceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "predictDur",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approvedMediatorOnly",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "approvedMarketOnly",
        type: "bool"
      }
    ],
    name: "updateTicketPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "windowDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "windows",
    outputs: [
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numPurchases",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "supply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/MinerRegistry.json
var MinerRegistry_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_minerBond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_matureDuration",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_cancelDuration",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "AddedReward",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "blocked",
        type: "bool"
      }
    ],
    name: "Blocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cancelDuration",
        type: "uint256"
      }
    ],
    name: "Cancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Drained",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "Registered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Slashed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "matureDuration",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cancelDuration",
        type: "uint256"
      }
    ],
    name: "UpdatedDurations",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "UpdatedMinerBond",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "UpdatedOpReward",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum MinerOperation[]",
        name: "ops",
        type: "uint8[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "UpdatedOpsReward",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "added",
        type: "bool"
      }
    ],
    name: "WriterUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "miner",
        type: "address"
      }
    ],
    name: "addReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "drain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "isMiner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "matureDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minerBond",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "miners",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "matureAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "cancelAt",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "blocked",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation",
        name: "",
        type: "uint8"
      }
    ],
    name: "opRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "miner",
        type: "address"
      }
    ],
    name: "rewardBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_matureDuration",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_cancelDuration",
        type: "uint256"
      }
    ],
    name: "setDurations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "slash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "miner",
        type: "address"
      }
    ],
    name: "toggleBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minerBond",
        type: "uint256"
      }
    ],
    name: "updateMinerBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "updateOpReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation[]",
        name: "ops",
        type: "uint8[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "updateOpsReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "updateWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address"
      }
    ],
    name: "withdrawBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "writers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/NFT.json
var NFT_default = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "string",
        name: "_initBaseURI",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_treasuryEditionSupply",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_feePool",
        type: "address"
      },
      {
        internalType: "address",
        name: "_allocator",
        type: "address"
      },
      {
        internalType: "address",
        name: "_energon",
        type: "address"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "OperatorNotAllowed",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Allocated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AllocatorUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "slot",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "AllowAddr",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allow",
        type: "bool"
      }
    ],
    name: "AllowAlloc",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allow",
        type: "bool"
      }
    ],
    name: "AllowBurn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allow",
        type: "bool"
      }
    ],
    name: "AllowMint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "_burner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "BurnAllowance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "_purpose",
        type: "bytes"
      }
    ],
    name: "BurnedEnergon",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "DepositedEnergon",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "EnergonUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "TokenUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_new",
        type: "string"
      }
    ],
    name: "UpdatedBaseExtension",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_new",
        type: "string"
      }
    ],
    name: "UpdatedBaseURI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_new",
        type: "string"
      }
    ],
    name: "UpdatedContractURI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_new",
        type: "uint256"
      }
    ],
    name: "UpdatedCost",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_new",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxMintAmount",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_new",
        type: "uint256"
      }
    ],
    name: "UpdatedMintCost",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amt",
        type: "uint256"
      }
    ],
    name: "Withdrawal",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "withdrawer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnEnergon",
    type: "event"
  },
  {
    inputs: [],
    name: "OPERATOR_FILTER_REGISTRY",
    outputs: [
      {
        internalType: "contract IOperatorFilterRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "_contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_alloc",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    name: "allocate",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "allocator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "slot",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "allowAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "allowAlloc",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowEnergonOps",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowMint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "allowlist",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "baseExtension",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_burner",
        type: "address"
      }
    ],
    name: "burnAllowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "burnAllowances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_burner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "burnApprove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_purpose",
        type: "bytes"
      }
    ],
    name: "burnEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "cost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "depositEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "energon",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "engBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "engBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feePool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_mintAmount",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "_noEnergon",
        type: "bool"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fromId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_mintAmount",
        type: "uint256"
      }
    ],
    name: "mintTE",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedByAllowlist",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedByOwner",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedByTreasury",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "p2pBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "p2pBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_salePrice",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_allocator",
        type: "address"
      }
    ],
    name: "setAllocator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_newBaseExtension",
        type: "string"
      }
    ],
    name: "setBaseExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_newBaseURI",
        type: "string"
      }
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "setCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "feeNumerator",
        type: "uint96"
      }
    ],
    name: "setDefaultRoyalty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_energon",
        type: "address"
      }
    ],
    name: "setEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "setMintCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "setToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowAlloc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowEnergonOps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256"
      }
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256"
      }
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      }
    ],
    name: "tokensOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalAllocated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "treasuryEditionSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "usedNonce",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/PayRouter.json
var PayRouter_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_bondToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "ApprovedRequester",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "BondReturned",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "BondTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "DepositedBond",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orgId",
        type: "uint256"
      }
    ],
    name: "OrgCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "OrgSourcePaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ProtocolFeeWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestClosed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "routeIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "bonds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sourceAmt",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "valueLockDuration",
        type: "uint256"
      }
    ],
    name: "RequestCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "RequestPaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RequesterFeeWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum SourceType",
        name: "source",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "address",
        name: "sourceToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sourceOrgId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "destOrgId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "RouteCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "SourceReturned",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "SourceTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "UnapprovedRequester",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bondToken",
        type: "address"
      }
    ],
    name: "UpdatedBondToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "protocolFeeBp",
        type: "uint256"
      }
    ],
    name: "UpdatedProtocolFeeBp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      }
    ],
    name: "UpdatedRequesterFeeBp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "UpdatedValueLockDuration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "withdrawer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnBond",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "approveRequester",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "approvedRouteRequesters",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bondToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "cancelRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "closeRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "createOrg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_routeIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_bonds",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "_sourceAmt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_valueLockDuration",
        type: "uint256"
      }
    ],
    name: "createRequest",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            internalType: "enum SourceType",
            name: "source",
            type: "uint8"
          },
          {
            internalType: "address",
            name: "sourceToken",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "sourceOrgId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "destOrgId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bond",
            type: "uint256"
          },
          {
            internalType: "address[]",
            name: "requesters",
            type: "address[]"
          }
        ],
        internalType: "struct Route",
        name: "route",
        type: "tuple"
      }
    ],
    name: "createRoute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "depositBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "feeBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "getRequest",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "sourceToken",
            type: "address"
          },
          {
            internalType: "uint256[]",
            name: "routeIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "bonds",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "sourceAmt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "sourceAmtLeft",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "requesterFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "protocolFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "valueLockDuration",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "valueUnlockAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numRoutersPaid",
            type: "uint256"
          },
          {
            internalType: "bool[]",
            name: "paid",
            type: "bool[]"
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "cancelled",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "orgSrcPaid",
            type: "bool"
          }
        ],
        internalType: "struct Request",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "isRequesterApproved",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "markOrgSourceAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      }
    ],
    name: "markRequestAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "numOrgs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numRequests",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numRoutes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "orgs",
    outputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "protocolFeeBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "protocolFeeBp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "requesterValueLockDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "requestersBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "requestersFeeBp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "address",
        name: "sourceToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "sourceAmt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "sourceAmtLeft",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "requesterFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "protocolFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "valueLockDuration",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "valueUnlockAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numRoutersPaid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "closed",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "cancelled",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "orgSrcPaid",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "routes",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "enum SourceType",
        name: "source",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "sourceToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "sourceOrgId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "destOrgId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bondToken",
        type: "address"
      }
    ],
    name: "setBondToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_protocolFeeBp",
        type: "uint256"
      }
    ],
    name: "setProtocolFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      }
    ],
    name: "setRequesterFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "setRequesterValueLockDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "transferRequestBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "transferRequestSource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "unapproveRequester",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "userHasOrg",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "userOrgs",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawProtocolFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawRequesterFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/ProviderRegistry.json
var ProviderRegistry_default = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "idx",
        type: "uint256"
      }
    ],
    name: "ProviderRegistered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "added",
        type: "bool"
      }
    ],
    name: "WriterUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "get",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getByAddr",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nextId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "providerIdx",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "providers",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "updateWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "writers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/Router.json
var Router_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      },
      {
        internalType: "address",
        name: "_provReg",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeCount",
        type: "uint256"
      }
    ],
    name: "Routed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedProvReg",
    type: "event"
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "asset",
        type: "tuple"
      }
    ],
    name: "isERC20",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "asset",
        type: "tuple"
      }
    ],
    name: "isNative",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "provReg",
    outputs: [
      {
        internalType: "contract IProviderRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "provider",
                    type: "uint256"
                  },
                  {
                    internalType: "uint256",
                    name: "lid",
                    type: "uint256"
                  },
                  {
                    internalType: "uint256",
                    name: "amount",
                    type: "uint256"
                  },
                  {
                    internalType: "uint256",
                    name: "maxPrice",
                    type: "uint256"
                  }
                ],
                internalType: "struct Liquidity[]",
                name: "liqs",
                type: "tuple[]"
              },
              {
                internalType: "address",
                name: "market",
                type: "address"
              }
            ],
            internalType: "struct Route[]",
            name: "routes",
            type: "tuple[]"
          },
          {
            internalType: "address",
            name: "target",
            type: "address"
          }
        ],
        internalType: "struct RouteParams",
        name: "routeParams",
        type: "tuple"
      }
    ],
    name: "route",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      }
    ],
    name: "setCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_provReg",
        type: "address"
      }
    ],
    name: "setProviderRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];

// src/abi/Token.json
var Token_default = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_initialSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "AddedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "RemovedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]"
      }
    ],
    name: "addMinters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "minters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numMinters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/TokenPool.json
var TokenPool_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_stakingToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Recovered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "StakeWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Staked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadgeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedFeePool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "UpdatedReqBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "VestStaked",
    type: "event"
  },
  {
    inputs: [],
    name: "badge",
    outputs: [
      {
        internalType: "contract IBadge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canStake",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "exit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "feePool",
    outputs: [
      {
        internalType: "contract IFeePool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRewardForDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_reward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_rewardsDuration",
        type: "uint256"
      }
    ],
    name: "notifyRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requiredBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setBadgeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "setRequiredBadges",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_cliffEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_vestedAt",
        type: "uint256"
      }
    ],
    name: "stakeVested",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "vesting",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "cliffEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "vestedAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "withdrawn",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/UniswapV2Router.json
var UniswapV2Router_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];

// src/abi/UniswapV2Router2.json
var UniswapV2Router2_default = [
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];

// src/abi/UniswapV3Router.json
var UniswapV3Router_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH9",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          }
        ],
        internalType: "struct ISwapRouter.ExactInputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct ISwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          }
        ],
        internalType: "struct ISwapRouter.ExactOutputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct ISwapRouter.ExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowed",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowedIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];

// src/abi/UniswapV3Router2.json
var UniswapV3Router2_default = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factoryV2",
        type: "address"
      },
      {
        internalType: "address",
        name: "factoryV3",
        type: "address"
      },
      {
        internalType: "address",
        name: "_positionManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH9",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveMax",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveMaxMinusOne",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveZeroThenMax",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveZeroThenMaxMinusOne",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "callPositionManager",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "paths",
        type: "bytes[]"
      },
      {
        internalType: "uint128[]",
        name: "amounts",
        type: "uint128[]"
      },
      {
        internalType: "uint24",
        name: "maximumTickDivergence",
        type: "uint24"
      },
      {
        internalType: "uint32",
        name: "secondsAgo",
        type: "uint32"
      }
    ],
    name: "checkOracleSlippage",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      },
      {
        internalType: "uint24",
        name: "maximumTickDivergence",
        type: "uint24"
      },
      {
        internalType: "uint32",
        name: "secondsAgo",
        type: "uint32"
      }
    ],
    name: "checkOracleSlippage",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactInputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactOutputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factoryV2",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "getApprovalType",
    outputs: [
      {
        internalType: "enum IApproveAndCall.ApprovalType",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address"
          },
          {
            internalType: "address",
            name: "token1",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256"
          }
        ],
        internalType: "struct IApproveAndCall.IncreaseLiquidityParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "increaseLiquidity",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address"
          },
          {
            internalType: "address",
            name: "token1",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "tickLower",
            type: "int24"
          },
          {
            internalType: "int24",
            name: "tickUpper",
            type: "int24"
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          }
        ],
        internalType: "struct IApproveAndCall.MintParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "previousBlockhash",
        type: "bytes32"
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "positionManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "pull",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowed",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowedIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "wrapETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];

// src/abi/UniswapV3RouterUniversal.json
var UniswapV3RouterUniversal_default = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "permit2",
            type: "address"
          },
          {
            internalType: "address",
            name: "weth9",
            type: "address"
          },
          {
            internalType: "address",
            name: "seaportV1_5",
            type: "address"
          },
          {
            internalType: "address",
            name: "seaportV1_4",
            type: "address"
          },
          {
            internalType: "address",
            name: "openseaConduit",
            type: "address"
          },
          {
            internalType: "address",
            name: "nftxZap",
            type: "address"
          },
          {
            internalType: "address",
            name: "x2y2",
            type: "address"
          },
          {
            internalType: "address",
            name: "foundation",
            type: "address"
          },
          {
            internalType: "address",
            name: "sudoswap",
            type: "address"
          },
          {
            internalType: "address",
            name: "elementMarket",
            type: "address"
          },
          {
            internalType: "address",
            name: "nft20Zap",
            type: "address"
          },
          {
            internalType: "address",
            name: "cryptopunks",
            type: "address"
          },
          {
            internalType: "address",
            name: "looksRareV2",
            type: "address"
          },
          {
            internalType: "address",
            name: "routerRewardsDistributor",
            type: "address"
          },
          {
            internalType: "address",
            name: "looksRareRewardsDistributor",
            type: "address"
          },
          {
            internalType: "address",
            name: "looksRareToken",
            type: "address"
          },
          {
            internalType: "address",
            name: "v2Factory",
            type: "address"
          },
          {
            internalType: "address",
            name: "v3Factory",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "pairInitCodeHash",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "poolInitCodeHash",
            type: "bytes32"
          }
        ],
        internalType: "struct RouterParameters",
        name: "params",
        type: "tuple"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "BalanceTooLow",
    type: "error"
  },
  {
    inputs: [],
    name: "BuyPunkFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "ContractLocked",
    type: "error"
  },
  {
    inputs: [],
    name: "ETHNotAccepted",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "commandIndex",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes"
      }
    ],
    name: "ExecutionFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "FromAddressIsNotOwner",
    type: "error"
  },
  {
    inputs: [],
    name: "InsufficientETH",
    type: "error"
  },
  {
    inputs: [],
    name: "InsufficientToken",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidBips",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "commandType",
        type: "uint256"
      }
    ],
    name: "InvalidCommandType",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidOwnerERC1155",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidOwnerERC721",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPath",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidReserves",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidSpender",
    type: "error"
  },
  {
    inputs: [],
    name: "LengthMismatch",
    type: "error"
  },
  {
    inputs: [],
    name: "SliceOutOfBounds",
    type: "error"
  },
  {
    inputs: [],
    name: "TransactionDeadlinePassed",
    type: "error"
  },
  {
    inputs: [],
    name: "UnableToClaim",
    type: "error"
  },
  {
    inputs: [],
    name: "UnsafeCast",
    type: "error"
  },
  {
    inputs: [],
    name: "V2InvalidPath",
    type: "error"
  },
  {
    inputs: [],
    name: "V2TooLittleReceived",
    type: "error"
  },
  {
    inputs: [],
    name: "V2TooMuchRequested",
    type: "error"
  },
  {
    inputs: [],
    name: "V3InvalidAmountOut",
    type: "error"
  },
  {
    inputs: [],
    name: "V3InvalidCaller",
    type: "error"
  },
  {
    inputs: [],
    name: "V3InvalidSwap",
    type: "error"
  },
  {
    inputs: [],
    name: "V3TooLittleReceived",
    type: "error"
  },
  {
    inputs: [],
    name: "V3TooMuchRequested",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RewardsSent",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "looksRareClaim",
        type: "bytes"
      }
    ],
    name: "collectRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "commands",
        type: "bytes"
      },
      {
        internalType: "bytes[]",
        name: "inputs",
        type: "bytes[]"
      }
    ],
    name: "execute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "commands",
        type: "bytes"
      },
      {
        internalType: "bytes[]",
        name: "inputs",
        type: "bytes[]"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "execute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];

// src/abi/WETH.json
var WETH_default = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "guy",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Withdrawal",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "guy",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];

// src/abi/index.ts
var Abi = {
  BadgeManager: BadgeManager_default,
  Core: Core_default,
  DisputeManager: DisputeManager_default,
  Energon: Energon_default,
  MarketCore: MarketCore_default,
  MediatorManager: MediatorManager_default,
  NFT: NFT_default,
  NativeToken: Token_default,
  WETHAbi: WETH_default,
  AssetRegistry: AssetRegistry_default,
  MinerRegistry: MinerRegistry_default,
  ProviderRegistry: ProviderRegistry_default,
  Router: Router_default,
  ERC20: ERC20_default,
  ERC721: ERC721_default,
  FeePool: FeePool_default,
  LPPool: LPPool_default,
  TokenPool: TokenPool_default,
  PayRouter: PayRouter_default,
  MarketManager: MarketManager_default,
  UniswapV2Router: UniswapV2Router_default,
  UniswapV2Router2: UniswapV2Router2_default,
  UniswapV3Router: UniswapV3Router_default,
  UniswapV3Router2: UniswapV3Router2_default,
  UniswapV3RouterUniversal: UniswapV3RouterUniversal_default,
  BondCurveDistro: BondCurveDistro_default
};

// src/badge_manifest.ts
var BadgeManifests = {
  localhost: {
    "^kyc(/[a-zA-Z]{3})?$": {
      name: "KYC",
      issuer: "Joint Labs",
      issuerAddress: "0x0B9Fc80B571e99C4ea796Eb34E75df59470826F3",
      logoUrl: "https://storage.googleapis.com/joint-images/kyc-badge-icon.svg",
      claimPageUrl: import.meta.env.LOCALHOST_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.VITE_LOCALHOST_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? "http://localhost:3002/claim/kyc",
      shortDescription: "Claim KYC Badge",
      longDescriptions: [
        "Complete the KYC verification process to claim a global or national KYC badge that will grant you access to a market or liquidity that require KYC.",
        "See our [privacy policy](http://joint.exchange/legal/privacy-policy) to learn how we handle your data."
      ]
    }
  },
  sepolia: {
    "^kyc(/[a-zA-Z]{3})?$": {
      name: "KYC",
      issuer: "Joint Labs",
      issuerAddress: "0x7D66e2a2Ad08e8708e92B2f01f36181502D2c964",
      logoUrl: "https://storage.googleapis.com/joint-images/kyc-badge-icon.svg",
      claimPageUrl: import.meta.env.SEPOLIA_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.VITE_SEPOLIA_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? "https://kycbadge.joint.exchange/claim/kyc",
      shortDescription: "Claim KYC Badge",
      longDescriptions: [
        "Complete the KYC verification process to claim a global or national KYC badge that will grant you access to a market or liquidity that require KYC.",
        "See our [privacy policy](http://joint.exchange/legal/privacy-policy) to learn how we handle your data."
      ]
    }
  },
  arbitrum: {
    "^kyc(/[a-zA-Z]{3})?$": {
      name: "KYC",
      issuer: "Joint Labs",
      issuerAddress: "0x7D66e2a2Ad08e8708e92B2f01f36181502D2c964",
      logoUrl: "https://storage.googleapis.com/joint-images/kyc-badge-icon.svg",
      claimPageUrl: import.meta.env.ARBITRUM_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.VITE_ARBITRUM_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? "https://kycbadge.joint.exchange/claim/kyc",
      shortDescription: "Claim KYC Badge",
      longDescriptions: [
        "Complete the KYC verification process to claim a global or national KYC badge that will grant you access to a market or liquidity that require KYC.",
        "See our [privacy policy](http://joint.exchange/legal/privacy-policy) to learn how we handle your data."
      ]
    }
  },
  ["arbitrum-sepolia"]: {
    "^kyc(/[a-zA-Z]{3})?$": {
      name: "KYC",
      issuer: "Joint Labs",
      issuerAddress: "0x7D66e2a2Ad08e8708e92B2f01f36181502D2c964",
      logoUrl: "https://storage.googleapis.com/joint-images/kyc-badge-icon.svg",
      claimPageUrl: import.meta.env.ARBITRUM_SEPOLIA_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_KYC_BADGE_MANIFEST_CLAIM_PAGE_URL ?? "https://kycbadge.joint.exchange/claim/kyc",
      shortDescription: "Claim KYC Badge",
      longDescriptions: [
        "Complete the KYC verification process to claim a global or national KYC badge that will grant you access to a market or liquidity that require KYC.",
        "See our [privacy policy](http://joint.exchange/legal/privacy-policy) to learn how we handle your data."
      ]
    }
  }
};
function parseBadgeLocals(badge, locals) {
  let str = JSON.stringify(badge);
  for (const key in locals) {
    str = str.replace(new RegExp(`{${key}}`, "g"), locals[key]);
  }
  return JSON.parse(str);
}

// src/chains.ts
import {
  arbitrum,
  arbitrumSepolia,
  base,
  blast,
  bsc,
  hardhat,
  mainnet,
  optimism,
  polygon,
  sepolia
} from "viem/chains";

// src/icons/IconArbitrum.tsx
import React from "react";
function IconArbitrum(props) {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      id: "b",
      "data-name": "Layer 2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1226.88 1226.88",
      ...props
    },
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, `
          .d {fill: #fff;}

          .e {
          fill: #9dcced;
        }

          .f {
          fill: #213147;
        }

          .g {
          fill: #12aaff;
        }`)),
    /* @__PURE__ */ React.createElement("g", { id: "c", "data-name": "Layer 3" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("circle", { className: "f", cx: "613.44", cy: "613.44", r: "613.44" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
      "path",
      {
        className: "f",
        d: "m162.91,397.79v431.21c0,27.53,14.71,52.99,38.54,66.71l373.44,215.65c23.83,13.72,53.17,13.72,77,0l373.44-215.65c23.83-13.72,38.54-39.18,38.54-66.71v-431.21c0-27.53-14.71-52.99-38.54-66.71l-373.44-215.65c-23.83-13.72-53.17-13.72-77,0l-373.53,215.65c-23.83,13.72-38.45,39.18-38.45,66.71Z"
      }
    ), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
      "path",
      {
        className: "g",
        d: "m694.86,697.03l-53.26,146.05c-1.44,4.06-1.44,8.49,0,12.55l91.62,251.3,105.97-61.2-127.19-348.7c-2.89-8.03-14.26-8.03-17.15,0Z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        className: "g",
        d: "m801.65,451.41c-2.89-8.03-14.26-8.03-17.15,0l-53.26,146.05c-1.44,4.06-1.44,8.49,0,12.55l150.11,411.44,105.97-61.2-185.68-508.84Z"
      }
    )), /* @__PURE__ */ React.createElement(
      "path",
      {
        className: "e",
        d: "m613.35,131.59c2.62,0,5.24.72,7.58,1.99l404.13,233.34c4.69,2.71,7.58,7.76,7.58,13.09v466.59c0,5.42-2.89,10.38-7.58,13.09l-404.13,233.34c-2.26,1.35-4.96,1.99-7.58,1.99s-5.24-.72-7.58-1.99l-404.13-233.16c-4.69-2.71-7.58-7.76-7.58-13.09v-466.68c0-5.42,2.89-10.38,7.58-13.09l404.13-233.34c2.35-1.35,4.96-2.08,7.58-2.08m0-68.15c-14.35,0-28.8,3.7-41.7,11.19l-404.04,233.25c-25.82,14.89-41.7,42.43-41.7,72.21v466.59c0,29.79,15.89,57.32,41.7,72.21l404.13,233.34c12.91,7.4,27.26,11.19,41.7,11.19s28.8-3.7,41.7-11.19l404.13-233.34c25.82-14.89,41.7-42.43,41.7-72.21v-466.59c0-29.79-15.89-57.32-41.7-72.21l-404.22-233.25c-12.91-7.49-27.35-11.19-41.7-11.19h0Z"
      }
    ), /* @__PURE__ */ React.createElement(
      "polygon",
      {
        className: "f",
        points: "346.07 1021.99 383.26 920.17 458.09 982.36 388.13 1046.27 346.07 1021.99"
      }
    ), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
      "path",
      {
        className: "d",
        d: "m579.32,346.7h-102.45c-7.67,0-14.53,4.78-17.15,12.01l-219.62,602.08,105.97,61.2,241.83-663.01c2.26-5.96-2.17-12.28-8.58-12.28Z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        className: "d",
        d: "m758.59,346.7h-102.45c-7.67,0-14.53,4.78-17.15,12.01l-250.76,687.48,105.97,61.2,272.97-748.41c2.17-5.96-2.26-12.28-8.58-12.28Z"
      }
    )))))
  );
}

// src/icons/IconBase.tsx
import React2 from "react";
function IconBase(props) {
  return /* @__PURE__ */ React2.createElement(
    "svg",
    {
      width: "100px",
      height: "100px",
      viewBox: "0 0 100 100",
      ...props,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    },
    /* @__PURE__ */ React2.createElement("defs", null, /* @__PURE__ */ React2.createElement(
      "path",
      {
        d: "M50,100 C22.384,100 0,77.616 0,50 C0,22.384 22.384,0 50,0 C77.616,0 100,22.384 100,50 C100,77.616 77.616,100 50,100 Z",
        id: "path-hs3laz6i_5-1"
      }
    )),
    /* @__PURE__ */ React2.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React2.createElement("g", { id: "base-logo-in-blue" }, /* @__PURE__ */ React2.createElement("mask", { id: "mask-hs3laz6i_5-2", fill: "white" }, /* @__PURE__ */ React2.createElement("use", { xlinkHref: "#path-hs3laz6i_5-1" })), /* @__PURE__ */ React2.createElement("g", { id: "SVGID_1_" }), /* @__PURE__ */ React2.createElement("g", { id: "Group", mask: "url(#mask-hs3laz6i_5-2)" }, /* @__PURE__ */ React2.createElement("g", { transform: "translate(-20.9877, -20.9877)" }, /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "Path",
        fill: "#FEFEFF",
        points: "70.9876543 70.9876543 0 70.5500042 0.0642422211 67.940164"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_1",
        fill: "#FDFEFF",
        points: "70.9876543 70.9876543 0.0521968046 68.3737989 0.160605553 66.1975937"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_2",
        fill: "#FCFDFF",
        points: "70.9876543 70.9876543 0.13651472 66.6352438 0.297120273 64.4630537"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_3",
        fill: "#FBFCFF",
        points: "70.9876543 70.9876543 0.264999162 64.8966887 0.477801519 62.7285138"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_4",
        fill: "#FAFCFF",
        points: "70.9876543 70.9876543 0.437650131 63.1621488 0.702649293 61.0020041"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_5",
        fill: "#F9FBFF",
        points: "70.9876543 70.9876543 0.650452489 61.4356391 0.967648455 59.2795095"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_6",
        fill: "#F8FAFF",
        points: "70.9876543 70.9876543 0.907421373 59.7091294 1.27681414 57.5650452"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_7",
        fill: "#F7FAFF",
        points: "70.9876543 70.9876543 1.20454165 57.9946651 1.62613122 55.8586113"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_8",
        fill: "#F6F9FF",
        points: "70.9876543 70.9876543 1.54181331 56.2882311 2.01961483 54.1602075"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_9",
        fill: "#F5F8FF",
        points: "70.9876543 70.9876543 1.92325149 54.5858122 2.45324982 52.4738492"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_10",
        fill: "#F4F8FF",
        points: "70.9876543 70.9876543 2.34885621 52.8954388 2.9270362 50.7955212"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_11",
        fill: "#F3F7FF",
        points: "70.9876543 70.9876543 2.81059717 51.2171108 3.44498911 49.1332537"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_12",
        fill: "#F2F6FF",
        points: "70.9876543 70.9876543 3.31650466 49.5508282 4.0030934 47.4830317"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_13",
        fill: "#F1F6FF",
        points: "70.9876543 70.9876543 3.86256354 47.896591 4.59733395 45.844855"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_14",
        fill: "#F0F5FF",
        points: "70.9876543 70.9876543 4.45278895 46.2543992 5.23574102 44.222739"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_15",
        fill: "#EFF4FF",
        points: "70.9876543 70.9876543 5.07915061 44.628268 5.91028434 42.6166834"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_16",
        fill: "#EEF3FF",
        points: "70.9876543 70.9876543 5.74566365 43.0181973 6.62899419 41.0307036"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_17",
        fill: "#EDF3FF",
        points: "70.9876543 70.9876543 6.45232808 41.4282023 7.38384029 39.4607843"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_18",
        fill: "#ECF2FF",
        points: "70.9876543 70.9876543 7.19512876 39.8542679 8.17482264 37.9069256"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_19",
        fill: "#EBF1FF",
        points: "70.9876543 70.9876543 7.97808083 38.2963941 9.00595637 36.3771577"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_20",
        fill: "#EAF1FF",
        points: "70.9876543 70.9876543 8.80118429 36.762611 9.87322636 34.8634504"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_21",
        fill: "#E9F0FF",
        points: "70.9876543 70.9876543 9.660424 35.2448886 10.7806477 33.377849"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_22",
        fill: "#E8EFFF",
        points: "70.9876543 70.9876543 10.5558 33.7512569 11.7201902 31.9083082"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_23",
        fill: "#E7EFFF",
        points: "70.9876543 70.9876543 11.4873122 32.277701 12.6998841 30.4668734"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_24",
        fill: "#E6EEFF",
        points: "70.9876543 70.9876543 12.4549606 30.8282359 13.7076839 29.0495294"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_25",
        fill: "#E5EDFF",
        points: "70.9876543 70.9876543 13.4587453 29.4068767 14.7556352 27.6562762"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_26",
        fill: "#E4EDFF",
        points: "70.9876543 70.9876543 14.4946511 28.0055933 15.8357075 26.2871138"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_27",
        fill: "#E3ECFF",
        points: "70.9876543 70.9876543 15.5666932 26.6324158 16.947901 24.9500726"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_28",
        fill: "#E2EBFF",
        points: "70.9876543 70.9876543 16.6748715 25.2873443 18.0962307 23.6371222"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_29",
        fill: "#E1EBFF",
        points: "70.9876543 70.9876543 17.8111558 23.9663636 19.2726663 22.3522778"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_30",
        fill: "#E0EAFF",
        points: "70.9876543 70.9876543 18.9795612 22.6775041 20.4812231 21.0995545"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_31",
        fill: "#DFE9FF",
        points: "70.9876543 70.9876543 20.1800877 21.4167505 21.721901 19.8749372"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_32",
        fill: "#DEE9FF",
        points: "70.9876543 70.9876543 21.4167505 20.1800877 22.9906849 18.6824409"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_33",
        fill: "#DDE8FF",
        points: "70.9876543 70.9876543 22.6775041 18.9795612 24.2915899 17.5180507"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_34",
        fill: "#DCE7FF",
        points: "70.9876543 70.9876543 23.9663636 17.8111558 25.6165857 16.3897967"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_35",
        fill: "#DBE7FF",
        points: "70.9876543 70.9876543 25.2873443 16.6748715 26.9696874 15.2936638"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_36",
        fill: "#DAE6FF",
        points: "70.9876543 70.9876543 26.6324158 15.5666932 28.3508952 14.229652"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_37",
        fill: "#D9E5FF",
        points: "70.9876543 70.9876543 28.0055933 14.4946511 29.7561938 13.1977613"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_38",
        fill: "#D8E5FF",
        points: "70.9876543 70.9876543 29.4068767 13.4587453 31.1855832 12.206022"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_39",
        fill: "#D7E4FF",
        points: "70.9876543 70.9876543 30.8282359 12.4549606 32.6390635 11.2464038"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_40",
        fill: "#D6E3FF",
        points: "70.9876543 70.9876543 32.277701 11.4873122 34.1206497 10.3229219"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_41",
        fill: "#D5E3FF",
        points: "70.9876543 70.9876543 33.7512569 10.5558 35.6182965 9.43557622"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_42",
        fill: "#D4E2FF",
        points: "70.9876543 70.9876543 35.2448886 9.660424 37.1400341 8.58838193"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_43",
        fill: "#D3E1FF",
        points: "70.9876543 70.9876543 36.762611 8.80118429 38.6818474 7.77330875"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_44",
        fill: "#D2E0FF",
        points: "70.9876543 70.9876543 38.2963941 7.97808083 40.2437364 7.0024021"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_45",
        fill: "#D1E0FF",
        points: "70.9876543 70.9876543 39.8542679 7.19512876 41.8216859 6.2676317"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_46",
        fill: "#D0DFFF",
        points: "70.9876543 70.9876543 41.4282023 6.45232808 43.4197112 5.56899754"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_47",
        fill: "#CFDEFF",
        points: "70.9876543 70.9876543 43.0181973 5.74566365 45.033797 4.91051478"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_48",
        fill: "#CEDEFF",
        points: "70.9876543 70.9876543 44.628268 5.07915061 46.6639434 4.29619854"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_49",
        fill: "#CDDDFF",
        points: "70.9876543 70.9876543 46.2543992 4.45278895 48.3061351 3.71801855"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_50",
        fill: "#CCDCFF",
        points: "70.9876543 70.9876543 47.896591 3.86256354 49.9643875 3.18400508"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_51",
        fill: "#CBDCFF",
        points: "70.9876543 70.9876543 49.5508282 3.31650466 51.6346852 2.68612787"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_52",
        fill: "#CADBFF",
        points: "70.9876543 70.9876543 51.2171108 2.81059717 53.3170284 2.23241718"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_53",
        fill: "#C9DAFF",
        points: "70.9876543 70.9876543 52.8954388 2.34885621 55.0074018 1.81885789"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_54",
        fill: "#C8DAFF",
        points: "70.9876543 70.9876543 54.5858122 1.92325149 56.7098207 1.44946511"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_55",
        fill: "#C7D9FF",
        points: "70.9876543 70.9876543 56.2882311 1.54181331 58.4202698 1.12022373"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_56",
        fill: "#C6D8FF",
        points: "70.9876543 70.9876543 57.9946651 1.20454165 60.1387492 0.831133736"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_57",
        fill: "#C5D8FF",
        points: "70.9876543 70.9876543 59.7091294 0.907421373 61.8652589 0.586210268"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_58",
        fill: "#C4D7FF",
        points: "70.9876543 70.9876543 61.4356391 0.650452489 63.5957838 0.385453327"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_59",
        fill: "#C3D6FF",
        points: "70.9876543 70.9876543 63.1621488 0.437650131 65.3303237 0.224847774"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_60",
        fill: "#C2D6FF",
        points: "70.9876543 70.9876543 64.8966887 0.264999162 67.0688788 0.104393609"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_61",
        fill: "#C1D5FF",
        points: "70.9876543 70.9876543 66.6352438 0.13651472 68.8114491 0.0321211106"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_62",
        fill: "#C0D4FF",
        points: "70.9876543 70.9876543 68.3737989 0.0521968046 70.5500042 0"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_63",
        fill: "#BFD4FF",
        points: "70.9876543 70.9876543 70.1163692 0.00803027764 72.2925744 0.00803027764"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_64",
        fill: "#BED3FF",
        points: "70.9876543 70.9876543 71.8589394 0.00803027764 74.0351447 0.0642422211"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_65",
        fill: "#BDD2FF",
        points: "70.9876543 70.9876543 73.6015097 0.0521968046 75.7736998 0.160605553"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_66",
        fill: "#BCD2FF",
        points: "70.9876543 70.9876543 75.3400648 0.13651472 77.5122549 0.297120273"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_67",
        fill: "#BBD1FF",
        points: "70.9876543 70.9876543 77.0786199 0.264999162 79.2467949 0.477801519"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_68",
        fill: "#BAD0FF",
        points: "70.9876543 70.9876543 78.8091447 0.437650131 80.9733046 0.702649293"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_69",
        fill: "#B9D0FF",
        points: "70.9876543 70.9876543 80.5396696 0.650452489 82.6957991 0.967648455"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_70",
        fill: "#B8CFFF",
        points: "70.9876543 70.9876543 82.2621641 0.907421373 84.4102634 1.27681414"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_71",
        fill: "#B7CEFF",
        points: "70.9876543 70.9876543 83.9806435 1.20454165 86.1166974 1.62613122"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_72",
        fill: "#B6CDFF",
        points: "70.9876543 70.9876543 85.6870775 1.54181331 87.8151011 2.01961483"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_73",
        fill: "#B5CDFF",
        points: "70.9876543 70.9876543 87.3894964 1.92325149 89.5014594 2.45324982"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_74",
        fill: "#B4CCFF",
        points: "70.9876543 70.9876543 89.0798698 2.34885621 91.1757723 2.9270362"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_75",
        fill: "#B3CBFF",
        points: "70.9876543 70.9876543 90.7581979 2.81059717 92.8420549 3.44498911"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_76",
        fill: "#B2CBFF",
        points: "70.9876543 70.9876543 92.4244805 3.31650466 94.492277 4.0030934"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_77",
        fill: "#B1CAFF",
        points: "70.9876543 70.9876543 94.0787177 3.86256354 96.1304536 4.59733395"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_78",
        fill: "#B0C9FF",
        points: "70.9876543 70.9876543 95.7209094 4.45278895 97.7525697 5.23574102"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_79",
        fill: "#AFC9FF",
        points: "70.9876543 70.9876543 97.3430255 5.07915061 99.3586252 5.91028434"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_80",
        fill: "#AEC8FF",
        points: "70.9876543 70.9876543 98.9530962 5.74566365 100.944605 6.62899419"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_81",
        fill: "#ADC7FF",
        points: "70.9876543 70.9876543 100.547106 6.45232808 102.514524 7.38384029"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_82",
        fill: "#ACC7FF",
        points: "70.9876543 70.9876543 102.121041 7.19512876 104.068383 8.17482264"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_83",
        fill: "#ABC6FF",
        points: "70.9876543 70.9876543 103.678915 7.97808083 105.598151 9.00595637"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_84",
        fill: "#AAC5FF",
        points: "70.9876543 70.9876543 105.212698 8.80118429 107.111858 9.87322636"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_85",
        fill: "#A9C5FF",
        points: "70.9876543 70.9876543 106.73042 9.660424 108.59746 10.7806477"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_86",
        fill: "#A8C4FF",
        points: "70.9876543 70.9876543 108.224052 10.5558 110.062985 11.7201902"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_87",
        fill: "#A7C3FF",
        points: "70.9876543 70.9876543 109.697608 11.4873122 111.508435 12.6998841"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_88",
        fill: "#A6C3FF",
        points: "70.9876543 70.9876543 111.147073 12.4549606 112.925779 13.7076839"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_89",
        fill: "#A5C2FF",
        points: "70.9876543 70.9876543 112.568432 13.4587453 114.319032 14.7556352"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_90",
        fill: "#A4C1FF",
        points: "70.9876543 70.9876543 113.969715 14.4946511 115.68418 15.8357075"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_91",
        fill: "#A3C1FF",
        points: "70.9876543 70.9876543 115.342893 15.5666932 117.025236 16.947901"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_92",
        fill: "#A2C0FF",
        points: "70.9876543 70.9876543 116.687964 16.6748715 118.338186 18.0962307"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_93",
        fill: "#A1BFFF",
        points: "70.9876543 70.9876543 118.008945 17.8111558 119.623031 19.2726663"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_94",
        fill: "#A0BFFF",
        points: "70.9876543 70.9876543 119.297805 18.9795612 120.875754 20.4812231"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_95",
        fill: "#9FBEFF",
        points: "70.9876543 70.9876543 120.558558 20.1800877 122.100371 21.721901"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_96",
        fill: "#9EBDFF",
        points: "70.9876543 70.9876543 121.791206 21.4167505 123.292868 22.9906849"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_97",
        fill: "#9DBDFF",
        points: "70.9876543 70.9876543 122.995747 22.6775041 124.457258 24.2915899"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_98",
        fill: "#9CBCFF",
        points: "70.9876543 70.9876543 124.164153 23.9663636 125.585512 25.6165857"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_99",
        fill: "#9BBBFF",
        points: "70.9876543 70.9876543 125.300437 25.2873443 126.681645 26.9696874"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_100",
        fill: "#9ABAFF",
        points: "70.9876543 70.9876543 126.408615 26.6324158 127.745657 28.3508952"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_101",
        fill: "#99BAFF",
        points: "70.9876543 70.9876543 127.480658 28.0055933 128.777547 29.7561938"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_102",
        fill: "#98B9FF",
        points: "70.9876543 70.9876543 128.516563 29.4068767 129.769287 31.1855832"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_103",
        fill: "#97B8FF",
        points: "70.9876543 70.9876543 129.520348 30.8282359 130.728905 32.6390635"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_104",
        fill: "#96B8FF",
        points: "70.9876543 70.9876543 130.487996 32.277701 131.652387 34.1206497"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_105",
        fill: "#95B7FF",
        points: "70.9876543 70.9876543 131.419509 33.7512569 132.539732 35.6182965"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_106",
        fill: "#94B6FF",
        points: "70.9876543 70.9876543 132.314885 35.2448886 133.386927 37.1400341"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_107",
        fill: "#93B6FF",
        points: "70.9876543 70.9876543 133.174124 36.762611 134.197985 38.6818474"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_108",
        fill: "#92B5FF",
        points: "70.9876543 70.9876543 133.993213 38.2963941 134.972907 40.2437364"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_109",
        fill: "#91B4FF",
        points: "70.9876543 70.9876543 134.78018 39.8542679 135.707677 41.8216859"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_110",
        fill: "#90B4FF",
        points: "70.9876543 70.9876543 135.522981 41.4282023 136.406311 43.4197112"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_111",
        fill: "#8FB3FF",
        points: "70.9876543 70.9876543 136.229645 43.0181973 137.060779 45.033797"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_112",
        fill: "#8EB2FF",
        points: "70.9876543 70.9876543 136.896158 44.628268 137.67911 46.6639434"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_113",
        fill: "#8DB2FF",
        points: "70.9876543 70.9876543 137.52252 46.2543992 138.25729 48.3061351"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_114",
        fill: "#8CB1FF",
        points: "70.9876543 70.9876543 138.10873 47.896591 138.791304 49.9643875"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_115",
        fill: "#8BB0FF",
        points: "70.9876543 70.9876543 138.654789 49.5508282 139.289181 51.6346852"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_116",
        fill: "#8AB0FF",
        points: "70.9876543 70.9876543 139.160696 51.2171108 139.742891 53.3170284"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_117",
        fill: "#89AFFF",
        points: "70.9876543 70.9876543 139.626452 52.8954388 140.156451 55.0074018"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_118",
        fill: "#88AEFF",
        points: "70.9876543 70.9876543 140.052057 54.5858122 140.525844 56.7098207"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_119",
        fill: "#87AEFF",
        points: "70.9876543 70.9876543 140.42948 56.2882311 140.855085 58.4202698"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_120",
        fill: "#86ADFF",
        points: "70.9876543 70.9876543 140.770767 57.9946651 141.144175 60.1387492"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_121",
        fill: "#85ACFF",
        points: "70.9876543 70.9876543 141.067887 59.7091294 141.389098 61.8652589"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_122",
        fill: "#84ACFF",
        points: "70.9876543 70.9876543 141.324856 61.4356391 141.589855 63.5957838"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_123",
        fill: "#83ABFF",
        points: "70.9876543 70.9876543 141.537659 63.1621488 141.750461 65.3303237"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_124",
        fill: "#82AAFF",
        points: "70.9876543 70.9876543 141.710309 64.8966887 141.870915 67.0688788"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_125",
        fill: "#81AAFF",
        points: "70.9876543 70.9876543 141.838794 66.6352438 141.943188 68.8114491"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_126",
        fill: "#80A9FF",
        points: "70.9876543 70.9876543 141.923112 68.3737989 141.975309 70.5500042"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_127",
        fill: "#7FA8FF",
        points: "70.9876543 70.9876543 141.963263 70.1163692 141.963263 72.2925744"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_128",
        fill: "#7EA7FF",
        points: "70.9876543 70.9876543 141.963263 71.8589394 141.911066 74.0351447"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_129",
        fill: "#7DA7FF",
        points: "70.9876543 70.9876543 141.923112 73.6015097 141.814703 75.7736998"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_130",
        fill: "#7CA6FF",
        points: "70.9876543 70.9876543 141.838794 75.3400648 141.678188 77.5122549"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_131",
        fill: "#7BA5FF",
        points: "70.9876543 70.9876543 141.710309 77.0786199 141.497507 79.2467949"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_132",
        fill: "#7AA5FF",
        points: "70.9876543 70.9876543 141.537659 78.8091447 141.272659 80.9733046"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_133",
        fill: "#79A4FF",
        points: "70.9876543 70.9876543 141.324856 80.5396696 141.003645 82.6957991"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_134",
        fill: "#78A3FF",
        points: "70.9876543 70.9876543 141.067887 82.2621641 140.698494 84.4102634"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_135",
        fill: "#77A3FF",
        points: "70.9876543 70.9876543 140.770767 83.9806435 140.345162 86.1166974"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_136",
        fill: "#76A2FF",
        points: "70.9876543 70.9876543 140.42948 85.6870775 139.955694 87.8151011"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_137",
        fill: "#75A1FF",
        points: "70.9876543 70.9876543 140.052057 87.3894964 139.522059 89.5014594"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_138",
        fill: "#74A1FF",
        points: "70.9876543 70.9876543 139.626452 89.0798698 139.048272 91.1757723"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_139",
        fill: "#73A0FF",
        points: "70.9876543 70.9876543 139.160696 90.7581979 138.53032 92.8420549"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_140",
        fill: "#729FFF",
        points: "70.9876543 70.9876543 138.654789 92.4244805 137.972215 94.492277"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_141",
        fill: "#719FFF",
        points: "70.9876543 70.9876543 138.10873 94.0787177 137.377975 96.1304536"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_142",
        fill: "#709EFF",
        points: "70.9876543 70.9876543 137.52252 95.7209094 136.739568 97.7525697"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_143",
        fill: "#6F9DFF",
        points: "70.9876543 70.9876543 136.896158 97.3430255 136.061009 99.3586252"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_144",
        fill: "#6E9DFF",
        points: "70.9876543 70.9876543 136.229645 98.9530962 135.346314 100.944605"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_145",
        fill: "#6D9CFF",
        points: "70.9876543 70.9876543 135.522981 100.547106 134.591468 102.514524"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_146",
        fill: "#6C9BFF",
        points: "70.9876543 70.9876543 134.78018 102.121041 133.800486 104.068383"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_147",
        fill: "#6B9BFF",
        points: "70.9876543 70.9876543 133.993213 103.678915 132.969352 105.598151"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_148",
        fill: "#6A9AFF",
        points: "70.9876543 70.9876543 133.174124 105.212698 132.102082 107.111858"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_149",
        fill: "#6999FF",
        points: "70.9876543 70.9876543 132.314885 106.73042 131.194661 108.59746"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_150",
        fill: "#6899FF",
        points: "70.9876543 70.9876543 131.419509 108.224052 130.255118 110.062985"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_151",
        fill: "#6798FF",
        points: "70.9876543 70.9876543 130.487996 109.697608 129.275425 111.508435"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_152",
        fill: "#6697FF",
        points: "70.9876543 70.9876543 129.520348 111.147073 128.267625 112.925779"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_153",
        fill: "#6597FF",
        points: "70.9876543 70.9876543 128.516563 112.568432 127.219673 114.319032"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_154",
        fill: "#6496FF",
        points: "70.9876543 70.9876543 127.480658 113.969715 126.139601 115.68418"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_155",
        fill: "#6395FF",
        points: "70.9876543 70.9876543 126.408615 115.342893 125.027408 117.025236"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_156",
        fill: "#6294FF",
        points: "70.9876543 70.9876543 125.300437 116.687964 123.879078 118.338186"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_157",
        fill: "#6194FF",
        points: "70.9876543 70.9876543 124.164153 118.008945 122.702642 119.623031"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_158",
        fill: "#6093FF",
        points: "70.9876543 70.9876543 122.995747 119.297805 121.494086 120.875754"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_159",
        fill: "#5F92FF",
        points: "70.9876543 70.9876543 121.791206 120.558558 120.253408 122.100371"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_160",
        fill: "#5E92FF",
        points: "70.9876543 70.9876543 120.558558 121.791206 118.984624 123.292868"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_161",
        fill: "#5D91FF",
        points: "70.9876543 70.9876543 119.297805 122.995747 117.683719 124.457258"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_162",
        fill: "#5C90FF",
        points: "70.9876543 70.9876543 118.008945 124.164153 116.358723 125.585512"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_163",
        fill: "#5B90FF",
        points: "70.9876543 70.9876543 116.687964 125.300437 115.005621 126.681645"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_164",
        fill: "#5A8FFF",
        points: "70.9876543 70.9876543 115.342893 126.408615 113.624413 127.745657"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_165",
        fill: "#598EFF",
        points: "70.9876543 70.9876543 113.969715 127.480658 112.219115 128.777547"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_166",
        fill: "#588EFF",
        points: "70.9876543 70.9876543 112.568432 128.516563 110.789725 129.769287"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_167",
        fill: "#578DFF",
        points: "70.9876543 70.9876543 111.147073 129.520348 109.33223 130.728905"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_168",
        fill: "#568CFF",
        points: "70.9876543 70.9876543 109.697608 130.487996 107.854659 131.652387"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_169",
        fill: "#558CFF",
        points: "70.9876543 70.9876543 108.224052 131.419509 106.357012 132.539732"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_170",
        fill: "#548BFF",
        points: "70.9876543 70.9876543 106.73042 132.314885 104.835275 133.386927"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_171",
        fill: "#538AFF",
        points: "70.9876543 70.9876543 105.212698 133.174124 103.293461 134.197985"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_172",
        fill: "#528AFF",
        points: "70.9876543 70.9876543 103.678915 133.993213 101.731572 134.972907"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_173",
        fill: "#5189FF",
        points: "70.9876543 70.9876543 102.121041 134.78018 100.153623 135.707677"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_174",
        fill: "#5088FF",
        points: "70.9876543 70.9876543 100.547106 135.522981 98.5555975 136.406311"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_175",
        fill: "#4F88FF",
        points: "70.9876543 70.9876543 98.9530962 136.229645 96.9415116 137.060779"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_176",
        fill: "#4E87FF",
        points: "70.9876543 70.9876543 97.3430255 136.896158 95.3113653 137.67911"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_177",
        fill: "#4D86FF",
        points: "70.9876543 70.9876543 95.7209094 137.52252 93.6691735 138.25729"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_178",
        fill: "#4C86FF",
        points: "70.9876543 70.9876543 94.0787177 138.10873 92.0109212 138.791304"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_179",
        fill: "#4B85FF",
        points: "70.9876543 70.9876543 92.4244805 138.654789 90.3406234 139.289181"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_180",
        fill: "#4A84FF",
        points: "70.9876543 70.9876543 90.7581979 139.160696 88.6582803 139.742891"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_181",
        fill: "#4984FF",
        points: "70.9876543 70.9876543 89.0798698 139.626452 86.9638917 140.156451"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_182",
        fill: "#4883FF",
        points: "70.9876543 70.9876543 87.3894964 140.052057 85.265488 140.525844"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_183",
        fill: "#4782FF",
        points: "70.9876543 70.9876543 85.6870775 140.42948 83.5510237 140.855085"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_184",
        fill: "#4681FF",
        points: "70.9876543 70.9876543 83.9806435 140.770767 81.8365594 141.144175"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_185",
        fill: "#4581FF",
        points: "70.9876543 70.9876543 82.2621641 141.067887 80.1100497 141.389098"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_186",
        fill: "#4480FF",
        points: "70.9876543 70.9876543 80.5396696 141.324856 78.3795249 141.589855"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_187",
        fill: "#437FFF",
        points: "70.9876543 70.9876543 78.8091447 141.537659 76.6449849 141.750461"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_188",
        fill: "#427FFF",
        points: "70.9876543 70.9876543 77.0786199 141.710309 74.9064298 141.870915"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_189",
        fill: "#417EFF",
        points: "70.9876543 70.9876543 75.3400648 141.838794 73.1638596 141.943188"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_190",
        fill: "#407DFF",
        points: "70.9876543 70.9876543 73.6015097 141.923112 71.4212893 141.975309"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_191",
        fill: "#3F7DFF",
        points: "70.9876543 70.9876543 71.8589394 141.963263 69.6787191 141.963263"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_192",
        fill: "#3E7CFF",
        points: "70.9876543 70.9876543 70.1163692 141.963263 67.940164 141.911066"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_193",
        fill: "#3D7BFF",
        points: "70.9876543 70.9876543 68.3737989 141.923112 66.1975937 141.814703"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_194",
        fill: "#3C7BFF",
        points: "70.9876543 70.9876543 66.6352438 141.838794 64.4630537 141.678188"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_195",
        fill: "#3B7AFF",
        points: "70.9876543 70.9876543 64.8966887 141.710309 62.7285138 141.497507"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_196",
        fill: "#3A79FF",
        points: "70.9876543 70.9876543 63.1621488 141.537659 61.0020041 141.272659"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_197",
        fill: "#3979FF",
        points: "70.9876543 70.9876543 61.4356391 141.324856 59.2795095 141.003645"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_198",
        fill: "#3878FF",
        points: "70.9876543 70.9876543 59.7091294 141.067887 57.5650452 140.698494"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_199",
        fill: "#3777FF",
        points: "70.9876543 70.9876543 57.9946651 140.770767 55.8586113 140.345162"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_200",
        fill: "#3677FF",
        points: "70.9876543 70.9876543 56.2882311 140.42948 54.1602075 139.955694"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_201",
        fill: "#3576FF",
        points: "70.9876543 70.9876543 54.5858122 140.052057 52.4738492 139.522059"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_202",
        fill: "#3475FF",
        points: "70.9876543 70.9876543 52.8954388 139.626452 50.7955212 139.048272"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_203",
        fill: "#3375FF",
        points: "70.9876543 70.9876543 51.2171108 139.160696 49.1332537 138.53032"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_204",
        fill: "#3274FF",
        points: "70.9876543 70.9876543 49.5508282 138.654789 47.4830317 137.972215"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_205",
        fill: "#3173FF",
        points: "70.9876543 70.9876543 47.896591 138.10873 45.844855 137.377975"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_206",
        fill: "#3073FF",
        points: "70.9876543 70.9876543 46.2543992 137.52252 44.222739 136.739568"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_207",
        fill: "#2F72FF",
        points: "70.9876543 70.9876543 44.628268 136.896158 42.6166834 136.061009"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_208",
        fill: "#2E71FF",
        points: "70.9876543 70.9876543 43.0181973 136.229645 41.0307036 135.346314"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_209",
        fill: "#2D71FF",
        points: "70.9876543 70.9876543 41.4282023 135.522981 39.4607843 134.591468"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_210",
        fill: "#2C70FF",
        points: "70.9876543 70.9876543 39.8542679 134.78018 37.9069256 133.800486"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_211",
        fill: "#2B6FFF",
        points: "70.9876543 70.9876543 38.2963941 133.993213 36.3771577 132.969352"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_212",
        fill: "#2A6EFF",
        points: "70.9876543 70.9876543 36.762611 133.174124 34.8634504 132.102082"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_213",
        fill: "#296EFF",
        points: "70.9876543 70.9876543 35.2448886 132.314885 33.377849 131.194661"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_214",
        fill: "#286DFF",
        points: "70.9876543 70.9876543 33.7512569 131.419509 31.9083082 130.255118"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_215",
        fill: "#276CFF",
        points: "70.9876543 70.9876543 32.277701 130.487996 30.4668734 129.275425"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_216",
        fill: "#266CFF",
        points: "70.9876543 70.9876543 30.8282359 129.520348 29.0495294 128.267625"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_217",
        fill: "#256BFF",
        points: "70.9876543 70.9876543 29.4068767 128.516563 27.6562762 127.219673"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_218",
        fill: "#246AFF",
        points: "70.9876543 70.9876543 28.0055933 127.480658 26.2871138 126.139601"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_219",
        fill: "#236AFF",
        points: "70.9876543 70.9876543 26.6324158 126.408615 24.9500726 125.027408"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_220",
        fill: "#2269FF",
        points: "70.9876543 70.9876543 25.2873443 125.300437 23.6371222 123.879078"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_221",
        fill: "#2168FF",
        points: "70.9876543 70.9876543 23.9663636 124.164153 22.3522778 122.702642"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_222",
        fill: "#2068FF",
        points: "70.9876543 70.9876543 22.6775041 122.995747 21.0995545 121.494086"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_223",
        fill: "#1F67FF",
        points: "70.9876543 70.9876543 21.4167505 121.791206 19.8749372 120.253408"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_224",
        fill: "#1E66FF",
        points: "70.9876543 70.9876543 20.1800877 120.558558 18.6824409 118.984624"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_225",
        fill: "#1D66FF",
        points: "70.9876543 70.9876543 18.9795612 119.297805 17.5180507 117.683719"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_226",
        fill: "#1C65FF",
        points: "70.9876543 70.9876543 17.8111558 118.008945 16.3897967 116.358723"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_227",
        fill: "#1B64FF",
        points: "70.9876543 70.9876543 16.6748715 116.687964 15.2936638 115.005621"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_228",
        fill: "#1A64FF",
        points: "70.9876543 70.9876543 15.5666932 115.342893 14.229652 113.624413"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_229",
        fill: "#1963FF",
        points: "70.9876543 70.9876543 14.4946511 113.969715 13.1977613 112.219115"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_230",
        fill: "#1862FF",
        points: "70.9876543 70.9876543 13.4587453 112.568432 12.206022 110.789725"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_231",
        fill: "#1762FF",
        points: "70.9876543 70.9876543 12.4549606 111.147073 11.2464038 109.33223"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_232",
        fill: "#1661FF",
        points: "70.9876543 70.9876543 11.4873122 109.697608 10.3229219 107.854659"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_233",
        fill: "#1560FF",
        points: "70.9876543 70.9876543 10.5558 108.224052 9.43557622 106.357012"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_234",
        fill: "#1460FF",
        points: "70.9876543 70.9876543 9.660424 106.73042 8.58838193 104.835275"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_235",
        fill: "#135FFF",
        points: "70.9876543 70.9876543 8.80118429 105.212698 7.77330875 103.293461"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_236",
        fill: "#125EFF",
        points: "70.9876543 70.9876543 7.97808083 103.678915 7.0024021 101.731572"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_237",
        fill: "#115EFF",
        points: "70.9876543 70.9876543 7.19512876 102.121041 6.2676317 100.153623"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_238",
        fill: "#105DFF",
        points: "70.9876543 70.9876543 6.45232808 100.547106 5.56899754 98.5555975"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_239",
        fill: "#0F5CFF",
        points: "70.9876543 70.9876543 5.74566365 98.9530962 4.91051478 96.9415116"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_240",
        fill: "#0E5BFF",
        points: "70.9876543 70.9876543 5.07915061 97.3430255 4.29619854 95.3113653"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_241",
        fill: "#0D5BFF",
        points: "70.9876543 70.9876543 4.45278895 95.7209094 3.71801855 93.6691735"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_242",
        fill: "#0C5AFF",
        points: "70.9876543 70.9876543 3.86256354 94.0787177 3.18400508 92.0109212"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_243",
        fill: "#0B59FF",
        points: "70.9876543 70.9876543 3.31650466 92.4244805 2.68612787 90.3406234"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_244",
        fill: "#0A59FF",
        points: "70.9876543 70.9876543 2.81059717 90.7581979 2.23241718 88.6582803"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_245",
        fill: "#0958FF",
        points: "70.9876543 70.9876543 2.34885621 89.0798698 1.81885789 86.9638917"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_246",
        fill: "#0857FF",
        points: "70.9876543 70.9876543 1.92325149 87.3894964 1.44946511 85.265488"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_247",
        fill: "#0757FF",
        points: "70.9876543 70.9876543 1.54181331 85.6870775 1.12022373 83.5510237"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_248",
        fill: "#0656FF",
        points: "70.9876543 70.9876543 1.20454165 83.9806435 0.831133736 81.8365594"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_249",
        fill: "#0555FF",
        points: "70.9876543 70.9876543 0.907421373 82.2621641 0.586210268 80.1100497"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_250",
        fill: "#0455FF",
        points: "70.9876543 70.9876543 0.650452489 80.5396696 0.385453327 78.3795249"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_251",
        fill: "#0354FF",
        points: "70.9876543 70.9876543 0.437650131 78.8091447 0.224847774 76.6449849"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_252",
        fill: "#0253FF",
        points: "70.9876543 70.9876543 0.264999162 77.0786199 0.104393609 74.9064298"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_253",
        fill: "#0153FF",
        points: "70.9876543 70.9876543 0.13651472 75.3400648 0.0321211106 73.1638596"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_254",
        fill: "#0052FF",
        points: "70.9876543 70.9876543 0.0521968046 73.6015097 0 71.4212893"
      }
    ), /* @__PURE__ */ React2.createElement(
      "polygon",
      {
        id: "_255",
        fill: "#FFFFFF",
        points: "70.9876543 70.9876543 0.00803027764 71.8589394 0.00803027764 70.1163692"
      }
    )))))
  );
}

// src/icons/IconBlast.tsx
import React3 from "react";
function IconBlast(props) {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      ...props,
      viewBox: "0 0 215 215",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    },
    /* @__PURE__ */ React3.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React3.createElement(
      "image",
      {
        id: "Bitmap",
        x: "0",
        y: "0",
        width: "215",
        height: "215",
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANcAAADXCAYAAACJfcS1AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA16ADAAQAAAABAAAA1wAAAACoOJduAAASvklEQVR4Ae2de6wcVR3Hd/bey7MFaVEwKhDUIiAQVAwKiiQ+EChPi+g/gAY1MWKMiYkJAv5h4otnsSbiH2hMxPIuAiIQpNGkgNqWFoNgSIu8H4XSEgi9u+PnbHftbe/uvbMz5zdzzux3E5jb3Znz+PzOd853zsw502joIwIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiUD2BpPoiDFeCNG0cODnZXJYkyaHDHam9R4EA7WPF+HhrUZI0nqq6vs2qCzBM/pOTY4tareYaCWsYaqO1L6I6mjaydnKycWLVNY9CXJyNdqG3ugZYSxuNZLeqoSn/0AkkezYaY7fTZpbQdnauqrTB28KuDbyD3uqgqiAp33gJpGn6yPh4+wx6tMfKrkXQPdcUGyhhld0yapKfu4TAJq6iLZ1fdpWC7LmcDQTIEizgeWUDUX61JnDL2FjrHHqx18qoZXDiQlgLuqOB6q3KaAEjl0f637Gx9mkI7J/WVQ/KFtJ1n0uPtVLXV9ZhH+X0k/fQxh7gv+9zIjftXEwTzxpCKrkzlf0tNvCsrMdoPxHwQOA+bOLZ9GIveEhrWhKVi0s2cFpM9EWpBNKX0rT95YmJxt2+s63UFmIDv0qPtUo20HdYlV52AsneSdK8a8uW5qWc6CeyHzf7npX0XFRiV0R1rWzg7AHSHuUR4J7Yau6JnYpNXO8j19LFhbAOQVjLENZ7fVRAaYiAXwLpZtrmV3g+8fqi6ZZqC1utsa8hrH9IWEXDpuPtCCRzSHspt4OupSMo9KhdKT0XhZyLqH4tG2jXJJSyfwLYxMexiSdgE5/Ik/p4noOGOUY2cBha2jckAgy0vZ/yjOUtk6ktpLf6hmxg3tDouKoJ0HOtpdd6PG85THoueqvdub76HdvT8hZMx4lAAARuLFIG7+JCUIfTW91KoQ4oUjAdKwJVE+B664YiZfBqCxHVN/nvQQYuDihSKB0rAlUTwBI+hiVcW6QcXnou2cAiIdCxgRIo1Gu5OhUWl2xgoE1DxSpEAEtY6HrLZV7IFmIBL+C/h2QDC8VRBwdHIF2PJSw83yt3z0WPtefkZPthuHwuODYqUI0JNJnomHzbsoK07aU+0i/lCQ0fBVUaIuAIMJPij2xOsqTBHK+P0XOtKJqHxFWUoI4vjQA9yhwuQ17mMmQnu0zT57jeeqeP9HPbQh+ZKw0RGIYADyYsZH9DYTUaviyhq1ehAY1hwFS5L2e771SZv/L2RuBMbykNSKjojeOpydbeFnIm2pcz3rPcFFwDOLc45H+mAtDfcRAgjm65vQ1Ywl3tSpxuoI3M95V+7XuudrvZOdsxwnQYwWFxyIb52c9XcJTONgKtllv73VJYnbz+sC3H4n/VXlxpmpyxDVOyOzMIbmAi3C85E+687Xv9FT6BrSdJy3KyUE3hG8dTy1drW4iA3CTNVzjjTZuT07WJp2AT100For/DI0AcJ4ijGyWca1e6dAOLhb6d9tD2lUetey6utbCA04Xl4HVt4sOyib6akl06WMLP2AqrU/abfQrLpVhrcVG/0zvYBv7PnQk7NtG9asZ0iHdgEfRDBgKlWMLCD+ruWJHa2kLE4kaXNnLGyyQabOLK7mjiuh0h6d/VESCOTeL4InGcZ1eKdBOW8G3quTISxkqcnFVYLkls4pEEUTYxI9+ydsO2f8pWWJ2aeLeELtUa28LmlFHCDsAM//u/TbxaNjEDrhJ2YTXcEm6d+B0l7GGppS1EGG506SXOeHv0KjrsVjZxWGI2+3Pb5FniuK9N6i7V9A0s4Z5Ywi2+86hlz4Ul/HQRYTnIU2ziQt/QlV42Apwkj7EVVqcct1oIy6VcS3FRrVlGCbMFl8C60cRlnD0XyyZmZeZvP7jnsPbD5l9sEZqZcqulLSQozhLOn6niw/4mmzgsseL7E8d1xHH/4ikNSqFjCefRc705aI8i39eu56KH+YRvYTnAsolFmtnwxxLHD9sKqxPVO6yE5VKvnbg423myhP0aRM8mjp3b71d9548AcSxhlLBxo78ST0+pdpMlOROdPb2afr9J09YzflNUan0IGIsrfYtRwpv75Ovtq1r1XFiJD2ElvEzRHkw43TQ+3rhn8O/6pSgB4ngoNnxB0XRmPj65y9ISurxrJS6sRAmjS41bCIq3J6dnbgCj+Stz8EqIY+s31nRrJS5gGV5v9ULRvqn3l7Y2BNrtxhdsUk45KabXsbrTB3Afptdbrvy1GYrHSixgism/bYLSS9Xubn4vh1HfEsf9iON6vxxItdG4nmusH+I6/uU37cGp1WZAoxwrkdxOcLw/JjM4PKP3C3H0OCDlRJXciKguLlNUvajVSFyJW3zG+mNuCWkOh7Dw5RLrioSaPjfrD/FUNieqS2gThd5UUqQstRAXDZIVnhpHFQEx+7GdodvbZt+v2B4MypxFgziuWCoxH13kDNnpqW7hmsr1VGuqplALcWElFtmDTO4mYJvt89HqVDkZ30pP9YMQRNUrfy3ExQpPJYwSNsqwhFzMJx/sBUfbTARu6/ZUKzPtXeJO0YsLIzCv1Uo/aTvwmbY4K5rezXcxpwf+Uomxjz2r2xGV66mCE1UPbPTiYtjWvdR82tJpvQr62SbLCeIrftIanEq7nZxJPvrMTOCObk/195l3q/7X6MUFQnNLmCSp+Q1HeuB97Adlqm9wBUrwp25PFbyoenWMWlw0SFZ4Sj9rawl5RqxpN6GuFwgs4Rd7f2u7HYE/d3uqwu/L2i7VEv4RtbiwhKfAKNPSaXlZIuAVWLXn8x6f9ThZwmmk7un2VNGJqleTqMXFc2I84Gl7kdJspmWMEu5FD+wmefbiMsrbexHVhZzQohVVL3jRiosehRWeGq7nMv1gCb2++aJfYemB3YOqo66s+xDVRYjqr/0YxfhdtOJCWO5ay/BdTe4tg+lqgv1kCYE1H5QpoQ45s0jf4O0iJ05MNP6SM4FgD4t4yonldP6t8Wo2S7lxPAcZc6IY1U+ya5KMXYQTmV83AhGLq+Hub5l+sITm11tb79P1fxOLaeXCSvx4FnF9BIGxTmF9PlGKiyDwYKvfpdOmhzRdjyUs44nqEmbdTq9deN8k3OdrLt+ypXkJ8Y2yXe7INMpKlDGdnwD/fkdYvv9NHrtgCU/ynW686SVN1s64mCk398PmHfHWY2vJoxQXPYr5U/C8TqgES9hAWNlecRR7Qxum/MT3WGcTt2xxL72L9xOduDijfYQGab3C03ME+CH7sJaxEIt9LWxySPbmDSd3YRN/QsyjHNWOTlwlWULze1s0mAka5UKbhlmXVDGJSfI9bOIKeL07tlpFd+OSM9mjAD/IEjQ3M4+j51pumQeNZTde7PZRyzxCTpteaRkOZG72MqavMinnHFZt4rg4PlGJiwZ5MEPXxqv3pBu43qrdPZeQmiNxPIo4PpivTOli5tZ9l5Nf8AsFRWULeXK8jCcZzKeX5GtU9TkKa39m/tok3+L4hxDo/vnTKOfIyMSVmN8T4lEcicu47dHrFFo+jcuCIxhNXIutPtW4qIWSj8YWcqZihacxXuFp+bF5q7tliWNLmzgeThxX+yt3eg028QIEa/KOrSLljKbnKmkyoXuFp9aBL9KiZjkWS+dmAHj8JOeT5ipEu8Bjol6SikhcZazwZH/j2EvU4k6kwPVW/4q70WNs4kqG7M/rv0c130ZhCzkrscJT51WshuW1fYVnNeENK1fiiAjGHrUsFeudXIhN/JFlHlnTjuLONwFxo4SGwnK4EtNXeGYNSJ33w9qbP7bGGpZPh8IwFltoPkpIQMyfJQwl6FWVg1cDebeE29fFrS/ZumH776r7l3FvULxiWAlWeGpupGfZqXhqg1LorAM/n8GMzYP20PfFCBBHg1cDTSvT3ePjrWAmngZvC7GEblKkobBcgJJ7JaxpDdXrF2WM9paxvuQwUGKwhWVYQt04HqbV5NiXpeM8D8HvWIg0Zeb40h2/rfLfQdtCrAQrPHUsoeFCNGnK6JKzhObLVVcZ6CrzJo7MMh57zrIM5LF8YqIV1KuXgu65WOHpBCybobBcuJP7JSzLZt95wUShx52ylI71JYNzH0GLi4WkzR/UxadrlDBL6y2wj70l7Cw5bj4Hb1gEwdpCuvkmlvAFehbT6R8M3e5Lz/X8sOC0fzYCWy1hk2dCoWz0IY8HsIRHGyWfO9lgey6eeDZf4ckFRcLK3XYyHcgoIQNSdsJyhQjREnbKlYlQBTsxU9V8lLCMdeArQBdUljwxYXzjOExL6IJg1lUXjTBPOj9D8UwXosES7s859cmiZdXx/QngDHjBRPNF4mj2ckKWHF81MdE+sn8Jqv02SFtIUFhbwlZYBOVhCcu28TH87iyhmbBc6VlyPLhRwh7VIMVFr1WCJdSzhL1GYLgtwxIGK64gbSHiWscZz3SNBCzh4fRcawwb1kgnjfuYgyVkxSa7ngv38RiW0HQlsCJBDK7nIiiHWguLJaTXS1hFms3sx26dJmQnrG4Jrp+9JNXtEZy4GLo1v3GMgK+rDvnI5GxuCVkCL1hL6KIcoLga5tdbZawDPzIS6lNRTl7uBROf7/OTx6867mOlxwS9JxWUuAjKfqyHYDysmrp14HMuSOmdfy0TxBKy5Jnl/DukmzaCtoQusEGJC0tobiWoc/BBqYHizOMYuiUMUFz2KzwxvSRonx67sOhReMFEerJtPTruY4VtHsVTD6bnIijzeEL92OJVmimFdAOW8P6Z9tBvxQgwTQhhWU8TisN9BDPNH5/urIT1fTdNLymmnQxH21v7WNxHMOIiauZD8Gh3vnvnboYWol1yEOBRpDdxIKfkOHSIQ+JxH9Y9RSZoBGQud/OZZm9+0zFTebRTbgJ/48hjch+d6cD0VwxmfD3TrhXvFMQ1F5ZwoYRVcUvwkn170ksyMyQS01toghAXLM1vHM8QL/3khUD6FifIw7wkNTCRdBNvlrxn4M+B/VC5uLpDtycGxkXFGZIAkyJ5WiKZN+Rhw+5+E6O90byFpnJxMXSLsMyHbocNovYfkkCStN8Y8pAcu8f1FprKxcVDIiWMEuaIow4ZgkDa4gR5xBAH5NjVvYWmcWeOAys7pFJxYQld/hJXZeH3lXHHEu7lK7UB6SzDEgb/kvGpZa9UXKzwdDxnvD2mFkh/x0eAEbxN9qVOontsrdKbyGWs8GQf9FHPgaEM3uxoRyF1N6aXcG/rNrs8bFKu9CZyGSs82WBTqj0CTLVfjbgMrrfS17ui+jF2cEMvv5i2lfVcgDu61bJd4SmmQMRaVh62puH7PEenm2kbv6Cn+mmsourFsjJxuRWegKdP9ASS9/mpQroJUV3dFRUL28T/qax5l7HCU/zhCbsGWMJHsIQsKFTk0xHVYkT1M062tRBVj0YlPRdnqMOwhKZLp/UqqK0dASyhe1FGTnGlr9EOrkJUl9ZNVD3ilYirjBWeehXU1pJAnhNkuhFRXYmoLkNUGy1LV3XaFYmroeutqiNfMH+3ICeWcEH2ZNJXEdMVvFr1irqLqsekdHFx1uKt7hZDt70qaVsGASzh01jCDOJKX+mK6nK2JdxsLqP22fIoXVxYwkXZiqa9QiaAUN7FiXKGT2fG8OX0VFeOmqh6UCoQV3I6sPWJmAC91hNp2hzQa6UvE9/LuqJ6PeJqFi56qeLiTDev1Uo/7vemY2EGSmBIAlxvPUkMD9z+sPQlRHUpolrMdqRF1eNSqri2WkL1Wz34sW45Se6zLYrpi11RXcW2hDld8VArVVw84qnp/PG0jb4lxRI+xRy8g1n48wXE9HN6qqslqr6ovD4U1j+H7rec7bTC04yEYvmxfSdD8PciqiUSVSwxUzlFQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREQAREYJQJ/A92DAbm0u9HWgAAAABJRU5ErkJggg=="
      }
    ))
  );
}

// src/icons/IconBSC.tsx
import React4 from "react";
function IconBSC(props) {
  return /* @__PURE__ */ React4.createElement(
    "svg",
    {
      version: "1.1",
      viewBox: "0 0 58.0 58.0",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React4.createElement("defs", null, /* @__PURE__ */ React4.createElement("clipPath", { id: "i0" }, /* @__PURE__ */ React4.createElement("path", { d: "M28.8662791,0 C44.8086848,0 57.7325581,12.9244128 57.7325581,28.8674839 C57.7325581,44.8105551 44.8086848,57.7349679 28.8662791,57.7349679 C12.9238734,57.7349679 0,44.8105551 0,28.8674839 C0,12.9244128 12.9238734,0 28.8662791,0 Z" })), /* @__PURE__ */ React4.createElement("clipPath", { id: "i1" }, /* @__PURE__ */ React4.createElement("path", { d: "M20.21419,0 L24.7710768,4.55108087 L12.3855384,16.9371363 L0.0059959037,4.55707702 L4.55888545,0.00399743598 L12.3855384,7.82897837 L20.21419,0 Z" })), /* @__PURE__ */ React4.createElement("clipPath", { id: "i2" }, /* @__PURE__ */ React4.createElement("path", { d: "M12.3795425,0 L24.7610837,12.3840567 L20.2081941,16.9371363 L12.3795425,9.10815789 L4.55288955,16.9331388 L0,12.3800592 L12.3795425,0 Z" })), /* @__PURE__ */ React4.createElement("clipPath", { id: "i3" }, /* @__PURE__ */ React4.createElement("path", { d: "M6.43980761,0 L6.43967322,6.43967322 L0,6.43980761 L0.000134392956,0.000134392956 L6.43980761,0 Z" })), /* @__PURE__ */ React4.createElement("clipPath", { id: "i4" }, /* @__PURE__ */ React4.createElement("path", { d: "M6.43980761,0 L6.43967322,6.43962589 L0,6.43976028 L0.000134391969,0.000134392956 L6.43980761,0 Z" })), /* @__PURE__ */ React4.createElement("clipPath", { id: "i5" }, /* @__PURE__ */ React4.createElement("path", { d: "M4.62084312,0 L9.24168624,4.621036 L4.62284176,9.24407071 L0.0059959037,4.62703215 L0.0059959037,4.61503984 L4.62084312,0 Z" }))),
    /* @__PURE__ */ React4.createElement("g", { transform: "translate(0.10465116279101494 0.07413893753709999)" }, /* @__PURE__ */ React4.createElement("g", { clipPath: "url(#i0)" }, /* @__PURE__ */ React4.createElement(
      "polygon",
      {
        points: "0,0 57.7325581,0 57.7325581,57.7349679 0,57.7349679 0,0",
        stroke: "none",
        fill: "#050911"
      }
    )), /* @__PURE__ */ React4.createElement("g", { transform: "translate(8.71758710950905 8.718407877430764)" }, /* @__PURE__ */ React4.createElement("g", { transform: "translate(7.763153540584426 0.0)" }, /* @__PURE__ */ React4.createElement("g", { transform: "translate(0.0 23.36101588065313)" }, /* @__PURE__ */ React4.createElement("g", { clipPath: "url(#i1)" }, /* @__PURE__ */ React4.createElement(
      "polygon",
      {
        points: "0,0 24.7710768,0 24.7710768,16.9371363 0,16.9371363 0,0",
        stroke: "none",
        fill: "#ECA300"
      }
    ))), /* @__PURE__ */ React4.createElement("g", { transform: "translate(0.005995903704853589 0.0)" }, /* @__PURE__ */ React4.createElement("g", { clipPath: "url(#i2)" }, /* @__PURE__ */ React4.createElement(
      "polygon",
      {
        points: "0,0 24.7610837,0 24.7610837,16.9371363 0,16.9371363 0,0",
        stroke: "none",
        fill: "#ECA300"
      }
    )))), /* @__PURE__ */ React4.createElement("g", { transform: "translate(0.0 15.526041355314188)" }, /* @__PURE__ */ React4.createElement("g", { transform: "translate(31.189697151016702 4.625826522838987) rotate(-44.99999999999999)" }, /* @__PURE__ */ React4.createElement("g", { clipPath: "url(#i3)" }, /* @__PURE__ */ React4.createElement(
      "polygon",
      {
        points: "-1.13686838e-13,0 6.43980761,0 6.43980761,6.43980761 -1.13686838e-13,6.43980761 -1.13686838e-13,0",
        stroke: "none",
        fill: "#ECA300"
      }
    ))), /* @__PURE__ */ React4.createElement("g", { transform: "translate(-2.717825964282383e-13 4.623387086831677) rotate(-44.99999999999999)" }, /* @__PURE__ */ React4.createElement("g", { clipPath: "url(#i4)" }, /* @__PURE__ */ React4.createElement(
      "polygon",
      {
        points: "-3.41060513e-13,0 6.43980761,0 6.43980761,6.43976028 -3.41060513e-13,6.43976028 -3.41060513e-13,0",
        stroke: "none",
        fill: "#ECA300"
      }
    ))), /* @__PURE__ */ React4.createElement("g", { transform: "translate(15.52784883837921 0.0)" }, /* @__PURE__ */ React4.createElement("g", { clipPath: "url(#i5)" }, /* @__PURE__ */ React4.createElement(
      "polygon",
      {
        points: "0,0 9.24568351,0 9.24568351,9.24407071 0,9.24407071 0,0",
        stroke: "none",
        fill: "#ECA300"
      }
    ))))))
  );
}

// src/icons/IconEthereum.tsx
import React5 from "react";
function IconEthereum(props) {
  return /* @__PURE__ */ React5.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React5.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React5.createElement("circle", { cx: "16", cy: "16", r: "16", fill: "#627EEA" }), /* @__PURE__ */ React5.createElement("g", { fill: "#FFF", fillRule: "nonzero" }, /* @__PURE__ */ React5.createElement("path", { fillOpacity: ".602", d: "M16.498 4v8.87l7.497 3.35z" }), /* @__PURE__ */ React5.createElement("path", { d: "M16.498 4L9 16.22l7.498-3.35z" }), /* @__PURE__ */ React5.createElement("path", { fillOpacity: ".602", d: "M16.498 21.968v6.027L24 17.616z" }), /* @__PURE__ */ React5.createElement("path", { d: "M16.498 27.995v-6.028L9 17.616z" }), /* @__PURE__ */ React5.createElement("path", { fillOpacity: ".2", d: "M16.498 20.573l7.497-4.353-7.497-3.348z" }), /* @__PURE__ */ React5.createElement("path", { fillOpacity: ".602", d: "M9 16.22l7.498 4.353v-7.701z" }))));
}

// src/icons/IconOptimism.tsx
import React6 from "react";
function IconOptimism(props) {
  return /* @__PURE__ */ React6.createElement("svg", { viewBox: "0 0 500 500", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React6.createElement("circle", { cx: "250", cy: "250", r: "250", fill: "#FF0420" }), /* @__PURE__ */ React6.createElement(
    "path",
    {
      d: "M177.133 316.446C162.247 316.446 150.051 312.943 140.544 305.938C131.162 298.808 126.471 288.676 126.471 275.541C126.471 272.789 126.784 269.411 127.409 265.408C129.036 256.402 131.35 245.581 134.352 232.947C142.858 198.547 164.812 181.347 200.213 181.347C209.845 181.347 218.476 182.973 226.107 186.225C233.738 189.352 239.742 194.106 244.12 200.486C248.498 206.74 250.688 214.246 250.688 223.002C250.688 225.629 250.375 228.944 249.749 232.947C247.873 244.08 245.621 254.901 242.994 265.408C238.616 282.546 231.048 295.368 220.29 303.874C209.532 312.255 195.147 316.446 177.133 316.446ZM179.76 289.426C186.766 289.426 192.707 287.362 197.586 283.234C202.59 279.106 206.155 272.789 208.281 264.283C211.158 252.524 213.348 242.266 214.849 233.51C215.349 230.883 215.599 228.194 215.599 225.441C215.599 214.058 209.657 208.366 197.774 208.366C190.768 208.366 184.764 210.43 179.76 214.558C174.882 218.687 171.379 225.004 169.253 233.51C167.001 241.891 164.749 252.149 162.498 264.283C161.997 266.784 161.747 269.411 161.747 272.163C161.747 283.672 167.752 289.426 179.76 289.426Z",
      fill: "white"
    }
  ), /* @__PURE__ */ React6.createElement(
    "path",
    {
      d: "M259.303 314.57C257.927 314.57 256.863 314.132 256.113 313.256C255.487 312.255 255.3 311.13 255.55 309.879L281.444 187.914C281.694 186.538 282.382 185.412 283.508 184.536C284.634 183.661 285.822 183.223 287.073 183.223H336.985C350.87 183.223 362.003 186.1 370.384 191.854C378.891 197.609 383.144 205.927 383.144 216.81C383.144 219.937 382.769 223.19 382.018 226.567C378.891 240.953 372.574 251.586 363.067 258.466C353.685 265.346 340.8 268.786 324.413 268.786H299.082L290.451 309.879C290.2 311.255 289.512 312.38 288.387 313.256C287.261 314.132 286.072 314.57 284.822 314.57H259.303ZM325.727 242.892C330.98 242.892 335.546 241.453 339.424 238.576C343.427 235.699 346.054 231.571 347.305 226.192C347.68 224.065 347.868 222.189 347.868 220.563C347.868 216.935 346.805 214.183 344.678 212.307C342.551 210.305 338.924 209.305 333.795 209.305H311.278L304.148 242.892H325.727Z",
      fill: "white"
    }
  ));
}

// src/icons/IconPolygon.tsx
import React7 from "react";
function IconPolygon(props) {
  return /* @__PURE__ */ React7.createElement(
    "svg",
    {
      id: "Layer_1",
      fill: "#8247e5",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 507.91 446.91",
      ...props
    },
    /* @__PURE__ */ React7.createElement(
      "path",
      {
        className: "cls-1",
        d: "M384.58,136.59c-9.28-5.3-21.22-5.3-31.83,0l-74.26,43.77L228.1,208.2,155.16,252c-9.28,5.3-21.22,5.3-31.83,0l-57-34.48a32.33,32.33,0,0,1-15.92-27.85V123.33c0-10.61,5.31-21.22,15.92-27.85l57-33.15c9.28-5.31,21.22-5.31,31.83,0l57,34.48a32.31,32.31,0,0,1,15.92,27.85v43.76l50.39-29.18V94.16c0-10.61-5.3-21.22-15.91-27.85L156.48,4c-9.28-5.31-21.21-5.31-31.82,0L15.91,67.63C5.3,72.94,0,83.55,0,94.16V218.81C0,229.42,5.3,240,15.91,246.66L123.33,309c9.28,5.31,21.22,5.31,31.83,0l72.94-42.44,50.39-29.17,72.94-42.44c9.28-5.3,21.22-5.3,31.83,0l57,33.16A32.32,32.32,0,0,1,456.19,256v66.3c0,10.61-5.3,21.22-15.91,27.85l-55.7,33.16c-9.28,5.3-21.22,5.3-31.83,0l-57-33.16a32.32,32.32,0,0,1-15.91-27.85V279.82L229.42,309v43.76c0,10.61,5.31,21.22,15.92,27.85l107.41,62.33c9.29,5.31,21.22,5.31,31.83,0L492,380.6a32.32,32.32,0,0,0,15.91-27.85v-126c0-10.61-5.3-21.22-15.91-27.85Z"
      }
    )
  );
}

// src/types/token.ts
import { isAddressEqual } from "viem";
var TokenInfo = class {
  address;
  name;
  symbol;
  decimals;
  logoURI;
  abi;
  constructor(props) {
    return Object.assign(this, props);
  }
  /**
   * Checks whether the object is equal to o
   * @param o - The other object
   */
  isEqual(o) {
    if (!this.address || !o.address)
      return false;
    return isAddressEqual(this.address, o.address);
  }
};

// src/chains.ts
var Chains = [
  {
    disabled: true,
    displayName: "Ethereum",
    queryName: "ethereum",
    chainId: mainnet.id,
    chain: mainnet,
    symbol: "ETH",
    apiUrl: import.meta.env.ETHEREUM_API_URL ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_API_URL ?? import.meta.env.VITE_ETHEREUM_API_URL,
    rpcUrl: import.meta.env.ETHEREUM_RPC_URL ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_RPC_URL ?? import.meta.env.VITE_ETHEREUM_RPC_URL,
    blockExplorer: "https://etherscan.io",
    logoPath: IconEthereum,
    wrappedTokenInfo: new TokenInfo({
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      name: "WETH",
      symbol: "WETH",
      abi: WETH_default,
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.ETHEREUM_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_ETHEREUM_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.ETHEREUM_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_ETHEREUM_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.ETHEREUM_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_ETHEREUM_BOND_TOKEN_SYMBOL
    },
    contracts: {
      core: {
        address: import.meta.env.ETHEREUM_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_CORE_ADDRESS ?? import.meta.env.VITE_ETHEREUM_CORE_ADDRESS,
        abi: Core_default
      },
      token: {
        address: import.meta.env.ETHEREUM_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_TOKEN_ADDRESS ?? import.meta.env.VITE_ETHEREUM_TOKEN_ADDRESS,
        abi: Token_default
      },
      badgeManager: {
        address: import.meta.env.ETHEREUM_BADGE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_BADGE_MGR_ADDRESS ?? import.meta.env.VITE_ETHEREUM_BADGE_MGR_ADDRESS,
        abi: BadgeManager_default
      },
      marketCore: {
        address: import.meta.env.ETHEREUM_MARKET_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_MARKET_CORE_ADDRESS ?? import.meta.env.VITE_ETHEREUM_MARKET_CORE_ADDRESS,
        abi: MarketCore_default
      },
      disputeManager: {
        address: import.meta.env.ETHEREUM_DISPUTE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_DISPUTE_MGR_ADDRESS ?? import.meta.env.VITE_ETHEREUM_DISPUTE_MGR_ADDRESS,
        abi: DisputeManager_default
      },
      mediatorManager: {
        address: import.meta.env.ETHEREUM_MEDIATOR_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_MEDIATOR_MGR_ADDRESS ?? import.meta.env.VITE_ETHEREUM_MEDIATOR_MGR_ADDRESS,
        abi: MediatorManager_default
      },
      energon: {
        address: import.meta.env.ETHEREUM_ENERGON_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_ENERGON_ADDRESS ?? import.meta.env.VITE_ETHEREUM_ENERGON_ADDRESS ?? "0x7787D10F8F277bC509fb79c68BFC508d69dd41dC",
        abi: Energon_default
      },
      nft: {
        address: import.meta.env.ETHEREUM_NFT_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_NFT_ADDRESS ?? import.meta.env.VITE_ETHEREUM_NFT_ADDRESS ?? "0x07b7cdd77e18ac2b0f0a0b529f2ea86200c9ebda",
        abi: NFT_default
      },
      assetRegistry: {
        address: import.meta.env.ETHEREUM_ASSET_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_ASSET_REG_ADDRESS ?? import.meta.env.VITE_ETHEREUM_ASSET_REG_ADDRESS,
        abi: AssetRegistry_default
      },
      minerRegistry: {
        address: import.meta.env.ETHEREUM_MINER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_MINER_REG_ADDRESS ?? import.meta.env.VITE_ETHEREUM_MINER_REG_ADDRESS ?? "",
        abi: MinerRegistry_default
      },
      providerRegistry: {
        address: import.meta.env.ETHEREUM_PROVIDER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_PROVIDER_REG_ADDRESS ?? import.meta.env.VITE_ETHEREUM_PROVIDER_REG_ADDRESS,
        abi: ProviderRegistry_default
      },
      router: {
        address: import.meta.env.ETHEREUM_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_ROUTER_ADDRESS ?? import.meta.env.VITE_ETHEREUM_ROUTER_ADDRESS,
        abi: Router_default
      },
      payRouter: {
        address: import.meta.env.ETHEREUM_PAY_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_PAY_ROUTER_ADDRESS ?? import.meta.env.VITE_ETHEREUM_PAY_ROUTER_ADDRESS,
        abi: PayRouter_default
      },
      marketManager: {
        address: import.meta.env.ETHEREUM_MARKET_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_MARKET_MGR_ADDRESS ?? import.meta.env.VITE_ETHEREUM_MARKET_MGR_ADDRESS,
        abi: MarketManager_default
      },
      bondCurveDistro: {
        address: import.meta.env.ETHEREUM_BOND_CURVE_DISTRO_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ETHEREUM_BOND_CURVE_DISTRO_ADDRESS ?? import.meta.env.VITE_ETHEREUM_BOND_CURVE_DISTRO_ADDRESS,
        abi: BondCurveDistro_default
      },
      uniswapV2Router: {
        address: "0xf164fC0Ec4E93095b804a4795bBe1e041497b92a",
        abi: Abi.UniswapV2Router
      },
      uniswapV2Router2: {
        address: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
        abi: Abi.UniswapV2Router2
      },
      uniswapV3Router: {
        address: "0xE592427A0AEce92De3Edee1F18E0157C05861564",
        abi: Abi.UniswapV3Router
      },
      uniswapV3Router02: {
        address: "0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45",
        abi: Abi.UniswapV3Router2
      },
      uniswapV3UniversalRouter: {
        address: "0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD",
        abi: Abi.UniswapV3RouterUniversal
      }
    }
  },
  {
    disabled: true,
    displayName: "Polygon",
    queryName: "polygon",
    chainId: polygon.id,
    chain: polygon,
    symbol: "MATIC",
    apiUrl: import.meta.env.POLYGON_API_URL ?? import.meta.env.NEXT_PUBLIC_POLYGON_API_URL ?? import.meta.env.VITE_POLYGON_API_URL,
    rpcUrl: import.meta.env.POLYGON_RPC_URL ?? import.meta.env.NEXT_PUBLIC_POLYGON_RPC_URL ?? import.meta.env.VITE_POLYGON_RPC_URL,
    blockExplorer: "https://polygonscan.com",
    logoPath: IconPolygon,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.POLYGON_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_POLYGON_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_POLYGON_WRAPPED_TOKEN_ADDRESS,
      name: "WMATIC",
      symbol: "WMATIC",
      abi: WETH_default,
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270/logo.png"
    }),
    bondToken: {
      address: import.meta.env.POLYGON_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_POLYGON_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_POLYGON_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.POLYGON_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_POLYGON_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_POLYGON_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.POLYGON_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_POLYGON_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_POLYGON_BOND_TOKEN_SYMBOL
    }
  },
  {
    disabled: true,
    displayName: "Optimism",
    queryName: "optimism",
    chainId: optimism.id,
    chain: optimism,
    symbol: "ETH",
    apiUrl: import.meta.env.OPTIMISM_API_URL ?? import.meta.env.NEXT_PUBLIC_OPTIMISM_API_URL ?? import.meta.env.VITE_OPTIMISM_API_URL,
    rpcUrl: import.meta.env.OPTIMISM_RPC_URL ?? import.meta.env.NEXT_PUBLIC_OPTIMISM_RPC_URL ?? import.meta.env.VITE_OPTIMISM_RPC_URL,
    blockExplorer: "https://optimistic.etherscan.io",
    logoPath: IconOptimism,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.OPTIMISM_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_OPTIMISM_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_OPTIMISM_WRAPPED_TOKEN_ADDRESS,
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.OPTIMISM_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_OPTIMISM_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_OPTIMISM_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.OPTIMISM_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_OPTIMISM_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_OPTIMISM_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.OPTIMISM_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_OPTIMISM_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_OPTIMISM_BOND_TOKEN_SYMBOL
    }
  },
  {
    disabled: true,
    displayName: "BNB Chain",
    altDisplayName: "BSC",
    queryName: "binance",
    chainId: bsc.id,
    chain: bsc,
    symbol: "BNB",
    apiUrl: import.meta.env.BINANCE_API_URL ?? import.meta.env.NEXT_PUBLIC_BINANCE_API_URL ?? import.meta.env.VITE_BINANCE_API_URL,
    rpcUrl: import.meta.env.BINANCE_RPC_URL ?? import.meta.env.NEXT_PUBLIC_BINANCE_RPC_URL ?? import.meta.env.VITE_BINANCE_RPC_URL,
    blockExplorer: "https://bscscan.com",
    logoPath: IconBSC,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.BINANCE_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BINANCE_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_BINANCE_WRAPPED_TOKEN_ADDRESS,
      name: "WBNB",
      symbol: "WBNB",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png"
    }),
    bondToken: {
      address: import.meta.env.BINANCE_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BINANCE_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_BINANCE_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.BINANCE_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_BINANCE_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_BINANCE_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.BINANCE_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_BINANCE_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_BINANCE_BOND_TOKEN_SYMBOL
    }
  },
  {
    displayName: "Base",
    altDisplayName: "Base",
    queryName: "base",
    chainId: base.id,
    chain: base,
    symbol: "ETH",
    apiUrl: import.meta.env.BASE_API_URL ?? import.meta.env.NEXT_PUBLIC_BASE_API_URL ?? import.meta.env.VITE_BASE_API_URL,
    rpcUrl: import.meta.env.BASE_RPC_URL ?? import.meta.env.NEXT_PUBLIC_BASE_RPC_URL ?? import.meta.env.VITE_BASE_RPC_URL,
    blockExplorer: "https://basescan.org/",
    logoPath: IconBase,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.BASE_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_BASE_WRAPPED_TOKEN_ADDRESS ?? "0x4200000000000000000000000000000000000006",
      name: "WETH",
      symbol: "ETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.BASE_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_BASE_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.BASE_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_BASE_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_BASE_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.BASE_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_BASE_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_BASE_BOND_TOKEN_SYMBOL
    },
    contracts: {
      core: {
        address: import.meta.env.BASE_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_CORE_ADDRESS ?? import.meta.env.VITE_BASE_CORE_ADDRESS ?? "0xe613759EE3fd3F8eE1240b3c7428f21c2f1c1996",
        abi: Core_default
      },
      token: {
        address: import.meta.env.BASE_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_TOKEN_ADDRESS ?? import.meta.env.VITE_BASE_TOKEN_ADDRESS ?? "0x60ea5245179F18E71771f6087Db737De56F03f16",
        abi: Token_default
      },
      badgeManager: {
        address: import.meta.env.BASE_BADGE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_BADGE_MGR_ADDRESS ?? import.meta.env.VITE_BASE_BADGE_MGR_ADDRESS ?? "0x43C4db101537078132dB28222af5079D91FEc914",
        abi: BadgeManager_default
      },
      marketCore: {
        address: import.meta.env.BASE_MARKET_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_MARKET_CORE_ADDRESS ?? import.meta.env.VITE_BASE_MARKET_CORE_ADDRESS ?? "0x7F21677753907Ce5f6E49C01FD03C16EA98737Ae",
        abi: MarketCore_default
      },
      disputeManager: {
        address: import.meta.env.BASE_DISPUTE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_DISPUTE_MGR_ADDRESS ?? import.meta.env.VITE_BASE_DISPUTE_MGR_ADDRESS ?? "0x52E1b685C3589CeB24196425aE9998e952479F79",
        abi: DisputeManager_default
      },
      mediatorManager: {
        address: import.meta.env.BASE_MEDIATOR_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_MEDIATOR_MGR_ADDRESS ?? import.meta.env.VITE_BASE_MEDIATOR_MGR_ADDRESS ?? "0x753489965A140c2bC6b551F8b9231c51479a7a77",
        abi: MediatorManager_default
      },
      energon: {
        address: import.meta.env.BASE_ENERGON_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_ENERGON_ADDRESS ?? import.meta.env.VITE_BASE_ENERGON_ADDRESS ?? "0x0000000000000000000000000000000000000000",
        abi: Energon_default
      },
      nft: {
        address: import.meta.env.BASE_NFT_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_NFT_ADDRESS ?? import.meta.env.VITE_BASE_NFT_ADDRESS ?? "0x0000000000000000000000000000000000000000",
        abi: NFT_default
      },
      assetRegistry: {
        address: import.meta.env.BASE_ASSET_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_ASSET_REG_ADDRESS ?? import.meta.env.VITE_BASE_ASSET_REG_ADDRESS ?? "0xed48ec3Dbbc198eeDEEf18db93928bEb13A8C722",
        abi: AssetRegistry_default
      },
      minerRegistry: {
        address: import.meta.env.BASE_MINER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_MINER_REG_ADDRESS ?? import.meta.env.VITE_BASE_MINER_REG_ADDRESS ?? "0x5Df5557a98d6F652505A1a52Aa76817bA56045eC",
        abi: MinerRegistry_default
      },
      providerRegistry: {
        address: import.meta.env.BASE_PROVIDER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_PROVIDER_REG_ADDRESS ?? import.meta.env.VITE_BASE_PROVIDER_REG_ADDRESS,
        abi: ProviderRegistry_default
      },
      router: {
        address: import.meta.env.BASE_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_ROUTER_ADDRESS ?? import.meta.env.VITE_BASE_ROUTER_ADDRESS,
        abi: Router_default
      },
      payRouter: {
        address: import.meta.env.BASE_PAY_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_PAY_ROUTER_ADDRESS ?? import.meta.env.VITE_BASE_PAY_ROUTER_ADDRESS,
        abi: PayRouter_default
      },
      marketManager: {
        address: import.meta.env.BASE_MARKET_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_MARKET_MGR_ADDRESS ?? import.meta.env.VITE_BASE_MARKET_MGR_ADDRESS,
        abi: MarketManager_default
      },
      bondCurveDistro: {
        address: import.meta.env.BASE_BOND_CURVE_DISTRO_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BASE_BOND_CURVE_DISTRO_ADDRESS ?? import.meta.env.VITE_BASE_BOND_CURVE_DISTRO_ADDRESS ?? "0x11b157C9C11c269B840372EF08d7F8b1EcEEA920",
        abi: BondCurveDistro_default
      }
    }
  },
  {
    disabled: true,
    displayName: "Blast",
    altDisplayName: "Blast",
    queryName: "blast",
    chainId: blast.id,
    chain: blast,
    symbol: "ETH",
    apiUrl: import.meta.env.BLAST_API_URL ?? import.meta.env.NEXT_PUBLIC_BLAST_API_URL ?? import.meta.env.VITE_BLAST_API_URL,
    rpcUrl: import.meta.env.BLAST_RPC_URL ?? import.meta.env.NEXT_PUBLIC_BLAST_RPC_URL ?? import.meta.env.VITE_BLAST_RPC_URL,
    blockExplorer: "https://blastscan.io/",
    logoPath: IconBlast,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.BLAST_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BLAST_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_BLAST_WRAPPED_TOKEN_ADDRESS ?? "0x4300000000000000000000000000000000000004",
      name: "WETH",
      symbol: "ETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.BLAST_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_BLAST_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_BLAST_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.BLAST_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_BLAST_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_BLAST_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.BLAST_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_BLAST_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_BLAST_BOND_TOKEN_SYMBOL
    }
  },
  {
    displayName: "Arbitrum One",
    queryName: "arbitrum",
    chainId: arbitrum.id,
    chain: arbitrum,
    symbol: "ETH",
    apiUrl: import.meta.env.ARBITRUM_API_URL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_API_URL ?? import.meta.env.VITE_ARBITRUM_API_URL,
    rpcUrl: import.meta.env.ARBITRUM_RPC_URL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_RPC_URL ?? import.meta.env.VITE_ARBITRUM_RPC_URL,
    blockExplorer: "https://arbiscan.io",
    logoPath: IconArbitrum,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.ARBITRUM_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_ARBITRUM_WRAPPED_TOKEN_ADDRESS ?? "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.ARBITRUM_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_ARBITRUM_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.ARBITRUM_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_ARBITRUM_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.ARBITRUM_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_ARBITRUM_BOND_TOKEN_SYMBOL
    },
    contracts: {
      core: {
        address: import.meta.env.ARBITRUM_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_CORE_ADDRESS ?? import.meta.env.VITE_ARBITRUM_CORE_ADDRESS ?? "0x3e50344B05e0f66351c21B5D3b9cAAF194cFC556",
        abi: Core_default
      },
      token: {
        address: import.meta.env.ARBITRUM_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_TOKEN_ADDRESS ?? import.meta.env.VITE_ARBITRUM_TOKEN_ADDRESS ?? "0x5e5e85370808363Ee3D59e8a778ee15cf8A1E15a",
        abi: Token_default
      },
      badgeManager: {
        address: import.meta.env.ARBITRUM_BADGE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_BADGE_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_BADGE_MGR_ADDRESS ?? "0x99eCb581130fD43B420C6e12fEeB3A267f6BA03f",
        abi: BadgeManager_default
      },
      marketCore: {
        address: import.meta.env.ARBITRUM_MARKET_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_MARKET_CORE_ADDRESS ?? import.meta.env.VITE_ARBITRUM_MARKET_CORE_ADDRESS ?? "0x640E94953cf32529705ce509748469C07300ca03",
        abi: MarketCore_default
      },
      disputeManager: {
        address: import.meta.env.ARBITRUM_DISPUTE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_DISPUTE_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_DISPUTE_MGR_ADDRESS ?? "0x1d045BFBC22e4c9Bf6c3955020CC7F93adfe3674",
        abi: DisputeManager_default
      },
      mediatorManager: {
        address: import.meta.env.ARBITRUM_MEDIATOR_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_MEDIATOR_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_MEDIATOR_MGR_ADDRESS ?? "0x1ebb49A430B5E0B60A885e54bCb27b3658afae55",
        abi: MediatorManager_default
      },
      energon: {
        address: import.meta.env.ARBITRUM_ENERGON_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_ENERGON_ADDRESS ?? import.meta.env.VITE_ARBITRUM_ENERGON_ADDRESS ?? "0x0000000000000000000000000000000000000000",
        abi: Energon_default
      },
      nft: {
        address: import.meta.env.ARBITRUM_NFT_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_NFT_ADDRESS ?? import.meta.env.VITE_ARBITRUM_NFT_ADDRESS ?? "0x0000000000000000000000000000000000000000",
        abi: NFT_default
      },
      assetRegistry: {
        address: import.meta.env.ARBITRUM_ASSET_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_ASSET_REG_ADDRESS ?? import.meta.env.VITE_ARBITRUM_ASSET_REG_ADDRESS ?? "0x1D1099f0616D8615375a11848442D9959404C8c1",
        abi: AssetRegistry_default
      },
      minerRegistry: {
        address: import.meta.env.ARBITRUM_MINER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_MINER_REG_ADDRESS ?? import.meta.env.VITE_ARBITRUM_MINER_REG_ADDRESS ?? "0x4fDEE423445866c9e626F5BAA116F8a080A21aC0",
        abi: MinerRegistry_default
      },
      providerRegistry: {
        address: import.meta.env.ARBITRUM_PROVIDER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_PROVIDER_REG_ADDRESS ?? import.meta.env.VITE_ARBITRUM_PROVIDER_REG_ADDRESS,
        abi: ProviderRegistry_default
      },
      router: {
        address: import.meta.env.ARBITRUM_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_ROUTER_ADDRESS ?? import.meta.env.VITE_ARBITRUM_ROUTER_ADDRESS,
        abi: Router_default
      },
      payRouter: {
        address: import.meta.env.ARBITRUM_PAY_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_PAY_ROUTER_ADDRESS ?? import.meta.env.VITE_ARBITRUM_PAY_ROUTER_ADDRESS,
        abi: PayRouter_default
      },
      marketManager: {
        address: import.meta.env.ARBITRUM_MARKET_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_MARKET_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_MARKET_MGR_ADDRESS,
        abi: MarketManager_default
      }
    }
  },
  {
    displayName: "Arbitrum Sepolia",
    queryName: "arbitrum-sepolia",
    testnet: true,
    disabled: true,
    chainId: arbitrumSepolia.id,
    chain: arbitrumSepolia,
    symbol: "ETH",
    apiUrl: import.meta.env.ARBITRUM_SEPOLIA_API_URL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_API_URL ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_API_URL,
    rpcUrl: import.meta.env.ARBITRUM_SEPOLIA_RPC_URL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_RPC_URL ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_RPC_URL,
    blockExplorer: "https://sepolia.arbiscan.io",
    logoPath: IconEthereum,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.ARBITRUM_SEPOLIA_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_WRAPPED_TOKEN_ADDRESS ?? "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.ARBITRUM_SEPOLIA_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.ARBITRUM_SEPOLIA_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.ARBITRUM_SEPOLIA_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_BOND_TOKEN_SYMBOL
    },
    contracts: {
      core: {
        address: import.meta.env.ARBITRUM_SEPOLIA_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_CORE_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_CORE_ADDRESS ?? "0xc79b36216F29C799aef1ea11F6E9bFEed097019D",
        abi: Core_default
      },
      token: {
        address: import.meta.env.ARBITRUM_SEPOLIA_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_TOKEN_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_TOKEN_ADDRESS ?? "0x3A56baecFa7b4A967B8aDF35a0494e22Dd807A86",
        abi: Token_default
      },
      badgeManager: {
        address: import.meta.env.ARBITRUM_SEPOLIA_BADGE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_BADGE_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_BADGE_MGR_ADDRESS ?? "0x9d7beF02CfFEb507D67C3706ABE6e280A845f82a",
        abi: BadgeManager_default
      },
      marketCore: {
        address: import.meta.env.ARBITRUM_SEPOLIA_MARKET_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_MARKET_CORE_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_MARKET_CORE_ADDRESS ?? "0x7561bEC4a302568f4bf6027327bdd59aEc104412",
        abi: MarketCore_default
      },
      disputeManager: {
        address: import.meta.env.ARBITRUM_SEPOLIA_DISPUTE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_DISPUTE_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_DISPUTE_MGR_ADDRESS ?? "0xd168EeF9d683a1CBac60De600B8254F71429c844",
        abi: DisputeManager_default
      },
      mediatorManager: {
        address: import.meta.env.ARBITRUM_SEPOLIA_MEDIATOR_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_MEDIATOR_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_MEDIATOR_MGR_ADDRESS ?? "0x24C1A0B6bD76E9D6b4D3Ec43dac3F6B4626d43d7",
        abi: MediatorManager_default
      },
      energon: {
        address: import.meta.env.ARBITRUM_SEPOLIA_ENERGON_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_ENERGON_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_ENERGON_ADDRESS,
        abi: Energon_default
      },
      nft: {
        address: import.meta.env.ARBITRUM_SEPOLIA_NFT_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_NFT_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_NFT_ADDRESS ?? "0x77e8489eED7D6718fFcBe3dEA0F776f00fcf513e",
        abi: NFT_default
      },
      assetRegistry: {
        address: import.meta.env.ARBITRUM_SEPOLIA_ASSET_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_ASSET_REG_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_ASSET_REG_ADDRESS ?? "0xdFa0520fafd554aA6d768B065f982D5a01365a4C",
        abi: AssetRegistry_default
      },
      minerRegistry: {
        address: import.meta.env.ARBITRUM_SEPOLIA_MINER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_MINER_REG_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_MINER_REG_ADDRESS ?? "",
        abi: MinerRegistry_default
      },
      providerRegistry: {
        address: import.meta.env.ARBITRUM_SEPOLIA_PROVIDER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_PROVIDER_REG_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_PROVIDER_REG_ADDRESS,
        abi: ProviderRegistry_default
      },
      router: {
        address: import.meta.env.ARBITRUM_SEPOLIA_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_ROUTER_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_ROUTER_ADDRESS,
        abi: Router_default
      },
      payRouter: {
        address: import.meta.env.ARBITRUM_SEPOLIA_PAY_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_PAY_ROUTER_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_PAY_ROUTER_ADDRESS,
        abi: PayRouter_default
      },
      marketManager: {
        address: import.meta.env.ARBITRUM_SEPOLIA_MARKET_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_ARBITRUM_SEPOLIA_MARKET_MGR_ADDRESS ?? import.meta.env.VITE_ARBITRUM_SEPOLIA_MARKET_MGR_ADDRESS,
        abi: MarketManager_default
      }
    }
  },
  {
    displayName: "Sepolia",
    queryName: "sepolia",
    testnet: true,
    chainId: sepolia.id,
    chain: sepolia,
    symbol: "ETH",
    apiUrl: import.meta.env.SEPOLIA_API_URL ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_API_URL ?? import.meta.env.VITE_SEPOLIA_API_URL,
    rpcUrl: import.meta.env.SEPOLIA_RPC_URL ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_RPC_URL ?? import.meta.env.VITE_SEPOLIA_RPC_URL,
    blockExplorer: "https://sepolia.etherscan.io",
    logoPath: IconEthereum,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.SEPOLIA_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_SEPOLIA_WRAPPED_TOKEN_ADDRESS ?? "0x4263541D13298963498ff1f83d992812Ef3d2E73",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.SEPOLIA_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_SEPOLIA_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.SEPOLIA_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_SEPOLIA_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.SEPOLIA_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_SEPOLIA_BOND_TOKEN_SYMBOL
    },
    contracts: {
      core: {
        address: import.meta.env.SEPOLIA_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_CORE_ADDRESS ?? import.meta.env.VITE_SEPOLIA_CORE_ADDRESS ?? "0xAACA1a3B9756D3CAba6fFef058245dfE7037A537",
        abi: Core_default
      },
      token: {
        address: import.meta.env.SEPOLIA_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_TOKEN_ADDRESS ?? import.meta.env.VITE_SEPOLIA_TOKEN_ADDRESS ?? "0xB556b3a796f5f104Bbaab840567844734e0490a0",
        abi: Token_default
      },
      badgeManager: {
        address: import.meta.env.SEPOLIA_BADGE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_BADGE_MGR_ADDRESS ?? import.meta.env.VITE_SEPOLIA_BADGE_MGR_ADDRESS ?? "0x8cf4a9D2fB4da5453ED98963C5B53AD691cA05CD",
        abi: BadgeManager_default
      },
      marketCore: {
        address: import.meta.env.SEPOLIA_MARKET_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_MARKET_CORE_ADDRESS ?? import.meta.env.VITE_SEPOLIA_MARKET_CORE_ADDRESS ?? "0x6A803C1CEEB34aF59Ef278a235A6A4cbd21d2022",
        abi: MarketCore_default
      },
      disputeManager: {
        address: import.meta.env.SEPOLIA_DISPUTE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_DISPUTE_MGR_ADDRESS ?? import.meta.env.VITE_SEPOLIA_DISPUTE_MGR_ADDRESS ?? "0x34DaFfAee3F646D58d538c578482FC607CEAB7F5",
        abi: DisputeManager_default
      },
      mediatorManager: {
        address: import.meta.env.SEPOLIA_MEDIATOR_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_MEDIATOR_MGR_ADDRESS ?? import.meta.env.VITE_SEPOLIA_MEDIATOR_MGR_ADDRESS ?? "0x7774E1E2809695bb3Bd85F22809c6c94373112c9",
        abi: MediatorManager_default
      },
      energon: {
        address: import.meta.env.SEPOLIA_ENERGON_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_ENERGON_ADDRESS ?? import.meta.env.VITE_SEPOLIA_ENERGON_ADDRESS,
        abi: Energon_default
      },
      nft: {
        address: import.meta.env.SEPOLIA_NFT_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_NFT_ADDRESS ?? import.meta.env.VITE_SEPOLIA_NFT_ADDRESS ?? "0xF6E0Fdd5fA9CEd3F075BCC63B454D42C35b43d24",
        abi: NFT_default
      },
      assetRegistry: {
        address: import.meta.env.SEPOLIA_ASSET_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_ASSET_REG_ADDRESS ?? import.meta.env.VITE_SEPOLIA_ASSET_REG_ADDRESS ?? "0x4B4eC83FAC2ce42a395b895336d7a952f7FE01c0",
        abi: AssetRegistry_default
      },
      minerRegistry: {
        address: import.meta.env.SEPOLIA_MINER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_MINER_REG_ADDRESS ?? import.meta.env.VITE_SEPOLIA_MINER_REG_ADDRESS ?? "",
        abi: MinerRegistry_default
      },
      providerRegistry: {
        address: import.meta.env.SEPOLIA_PROVIDER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_PROVIDER_REG_ADDRESS ?? import.meta.env.VITE_SEPOLIA_PROVIDER_REG_ADDRESS,
        abi: ProviderRegistry_default
      },
      router: {
        address: import.meta.env.SEPOLIA_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_ROUTER_ADDRESS ?? import.meta.env.VITE_SEPOLIA_ROUTER_ADDRESS,
        abi: Router_default
      },
      payRouter: {
        address: import.meta.env.SEPOLIA_PAY_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_PAY_ROUTER_ADDRESS ?? import.meta.env.VITE_SEPOLIA_PAY_ROUTER_ADDRESS,
        abi: PayRouter_default
      },
      marketManager: {
        address: import.meta.env.SEPOLIA_MARKET_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_SEPOLIA_MARKET_MGR_ADDRESS ?? import.meta.env.VITE_SEPOLIA_MARKET_MGR_ADDRESS,
        abi: MarketManager_default
      }
    }
  },
  {
    displayName: "Hardhat",
    queryName: "localhost",
    testnet: true,
    chainId: hardhat.id,
    chain: hardhat,
    symbol: "ETH",
    apiUrl: import.meta.env.LOCALHOST_API_URL ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_API_URL ?? import.meta.env.VITE_LOCALHOST_API_URL,
    rpcUrl: import.meta.env.LOCALHOST_RPC_URL ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_RPC_URL ?? import.meta.env.VITE_LOCALHOST_RPC_URL,
    blockExplorer: "https://etherscan.io",
    logoPath: IconEthereum,
    wrappedTokenInfo: new TokenInfo({
      address: import.meta.env.LOCALHOST_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_WRAPPED_TOKEN_ADDRESS ?? import.meta.env.VITE_LOCALHOST_WRAPPED_TOKEN_ADDRESS,
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      abi: WETH_default,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }),
    bondToken: {
      address: import.meta.env.LOCALHOST_BOND_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_BOND_TOKEN_ADDRESS ?? import.meta.env.VITE_LOCALHOST_BOND_TOKEN_ADDRESS,
      decimals: parseInt(
        import.meta.env.LOCALHOST_BOND_TOKEN_DECIMALS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_BOND_TOKEN_DECIMALS ?? import.meta.env.VITE_LOCALHOST_BOND_TOKEN_DECIMALS ?? "18"
      ),
      symbol: import.meta.env.LOCALHOST_BOND_TOKEN_SYMBOL ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_BOND_TOKEN_SYMBOL ?? import.meta.env.VITE_LOCALHOST_BOND_TOKEN_SYMBOL
    },
    contracts: {
      core: {
        address: import.meta.env.LOCALHOST_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_CORE_ADDRESS ?? import.meta.env.VITE_LOCALHOST_CORE_ADDRESS,
        abi: Core_default
      },
      token: {
        address: import.meta.env.LOCALHOST_TOKEN_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_TOKEN_ADDRESS ?? import.meta.env.VITE_LOCALHOST_TOKEN_ADDRESS,
        abi: Token_default
      },
      badgeManager: {
        address: import.meta.env.LOCALHOST_BADGE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_BADGE_MGR_ADDRESS ?? import.meta.env.VITE_LOCALHOST_BADGE_MGR_ADDRESS,
        abi: BadgeManager_default
      },
      marketCore: {
        address: import.meta.env.LOCALHOST_MARKET_CORE_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_MARKET_CORE_ADDRESS ?? import.meta.env.VITE_LOCALHOST_MARKET_CORE_ADDRESS,
        abi: MarketCore_default
      },
      disputeManager: {
        address: import.meta.env.LOCALHOST_DISPUTE_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_DISPUTE_MGR_ADDRESS ?? import.meta.env.VITE_LOCALHOST_DISPUTE_MGR_ADDRESS,
        abi: DisputeManager_default
      },
      mediatorManager: {
        address: import.meta.env.LOCALHOST_MEDIATOR_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_MEDIATOR_MGR_ADDRESS ?? import.meta.env.VITE_LOCALHOST_MEDIATOR_MGR_ADDRESS,
        abi: MediatorManager_default
      },
      energon: {
        address: import.meta.env.LOCALHOST_ENERGON_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_ENERGON_ADDRESS ?? import.meta.env.VITE_LOCALHOST_ENERGON_ADDRESS,
        abi: Energon_default
      },
      nft: {
        address: import.meta.env.LOCALHOST_NFT_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_NFT_ADDRESS ?? import.meta.env.VITE_LOCALHOST_NFT_ADDRESS,
        abi: NFT_default
      },
      assetRegistry: {
        address: import.meta.env.LOCALHOST_ASSET_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_ASSET_REG_ADDRESS ?? import.meta.env.VITE_LOCALHOST_ASSET_REG_ADDRESS,
        abi: AssetRegistry_default
      },
      minerRegistry: {
        address: import.meta.env.LOCALHOST_MINER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_MINER_REG_ADDRESS ?? import.meta.env.VITE_LOCALHOST_MINER_REG_ADDRESS,
        abi: MinerRegistry_default
      },
      providerRegistry: {
        address: import.meta.env.LOCALHOST_PROVIDER_REG_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_PROVIDER_REG_ADDRESS ?? import.meta.env.VITE_LOCALHOST_PROVIDER_REG_ADDRESS,
        abi: ProviderRegistry_default
      },
      router: {
        address: import.meta.env.LOCALHOST_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_ROUTER_ADDRESS ?? import.meta.env.VITE_LOCALHOST_ROUTER_ADDRESS,
        abi: Router_default
      },
      payRouter: {
        address: import.meta.env.LOCALHOST_PAY_ROUTER_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_PAY_ROUTER_ADDRESS ?? import.meta.env.VITE_LOCALHOST_PAY_ROUTER_ADDRESS,
        abi: PayRouter_default
      },
      marketManager: {
        address: import.meta.env.LOCALHOST_MARKET_MGR_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_MARKET_MGR_ADDRESS ?? import.meta.env.VITE_LOCALHOST_MARKET_MGR_ADDRESS,
        abi: MarketManager_default
      },
      bondCurveDistro: {
        address: import.meta.env.LOCALHOST_BOND_CURVE_DISTRO_ADDRESS ?? import.meta.env.NEXT_PUBLIC_LOCALHOST_BOND_CURVE_DISTRO_ADDRESS ?? import.meta.env.VITE_LOCALHOST_BOND_CURVE_DISTRO_ADDRESS,
        abi: BondCurveDistro_default
      }
    }
  }
];
function getChainsID(testnetOnly = false, ignoreTestnet = false, ignore = []) {
  let supported = Chains;
  if (testnetOnly) {
    supported = supported.filter((s) => s.testnet);
  }
  return supported.filter((s) => !s.disabled && !ignore.includes(s.chainId) && (!ignoreTestnet || !s.testnet)).map((s) => s.chainId);
}
function getChains(testnetOnly = false, ignoreTestnet = false, ignore = []) {
  let supported = Chains;
  if (testnetOnly) {
    supported = supported.filter((s) => s.testnet);
  }
  return supported.filter((s) => !s.disabled && !ignore.includes(s.chainId) && (!ignoreTestnet || !s.testnet)).map((s) => s.chain);
}
function getChain(id2) {
  if (!id2)
    return;
  if (typeof id2 === "string")
    return getChainByName(id2);
  return Chains.find((s) => s.chainId === id2);
}
function getChainByName(name) {
  return Chains.find((s) => s.queryName === name);
}
function getChainNames() {
  return Chains.map((chain) => {
    return chain.queryName;
  });
}
function getChainID(name) {
  const chain = getChainByName(name);
  if (!chain)
    throw new Error(`Chain ${name} is not supported`);
  return chain.chainId;
}
function isValidChain(chain) {
  return getChainByName(chain) !== void 0;
}
var chains_default = Chains;

// src/contracts_params.ts
var contractsParams = {
  localhost: {
    others: {
      operatorBond: "120",
      allocatorAddr: "0xA47FFd6c828EFB58c6B42F722ABA286cF87C19a0",
      nativeAssetAddr: "0x0E801D84Fa97b50751Dbf25036d067dCf18858bF"
    },
    core: {
      minTimeToPay: 1800,
      orderGraceDur: 1800,
      maxOpenOrders: 3,
      maxOpenDisputes: 3,
      transferToFeePoolInterval: 86400
    },
    token: {},
    energon: {},
    nft: {},
    badgeManager: {},
    marketCore: {
      defaultDisputeDelayDur: 0
    },
    disputeManager: {
      evidenceDur: 60,
      predictDur: 120
    },
    mediatorManager: {
      ticketMaxPause: 3,
      baseTicketPrice: "100000000000000000000",
      ticketWindowDur: 86400,
      ticketsPerWindow: 256,
      ticketSupply: 6e4,
      priceSupplyDeltaBP: 2e3,
      minInactiveWindowBeforeReset: 7,
      soldOutBP: 8e3,
      ticketMatureDur: 86400,
      ticketCancelDur: 604800,
      ticketExpireDur: 172800,
      ticketPauseDur: 604800,
      reqPoolBond: "1000000000000000000000",
      poolDraftReward: "10000000000000000000",
      poolWinReward: "20000000000000000000",
      poolNumDraftee: 1,
      poolNoVoteSlashBP: 1e3,
      poolLoseVoteSlashBP: 2e3,
      poolEvidenceDur: 86400,
      poolPredictDur: 172800
    },
    assetRegistry: {},
    minerRegistry: {
      minerBond: "1000000000000000000000",
      minerMatureDur: 86400,
      minerCancelDur: 604800
    },
    payRouter: {
      payRouterProtocolFeeBp: 0
    },
    marketManager: {},
    chainlink: {}
  },
  sepolia: {
    others: {
      operatorBond: "0",
      allocatorAddr: "0xA47FFd6c828EFB58c6B42F722ABA286cF87C19a0"
    },
    core: {
      minTimeToPay: 1800,
      orderGraceDur: 1800,
      maxOpenOrders: 3,
      maxOpenDisputes: 3,
      transferToFeePoolInterval: 86400
    },
    token: {},
    energon: {},
    nft: {},
    badgeManager: {},
    marketCore: {
      defaultDisputeDelayDur: 0
    },
    disputeManager: {
      evidenceDur: 1800,
      predictDur: 3600
    },
    mediatorManager: {
      baseTicketPrice: "100000000000000000000",
      ticketWindowDur: 86400,
      ticketsPerWindow: 256,
      ticketSupply: 6e4,
      priceSupplyDeltaBP: 2e3,
      minInactiveWindowBeforeReset: 7,
      soldOutBP: 8e3,
      ticketMatureDur: 86400,
      ticketCancelDur: 604800,
      ticketExpireDur: 172800,
      ticketPauseDur: 604800,
      reqPoolBond: "1000000000000000000000",
      poolDraftReward: "100000000000000000000",
      poolWinReward: "200000000000000000000",
      poolNumDraftee: 1,
      poolNoVoteSlashBP: 1e3,
      poolLoseVoteSlashBP: 2e3,
      poolEvidenceDur: 86400,
      poolPredictDur: 172800
    },
    assetRegistry: {},
    minerRegistry: {
      minerBond: "1000000000000000000000",
      minerMatureDur: 86400,
      minerCancelDur: 604800
    },
    chainlink: {},
    payRouter: {
      payRouterProtocolFeeBp: 0
    },
    marketManager: {}
  },
  base: {
    others: {
      operatorBond: "0",
      allocatorAddr: "0xA47FFd6c828EFB58c6B42F722ABA286cF87C19a0"
    },
    core: {
      minTimeToPay: 1800,
      orderGraceDur: 1800,
      maxOpenOrders: 3,
      maxOpenDisputes: 3,
      transferToFeePoolInterval: 86400
    },
    token: {},
    energon: {},
    nft: {},
    badgeManager: {},
    marketCore: {
      defaultDisputeDelayDur: 0
    },
    disputeManager: {
      evidenceDur: 1800,
      predictDur: 3600
    },
    mediatorManager: {
      baseTicketPrice: "100000000000000000000",
      ticketWindowDur: 86400,
      ticketsPerWindow: 256,
      ticketSupply: 6e4,
      priceSupplyDeltaBP: 2e3,
      minInactiveWindowBeforeReset: 7,
      soldOutBP: 8e3,
      ticketMatureDur: 86400,
      ticketCancelDur: 604800,
      ticketExpireDur: 172800,
      ticketPauseDur: 604800,
      reqPoolBond: "1000000000000000000000",
      poolDraftReward: "100000000000000000000",
      poolWinReward: "200000000000000000000",
      poolNumDraftee: 1,
      poolNoVoteSlashBP: 1e3,
      poolLoseVoteSlashBP: 2e3,
      poolEvidenceDur: 86400,
      poolPredictDur: 172800
    },
    assetRegistry: {},
    minerRegistry: {
      minerBond: "1000000000000000000000",
      minerMatureDur: 86400,
      minerCancelDur: 604800
    },
    chainlink: {},
    payRouter: {
      payRouterProtocolFeeBp: 0
    },
    marketManager: {}
  },
  arbitrum: {
    others: {
      operatorBond: "0",
      allocatorAddr: "0xA47FFd6c828EFB58c6B42F722ABA286cF87C19a0"
    },
    core: {
      minTimeToPay: 1800,
      orderGraceDur: 1800,
      maxOpenOrders: 3,
      maxOpenDisputes: 3,
      transferToFeePoolInterval: 86400
    },
    token: {},
    energon: {},
    nft: {},
    badgeManager: {},
    marketCore: {
      defaultDisputeDelayDur: 0
    },
    disputeManager: {
      evidenceDur: 1800,
      predictDur: 3600
    },
    mediatorManager: {
      baseTicketPrice: "100000000000000000000",
      ticketWindowDur: 86400,
      ticketsPerWindow: 256,
      ticketSupply: 6e4,
      priceSupplyDeltaBP: 2e3,
      minInactiveWindowBeforeReset: 7,
      soldOutBP: 8e3,
      ticketMatureDur: 86400,
      ticketCancelDur: 604800,
      ticketExpireDur: 172800,
      ticketPauseDur: 604800,
      reqPoolBond: "1000000000000000000000",
      poolDraftReward: "100000000000000000000",
      poolWinReward: "200000000000000000000",
      poolNumDraftee: 1,
      poolNoVoteSlashBP: 1e3,
      poolLoseVoteSlashBP: 2e3,
      poolEvidenceDur: 86400,
      poolPredictDur: 172800
    },
    assetRegistry: {},
    minerRegistry: {
      minerBond: "1000000000000000000000",
      minerMatureDur: 86400,
      minerCancelDur: 604800
    },
    chainlink: {},
    payRouter: {
      payRouterProtocolFeeBp: 0
    },
    marketManager: {}
  },
  "arbitrum-sepolia": {
    others: {
      operatorBond: "0",
      allocatorAddr: "0xA47FFd6c828EFB58c6B42F722ABA286cF87C19a0"
    },
    core: {
      minTimeToPay: 1800,
      orderGraceDur: 1800,
      maxOpenOrders: 3,
      maxOpenDisputes: 3,
      transferToFeePoolInterval: 86400
    },
    token: {},
    energon: {},
    nft: {},
    badgeManager: {},
    marketCore: {
      defaultDisputeDelayDur: 0
    },
    disputeManager: {
      evidenceDur: 1800,
      predictDur: 3600
    },
    mediatorManager: {
      baseTicketPrice: "100000000000000000000",
      ticketWindowDur: 86400,
      ticketsPerWindow: 256,
      ticketSupply: 6e4,
      priceSupplyDeltaBP: 2e3,
      minInactiveWindowBeforeReset: 7,
      soldOutBP: 8e3,
      ticketMatureDur: 86400,
      ticketCancelDur: 604800,
      ticketExpireDur: 172800,
      ticketPauseDur: 604800,
      reqPoolBond: "1000000000000000000000",
      poolDraftReward: "100000000000000000000",
      poolWinReward: "200000000000000000000",
      poolNumDraftee: 1,
      poolNoVoteSlashBP: 1e3,
      poolLoseVoteSlashBP: 2e3,
      poolEvidenceDur: 86400,
      poolPredictDur: 172800
    },
    assetRegistry: {},
    minerRegistry: {
      minerBond: "1000000000000000000000",
      minerMatureDur: 86400,
      minerCancelDur: 604800
    },
    chainlink: {},
    payRouter: {
      payRouterProtocolFeeBp: 0
    },
    marketManager: {}
  },
  ethereum: {
    others: {
      operatorBond: "0",
      allocatorAddr: ""
    },
    core: {
      minTimeToPay: 0,
      orderGraceDur: 0,
      maxOpenOrders: 0,
      maxOpenDisputes: 0,
      transferToFeePoolInterval: 0
    },
    token: {},
    energon: {},
    nft: {},
    badgeManager: {},
    marketCore: {
      defaultDisputeDelayDur: 0
    },
    disputeManager: {
      evidenceDur: 0,
      predictDur: 0
    },
    mediatorManager: {
      baseTicketPrice: "0",
      ticketWindowDur: 0,
      ticketsPerWindow: 0,
      ticketSupply: 0,
      priceSupplyDeltaBP: 0,
      minInactiveWindowBeforeReset: 0,
      soldOutBP: 0,
      ticketMatureDur: 0,
      ticketCancelDur: 0,
      ticketExpireDur: 0,
      ticketPauseDur: 0,
      reqPoolBond: "0",
      poolDraftReward: "0",
      poolWinReward: "0",
      poolNumDraftee: 0,
      poolNoVoteSlashBP: 0,
      poolLoseVoteSlashBP: 0,
      poolEvidenceDur: 0,
      poolPredictDur: 0
    },
    assetRegistry: {},
    minerRegistry: {
      minerBond: "1000000000000000000000",
      minerMatureDur: 86400,
      minerCancelDur: 604800
    },
    chainlink: {},
    payRouter: {
      payRouterProtocolFeeBp: 0
    },
    marketManager: {}
  }
};
function getContractsParams(network) {
  return contractsParams[network];
}

// src/mediator_pools.ts
var MediatorPools = {
  localhost: [
    {
      name: "General",
      description: "For mediators specializing in global crypto to fiat swaps and vice versa.",
      id: 0,
      reqBond: "1000000000000000000000",
      draftReward: "10000000000000000000",
      winReward: "20000000000000000000",
      noVoteSlashBP: 1e3,
      loseVoteSlashBP: 2e3,
      numDraftees: 1
    }
  ],
  ethereum: [
    {
      name: "General",
      description: "For mediators specializing in global crypto to fiat swaps and vice versa.",
      id: 0,
      reqBond: "10000000000000000000",
      draftReward: "10000000000000000000",
      winReward: "10000000000000000000",
      noVoteSlashBP: 1e3,
      loseVoteSlashBP: 1e3,
      numDraftees: 3
    }
  ],
  sepolia: [
    {
      name: "General",
      description: "For mediators specializing in global crypto to fiat swaps and vice versa.",
      id: 0,
      reqBond: "1000000000000000000000",
      draftReward: "100000000000000000000",
      winReward: "200000000000000000000",
      noVoteSlashBP: 1e3,
      loseVoteSlashBP: 2e3,
      numDraftees: 1
    }
  ],
  "arbitrum-sepolia": [
    {
      name: "General",
      description: "For mediators specializing in global crypto to fiat swaps and vice versa.",
      id: 0,
      reqBond: "1000000000000000000000",
      draftReward: "100000000000000000000",
      winReward: "200000000000000000000",
      noVoteSlashBP: 1e3,
      loseVoteSlashBP: 2e3,
      numDraftees: 1
    }
  ],
  arbitrum: [
    {
      name: "General",
      description: "For mediators specializing in global crypto to fiat swaps and vice versa.",
      id: 0,
      reqBond: "1000000000000000000000",
      draftReward: "100000000000000000000",
      winReward: "200000000000000000000",
      noVoteSlashBP: 1e3,
      loseVoteSlashBP: 2e3,
      numDraftees: 1
    }
  ],
  base: [
    {
      name: "General",
      description: "For mediators specializing in global crypto to fiat swaps and vice versa.",
      id: 0,
      reqBond: "1000000000000000000000",
      draftReward: "100000000000000000000",
      winReward: "200000000000000000000",
      noVoteSlashBP: 1e3,
      loseVoteSlashBP: 2e3,
      numDraftees: 1
    }
  ]
};

// src/tokens_list.ts
import _ from "lodash";
import { isAddressEqual as isAddressEqual2 } from "viem";

// src/tokenlist/arbitrum-sepolia.json
var arbitrum_sepolia_default = {
  name: "Trust Wallet: Arbitrum Sepolia",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  tokens: [
    {
      asset: "0000",
      chainId: 1,
      type: "ERC20",
      address: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73",
      name: "ETH",
      symbol: "ETH",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/eth.svg",
      price: 0
    },
    {
      asset: "0001",
      type: "ERC20",
      address: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      price: 0
    },
    {
      asset: "0002",
      type: "ERC20",
      address: "0x3A56baecFa7b4A967B8aDF35a0494e22Dd807A86",
      name: "Joint",
      symbol: "JOIN",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/join.svg",
      price: 0
    }
  ],
  version: {
    major: 6,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/arbitrum.json
var arbitrum_default = {
  name: "Trust Wallet: Arbitrum",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  version: {
    major: 6,
    minor: 0,
    patch: 0
  },
  tokens: [
    {
      asset: "0000",
      chainId: 1,
      type: "ERC20",
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      name: "ETH",
      symbol: "ETH",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/eth.svg",
      price: 0
    },
    {
      asset: "0001",
      type: "ERC20",
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      price: 0
    },
    {
      asset: "0002",
      type: "ERC20",
      address: "0x5e5e85370808363Ee3D59e8a778ee15cf8A1E15a",
      name: "Joint",
      symbol: "tJOIN",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/join.svg",
      price: 0
    },
    {
      asset: "0003",
      type: "ERC20",
      address: "0xda668F1c6B6329f19afc657fD9D8093E6187e3eF",
      name: "BANDIT",
      symbol: "BANDIT",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/bandit.svg",
      price: 0
    },
    {
      asset: "0004",
      type: "ERC20",
      address: "0xAa77e14277F727B3C5158A07DFf83019d063a131",
      name: "DROID",
      symbol: "DROID",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/droid.svg",
      price: 0
    },
    {
      asset: "0005",
      type: "ERC20",
      address: "0x9c2F13C5fCc4f956921CeA990356166D63B663f4",
      name: "MULTIPLIER",
      symbol: "MULTI",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/multi.svg",
      price: 0
    },
    {
      asset: "0006",
      type: "ERC20",
      address: "0x5Eb896c6de72f763D0F3D26ee7F63F575D466902",
      name: "WARBOND",
      symbol: "BOND",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/bond.svg",
      price: 0
    },
    {
      asset: "0007",
      type: "ERC20",
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      name: "USDC",
      symbol: "USDC",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/arbitrum/assets/0xaf88d065e77c8cC2239327C5EDb3A432268e5831/logo.png",
      price: 0
    }
  ]
};

// src/tokenlist/base.json
var base_default = {
  name: "Trust Wallet: Base",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  version: {
    major: 6,
    minor: 0,
    patch: 0
  },
  tokens: [
    {
      asset: "0001",
      type: "ERC20",
      address: "0x60ea5245179F18E71771f6087Db737De56F03f16",
      name: "Joint",
      symbol: "JOIN",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/join.svg",
      price: 0
    },
    {
      asset: "0002",
      type: "ERC20",
      address: "0x40cF5289cbc6949fddAD8b14d85ead5d20F6AE8C",
      name: "BANDIT",
      symbol: "BANDIT",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/bandit.svg",
      price: 0
    },
    {
      asset: "0003",
      type: "ERC20",
      address: "0x6225ccf32687ea72FDaf21394C9eb917bC9B485E",
      name: "DROID",
      symbol: "DROID",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/droid.svg",
      price: 0
    },
    {
      asset: "0004",
      type: "ERC20",
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      name: "USDC",
      symbol: "USDC",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/arbitrum/assets/0xaf88d065e77c8cC2239327C5EDb3A432268e5831/logo.png",
      price: 0
    },
    {
      asset: "0005",
      type: "ERC20",
      address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
      name: "USDT",
      symbol: "USDT",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
      price: 0
    }
  ]
};

// src/tokenlist/binance.json
var binance_default = {
  name: "Trust Wallet: Smart Chain",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-06-17T12:17:25.447Z",
  tokens: [
    {
      asset: "0000",
      chainId: 56,
      type: "BEP20",
      address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
      name: "BNB",
      symbol: "BNB",
      native: true,
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png",
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
      type: "BEP20",
      address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
      name: "Wrapped BNB",
      symbol: "WBNB",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/wbnb.svg",
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x0231f91e02DebD20345Ae8AB7D71A41f8E140cE7",
      type: "BEP20",
      address: "0x0231f91e02DebD20345Ae8AB7D71A41f8E140cE7",
      name: "Jupiter",
      symbol: "bwJUP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0231f91e02DebD20345Ae8AB7D71A41f8E140cE7/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153",
      type: "BEP20",
      address: "0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153",
      name: "Binance-Peg Filecoin",
      symbol: "FIL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
      type: "BEP20",
      address: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
      name: "PancakeSwap Token",
      symbol: "CAKE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x0Eb3a705fc54725037CC9e008bDede697f62F335",
      type: "BEP20",
      address: "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
      name: "Binance-Peg Cosmos Token",
      symbol: "ATOM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x0Eb3a705fc54725037CC9e008bDede697f62F335/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x16939ef78684453bfDFb47825F8a5F714f12623a",
      type: "BEP20",
      address: "0x16939ef78684453bfDFb47825F8a5F714f12623a",
      name: "Binance-Peg Tezos Token",
      symbol: "XTZ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x16939ef78684453bfDFb47825F8a5F714f12623a/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454",
      type: "BEP20",
      address: "0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454",
      name: "bDollar",
      symbol: "BDO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
      type: "BEP20",
      address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
      name: "Binance-Peg Dai Token",
      symbol: "DAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
      type: "BEP20",
      address: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
      name: "Binance-Peg XRP Token",
      symbol: "XRP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A",
      type: "BEP20",
      address: "0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A",
      name: "Fuel Token",
      symbol: "Fuel",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
      type: "BEP20",
      address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
      name: "Binance-Peg Ethereum",
      symbol: "ETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x2170Ed0880ac9A755fd29B2688956BD959F933F8/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
      type: "BEP20",
      address: "0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
      name: "Wrapped UST Token",
      symbol: "UST",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x23396cF899Ca06c4472205fC903bDB4de249D6fC/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x233d91A0713155003fc4DcE0AFa871b508B3B715",
      type: "BEP20",
      address: "0x233d91A0713155003fc4DcE0AFa871b508B3B715",
      name: "Ditto",
      symbol: "DITTO",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x233d91A0713155003fc4DcE0AFa871b508B3B715/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x37Ac4D6140e54304D77437A5c11924f61a2D976f",
      type: "BEP20",
      address: "0x37Ac4D6140e54304D77437A5c11924f61a2D976f",
      name: "SparkPoint Fuel",
      symbol: "SFUEL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x37Ac4D6140e54304D77437A5c11924f61a2D976f/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x3aabCf53A1930A42E18D938C019E83Ebee50a849",
      type: "BEP20",
      address: "0x3aabCf53A1930A42E18D938C019E83Ebee50a849",
      name: "SPONGE",
      symbol: "SPG",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x3aabCf53A1930A42E18D938C019E83Ebee50a849/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
      type: "BEP20",
      address: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
      name: "Binance-Peg Cardano Token",
      symbol: "ADA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x4197C6EF3879a08cD51e5560da5064B773aa1d29",
      type: "BEP20",
      address: "0x4197C6EF3879a08cD51e5560da5064B773aa1d29",
      name: "ACryptoS",
      symbol: "ACS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4197C6EF3879a08cD51e5560da5064B773aa1d29/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x4338665CBB7B2485A8855A139b75D5e34AB0DB94",
      type: "BEP20",
      address: "0x4338665CBB7B2485A8855A139b75D5e34AB0DB94",
      name: "Binance-Peg Litecoin Token",
      symbol: "LTC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4338665CBB7B2485A8855A139b75D5e34AB0DB94/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x44754455564474A89358B2C2265883DF993b12F0",
      type: "BEP20",
      address: "0x44754455564474A89358B2C2265883DF993b12F0",
      name: "ZeroSwapToken",
      symbol: "ZEE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x44754455564474A89358B2C2265883DF993b12F0/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
      type: "BEP20",
      address: "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
      name: "Swipe",
      symbol: "SXP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x4B0F1812e5Df2A09796481Ff14017e6005508003",
      type: "BEP20",
      address: "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
      name: "Trust Wallet",
      symbol: "TWT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4B0F1812e5Df2A09796481Ff14017e6005508003/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
      type: "BEP20",
      address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
      name: "VAI Stablecoin",
      symbol: "VAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x55d398326f99059fF775485246999027B3197955",
      type: "BEP20",
      address: "0x55d398326f99059fF775485246999027B3197955",
      name: "Binance-Peg BSC-USD",
      symbol: "USDT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x55d398326f99059fF775485246999027B3197955/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
      type: "BEP20",
      address: "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
      name: "Binance-Peg EOS Token",
      symbol: "EOS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587",
      type: "BEP20",
      address: "0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587",
      name: "BSCX",
      symbol: "BSCX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F",
      type: "BEP20",
      address: "0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F",
      name: "BLinkToken",
      symbol: "BLINK",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
      type: "BEP20",
      address: "0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
      name: "DODO",
      symbol: "DODO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x6c5FE6e99D2484db7E4BF34F365ABA42d0E4dC20",
      type: "BEP20",
      address: "0x6c5FE6e99D2484db7E4BF34F365ABA42d0E4dC20",
      name: "Absorber",
      symbol: "ABS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x6c5FE6e99D2484db7E4BF34F365ABA42d0E4dC20/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
      type: "BEP20",
      address: "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
      name: "Binance-Peg Polkadot Token",
      symbol: "DOT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
      type: "BEP20",
      address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
      name: "Binance-Peg BTCB Token",
      symbol: "BTCB",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
      type: "BEP20",
      address: "0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
      name: "UNFI",
      symbol: "UNFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x72fAa679E1008Ad8382959FF48E392042A8b06f7",
      type: "BEP20",
      address: "0x72fAa679E1008Ad8382959FF48E392042A8b06f7",
      name: "AllianceBlock Token",
      symbol: "bALBT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x72fAa679E1008Ad8382959FF48E392042A8b06f7/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x78650B139471520656b9E7aA7A5e9276814a38e9",
      type: "BEP20",
      address: "0x78650B139471520656b9E7aA7A5e9276814a38e9",
      name: "StandardBTCHashrateToken",
      symbol: "BTCST",
      decimals: 17,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x78650B139471520656b9E7aA7A5e9276814a38e9/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x790Be81C3cA0e53974bE2688cDb954732C9862e1",
      type: "BEP20",
      address: "0x790Be81C3cA0e53974bE2688cDb954732C9862e1",
      name: "CafeSwap Token",
      symbol: "BREW",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x790Be81C3cA0e53974bE2688cDb954732C9862e1/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x7979F6C54ebA05E18Ded44C4F986F49a5De551c2",
      type: "BEP20",
      address: "0x7979F6C54ebA05E18Ded44C4F986F49a5De551c2",
      name: "Kebab Token",
      symbol: "KEBAB",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7979F6C54ebA05E18Ded44C4F986F49a5De551c2/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x7F70642d88cf1C4a3a7abb072B53B929b653edA5",
      type: "BEP20",
      address: "0x7F70642d88cf1C4a3a7abb072B53B929b653edA5",
      name: "Binance-Peg YFII.finance Token",
      symbol: "YFII",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x7F70642d88cf1C4a3a7abb072B53B929b653edA5/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x81859801b01764D4f0Fa5E64729f5a6C3b91435b",
      type: "BEP20",
      address: "0x81859801b01764D4f0Fa5E64729f5a6C3b91435b",
      name: "bearn.fi",
      symbol: "BFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x81859801b01764D4f0Fa5E64729f5a6C3b91435b/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e",
      type: "BEP20",
      address: "0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e",
      name: "Binance-Peg yearn.finance",
      symbol: "YFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
      type: "BEP20",
      address: "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
      name: "Binance-Peg Bitcoin Cash Token",
      symbol: "BCH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
      type: "BEP20",
      address: "0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
      name: "Frontier Token",
      symbol: "FRONT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8",
      type: "BEP20",
      address: "0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8",
      name: "Helmet.insure Governance Token",
      symbol: "Helmet",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x97a30C692eCe9C317235d48287d23d358170FC40",
      type: "BEP20",
      address: "0x97a30C692eCe9C317235d48287d23d358170FC40",
      name: "CryptEx Token",
      symbol: "CRX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x97a30C692eCe9C317235d48287d23d358170FC40/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xa184088a740c695E156F91f5cC086a06bb78b827",
      type: "BEP20",
      address: "0xa184088a740c695E156F91f5cC086a06bb78b827",
      name: "AUTOv2",
      symbol: "AUTO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xa184088a740c695E156F91f5cC086a06bb78b827/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
      type: "BEP20",
      address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
      name: "Alpha Finance",
      symbol: "ALPHA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xa1faa113cbE53436Df28FF0aEe54275c13B40975/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xa2B726B1145A4773F68593CF171187d8EBe4d495",
      type: "BEP20",
      address: "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
      name: "Injective Protocol",
      symbol: "INJ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xa2B726B1145A4773F68593CF171187d8EBe4d495/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929",
      type: "BEP20",
      address: "0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929",
      name: "CertiK Token",
      symbol: "CTK",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18",
      type: "BEP20",
      address: "0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18",
      name: "Binance-Peg Band Protocol Token",
      symbol: "BAND",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723",
      type: "BEP20",
      address: "0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723",
      name: "Litentry",
      symbol: "LIT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
      type: "BEP20",
      address: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
      name: "Binance-Peg Uniswap",
      symbol: "UNI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xBf5140A22578168FD562DCcF235E5D43A02ce9B1/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe",
      type: "BEP20",
      address: "0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe",
      name: "Binance-Peg Elrond",
      symbol: "EGLD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731",
      type: "BEP20",
      address: "0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731",
      name: "Hedget",
      symbol: "HGET",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xC7FB8c5eFE8564205eE5CbA4dE8eeA8a086a4bd2",
      type: "BEP20",
      address: "0xC7FB8c5eFE8564205eE5CbA4dE8eeA8a086a4bd2",
      name: "PocketRocket",
      symbol: "POCROC",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xC7FB8c5eFE8564205eE5CbA4dE8eeA8a086a4bd2/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51",
      type: "BEP20",
      address: "0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51",
      name: "Bunny Token",
      symbol: "BUNNY",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xCa3F508B8e4Dd382eE878A314789373D80A5190A",
      type: "BEP20",
      address: "0xCa3F508B8e4Dd382eE878A314789373D80A5190A",
      name: "beefy.finance",
      symbol: "BIFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xCa3F508B8e4Dd382eE878A314789373D80A5190A/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xcc2E12a9b5b75360c6FBf23B584c275D52cDdb0E",
      type: "BEP20",
      address: "0xcc2E12a9b5b75360c6FBf23B584c275D52cDdb0E",
      name: "Crow Token",
      symbol: "CROW",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xcc2E12a9b5b75360c6FBf23B584c275D52cDdb0E/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63",
      type: "BEP20",
      address: "0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63",
      name: "Venus",
      symbol: "XVS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
      type: "BEP20",
      address: "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
      name: "SafePal Token",
      symbol: "SFP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xE40255C5d7fa7ceEc5120408C78C787CECB4cfdb",
      type: "BEP20",
      address: "0xE40255C5d7fa7ceEc5120408C78C787CECB4cfdb",
      name: "SWGb",
      symbol: "SWGb",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xE40255C5d7fa7ceEc5120408C78C787CECB4cfdb/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
      type: "BEP20",
      address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
      name: "Binance-Peg BUSD",
      symbol: "BUSD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x9798dF2f5d213a872c787bD03b2b91F54D0D04A1",
      type: "BEP20",
      address: "0x9798dF2f5d213a872c787bD03b2b91F54D0D04A1",
      name: "TeraBlock Token",
      symbol: "TBC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x9798dF2f5d213a872c787bD03b2b91F54D0D04A1/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
      type: "BEP20",
      address: "0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
      name: "Reef.finance",
      symbol: "REEF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e/logo.png",
      pairs: [],
      price: 0
    },
    {
      chainId: 56,
      asset: "c20000714_t0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4",
      type: "BEP20",
      address: "0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4",
      name: "Hard Protocol",
      symbol: "HARD",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
      type: "BEP20",
      address: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
      name: "Binance-Peg ChainLink",
      symbol: "LINK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6",
      type: "BEP20",
      address: "0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6",
      name: "Goose Golden Egg",
      symbol: "EGG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x016CF83732f1468150D87dCC5BdF67730B3934D3",
      type: "BEP20",
      address: "0x016CF83732f1468150D87dCC5BdF67730B3934D3",
      name: "AirNFT Token",
      symbol: "AIRT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x016CF83732f1468150D87dCC5BdF67730B3934D3/logo.png",
      pairs: [],
      price: 0
    },
    {
      asset: "c20000714_t0x8C851d1a123Ff703BD1f9dabe631b69902Df5f97",
      type: "BEP20",
      address: "0x8C851d1a123Ff703BD1f9dabe631b69902Df5f97",
      name: "BinaryX",
      symbol: "BNX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/0x8C851d1a123Ff703BD1f9dabe631b69902Df5f97/logo.png",
      pairs: []
    }
  ],
  version: {
    major: 11,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/blast.json
var blast_default = {
  name: "Trust Wallet: Blast",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  tokens: [
    {
      asset: "0000",
      type: "ERC20",
      address: "0x4300000000000000000000000000000000000004",
      name: "ETH",
      symbol: "ETH",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/eth.svg",
      price: 0
    },
    {
      asset: "0001",
      type: "ERC20",
      address: "0x4300000000000000000000000000000000000004",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      price: 0
    }
  ],
  version: {
    major: 6,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/ethereum.json
var ethereum_default = {
  name: "Trust Wallet: Ethereum",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-11-09T22:30:24.689Z",
  tokens: [
    {
      chainId: 1,
      asset: "c60_t0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      type: "NATIVE",
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      name: "ETH",
      symbol: "ETH",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/eth.svg"
    },
    {
      chainId: 1,
      asset: "c60_t0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      type: "ERC20",
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      pairs: [
        {
          base: "c60_t0x0000000000085d4780B73119b644AE5ecd22b376"
        },
        {
          base: "c60_t0x0000000000095413afC295d19EDeb1Ad7B71c952"
        },
        {
          base: "c60_t0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7"
        },
        {
          base: "c60_t0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1"
        },
        {
          base: "c60_t0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a"
        },
        {
          base: "c60_t0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919"
        },
        {
          base: "c60_t0x09a3EcAFa817268f77BE1283176B946C4ff2E608"
        },
        {
          base: "c60_t0x0Ae055097C6d159879521C384F1D2123D1f195e6"
        },
        {
          base: "c60_t0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e"
        },
        {
          base: "c60_t0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c"
        },
        {
          base: "c60_t0x0CDF9acd87E940837ff21BB40c9fd55F68bba059"
        },
        {
          base: "c60_t0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e"
        },
        {
          base: "c60_t0x0D8775F648430679A709E98d2b0Cb6250d2887EF"
        },
        {
          base: "c60_t0x0f51bb10119727a7e5eA3538074fb341F56B09Ad"
        },
        {
          base: "c60_t0x0F5D2fB29fb7d3CFeE444a200298f468908cC942"
        },
        {
          base: "c60_t0x0f7F961648aE6Db43C75663aC7E5414Eb79b5704"
        },
        {
          base: "c60_t0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
        },
        {
          base: "c60_t0x0fF6ffcFDa92c53F615a4A75D982f399C989366b"
        },
        {
          base: "c60_t0x10Be9a8dAe441d276a5027936c3aADEd2d82bC15"
        },
        {
          base: "c60_t0x111111111117dC0aa78b770fA6A738034120C302"
        },
        {
          base: "c60_t0x1337DEF16F9B486fAEd0293eb623Dc8395dFE46a"
        },
        {
          base: "c60_t0x1337DEF18C680aF1f9f45cBcab6309562975b1dD"
        },
        {
          base: "c60_t0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b"
        },
        {
          base: "c60_t0x15874d65e649880c2614e7a480cb7c9A55787FF6"
        },
        {
          base: "c60_t0x1614F18Fc94f47967A3Fbe5FfcD46d4e7Da3D787"
        },
        {
          base: "c60_t0x16980b3B4a3f9D89E33311B5aa8f80303E5ca4F8"
        },
        {
          base: "c60_t0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998"
        },
        {
          base: "c60_t0x1b40183EFB4Dd766f11bDa7A7c3AD8982e998421"
        },
        {
          base: "c60_t0x1cBb83EbcD552D5EBf8131eF8c9CD9d9BAB342bC"
        },
        {
          base: "c60_t0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44"
        },
        {
          base: "c60_t0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984"
        },
        {
          base: "c60_t0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
        },
        {
          base: "c60_t0x226f7b842E0F0120b7E194D05432b3fd14773a9D"
        },
        {
          base: "c60_t0x25e1474170c4c0aA64fa98123bdc8dB49D7802fa"
        },
        {
          base: "c60_t0x26c8AFBBFE1EBaca03C2bB082E69D0476Bffe099"
        },
        {
          base: "c60_t0x27C70Cd1946795B66be9d954418546998b546634"
        },
        {
          base: "c60_t0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39"
        },
        {
          base: "c60_t0x3301Ee63Fb29F863f2333Bd4466acb46CD8323E6"
        },
        {
          base: "c60_t0x3383c5a8969Dc413bfdDc9656Eb80A1408E4bA20"
        },
        {
          base: "c60_t0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f"
        },
        {
          base: "c60_t0x3845badAde8e6dFF049820680d1F14bD3903a5d0"
        },
        {
          base: "c60_t0x38e4adB44ef08F22F5B5b76A8f0c2d0dCbE7DcA1"
        },
        {
          base: "c60_t0x408e41876cCCDC0F92210600ef50372656052a38"
        },
        {
          base: "c60_t0x40FD72257597aA14C7231A7B1aaa29Fce868F677"
        },
        {
          base: "c60_t0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5"
        },
        {
          base: "c60_t0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E"
        },
        {
          base: "c60_t0x45804880De22913dAFE09f4980848ECE6EcbAf78"
        },
        {
          base: "c60_t0x4691937a7508860F876c9c0a2a617E7d9E945D4B"
        },
        {
          base: "c60_t0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42"
        },
        {
          base: "c60_t0x514910771AF9Ca656af840dff83E8264EcF986CA"
        },
        {
          base: "c60_t0x5218E472cFCFE0b64A064F055B43b4cdC9EfD3A6"
        },
        {
          base: "c60_t0x5228a22e72ccC52d415EcFd199F99D0665E7733b"
        },
        {
          base: "c60_t0x584bC13c7D411c00c01A62e8019472dE68768430"
        },
        {
          base: "c60_t0x5BEfBB272290dD5b8521D4a938f6c4757742c430"
        },
        {
          base: "c60_t0x607F4C5BB672230e8672085532f7e901544a7375"
        },
        {
          base: "c60_t0x62359Ed7505Efc61FF1D56fEF82158CcaffA23D7"
        },
        {
          base: "c60_t0x6243d8CEA23066d098a15582d81a598b4e8391F4"
        },
        {
          base: "c60_t0x63b4f3e3fa4e438698CE330e365E831F7cCD1eF4"
        },
        {
          base: "c60_t0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6"
        },
        {
          base: "c60_t0x67c597624B17b16fb77959217360B7cD18284253"
        },
        {
          base: "c60_t0x6810e776880C02933D47DB1b9fc05908e5386b96"
        },
        {
          base: "c60_t0x6B175474E89094C44Da98b954EedeAC495271d0F"
        },
        {
          base: "c60_t0x6B3595068778DD592e39A122f4f5a5cF09C90fE2"
        },
        {
          base: "c60_t0x70401dFD142A16dC7031c56E862Fc88Cb9537Ce0"
        },
        {
          base: "c60_t0x71F85B2E46976bD21302B64329868fd15eb0D127"
        },
        {
          base: "c60_t0x725C263e32c72dDC3A19bEa12C5a0479a81eE688"
        },
        {
          base: "c60_t0x72e364F2ABdC788b7E918bc238B21f109Cd634D7"
        },
        {
          base: "c60_t0x761D38e5ddf6ccf6Cf7c55759d5210750B5D60F3"
        },
        {
          base: "c60_t0x7659CE147D0e714454073a5dd7003544234b6Aa0"
        },
        {
          base: "c60_t0x77777FeDdddFfC19Ff86DB637967013e6C6A116C"
        },
        {
          base: "c60_t0x7a2Bc711E19ba6aff6cE8246C546E8c4B4944DFD"
        },
        {
          base: "c60_t0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0"
        },
        {
          base: "c60_t0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7"
        },
        {
          base: "c60_t0x7F3EDcdD180Dbe4819Bd98FeE8929b5cEdB3AdEB"
        },
        {
          base: "c60_t0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9"
        },
        {
          base: "c60_t0x7FF4169a6B5122b664c51c95727d87750eC07c84"
        },
        {
          base: "c60_t0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26"
        },
        {
          base: "c60_t0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa"
        },
        {
          base: "c60_t0x8400D94A5cb0fa0D041a3788e395285d61c9ee5e"
        },
        {
          base: "c60_t0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419"
        },
        {
          base: "c60_t0x853d955aCEf822Db058eb8505911ED77F175b99e"
        },
        {
          base: "c60_t0x85Eee30c52B0b379b046Fb0F85F4f3Dc3009aFEC"
        },
        {
          base: "c60_t0x88ACDd2a6425c3FaAE4Bc9650Fd7E27e0Bebb7aB"
        },
        {
          base: "c60_t0x88EF27e69108B2633F8E1C184CC37940A075cC02"
        },
        {
          base: "c60_t0x8a40c222996f9F3431f63Bf80244C36822060f12"
        },
        {
          base: "c60_t0x8a854288a5976036A725879164Ca3e91d30c6A1B"
        },
        {
          base: "c60_t0xCE3f08e664693ca792caCE4af1364D5e220827B2"
        },
        {
          base: "c60_t0x8CE9137d39326AD0cD6491fb5CC0CbA0e089b6A9"
        },
        {
          base: "c60_t0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa"
        },
        {
          base: "c60_t0x8f8221aFbB33998d8584A2B05749bA73c37a938a"
        },
        {
          base: "c60_t0x9355372396e3F6daF13359B7b607a3374cc638e0"
        },
        {
          base: "c60_t0x93ED3FBe21207Ec2E8f2d3c3de6e058Cb73Bc04d"
        },
        {
          base: "c60_t0x954b890704693af242613edEf1B603825afcD708"
        },
        {
          base: "c60_t0x956F47F50A910163D8BF957Cf5846D573E7f87CA"
        },
        {
          base: "c60_t0x95a4492F028aa1fd432Ea71146b433E7B4446611"
        },
        {
          base: "c60_t0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE"
        },
        {
          base: "c60_t0x967da4048cD07aB37855c090aAF366e4ce1b9F48"
        },
        {
          base: "c60_t0x990f341946A3fdB507aE7e52d17851B87168017c"
        },
        {
          base: "c60_t0x9B02dD390a603Add5c07f9fd9175b7DABE8D63B7"
        },
        {
          base: "c60_t0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541"
        },
        {
          base: "c60_t0x9EA3b5b4EC044b70375236A281986106457b20EF"
        },
        {
          base: "c60_t0x9Ed8e7C9604790F7Ec589F99b94361d8AAB64E5E"
        },
        {
          base: "c60_t0x9f7229aF0c4b9740e207Ea283b9094983f78ba04"
        },
        {
          base: "c60_t0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2"
        },
        {
          base: "c60_t0x9F9c8ec3534c3cE16F928381372BfbFBFb9F4D24"
        },
        {
          base: "c60_t0xa0246c9032bC3A600820415aE600c6388619A14D"
        },
        {
          base: "c60_t0xa0afAA285Ce85974c3C881256cB7F225e3A1178a"
        },
        {
          base: "c60_t0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        {
          base: "c60_t0xa117000000f279D81A1D3cc75430fAA017FA5A2e"
        },
        {
          base: "c60_t0xa393473d64d2F9F026B60b6Df7859A689715d092"
        },
        {
          base: "c60_t0xA4EED63db85311E22dF4473f87CcfC3DaDCFA3E3"
        },
        {
          base: "c60_t0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca"
        },
        {
          base: "c60_t0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD"
        },
        {
          base: "c60_t0xaaAEBE6Fe48E54f431b0C390CfaF0b017d09D42d"
        },
        {
          base: "c60_t0xAd4f86a25bbc20FfB751f2FAC312A0B4d8F88c64"
        },
        {
          base: "c60_t0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0"
        },
        {
          base: "c60_t0xaE697F994Fc5eBC000F8e22EbFfeE04612f98A0d"
        },
        {
          base: "c60_t0x41A3Dba3D677E573636BA691a70ff2D606c29666"
        },
        {
          base: "c60_t0xaf9f549774ecEDbD0966C52f250aCc548D3F36E5"
        },
        {
          base: "c60_t0xB26631c6dda06aD89B93C71400D25692de89c068"
        },
        {
          base: "c60_t0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206"
        },
        {
          base: "c60_t0xB6ff96B8A8d214544Ca0dBc9B33f7AD6503eFD32"
        },
        {
          base: "c60_t0xb753428af26E81097e7fD17f40c88aaA3E04902c"
        },
        {
          base: "c60_t0xB9d99C33eA2d86EC5eC6b8A4dD816EBBA64404AF"
        },
        {
          base: "c60_t0xba100000625a3754423978a60c9317c58a424e3D"
        },
        {
          base: "c60_t0xBa21Ef4c9f433Ede00badEFcC2754B8E74bd538A"
        },
        {
          base: "c60_t0xBBc2AE13b23d715c30720F079fcd9B4a74093505"
        },
        {
          base: "c60_t0xbC396689893D065F41bc2C6EcbeE5e0085233447"
        },
        {
          base: "c60_t0xc00e94Cb662C3520282E6f5717214004A7f26888"
        },
        {
          base: "c60_t0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F"
        },
        {
          base: "c60_t0xC0bA369c8Db6eB3924965e5c4FD0b4C1B91e305F"
        },
        {
          base: "c60_t0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72"
        },
        {
          base: "c60_t0xC4C2614E694cF534D407Ee49F8E44D125E4681c4"
        },
        {
          base: "c60_t0xC52C326331E9Ce41F04484d3B5E5648158028804"
        },
        {
          base: "c60_t0xCb5f72d37685C3D5aD0bB5F982443BC8FcdF570E"
        },
        {
          base: "c60_t0xCbfef8fdd706cde6F208460f2Bf39Aa9c785F05D"
        },
        {
          base: "c60_t0xCC4304A31d09258b0029eA7FE63d032f52e44EFe"
        },
        {
          base: "c60_t0xD23Ac27148aF6A2f339BD82D0e3CFF380b5093de"
        },
        {
          base: "c60_t0xd26114cd6EE289AccF82350c8d8487fedB8A0C07"
        },
        {
          base: "c60_t0xd379700999F4805Ce80aa32DB46A94dF64561108"
        },
        {
          base: "c60_t0xD46bA6D942050d489DBd938a2C909A5d5039A161"
        },
        {
          base: "c60_t0xD533a949740bb3306d119CC777fa900bA034cd52"
        },
        {
          base: "c60_t0xdAC17F958D2ee523a2206206994597C13D831ec7"
        },
        {
          base: "c60_t0xDDB3422497E61e13543BeA06989C0789117555c5"
        },
        {
          base: "c60_t0xE41d2489571d322189246DaFA5ebDe1F4699F498"
        },
        {
          base: "c60_t0xE452E6Ea2dDeB012e20dB73bf5d3863A3Ac8d77a"
        },
        {
          base: "c60_t0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55"
        },
        {
          base: "c60_t0xE61fDAF474Fac07063f2234Fb9e60C1163Cfa850"
        },
        {
          base: "c60_t0xE95A203B1a91a908F9B9CE46459d101078c2c3cb"
        },
        {
          base: "c60_t0xEa319e87Cf06203DAe107Dd8E5672175e3Ee976c"
        },
        {
          base: "c60_t0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D"
        },
        {
          base: "c60_t0xeEAA40B28A2d1b0B08f6f97bB1DD4B75316c6107"
        },
        {
          base: "c60_t0xEec2bE5c91ae7f8a338e1e5f3b5DE49d07AfdC81"
        },
        {
          base: "c60_t0xEEF9f339514298C6A857EfCfC1A762aF84438dEE"
        },
        {
          base: "c60_t0xf1f955016EcbCd7321c7266BccFB96c68ea5E49b"
        },
        {
          base: "c60_t0xf418588522d5dd018b425E472991E52EBBeEEEEE"
        },
        {
          base: "c60_t0xf4CD3d3Fda8d7Fd6C5a500203e38640A70Bf9577"
        },
        {
          base: "c60_t0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c"
        },
        {
          base: "c60_t0xF938424F7210f31dF2Aee3011291b658f872e91e"
        },
        {
          base: "c60_t0xF94b5C5651c888d928439aB6514B93944eEE6F48"
        },
        {
          base: "c60_t0xfF20817765cB7f73d4bde2e66e067E58D11095C2"
        },
        {
          base: "c60_t0xf4d2888d29D722226FafA5d9B24F9164c092421E"
        },
        {
          base: "c60_t0x70e8dE73cE538DA2bEEd35d14187F6959a8ecA96"
        },
        {
          base: "c60_t0xbAFDabaDcf19d0cFbbe0AB9C69CF050D86ff888C"
        },
        {
          base: "c60_t0xB0c7a3Ba49C7a6EaBa6cD4a96C55a1391070Ac9A"
        },
        {
          base: "c60_t0xCEBA2a8F6Ec221AEB5f3a7bcd15Cbc7e6a387bfb"
        }
      ]
    },
    {
      chainId: 1,
      asset: "c60_t0x0000000000085d4780B73119b644AE5ecd22b376",
      type: "ERC20",
      address: "0x0000000000085d4780B73119b644AE5ecd22b376",
      name: "TrueUSD",
      symbol: "TUSD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0000000000085d4780B73119b644AE5ecd22b376/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0000000000095413afC295d19EDeb1Ad7B71c952",
      type: "ERC20",
      address: "0x0000000000095413afC295d19EDeb1Ad7B71c952",
      name: "Tokenlon",
      symbol: "LON",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0000000000095413afC295d19EDeb1Ad7B71c952/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7",
      type: "ERC20",
      address: "0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7",
      name: "SKALE Network",
      symbol: "SKL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
      type: "ERC20",
      address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
      name: "UniLend",
      symbol: "UFT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
      type: "ERC20",
      address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
      name: "Orion Protocol",
      symbol: "ORN",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
      type: "ERC20",
      address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
      name: "Rai Reflex Index",
      symbol: "RAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0488401c3F535193Fa8Df029d9fFe615A06E74E6",
      type: "ERC20",
      address: "0x0488401c3F535193Fa8Df029d9fFe615A06E74E6",
      name: "SparkPoint",
      symbol: "SRK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0488401c3F535193Fa8Df029d9fFe615A06E74E6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
      type: "ERC20",
      address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
      name: "UMA",
      symbol: "UMA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x06A01a4d579479Dd5D884EBf61A31727A3d8D442",
      type: "ERC20",
      address: "0x06A01a4d579479Dd5D884EBf61A31727A3d8D442",
      name: "SmartKey",
      symbol: "Skey",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x06A01a4d579479Dd5D884EBf61A31727A3d8D442/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x07150e919B4De5fD6a63DE1F9384828396f25fDC",
      type: "ERC20",
      address: "0x07150e919B4De5fD6a63DE1F9384828396f25fDC",
      name: "Base Protocol",
      symbol: "BASE",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x07150e919B4De5fD6a63DE1F9384828396f25fDC/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
      type: "ERC20",
      address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
      name: "Mirror Protocol",
      symbol: "MIR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x09a3EcAFa817268f77BE1283176B946C4ff2E608/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x09e64c2B61a5f1690Ee6fbeD9baf5D6990F8dFd0",
      type: "ERC20",
      address: "0x09e64c2B61a5f1690Ee6fbeD9baf5D6990F8dFd0",
      name: "Growth DeFi",
      symbol: "GRO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x09e64c2B61a5f1690Ee6fbeD9baf5D6990F8dFd0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0a50C93c762fDD6E56D86215C24AaAD43aB629aa",
      type: "ERC20",
      address: "0x0a50C93c762fDD6E56D86215C24AaAD43aB629aa",
      name: "LGO Token",
      symbol: "LGO",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0a50C93c762fDD6E56D86215C24AaAD43aB629aa/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x0Ae055097C6d159879521C384F1D2123D1f195e6",
      type: "ERC20",
      address: "0x0Ae055097C6d159879521C384F1D2123D1f195e6",
      name: "xDai",
      symbol: "STAKE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0Ae055097C6d159879521C384F1D2123D1f195e6/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
      type: "ERC20",
      address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
      name: "yearn.finance",
      symbol: "YFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
      type: "ERC20",
      address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
      name: "Bifrost",
      symbol: "BFC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0CDF9acd87E940837ff21BB40c9fd55F68bba059",
      type: "ERC20",
      address: "0x0CDF9acd87E940837ff21BB40c9fd55F68bba059",
      name: "Public Mint",
      symbol: "MINT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0CDF9acd87E940837ff21BB40c9fd55F68bba059/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e",
      type: "ERC20",
      address: "0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e",
      name: "PoolTogether",
      symbol: "POOL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
      type: "ERC20",
      address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
      name: "Basic Attention Token",
      symbol: "BAT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0D8775F648430679A709E98d2b0Cb6250d2887EF/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0f51bb10119727a7e5eA3538074fb341F56B09Ad",
      type: "ERC20",
      address: "0x0f51bb10119727a7e5eA3538074fb341F56B09Ad",
      name: "DAO Maker",
      symbol: "DAO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0f51bb10119727a7e5eA3538074fb341F56B09Ad/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
      type: "ERC20",
      address: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
      name: "Decentraland",
      symbol: "MANA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0F5D2fB29fb7d3CFeE444a200298f468908cC942/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0f7F961648aE6Db43C75663aC7E5414Eb79b5704",
      type: "ERC20",
      address: "0x0f7F961648aE6Db43C75663aC7E5414Eb79b5704",
      name: "Blockzero Labs",
      symbol: "XIO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0f7F961648aE6Db43C75663aC7E5414Eb79b5704/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
      type: "ERC20",
      address: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
      name: "Pundi X",
      symbol: "PUNDIX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
      type: "ERC20",
      address: "0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
      name: "Unilayer",
      symbol: "LAYER",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x0fF6ffcFDa92c53F615a4A75D982f399C989366b/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x10Be9a8dAe441d276a5027936c3aADEd2d82bC15",
      type: "ERC20",
      address: "0x10Be9a8dAe441d276a5027936c3aADEd2d82bC15",
      name: "UniMex Network",
      symbol: "UMX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x10Be9a8dAe441d276a5027936c3aADEd2d82bC15/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x111111111117dC0aa78b770fA6A738034120C302",
      type: "ERC20",
      address: "0x111111111117dC0aa78b770fA6A738034120C302",
      name: "1INCH Token",
      symbol: "1INCH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x111111111117dC0aa78b770fA6A738034120C302/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1337DEF16F9B486fAEd0293eb623Dc8395dFE46a",
      type: "ERC20",
      address: "0x1337DEF16F9B486fAEd0293eb623Dc8395dFE46a",
      name: "ARMOR",
      symbol: "ARMOR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1337DEF16F9B486fAEd0293eb623Dc8395dFE46a/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1337DEF18C680aF1f9f45cBcab6309562975b1dD",
      type: "ERC20",
      address: "0x1337DEF18C680aF1f9f45cBcab6309562975b1dD",
      name: "Armor NXM",
      symbol: "arNXM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1337DEF18C680aF1f9f45cBcab6309562975b1dD/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
      type: "ERC20",
      address: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
      name: "DeFi Pulse Index",
      symbol: "DPI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x152687Bc4A7FCC89049cF119F9ac3e5aCF2eE7ef",
      type: "ERC20",
      address: "0x152687Bc4A7FCC89049cF119F9ac3e5aCF2eE7ef",
      name: "DeltaHub Community",
      symbol: "DHC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x152687Bc4A7FCC89049cF119F9ac3e5aCF2eE7ef/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x15874d65e649880c2614e7a480cb7c9A55787FF6",
      type: "ERC20",
      address: "0x15874d65e649880c2614e7a480cb7c9A55787FF6",
      name: "EthereumMax",
      symbol: "eMax",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x15874d65e649880c2614e7a480cb7c9A55787FF6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1614F18Fc94f47967A3Fbe5FfcD46d4e7Da3D787",
      type: "ERC20",
      address: "0x1614F18Fc94f47967A3Fbe5FfcD46d4e7Da3D787",
      name: "PAID Network",
      symbol: "PAID",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1614F18Fc94f47967A3Fbe5FfcD46d4e7Da3D787/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x16980b3B4a3f9D89E33311B5aa8f80303E5ca4F8",
      type: "ERC20",
      address: "0x16980b3B4a3f9D89E33311B5aa8f80303E5ca4F8",
      name: "KIRA Network",
      symbol: "KEX",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x16980b3B4a3f9D89E33311B5aa8f80303E5ca4F8/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
      type: "ERC20",
      address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
      name: "Polychain Monsters",
      symbol: "PMON",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1796ae0b0fa4862485106a0de9b654eFE301D0b2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3",
      type: "ERC20",
      address: "0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3",
      name: "Cryptocurrency Top 10 Tokens Index",
      symbol: "CC10",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998",
      type: "ERC20",
      address: "0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998",
      name: "Audius",
      symbol: "AUDIO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x1985365e9f78359a9B6AD760e32412f4a445E862",
      type: "ERC20",
      address: "0x1985365e9f78359a9B6AD760e32412f4a445E862",
      name: "Augur",
      symbol: "REP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1985365e9f78359a9B6AD760e32412f4a445E862/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1b40183EFB4Dd766f11bDa7A7c3AD8982e998421",
      type: "ERC20",
      address: "0x1b40183EFB4Dd766f11bDa7A7c3AD8982e998421",
      name: "Vesper",
      symbol: "VSP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1b40183EFB4Dd766f11bDa7A7c3AD8982e998421/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1C9491865a1DE77C5b6e19d2E6a5F1D7a6F2b25F",
      type: "ERC20",
      address: "0x1C9491865a1DE77C5b6e19d2E6a5F1D7a6F2b25F",
      name: "Antimatter.Finance Governance Token",
      symbol: "MATTER",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1C9491865a1DE77C5b6e19d2E6a5F1D7a6F2b25F/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1C9922314ED1415c95b9FD453c3818fd41867d0B",
      type: "ERC20",
      address: "0x1C9922314ED1415c95b9FD453c3818fd41867d0B",
      name: "TOWER",
      symbol: "TOWER",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1C9922314ED1415c95b9FD453c3818fd41867d0B/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1cBb83EbcD552D5EBf8131eF8c9CD9d9BAB342bC",
      type: "ERC20",
      address: "0x1cBb83EbcD552D5EBf8131eF8c9CD9d9BAB342bC",
      name: "Non-Fungible Yearn",
      symbol: "NFY",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1cBb83EbcD552D5EBf8131eF8c9CD9d9BAB342bC/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44",
      type: "ERC20",
      address: "0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44",
      name: "Keep3rV1",
      symbol: "KP3R",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1dD80016e3d4ae146Ee2EBB484e8edD92dacC4ce",
      type: "ERC20",
      address: "0x1dD80016e3d4ae146Ee2EBB484e8edD92dacC4ce",
      name: "Lead Wallet",
      symbol: "LEAD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1dD80016e3d4ae146Ee2EBB484e8edD92dacC4ce/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
      type: "ERC20",
      address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
      name: "Uniswap",
      symbol: "UNI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1fE24F25b1Cf609B9c4e7E12D802e3640dFA5e43",
      type: "ERC20",
      address: "0x1fE24F25b1Cf609B9c4e7E12D802e3640dFA5e43",
      name: "ChainGuardians Governance Token",
      symbol: "CGG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1fE24F25b1Cf609B9c4e7E12D802e3640dFA5e43/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x21BfBDa47A0B4B5b1248c767Ee49F7caA9B23697",
      type: "ERC20",
      address: "0x21BfBDa47A0B4B5b1248c767Ee49F7caA9B23697",
      name: "OVR",
      symbol: "OVR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x21BfBDa47A0B4B5b1248c767Ee49F7caA9B23697/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x221657776846890989a759BA2973e427DfF5C9bB",
      type: "ERC20",
      address: "0x221657776846890989a759BA2973e427DfF5C9bB",
      name: "Reputation",
      symbol: "REPv2",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x221657776846890989a759BA2973e427DfF5C9bB/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      type: "ERC20",
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      name: "Wrapped Bitcoin",
      symbol: "WBTC",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x226f7b842E0F0120b7E194D05432b3fd14773a9D",
      type: "ERC20",
      address: "0x226f7b842E0F0120b7E194D05432b3fd14773a9D",
      name: "UNION Protocol Governance Token",
      symbol: "UNN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x226f7b842E0F0120b7E194D05432b3fd14773a9D/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x23B608675a2B2fB1890d3ABBd85c5775c51691d5",
      type: "ERC20",
      address: "0x23B608675a2B2fB1890d3ABBd85c5775c51691d5",
      name: "Unisocks Edition 0",
      symbol: "SOCKS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x23B608675a2B2fB1890d3ABBd85c5775c51691d5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x25e1474170c4c0aA64fa98123bdc8dB49D7802fa",
      type: "ERC20",
      address: "0x25e1474170c4c0aA64fa98123bdc8dB49D7802fa",
      name: "Bidao",
      symbol: "BID",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x25e1474170c4c0aA64fa98123bdc8dB49D7802fa/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x26c8AFBBFE1EBaca03C2bB082E69D0476Bffe099",
      type: "ERC20",
      address: "0x26c8AFBBFE1EBaca03C2bB082E69D0476Bffe099",
      name: "Cellframe",
      symbol: "CELL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x26c8AFBBFE1EBaca03C2bB082E69D0476Bffe099/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x26E43759551333e57F073bb0772F50329A957b30",
      type: "ERC20",
      address: "0x26E43759551333e57F073bb0772F50329A957b30",
      name: "DegenVC",
      symbol: "DGVC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x26E43759551333e57F073bb0772F50329A957b30/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x27C70Cd1946795B66be9d954418546998b546634",
      type: "ERC20",
      address: "0x27C70Cd1946795B66be9d954418546998b546634",
      name: "DOGE KILLER",
      symbol: "LEASH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x27C70Cd1946795B66be9d954418546998b546634/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x29502fE4d233EF0b45C3647101Fa1252cE0634BD",
      type: "ERC20",
      address: "0x29502fE4d233EF0b45C3647101Fa1252cE0634BD",
      name: "Froge Finance",
      symbol: "FROGE",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x29502fE4d233EF0b45C3647101Fa1252cE0634BD/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39",
      type: "ERC20",
      address: "0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39",
      name: "HEX",
      symbol: "HEX",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x2ba592F78dB6436527729929AAf6c908497cB200",
      type: "ERC20",
      address: "0x2ba592F78dB6436527729929AAf6c908497cB200",
      name: "Cream Finance",
      symbol: "CREAM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x2ba592F78dB6436527729929AAf6c908497cB200/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
      type: "ERC20",
      address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
      name: "Mettalex",
      symbol: "MTLX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x2e2f3246b6c65CCc4239c9Ee556EC143a7E5DE2c",
      type: "ERC20",
      address: "0x2e2f3246b6c65CCc4239c9Ee556EC143a7E5DE2c",
      name: "Yfi.mobi",
      symbol: "YFIM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x2e2f3246b6c65CCc4239c9Ee556EC143a7E5DE2c/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5",
      type: "ERC20",
      address: "0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5",
      name: "ZeroSwap",
      symbol: "ZEE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x30f271C9E86D2B7d00a6376Cd96A1cFBD5F0b9b3",
      type: "ERC20",
      address: "0x30f271C9E86D2B7d00a6376Cd96A1cFBD5F0b9b3",
      name: "Decentr",
      symbol: "DEC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x30f271C9E86D2B7d00a6376Cd96A1cFBD5F0b9b3/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3155BA85D5F96b2d030a4966AF206230e46849cb",
      type: "ERC20",
      address: "0x3155BA85D5F96b2d030a4966AF206230e46849cb",
      name: "THORChain ETH.RUNE",
      symbol: "RUNE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3155BA85D5F96b2d030a4966AF206230e46849cb/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3301Ee63Fb29F863f2333Bd4466acb46CD8323E6",
      type: "ERC20",
      address: "0x3301Ee63Fb29F863f2333Bd4466acb46CD8323E6",
      name: "Akita Inu",
      symbol: "AKITA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3301Ee63Fb29F863f2333Bd4466acb46CD8323E6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3383c5a8969Dc413bfdDc9656Eb80A1408E4bA20",
      type: "ERC20",
      address: "0x3383c5a8969Dc413bfdDc9656Eb80A1408E4bA20",
      name: "Anatha",
      symbol: "wANATHA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3383c5a8969Dc413bfdDc9656Eb80A1408E4bA20/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f",
      type: "ERC20",
      address: "0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f",
      name: "RAMP DEFI",
      symbol: "RAMP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3593D125a4f7849a1B059E64F4517A86Dd60c95d",
      type: "ERC20",
      address: "0x3593D125a4f7849a1B059E64F4517A86Dd60c95d",
      name: "MANTRA DAO",
      symbol: "OM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3593D125a4f7849a1B059E64F4517A86Dd60c95d/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x362bc847A3a9637d3af6624EeC853618a43ed7D2",
      type: "ERC20",
      address: "0x362bc847A3a9637d3af6624EeC853618a43ed7D2",
      name: "PARSIQ",
      symbol: "PRQ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x362bc847A3a9637d3af6624EeC853618a43ed7D2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
      type: "ERC20",
      address: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
      name: "The Sandbox",
      symbol: "SAND",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3845badAde8e6dFF049820680d1F14bD3903a5d0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x38e4adB44ef08F22F5B5b76A8f0c2d0dCbE7DcA1",
      type: "ERC20",
      address: "0x38e4adB44ef08F22F5B5b76A8f0c2d0dCbE7DcA1",
      name: "Concentrated Voting Power",
      symbol: "CVP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x38e4adB44ef08F22F5B5b76A8f0c2d0dCbE7DcA1/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3aFfCCa64c2A6f4e3B6Bd9c64CD2C969EFd1ECBe",
      type: "ERC20",
      address: "0x3aFfCCa64c2A6f4e3B6Bd9c64CD2C969EFd1ECBe",
      name: "DSLA",
      symbol: "DSLA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3aFfCCa64c2A6f4e3B6Bd9c64CD2C969EFd1ECBe/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3D3D35bb9bEC23b06Ca00fe472b50E7A4c692C30",
      type: "ERC20",
      address: "0x3D3D35bb9bEC23b06Ca00fe472b50E7A4c692C30",
      name: "Vidya",
      symbol: "VIDYA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3D3D35bb9bEC23b06Ca00fe472b50E7A4c692C30/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x408e41876cCCDC0F92210600ef50372656052a38",
      type: "ERC20",
      address: "0x408e41876cCCDC0F92210600ef50372656052a38",
      name: "Ren",
      symbol: "REN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x408e41876cCCDC0F92210600ef50372656052a38/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x40FD72257597aA14C7231A7B1aaa29Fce868F677",
      type: "ERC20",
      address: "0x40FD72257597aA14C7231A7B1aaa29Fce868F677",
      name: "SORA",
      symbol: "XOR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x40FD72257597aA14C7231A7B1aaa29Fce868F677/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b",
      type: "ERC20",
      address: "0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b",
      name: "FunFair",
      symbol: "FUN",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x41A3Dba3D677E573636BA691a70ff2D606c29666",
      type: "ERC20",
      address: "0x41A3Dba3D677E573636BA691a70ff2D606c29666",
      name: "GoBlank",
      symbol: "BLANK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x41A3Dba3D677E573636BA691a70ff2D606c29666/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5",
      type: "ERC20",
      address: "0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5",
      name: "Pickle Finance",
      symbol: "PICKLE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x431ad2ff6a9C365805eBaD47Ee021148d6f7DBe0",
      type: "ERC20",
      address: "0x431ad2ff6a9C365805eBaD47Ee021148d6f7DBe0",
      name: "dForce",
      symbol: "DF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x431ad2ff6a9C365805eBaD47Ee021148d6f7DBe0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
      type: "ERC20",
      address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
      name: "FLOKI",
      symbol: "FLOKI",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
      type: "ERC20",
      address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
      name: "Orchid",
      symbol: "OXT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4575f41308EC1483f3d399aa9a2826d74Da13Deb/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      type: "ERC20",
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      name: "PAX Gold",
      symbol: "PAXG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x45804880De22913dAFE09f4980848ECE6EcbAf78/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
      type: "ERC20",
      address: "0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
      name: "WOO Network",
      symbol: "WOO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4691937a7508860F876c9c0a2a617E7d9E945D4B/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4a220E6096B25EADb88358cb44068A3248254675",
      type: "ERC20",
      address: "0x4a220E6096B25EADb88358cb44068A3248254675",
      name: "Quant",
      symbol: "QNT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4a220E6096B25EADb88358cb44068A3248254675/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4B1E80cAC91e2216EEb63e29B957eB91Ae9C2Be8",
      type: "ERC20",
      address: "0x4B1E80cAC91e2216EEb63e29B957eB91Ae9C2Be8",
      name: "Jupiter",
      symbol: "JUP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4B1E80cAC91e2216EEb63e29B957eB91Ae9C2Be8/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4c11249814f11b9346808179Cf06e71ac328c1b5",
      type: "ERC20",
      address: "0x4c11249814f11b9346808179Cf06e71ac328c1b5",
      name: "Oraichain Token",
      symbol: "ORAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4c11249814f11b9346808179Cf06e71ac328c1b5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4C19596f5aAfF459fA38B0f7eD92F11AE6543784",
      type: "ERC20",
      address: "0x4C19596f5aAfF459fA38B0f7eD92F11AE6543784",
      name: "TrueFi",
      symbol: "TRU",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4C19596f5aAfF459fA38B0f7eD92F11AE6543784/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42",
      type: "ERC20",
      address: "0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42",
      name: "MCDEX Token",
      symbol: "MCB",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
      type: "ERC20",
      address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
      name: "NuCypher",
      symbol: "NU",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4fE83213D56308330EC302a8BD641f1d0113A4Cc/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x50DE6856358Cc35f3A9a57eAAA34BD4cB707d2cd",
      type: "ERC20",
      address: "0x50DE6856358Cc35f3A9a57eAAA34BD4cB707d2cd",
      name: "Razor Network",
      symbol: "RAZOR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x50DE6856358Cc35f3A9a57eAAA34BD4cB707d2cd/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x514910771AF9Ca656af840dff83E8264EcF986CA",
      type: "ERC20",
      address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      name: "Chainlink",
      symbol: "LINK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5218E472cFCFE0b64A064F055B43b4cdC9EfD3A6",
      type: "ERC20",
      address: "0x5218E472cFCFE0b64A064F055B43b4cdC9EfD3A6",
      name: "unFederalReserve",
      symbol: "eRSDL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5218E472cFCFE0b64A064F055B43b4cdC9EfD3A6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5228a22e72ccC52d415EcFd199F99D0665E7733b",
      type: "ERC20",
      address: "0x5228a22e72ccC52d415EcFd199F99D0665E7733b",
      name: "pTokens BTC",
      symbol: "pBTC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5228a22e72ccC52d415EcFd199F99D0665E7733b/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x54C9EA2E9C9E8eD865Db4A4ce6711C2a0d5063Ba",
      type: "ERC20",
      address: "0x54C9EA2E9C9E8eD865Db4A4ce6711C2a0d5063Ba",
      name: "BarterTrade",
      symbol: "BART",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x54C9EA2E9C9E8eD865Db4A4ce6711C2a0d5063Ba/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x557B933a7C2c45672B610F8954A3deB39a51A8Ca",
      type: "ERC20",
      address: "0x557B933a7C2c45672B610F8954A3deB39a51A8Ca",
      name: "REVV",
      symbol: "REVV",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x557B933a7C2c45672B610F8954A3deB39a51A8Ca/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
      type: "ERC20",
      address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
      name: "sUSD",
      symbol: "sUSD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x57Ab1ec28D129707052df4dF418D58a2D46d5f51/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x584bC13c7D411c00c01A62e8019472dE68768430",
      type: "ERC20",
      address: "0x584bC13c7D411c00c01A62e8019472dE68768430",
      name: "Hegic",
      symbol: "HEGIC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x584bC13c7D411c00c01A62e8019472dE68768430/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5a666c7d92E5fA7Edcb6390E4efD6d0CDd69cF37",
      type: "ERC20",
      address: "0x5a666c7d92E5fA7Edcb6390E4efD6d0CDd69cF37",
      name: "UnMarshal",
      symbol: "MARSH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5a666c7d92E5fA7Edcb6390E4efD6d0CDd69cF37/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5BEfBB272290dD5b8521D4a938f6c4757742c430",
      type: "ERC20",
      address: "0x5BEfBB272290dD5b8521D4a938f6c4757742c430",
      name: "Xfinance",
      symbol: "XFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5BEfBB272290dD5b8521D4a938f6c4757742c430/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5cAf454Ba92e6F2c929DF14667Ee360eD9fD5b26",
      type: "ERC20",
      address: "0x5cAf454Ba92e6F2c929DF14667Ee360eD9fD5b26",
      name: "Dev",
      symbol: "DEV",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5cAf454Ba92e6F2c929DF14667Ee360eD9fD5b26/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5Dc02Ea99285E17656b8350722694c35154DB1E8",
      type: "ERC20",
      address: "0x5Dc02Ea99285E17656b8350722694c35154DB1E8",
      name: "BOND",
      symbol: "BOND",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5Dc02Ea99285E17656b8350722694c35154DB1E8/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5F64Ab1544D28732F0A24F4713c2C8ec0dA089f0",
      type: "ERC20",
      address: "0x5F64Ab1544D28732F0A24F4713c2C8ec0dA089f0",
      name: "DEXTF Token",
      symbol: "DEXTF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5F64Ab1544D28732F0A24F4713c2C8ec0dA089f0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
      type: "ERC20",
      address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
      name: "Liquity USD",
      symbol: "LUSD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5f98805A4E8be255a32880FDeC7F6728C6568bA0/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x607F4C5BB672230e8672085532f7e901544a7375",
      type: "ERC20",
      address: "0x607F4C5BB672230e8672085532f7e901544a7375",
      name: "iExec RLC",
      symbol: "RLC",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x607F4C5BB672230e8672085532f7e901544a7375/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6149C26Cd2f7b5CCdb32029aF817123F6E37Df5B",
      type: "ERC20",
      address: "0x6149C26Cd2f7b5CCdb32029aF817123F6E37Df5B",
      name: "Launchpool",
      symbol: "LPOOL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6149C26Cd2f7b5CCdb32029aF817123F6E37Df5B/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x62359Ed7505Efc61FF1D56fEF82158CcaffA23D7",
      type: "ERC20",
      address: "0x62359Ed7505Efc61FF1D56fEF82158CcaffA23D7",
      name: "cVault.finance",
      symbol: "CORE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x62359Ed7505Efc61FF1D56fEF82158CcaffA23D7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6243d8CEA23066d098a15582d81a598b4e8391F4",
      type: "ERC20",
      address: "0x6243d8CEA23066d098a15582d81a598b4e8391F4",
      name: "Reflexer Ungovernance Token",
      symbol: "FLX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6243d8CEA23066d098a15582d81a598b4e8391F4/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x626E8036dEB333b408Be468F951bdB42433cBF18",
      type: "ERC20",
      address: "0x626E8036dEB333b408Be468F951bdB42433cBF18",
      name: "AIOZ Network",
      symbol: "AIOZ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x626E8036dEB333b408Be468F951bdB42433cBF18/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x63b4f3e3fa4e438698CE330e365E831F7cCD1eF4",
      type: "ERC20",
      address: "0x63b4f3e3fa4e438698CE330e365E831F7cCD1eF4",
      name: "CyberFi Token",
      symbol: "CFi",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x63b4f3e3fa4e438698CE330e365E831F7cCD1eF4/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6",
      type: "ERC20",
      address: "0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6",
      name: "Wise Token",
      symbol: "WISE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x67B6D479c7bB412C54e03dCA8E1Bc6740ce6b99C",
      type: "ERC20",
      address: "0x67B6D479c7bB412C54e03dCA8E1Bc6740ce6b99C",
      name: "Kylin",
      symbol: "KYL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x67B6D479c7bB412C54e03dCA8E1Bc6740ce6b99C/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x67c597624B17b16fb77959217360B7cD18284253",
      type: "ERC20",
      address: "0x67c597624B17b16fb77959217360B7cD18284253",
      name: "Benchmark Protocol",
      symbol: "MARK",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x67c597624B17b16fb77959217360B7cD18284253/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6810e776880C02933D47DB1b9fc05908e5386b96",
      type: "ERC20",
      address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
      name: "Gnosis",
      symbol: "GNO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6810e776880C02933D47DB1b9fc05908e5386b96/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x69692D3345010a207b759a7D1af6fc7F38b35c5E",
      type: "ERC20",
      address: "0x69692D3345010a207b759a7D1af6fc7F38b35c5E",
      name: "chads.vc",
      symbol: "CHADS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x69692D3345010a207b759a7D1af6fc7F38b35c5E/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x69A95185ee2a045CDC4bCd1b1Df10710395e4e23",
      type: "ERC20",
      address: "0x69A95185ee2a045CDC4bCd1b1Df10710395e4e23",
      name: "Poolz Finance",
      symbol: "POOLZ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x69A95185ee2a045CDC4bCd1b1Df10710395e4e23/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074",
      type: "ERC20",
      address: "0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074",
      name: "Mask Network",
      symbol: "MASK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x6B175474E89094C44Da98b954EedeAC495271d0F",
      type: "ERC20",
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      name: "Dai",
      symbol: "DAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
      type: "ERC20",
      address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
      name: "SushiSwap",
      symbol: "SUSHI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6B3595068778DD592e39A122f4f5a5cF09C90fE2/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x6BFf2fE249601ed0Db3a87424a2E923118BB0312",
      type: "ERC20",
      address: "0x6BFf2fE249601ed0Db3a87424a2E923118BB0312",
      name: "Fyooz",
      symbol: "FYZ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6BFf2fE249601ed0Db3a87424a2E923118BB0312/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6c6EE5e31d828De241282B9606C8e98Ea48526E2",
      type: "ERC20",
      address: "0x6c6EE5e31d828De241282B9606C8e98Ea48526E2",
      name: "Holo",
      symbol: "HOT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6c6EE5e31d828De241282B9606C8e98Ea48526E2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6e0daDE58D2d89eBBe7aFc384e3E4f15b70b14D8",
      type: "ERC20",
      address: "0x6e0daDE58D2d89eBBe7aFc384e3E4f15b70b14D8",
      name: "QuiverX",
      symbol: "QRX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6e0daDE58D2d89eBBe7aFc384e3E4f15b70b14D8/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1",
      type: "ERC20",
      address: "0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1",
      name: "UniTrade",
      symbol: "TRADE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6fC13EACE26590B80cCCAB1ba5d51890577D83B2",
      type: "ERC20",
      address: "0x6fC13EACE26590B80cCCAB1ba5d51890577D83B2",
      name: "Umbrella Network",
      symbol: "UMB",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6fC13EACE26590B80cCCAB1ba5d51890577D83B2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x70401dFD142A16dC7031c56E862Fc88Cb9537Ce0",
      type: "ERC20",
      address: "0x70401dFD142A16dC7031c56E862Fc88Cb9537Ce0",
      name: "Bird.Money",
      symbol: "BIRD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x70401dFD142A16dC7031c56E862Fc88Cb9537Ce0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x71F85B2E46976bD21302B64329868fd15eb0D127",
      type: "ERC20",
      address: "0x71F85B2E46976bD21302B64329868fd15eb0D127",
      name: "Axion",
      symbol: "AXN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x71F85B2E46976bD21302B64329868fd15eb0D127/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x725C263e32c72dDC3A19bEa12C5a0479a81eE688",
      type: "ERC20",
      address: "0x725C263e32c72dDC3A19bEa12C5a0479a81eE688",
      name: "Bridge Mutual",
      symbol: "BMI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x725C263e32c72dDC3A19bEa12C5a0479a81eE688/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x72630B1e3B42874bf335020Ba0249e3E9e47Bafc",
      type: "ERC20",
      address: "0x72630B1e3B42874bf335020Ba0249e3E9e47Bafc",
      name: "Paypolitan Token",
      symbol: "EPAN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x72630B1e3B42874bf335020Ba0249e3E9e47Bafc/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x72e364F2ABdC788b7E918bc238B21f109Cd634D7",
      type: "ERC20",
      address: "0x72e364F2ABdC788b7E918bc238B21f109Cd634D7",
      name: "Metaverse Index",
      symbol: "MVI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x72e364F2ABdC788b7E918bc238B21f109Cd634D7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x72e9D9038cE484EE986FEa183f8d8Df93f9aDA13",
      type: "ERC20",
      address: "0x72e9D9038cE484EE986FEa183f8d8Df93f9aDA13",
      name: "SmartCredit Token",
      symbol: "SMARTCREDIT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x72e9D9038cE484EE986FEa183f8d8Df93f9aDA13/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x761D38e5ddf6ccf6Cf7c55759d5210750B5D60F3",
      type: "ERC20",
      address: "0x761D38e5ddf6ccf6Cf7c55759d5210750B5D60F3",
      name: "Dogelon",
      symbol: "ELON",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x761D38e5ddf6ccf6Cf7c55759d5210750B5D60F3/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7659CE147D0e714454073a5dd7003544234b6Aa0",
      type: "ERC20",
      address: "0x7659CE147D0e714454073a5dd7003544234b6Aa0",
      name: "XCAD Network",
      symbol: "XCAD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7659CE147D0e714454073a5dd7003544234b6Aa0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7671904eed7f10808B664fc30BB8693FD7237abF",
      type: "ERC20",
      address: "0x7671904eed7f10808B664fc30BB8693FD7237abF",
      name: "Boolberry",
      symbol: "BBR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7671904eed7f10808B664fc30BB8693FD7237abF/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x77777FeDdddFfC19Ff86DB637967013e6C6A116C",
      type: "ERC20",
      address: "0x77777FeDdddFfC19Ff86DB637967013e6C6A116C",
      name: "Tornado Cash",
      symbol: "TORN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x77777FeDdddFfC19Ff86DB637967013e6C6A116C/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7a2Bc711E19ba6aff6cE8246C546E8c4B4944DFD",
      type: "ERC20",
      address: "0x7a2Bc711E19ba6aff6cE8246C546E8c4B4944DFD",
      name: "WAXE",
      symbol: "WAXE",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7a2Bc711E19ba6aff6cE8246C546E8c4B4944DFD/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7b123f53421b1bF8533339BFBdc7C98aA94163db",
      type: "ERC20",
      address: "0x7b123f53421b1bF8533339BFBdc7C98aA94163db",
      name: "DFOhub",
      symbol: "buidl",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7b123f53421b1bF8533339BFBdc7C98aA94163db/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
      type: "ERC20",
      address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
      name: "Polygon",
      symbol: "MATIC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7",
      type: "ERC20",
      address: "0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7",
      name: "Robonomics",
      symbol: "XRT",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7F3EDcdD180Dbe4819Bd98FeE8929b5cEdB3AdEB",
      type: "ERC20",
      address: "0x7F3EDcdD180Dbe4819Bd98FeE8929b5cEdB3AdEB",
      name: "xToken",
      symbol: "XTK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7F3EDcdD180Dbe4819Bd98FeE8929b5cEdB3AdEB/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
      type: "ERC20",
      address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
      name: "Aave",
      symbol: "AAVE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x7FF4169a6B5122b664c51c95727d87750eC07c84",
      type: "ERC20",
      address: "0x7FF4169a6B5122b664c51c95727d87750eC07c84",
      name: "Tenset",
      symbol: "10SET",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x7FF4169a6B5122b664c51c95727d87750eC07c84/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26",
      type: "ERC20",
      address: "0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26",
      name: "Origin Protocol",
      symbol: "OGN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
      type: "ERC20",
      address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
      name: "Polkastarter",
      symbol: "POLS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x8400D94A5cb0fa0D041a3788e395285d61c9ee5e",
      type: "ERC20",
      address: "0x8400D94A5cb0fa0D041a3788e395285d61c9ee5e",
      name: "Unibright",
      symbol: "UBT",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8400D94A5cb0fa0D041a3788e395285d61c9ee5e/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
      type: "ERC20",
      address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
      name: "DIA",
      symbol: "DIA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x853d955aCEf822Db058eb8505911ED77F175b99e",
      type: "ERC20",
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      name: "Frax",
      symbol: "FRAX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x853d955aCEf822Db058eb8505911ED77F175b99e/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x85Eee30c52B0b379b046Fb0F85F4f3Dc3009aFEC",
      type: "ERC20",
      address: "0x85Eee30c52B0b379b046Fb0F85F4f3Dc3009aFEC",
      name: "KEEP Token",
      symbol: "KEEP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x85Eee30c52B0b379b046Fb0F85F4f3Dc3009aFEC/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8888801aF4d980682e47f1A9036e589479e835C5",
      type: "ERC20",
      address: "0x8888801aF4d980682e47f1A9036e589479e835C5",
      name: "88mph.app",
      symbol: "MPH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8888801aF4d980682e47f1A9036e589479e835C5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x88ACDd2a6425c3FaAE4Bc9650Fd7E27e0Bebb7aB",
      type: "ERC20",
      address: "0x88ACDd2a6425c3FaAE4Bc9650Fd7E27e0Bebb7aB",
      name: "Alchemist",
      symbol: "\u2697\uFE0F",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x88ACDd2a6425c3FaAE4Bc9650Fd7E27e0Bebb7aB/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x88EF27e69108B2633F8E1C184CC37940A075cC02",
      type: "ERC20",
      address: "0x88EF27e69108B2633F8E1C184CC37940A075cC02",
      name: "Dego Finance",
      symbol: "DEGO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x88EF27e69108B2633F8E1C184CC37940A075cC02/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
      type: "ERC20",
      address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
      name: "pNetwork",
      symbol: "PNT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8a40c222996f9F3431f63Bf80244C36822060f12",
      type: "ERC20",
      address: "0x8a40c222996f9F3431f63Bf80244C36822060f12",
      name: "Finxflo",
      symbol: "FXF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8a40c222996f9F3431f63Bf80244C36822060f12/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8a854288a5976036A725879164Ca3e91d30c6A1B",
      type: "ERC20",
      address: "0x8a854288a5976036A725879164Ca3e91d30c6A1B",
      name: "GET",
      symbol: "GET",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8a854288a5976036A725879164Ca3e91d30c6A1B/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xCE3f08e664693ca792caCE4af1364D5e220827B2",
      type: "ERC20",
      address: "0xCE3f08e664693ca792caCE4af1364D5e220827B2",
      name: "SAITAMA",
      symbol: "SAITAMA",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xCE3f08e664693ca792caCE4af1364D5e220827B2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8B39B70E39Aa811b69365398e0aACe9bee238AEb",
      type: "ERC20",
      address: "0x8B39B70E39Aa811b69365398e0aACe9bee238AEb",
      name: "PolkaFoundry",
      symbol: "PKF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8B39B70E39Aa811b69365398e0aACe9bee238AEb/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8c15Ef5b4B21951d50E53E4fbdA8298FFAD25057",
      type: "ERC20",
      address: "0x8c15Ef5b4B21951d50E53E4fbdA8298FFAD25057",
      name: "Function X",
      symbol: "FX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8c15Ef5b4B21951d50E53E4fbdA8298FFAD25057/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x8CE9137d39326AD0cD6491fb5CC0CbA0e089b6A9",
      type: "ERC20",
      address: "0x8CE9137d39326AD0cD6491fb5CC0CbA0e089b6A9",
      name: "Swipe",
      symbol: "SXP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8CE9137d39326AD0cD6491fb5CC0CbA0e089b6A9/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa",
      type: "ERC20",
      address: "0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa",
      name: "tBTC",
      symbol: "TBTC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x5B7533812759B45C2B44C19e320ba2cD2681b542",
      type: "ERC20",
      address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
      name: "SingularityNET Token",
      symbol: "AGIX",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x5B7533812759B45C2B44C19e320ba2cD2681b542/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x8f8221aFbB33998d8584A2B05749bA73c37a938a",
      type: "ERC20",
      address: "0x8f8221aFbB33998d8584A2B05749bA73c37a938a",
      name: "Request Token",
      symbol: "REQ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x8f8221aFbB33998d8584A2B05749bA73c37a938a/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9355372396e3F6daF13359B7b607a3374cc638e0",
      type: "ERC20",
      address: "0x9355372396e3F6daF13359B7b607a3374cc638e0",
      name: "WHALE",
      symbol: "WHALE",
      decimals: 4,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9355372396e3F6daF13359B7b607a3374cc638e0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x93ED3FBe21207Ec2E8f2d3c3de6e058Cb73Bc04d",
      type: "ERC20",
      address: "0x93ED3FBe21207Ec2E8f2d3c3de6e058Cb73Bc04d",
      name: "Pinakion",
      symbol: "PNK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x93ED3FBe21207Ec2E8f2d3c3de6e058Cb73Bc04d/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9469D013805bFfB7D3DEBe5E7839237e535ec483",
      type: "ERC20",
      address: "0x9469D013805bFfB7D3DEBe5E7839237e535ec483",
      name: "Evolution Land Global Token",
      symbol: "RING",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9469D013805bFfB7D3DEBe5E7839237e535ec483/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x954b890704693af242613edEf1B603825afcD708",
      type: "ERC20",
      address: "0x954b890704693af242613edEf1B603825afcD708",
      name: "Cardstack",
      symbol: "CARD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x954b890704693af242613edEf1B603825afcD708/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
      type: "ERC20",
      address: "0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
      name: "Fei USD",
      symbol: "FEI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x956F47F50A910163D8BF957Cf5846D573E7f87CA/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x95a4492F028aa1fd432Ea71146b433E7B4446611",
      type: "ERC20",
      address: "0x95a4492F028aa1fd432Ea71146b433E7B4446611",
      name: "APY.Finance",
      symbol: "APY",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x95a4492F028aa1fd432Ea71146b433E7B4446611/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
      type: "ERC20",
      address: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
      name: "SHIBA INU",
      symbol: "SHIB",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
      type: "ERC20",
      address: "0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
      name: "Dypius",
      symbol: "DYP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
      type: "ERC20",
      address: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
      name: "Ocean Protocol",
      symbol: "OCEAN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x967da4048cD07aB37855c090aAF366e4ce1b9F48/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x990f341946A3fdB507aE7e52d17851B87168017c",
      type: "ERC20",
      address: "0x990f341946A3fdB507aE7e52d17851B87168017c",
      name: "Strong",
      symbol: "STRONG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x990f341946A3fdB507aE7e52d17851B87168017c/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9B02dD390a603Add5c07f9fd9175b7DABE8D63B7",
      type: "ERC20",
      address: "0x9B02dD390a603Add5c07f9fd9175b7DABE8D63B7",
      name: "Shopping.io",
      symbol: "SPI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9B02dD390a603Add5c07f9fd9175b7DABE8D63B7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541",
      type: "ERC20",
      address: "0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541",
      name: "Binance Wrapped BTC",
      symbol: "BBTC",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9cEB84f92A0561fa3Cc4132aB9c0b76A59787544",
      type: "ERC20",
      address: "0x9cEB84f92A0561fa3Cc4132aB9c0b76A59787544",
      name: "Doki Doki Finance",
      symbol: "DOKI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9cEB84f92A0561fa3Cc4132aB9c0b76A59787544/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9EA3b5b4EC044b70375236A281986106457b20EF",
      type: "ERC20",
      address: "0x9EA3b5b4EC044b70375236A281986106457b20EF",
      name: "Delta Financial",
      symbol: "DELTA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9EA3b5b4EC044b70375236A281986106457b20EF/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9Ed8e7C9604790F7Ec589F99b94361d8AAB64E5E",
      type: "ERC20",
      address: "0x9Ed8e7C9604790F7Ec589F99b94361d8AAB64E5E",
      name: "Unistake",
      symbol: "UNISTAKE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9Ed8e7C9604790F7Ec589F99b94361d8AAB64E5E/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9f7229aF0c4b9740e207Ea283b9094983f78ba04",
      type: "ERC20",
      address: "0x9f7229aF0c4b9740e207Ea283b9094983f78ba04",
      name: "Tadpole",
      symbol: "TAD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9f7229aF0c4b9740e207Ea283b9094983f78ba04/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      type: "ERC20",
      address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      name: "Maker",
      symbol: "MKR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9F9c8ec3534c3cE16F928381372BfbFBFb9F4D24",
      type: "ERC20",
      address: "0x9F9c8ec3534c3cE16F928381372BfbFBFb9F4D24",
      name: "GraphLinq",
      symbol: "GLQ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9F9c8ec3534c3cE16F928381372BfbFBFb9F4D24/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa0246c9032bC3A600820415aE600c6388619A14D",
      type: "ERC20",
      address: "0xa0246c9032bC3A600820415aE600c6388619A14D",
      name: "Harvest Finance",
      symbol: "FARM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa0246c9032bC3A600820415aE600c6388619A14D/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa0afAA285Ce85974c3C881256cB7F225e3A1178a",
      type: "ERC20",
      address: "0xa0afAA285Ce85974c3C881256cB7F225e3A1178a",
      name: "Wrapped CrescoFin",
      symbol: "wCRES",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa0afAA285Ce85974c3C881256cB7F225e3A1178a/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      type: "ERC20",
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      name: "USD Coin",
      symbol: "USDC",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa117000000f279D81A1D3cc75430fAA017FA5A2e",
      type: "ERC20",
      address: "0xa117000000f279D81A1D3cc75430fAA017FA5A2e",
      name: "Aragon",
      symbol: "ANT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa117000000f279D81A1D3cc75430fAA017FA5A2e/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa1d6Df714F91DeBF4e0802A542E13067f31b8262",
      type: "ERC20",
      address: "0xa1d6Df714F91DeBF4e0802A542E13067f31b8262",
      name: "RFOX",
      symbol: "RFOX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa1d6Df714F91DeBF4e0802A542E13067f31b8262/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa393473d64d2F9F026B60b6Df7859A689715d092",
      type: "ERC20",
      address: "0xa393473d64d2F9F026B60b6Df7859A689715d092",
      name: "Lattice Token",
      symbol: "LTX",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa393473d64d2F9F026B60b6Df7859A689715d092/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
      type: "ERC20",
      address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
      name: "Meta",
      symbol: "MTA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xA4EED63db85311E22dF4473f87CcfC3DaDCFA3E3",
      type: "ERC20",
      address: "0xA4EED63db85311E22dF4473f87CcfC3DaDCFA3E3",
      name: "Rubic",
      symbol: "RBC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xA4EED63db85311E22dF4473f87CcfC3DaDCFA3E3/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xA8b919680258d369114910511cc87595aec0be6D",
      type: "ERC20",
      address: "0xA8b919680258d369114910511cc87595aec0be6D",
      name: "LUKSO",
      symbol: "LYXe",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xA8b919680258d369114910511cc87595aec0be6D/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca",
      type: "ERC20",
      address: "0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca",
      name: "Syntropy",
      symbol: "NOIA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xA91ac63D040dEB1b7A5E4d4134aD23eb0ba07e14",
      type: "ERC20",
      address: "0xA91ac63D040dEB1b7A5E4d4134aD23eb0ba07e14",
      name: "Bella Protocol",
      symbol: "BEL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xA91ac63D040dEB1b7A5E4d4134aD23eb0ba07e14/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD",
      type: "ERC20",
      address: "0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD",
      name: "ETH 2x Flexible Leverage Index",
      symbol: "ETH2x-FLI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xaA7a9CA87d3694B5755f213B5D04094b8d0F0A6F",
      type: "ERC20",
      address: "0xaA7a9CA87d3694B5755f213B5D04094b8d0F0A6F",
      name: "Trace Token",
      symbol: "TRAC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaA7a9CA87d3694B5755f213B5D04094b8d0F0A6F/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xaaAEBE6Fe48E54f431b0C390CfaF0b017d09D42d",
      type: "ERC20",
      address: "0xaaAEBE6Fe48E54f431b0C390CfaF0b017d09D42d",
      name: "Celsius",
      symbol: "CEL",
      decimals: 4,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaaAEBE6Fe48E54f431b0C390CfaF0b017d09D42d/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xaAAf91D9b90dF800Df4F55c205fd6989c977E73a",
      type: "ERC20",
      address: "0xaAAf91D9b90dF800Df4F55c205fd6989c977E73a",
      name: "Monolith TKN",
      symbol: "TKN",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaAAf91D9b90dF800Df4F55c205fd6989c977E73a/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xaC0104Cca91D167873B8601d2e71EB3D4D8c33e0",
      type: "ERC20",
      address: "0xaC0104Cca91D167873B8601d2e71EB3D4D8c33e0",
      name: "Crowns",
      symbol: "CWS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaC0104Cca91D167873B8601d2e71EB3D4D8c33e0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xAd4f86a25bbc20FfB751f2FAC312A0B4d8F88c64",
      type: "ERC20",
      address: "0xAd4f86a25bbc20FfB751f2FAC312A0B4d8F88c64",
      name: "OptionRoom Token",
      symbol: "ROOM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xAd4f86a25bbc20FfB751f2FAC312A0B4d8F88c64/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0",
      type: "ERC20",
      address: "0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0",
      name: "UniCrypt",
      symbol: "UNCX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xADE00C28244d5CE17D72E40330B1c318cD12B7c3",
      type: "ERC20",
      address: "0xADE00C28244d5CE17D72E40330B1c318cD12B7c3",
      name: "Ambire AdEx",
      symbol: "ADX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xADE00C28244d5CE17D72E40330B1c318cD12B7c3/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xAE1eaAE3F627AAca434127644371b67B18444051",
      type: "ERC20",
      address: "0xAE1eaAE3F627AAca434127644371b67B18444051",
      name: "YOP",
      symbol: "YOP",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xAE1eaAE3F627AAca434127644371b67B18444051/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xaE697F994Fc5eBC000F8e22EbFfeE04612f98A0d",
      type: "ERC20",
      address: "0xaE697F994Fc5eBC000F8e22EbFfeE04612f98A0d",
      name: "LGCY Network",
      symbol: "LGCY",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaE697F994Fc5eBC000F8e22EbFfeE04612f98A0d/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xaf9f549774ecEDbD0966C52f250aCc548D3F36E5",
      type: "ERC20",
      address: "0xaf9f549774ecEDbD0966C52f250aCc548D3F36E5",
      name: "Rio Fuel Token",
      symbol: "RFuel",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xaf9f549774ecEDbD0966C52f250aCc548D3F36E5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB1e9157c2Fdcc5a856C8DA8b2d89b6C32b3c1229",
      type: "ERC20",
      address: "0xB1e9157c2Fdcc5a856C8DA8b2d89b6C32b3c1229",
      name: "Zenfuse",
      symbol: "ZEFU",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB1e9157c2Fdcc5a856C8DA8b2d89b6C32b3c1229/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB26631c6dda06aD89B93C71400D25692de89c068",
      type: "ERC20",
      address: "0xB26631c6dda06aD89B93C71400D25692de89c068",
      name: "Minds",
      symbol: "MINDS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB26631c6dda06aD89B93C71400D25692de89c068/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x745407c86DF8DB893011912d3aB28e68B62E49B0",
      type: "ERC20",
      address: "0x745407c86DF8DB893011912d3aB28e68B62E49B0",
      name: "MahaDAO",
      symbol: "MAHA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x745407c86DF8DB893011912d3aB28e68B62E49B0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206",
      type: "ERC20",
      address: "0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206",
      name: "Nexo",
      symbol: "NEXO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB6ff96B8A8d214544Ca0dBc9B33f7AD6503eFD32",
      type: "ERC20",
      address: "0xB6ff96B8A8d214544Ca0dBc9B33f7AD6503eFD32",
      name: "SYNC",
      symbol: "SYNC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB6ff96B8A8d214544Ca0dBc9B33f7AD6503eFD32/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xb753428af26E81097e7fD17f40c88aaA3E04902c",
      type: "ERC20",
      address: "0xb753428af26E81097e7fD17f40c88aaA3E04902c",
      name: "saffron.finance",
      symbol: "SFI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xb753428af26E81097e7fD17f40c88aaA3E04902c/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB987D48Ed8f2C468D52D6405624EADBa5e76d723",
      type: "ERC20",
      address: "0xB987D48Ed8f2C468D52D6405624EADBa5e76d723",
      name: "Stabilize Token",
      symbol: "STBZ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB987D48Ed8f2C468D52D6405624EADBa5e76d723/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB9d99C33eA2d86EC5eC6b8A4dD816EBBA64404AF",
      type: "ERC20",
      address: "0xB9d99C33eA2d86EC5eC6b8A4dD816EBBA64404AF",
      name: "K21",
      symbol: "K21",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB9d99C33eA2d86EC5eC6b8A4dD816EBBA64404AF/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xb9EF770B6A5e12E45983C5D80545258aA38F3B78",
      type: "ERC20",
      address: "0xb9EF770B6A5e12E45983C5D80545258aA38F3B78",
      name: "0chain",
      symbol: "ZCN",
      decimals: 10,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xb9EF770B6A5e12E45983C5D80545258aA38F3B78/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xba100000625a3754423978a60c9317c58a424e3D",
      type: "ERC20",
      address: "0xba100000625a3754423978a60c9317c58a424e3D",
      name: "Balancer",
      symbol: "BAL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xba100000625a3754423978a60c9317c58a424e3D/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55",
      type: "ERC20",
      address: "0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55",
      name: "Band Protocol",
      symbol: "BAND",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xBa21Ef4c9f433Ede00badEFcC2754B8E74bd538A",
      type: "ERC20",
      address: "0xBa21Ef4c9f433Ede00badEFcC2754B8E74bd538A",
      name: "Swapfolio",
      symbol: "SWFL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xBa21Ef4c9f433Ede00badEFcC2754B8E74bd538A/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD",
      type: "ERC20",
      address: "0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD",
      name: "Loopring",
      symbol: "LRC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xBBc2AE13b23d715c30720F079fcd9B4a74093505",
      type: "ERC20",
      address: "0xBBc2AE13b23d715c30720F079fcd9B4a74093505",
      name: "Ethernity Chain",
      symbol: "ERN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xBBc2AE13b23d715c30720F079fcd9B4a74093505/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xbC396689893D065F41bc2C6EcbeE5e0085233447",
      type: "ERC20",
      address: "0xbC396689893D065F41bc2C6EcbeE5e0085233447",
      name: "Perpetual",
      symbol: "PERP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xbC396689893D065F41bc2C6EcbeE5e0085233447/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xbEa98c05eEAe2f3bC8c3565Db7551Eb738c8CCAb",
      type: "ERC20",
      address: "0xbEa98c05eEAe2f3bC8c3565Db7551Eb738c8CCAb",
      name: "GYSR",
      symbol: "GYSR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xbEa98c05eEAe2f3bC8c3565Db7551Eb738c8CCAb/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xBF494F02EE3FdE1F20BEE6242bCe2d1ED0c15e47",
      type: "ERC20",
      address: "0xBF494F02EE3FdE1F20BEE6242bCe2d1ED0c15e47",
      name: "World Token",
      symbol: "WORLD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xBF494F02EE3FdE1F20BEE6242bCe2d1ED0c15e47/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xc00e94Cb662C3520282E6f5717214004A7f26888",
      type: "ERC20",
      address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
      name: "Compound",
      symbol: "COMP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
      type: "ERC20",
      address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
      name: "Synthetix",
      symbol: "SNX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xC0bA369c8Db6eB3924965e5c4FD0b4C1B91e305F",
      type: "ERC20",
      address: "0xC0bA369c8Db6eB3924965e5c4FD0b4C1B91e305F",
      name: "DLP Duck Token",
      symbol: "DUCK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC0bA369c8Db6eB3924965e5c4FD0b4C1B91e305F/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
      type: "ERC20",
      address: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
      name: "Ethereum Name Service",
      symbol: "ENS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xC4C2614E694cF534D407Ee49F8E44D125E4681c4",
      type: "ERC20",
      address: "0xC4C2614E694cF534D407Ee49F8E44D125E4681c4",
      name: "Chain Games",
      symbol: "CHAIN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC4C2614E694cF534D407Ee49F8E44D125E4681c4/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xC52C326331E9Ce41F04484d3B5E5648158028804",
      type: "ERC20",
      address: "0xC52C326331E9Ce41F04484d3B5E5648158028804",
      name: "ZEN Exchange Token",
      symbol: "ZCX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC52C326331E9Ce41F04484d3B5E5648158028804/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xC57d533c50bC22247d49a368880fb49a1caA39F7",
      type: "ERC20",
      address: "0xC57d533c50bC22247d49a368880fb49a1caA39F7",
      name: "PowerTrade Fuel",
      symbol: "PTF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC57d533c50bC22247d49a368880fb49a1caA39F7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xc719d010B63E5bbF2C0551872CD5316ED26AcD83",
      type: "ERC20",
      address: "0xc719d010B63E5bbF2C0551872CD5316ED26AcD83",
      name: "Decentralized Insurance Protocol",
      symbol: "DIP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xc719d010B63E5bbF2C0551872CD5316ED26AcD83/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
      type: "ERC20",
      address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
      name: "Tribe",
      symbol: "TRIBE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xc834Fa996fA3BeC7aAD3693af486ae53D8aA8B50",
      type: "ERC20",
      address: "0xc834Fa996fA3BeC7aAD3693af486ae53D8aA8B50",
      name: "Convergence",
      symbol: "CONV",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xc834Fa996fA3BeC7aAD3693af486ae53D8aA8B50/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
      type: "ERC20",
      address: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
      name: "The Graph",
      symbol: "GRT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xc944E90C64B2c07662A292be6244BDf05Cda44a7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xCb5f72d37685C3D5aD0bB5F982443BC8FcdF570E",
      type: "ERC20",
      address: "0xCb5f72d37685C3D5aD0bB5F982443BC8FcdF570E",
      name: "Rootkit Finance",
      symbol: "ROOT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xCb5f72d37685C3D5aD0bB5F982443BC8FcdF570E/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xCbfef8fdd706cde6F208460f2Bf39Aa9c785F05D",
      type: "ERC20",
      address: "0xCbfef8fdd706cde6F208460f2Bf39Aa9c785F05D",
      name: "Kine Governance Token",
      symbol: "KINE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xCbfef8fdd706cde6F208460f2Bf39Aa9c785F05D/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xCC4304A31d09258b0029eA7FE63d032f52e44EFe",
      type: "ERC20",
      address: "0xCC4304A31d09258b0029eA7FE63d032f52e44EFe",
      name: "TrustSwap Token",
      symbol: "SWAP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xCC4304A31d09258b0029eA7FE63d032f52e44EFe/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xCF3C8Be2e2C42331Da80EF210e9B1b307C03d36A",
      type: "ERC20",
      address: "0xCF3C8Be2e2C42331Da80EF210e9B1b307C03d36A",
      name: "BEPRO Network",
      symbol: "BEPRO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xCF3C8Be2e2C42331Da80EF210e9B1b307C03d36A/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xd084B83C305daFD76AE3E1b4E1F1fe2eCcCb3988",
      type: "ERC20",
      address: "0xd084B83C305daFD76AE3E1b4E1F1fe2eCcCb3988",
      name: "Terra Virtua Kolect",
      symbol: "TVK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xd084B83C305daFD76AE3E1b4E1F1fe2eCcCb3988/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xD23Ac27148aF6A2f339BD82D0e3CFF380b5093de",
      type: "ERC20",
      address: "0xD23Ac27148aF6A2f339BD82D0e3CFF380b5093de",
      name: "SIREN",
      symbol: "SI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xD23Ac27148aF6A2f339BD82D0e3CFF380b5093de/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
      type: "ERC20",
      address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
      name: "OMG Network",
      symbol: "OMG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xd26114cd6EE289AccF82350c8d8487fedB8A0C07/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xd2877702675e6cEb975b4A1dFf9fb7BAF4C91ea9",
      type: "ERC20",
      address: "0xd2877702675e6cEb975b4A1dFf9fb7BAF4C91ea9",
      name: "Terra",
      symbol: "LUNA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xd2877702675e6cEb975b4A1dFf9fb7BAF4C91ea9/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xd379700999F4805Ce80aa32DB46A94dF64561108",
      type: "ERC20",
      address: "0xd379700999F4805Ce80aa32DB46A94dF64561108",
      name: "Dextrust",
      symbol: "DETS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xd379700999F4805Ce80aa32DB46A94dF64561108/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xD46bA6D942050d489DBd938a2C909A5d5039A161",
      type: "ERC20",
      address: "0xD46bA6D942050d489DBd938a2C909A5d5039A161",
      name: "Ampleforth",
      symbol: "AMPL",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xD46bA6D942050d489DBd938a2C909A5d5039A161/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xD478161C952357F05f0292B56012Cd8457F1cfbF",
      type: "ERC20",
      address: "0xD478161C952357F05f0292B56012Cd8457F1cfbF",
      name: "Polkamarkets",
      symbol: "POLK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xD478161C952357F05f0292B56012Cd8457F1cfbF/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xD533a949740bb3306d119CC777fa900bA034cd52",
      type: "ERC20",
      address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
      name: "Curve DAO Token",
      symbol: "CRV",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xD533a949740bb3306d119CC777fa900bA034cd52/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xD5525D397898e5502075Ea5E830d8914f6F0affe",
      type: "ERC20",
      address: "0xD5525D397898e5502075Ea5E830d8914f6F0affe",
      name: "MEME",
      symbol: "MEME",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xD5525D397898e5502075Ea5E830d8914f6F0affe/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xD6c67B93a7b248dF608a653d82a100556144c5DA",
      type: "ERC20",
      address: "0xD6c67B93a7b248dF608a653d82a100556144c5DA",
      name: "ExNetwork Token",
      symbol: "EXNT",
      decimals: 16,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xD6c67B93a7b248dF608a653d82a100556144c5DA/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xdAC17F958D2ee523a2206206994597C13D831ec7",
      type: "ERC20",
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      name: "Tether",
      symbol: "USDT",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xdacD69347dE42baBfAEcD09dC88958378780FB62",
      type: "ERC20",
      address: "0xdacD69347dE42baBfAEcD09dC88958378780FB62",
      name: "Atari Token",
      symbol: "ATRI",
      decimals: 0,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xdacD69347dE42baBfAEcD09dC88958378780FB62/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xDcB01cc464238396E213a6fDd933E36796eAfF9f",
      type: "ERC20",
      address: "0xDcB01cc464238396E213a6fDd933E36796eAfF9f",
      name: "Yield",
      symbol: "YLD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xDcB01cc464238396E213a6fDd933E36796eAfF9f/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xDDB3422497E61e13543BeA06989C0789117555c5",
      type: "ERC20",
      address: "0xDDB3422497E61e13543BeA06989C0789117555c5",
      name: "COTI",
      symbol: "COTI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xDDB3422497E61e13543BeA06989C0789117555c5/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xE1c7E30C42C24582888C758984f6e382096786bd",
      type: "ERC20",
      address: "0xE1c7E30C42C24582888C758984f6e382096786bd",
      name: "Curate",
      symbol: "XCUR",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xE1c7E30C42C24582888C758984f6e382096786bd/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30",
      type: "ERC20",
      address: "0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30",
      name: "Injective",
      symbol: "INJ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xe3818504c1B32bF1557b16C238B2E01Fd3149C17",
      type: "ERC20",
      address: "0xe3818504c1B32bF1557b16C238B2E01Fd3149C17",
      name: "PILLAR",
      symbol: "PLR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xe3818504c1B32bF1557b16C238B2E01Fd3149C17/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xE41d2489571d322189246DaFA5ebDe1F4699F498",
      type: "ERC20",
      address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
      name: "0x",
      symbol: "ZRX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xE41d2489571d322189246DaFA5ebDe1F4699F498/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xE452E6Ea2dDeB012e20dB73bf5d3863A3Ac8d77a",
      type: "ERC20",
      address: "0xE452E6Ea2dDeB012e20dB73bf5d3863A3Ac8d77a",
      name: "WCELO",
      symbol: "WCELO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xE452E6Ea2dDeB012e20dB73bf5d3863A3Ac8d77a/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55",
      type: "ERC20",
      address: "0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55",
      name: "SuperFarm",
      symbol: "SUPER",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xE5CAeF4Af8780E59Df925470b050Fb23C43CA68C",
      type: "ERC20",
      address: "0xE5CAeF4Af8780E59Df925470b050Fb23C43CA68C",
      name: "Ferrum Network",
      symbol: "FRM",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xE5CAeF4Af8780E59Df925470b050Fb23C43CA68C/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xE61fDAF474Fac07063f2234Fb9e60C1163Cfa850",
      type: "ERC20",
      address: "0xE61fDAF474Fac07063f2234Fb9e60C1163Cfa850",
      name: "COIN",
      symbol: "COIN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xE61fDAF474Fac07063f2234Fb9e60C1163Cfa850/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
      type: "ERC20",
      address: "0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
      name: "ankrETH",
      symbol: "aETHc",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xE95A203B1a91a908F9B9CE46459d101078c2c3cb/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEA1ea0972fa092dd463f2968F9bB51Cc4c981D71",
      type: "ERC20",
      address: "0xEA1ea0972fa092dd463f2968F9bB51Cc4c981D71",
      name: "Modefi",
      symbol: "MOD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEA1ea0972fa092dd463f2968F9bB51Cc4c981D71/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEa319e87Cf06203DAe107Dd8E5672175e3Ee976c",
      type: "ERC20",
      address: "0xEa319e87Cf06203DAe107Dd8E5672175e3Ee976c",
      name: "SURF Finance",
      symbol: "SURF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEa319e87Cf06203DAe107Dd8E5672175e3Ee976c/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
      type: "ERC20",
      address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
      name: "renBTC",
      symbol: "renBTC",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEBd9D99A3982d547C5Bb4DB7E3b1F9F14b67Eb83",
      type: "ERC20",
      address: "0xEBd9D99A3982d547C5Bb4DB7E3b1F9F14b67Eb83",
      name: "Everest",
      symbol: "ID",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEBd9D99A3982d547C5Bb4DB7E3b1F9F14b67Eb83/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEd91879919B71bB6905f23af0A68d231EcF87b14",
      type: "ERC20",
      address: "0xEd91879919B71bB6905f23af0A68d231EcF87b14",
      name: "DMM: Governance",
      symbol: "DMG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEd91879919B71bB6905f23af0A68d231EcF87b14/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xee573a945B01B788B9287CE062A0CFC15bE9fd86",
      type: "ERC20",
      address: "0xee573a945B01B788B9287CE062A0CFC15bE9fd86",
      name: "Exeedme",
      symbol: "XED",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xee573a945B01B788B9287CE062A0CFC15bE9fd86/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xeEAA40B28A2d1b0B08f6f97bB1DD4B75316c6107",
      type: "ERC20",
      address: "0xeEAA40B28A2d1b0B08f6f97bB1DD4B75316c6107",
      name: "GOVI",
      symbol: "GOVI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xeEAA40B28A2d1b0B08f6f97bB1DD4B75316c6107/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEec2bE5c91ae7f8a338e1e5f3b5DE49d07AfdC81",
      type: "ERC20",
      address: "0xEec2bE5c91ae7f8a338e1e5f3b5DE49d07AfdC81",
      name: "Dopex Governance Token",
      symbol: "DPX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEec2bE5c91ae7f8a338e1e5f3b5DE49d07AfdC81/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xEEF9f339514298C6A857EfCfC1A762aF84438dEE",
      type: "ERC20",
      address: "0xEEF9f339514298C6A857EfCfC1A762aF84438dEE",
      name: "Hermez Network Token",
      symbol: "HEZ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xEEF9f339514298C6A857EfCfC1A762aF84438dEE/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xF063fE1aB7a291c5d06a86e14730b00BF24cB589",
      type: "ERC20",
      address: "0xF063fE1aB7a291c5d06a86e14730b00BF24cB589",
      name: "DxSale Network",
      symbol: "SALE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xF063fE1aB7a291c5d06a86e14730b00BF24cB589/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xf1f955016EcbCd7321c7266BccFB96c68ea5E49b",
      type: "ERC20",
      address: "0xf1f955016EcbCd7321c7266BccFB96c68ea5E49b",
      name: "Rally",
      symbol: "RLY",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xf1f955016EcbCd7321c7266BccFB96c68ea5E49b/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xf21661D0D1d76d3ECb8e1B9F1c923DBfffAe4097",
      type: "ERC20",
      address: "0xf21661D0D1d76d3ECb8e1B9F1c923DBfffAe4097",
      name: "Realio Network",
      symbol: "RIO",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xf21661D0D1d76d3ECb8e1B9F1c923DBfffAe4097/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xF411903cbC70a74d22900a5DE66A2dda66507255",
      type: "ERC20",
      address: "0xF411903cbC70a74d22900a5DE66A2dda66507255",
      name: "Verasity",
      symbol: "VRA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xF411903cbC70a74d22900a5DE66A2dda66507255/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xf418588522d5dd018b425E472991E52EBBeEEEEE",
      type: "ERC20",
      address: "0xf418588522d5dd018b425E472991E52EBBeEEEEE",
      name: "PUSH",
      symbol: "PUSH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xf418588522d5dd018b425E472991E52EBBeEEEEE/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xf4CD3d3Fda8d7Fd6C5a500203e38640A70Bf9577",
      type: "ERC20",
      address: "0xf4CD3d3Fda8d7Fd6C5a500203e38640A70Bf9577",
      name: "YfDAI.finance",
      symbol: "Yf-DAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xf4CD3d3Fda8d7Fd6C5a500203e38640A70Bf9577/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xF4d861575ecC9493420A3f5a14F85B13f0b50EB3",
      type: "ERC20",
      address: "0xF4d861575ecC9493420A3f5a14F85B13f0b50EB3",
      name: "Fractal",
      symbol: "FCL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xF4d861575ecC9493420A3f5a14F85B13f0b50EB3/logo.png",
      pairs: []
    },
    {
      chainId: 1,
      asset: "c60_t0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c",
      type: "ERC20",
      address: "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c",
      name: "Enjin Coin",
      symbol: "ENJ",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xf6537FE0df7F0Cc0985Cf00792CC98249E73EFa0",
      type: "ERC20",
      address: "0xf6537FE0df7F0Cc0985Cf00792CC98249E73EFa0",
      name: "GIVLY Coin",
      symbol: "GIV",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xf6537FE0df7F0Cc0985Cf00792CC98249E73EFa0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xF938424F7210f31dF2Aee3011291b658f872e91e",
      type: "ERC20",
      address: "0xF938424F7210f31dF2Aee3011291b658f872e91e",
      name: "Visor.Finance",
      symbol: "VISR",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xF938424F7210f31dF2Aee3011291b658f872e91e/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xF94b5C5651c888d928439aB6514B93944eEE6F48",
      type: "ERC20",
      address: "0xF94b5C5651c888d928439aB6514B93944eEE6F48",
      name: "Yield",
      symbol: "YLD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xF94b5C5651c888d928439aB6514B93944eEE6F48/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xfAd45E47083e4607302aa43c65fB3106F1cd7607",
      type: "ERC20",
      address: "0xfAd45E47083e4607302aa43c65fB3106F1cd7607",
      name: "Hoge Finance",
      symbol: "HOGE",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xfAd45E47083e4607302aa43c65fB3106F1cd7607/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xFbEEa1C75E4c4465CB2FCCc9c6d6afe984558E20",
      type: "ERC20",
      address: "0xFbEEa1C75E4c4465CB2FCCc9c6d6afe984558E20",
      name: "DuckDaoDime",
      symbol: "DDIM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xFbEEa1C75E4c4465CB2FCCc9c6d6afe984558E20/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xfC98e825A2264D890F9a1e68ed50E1526abCcacD",
      type: "ERC20",
      address: "0xfC98e825A2264D890F9a1e68ed50E1526abCcacD",
      name: "Moss Carbon Credit",
      symbol: "MCO2",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xfC98e825A2264D890F9a1e68ed50E1526abCcacD/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xFca59Cd816aB1eaD66534D82bc21E7515cE441CF",
      type: "ERC20",
      address: "0xFca59Cd816aB1eaD66534D82bc21E7515cE441CF",
      name: "Rarible",
      symbol: "RARI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xFca59Cd816aB1eaD66534D82bc21E7515cE441CF/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xFE3E6a25e6b192A42a44ecDDCd13796471735ACf",
      type: "ERC20",
      address: "0xFE3E6a25e6b192A42a44ecDDCd13796471735ACf",
      name: "Reef",
      symbol: "REEF",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xFE3E6a25e6b192A42a44ecDDCd13796471735ACf/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xfF20817765cB7f73d4bde2e66e067E58D11095C2",
      type: "ERC20",
      address: "0xfF20817765cB7f73d4bde2e66e067E58D11095C2",
      name: "Amp",
      symbol: "AMP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xfF20817765cB7f73d4bde2e66e067E58D11095C2/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xfffffffFf15AbF397dA76f1dcc1A1604F45126DB",
      type: "ERC20",
      address: "0xfffffffFf15AbF397dA76f1dcc1A1604F45126DB",
      name: "FalconSwap Token",
      symbol: "FSW",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xfffffffFf15AbF397dA76f1dcc1A1604F45126DB/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x383518188C0C6d7730D91b2c03a03C837814a899",
      type: "ERC20",
      address: "0x383518188C0C6d7730D91b2c03a03C837814a899",
      name: "OlympusDAO",
      symbol: "OHM",
      decimals: 9,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x383518188C0C6d7730D91b2c03a03C837814a899/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x767FE9EDC9E0dF98E07454847909b5E959D7ca0E",
      type: "ERC20",
      address: "0x767FE9EDC9E0dF98E07454847909b5E959D7ca0E",
      name: "Illuvium",
      symbol: "ILV",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x767FE9EDC9E0dF98E07454847909b5E959D7ca0E/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xd1d2Eb1B1e90B638588728b4130137D262C87cae",
      type: "ERC20",
      address: "0xd1d2Eb1B1e90B638588728b4130137D262C87cae",
      name: "Gala",
      symbol: "GALA",
      decimals: 8,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xd1d2Eb1B1e90B638588728b4130137D262C87cae/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
      type: "ERC20",
      address: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
      name: "Convex Token",
      symbol: "CVX",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x090185f2135308BaD17527004364eBcC2D37e5F6",
      type: "ERC20",
      address: "0x090185f2135308BaD17527004364eBcC2D37e5F6",
      name: "Spell Token",
      symbol: "SPELL",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x090185f2135308BaD17527004364eBcC2D37e5F6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x3b484b82567a09e2588A13D54D032153f0c0aEe0",
      type: "ERC20",
      address: "0x3b484b82567a09e2588A13D54D032153f0c0aEe0",
      name: "OpenDAO",
      symbol: "SOS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x3b484b82567a09e2588A13D54D032153f0c0aEe0/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x6Bba316c48b49BD1eAc44573c5c871ff02958469",
      type: "ERC20",
      address: "0x6Bba316c48b49BD1eAc44573c5c871ff02958469",
      name: "Gas DAO",
      symbol: "GAS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x6Bba316c48b49BD1eAc44573c5c871ff02958469/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4Fabb145d64652a948d72533023f6E7A623C7C53",
      type: "ERC20",
      address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
      name: "Binance USD",
      symbol: "BUSD",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4Fabb145d64652a948d72533023f6E7A623C7C53/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
      type: "ERC20",
      address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
      name: "MetisDAO",
      symbol: "Metis",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x9E32b13ce7f2E80A01932B42553652E053D6ed8e/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xf4d2888d29D722226FafA5d9B24F9164c092421E",
      type: "ERC20",
      address: "0xf4d2888d29D722226FafA5d9B24F9164c092421E",
      name: "LooksRare",
      symbol: "LOOKS",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xf4d2888d29D722226FafA5d9B24F9164c092421E/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x1E4EDE388cbc9F4b5c79681B7f94d36a11ABEBC9",
      type: "ERC20",
      address: "0x1E4EDE388cbc9F4b5c79681B7f94d36a11ABEBC9",
      name: "X2Y2Token",
      symbol: "X2Y2",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x1E4EDE388cbc9F4b5c79681B7f94d36a11ABEBC9/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x4d224452801ACEd8B2F0aebE155379bb5D594381",
      type: "ERC20",
      address: "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
      name: "ApeCoin (APE)",
      symbol: "APE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x4d224452801ACEd8B2F0aebE155379bb5D594381/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
      type: "ERC20",
      address: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
      name: "StargateToken",
      symbol: "STG",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0x70e8dE73cE538DA2bEEd35d14187F6959a8ecA96",
      type: "ERC20",
      address: "0x70e8dE73cE538DA2bEEd35d14187F6959a8ecA96",
      name: "XSGD",
      symbol: "XSGD",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0x70e8dE73cE538DA2bEEd35d14187F6959a8ecA96/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xB0c7a3Ba49C7a6EaBa6cD4a96C55a1391070Ac9A",
      type: "ERC20",
      address: "0xB0c7a3Ba49C7a6EaBa6cD4a96C55a1391070Ac9A",
      name: "MAGIC",
      symbol: "MAGIC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xB0c7a3Ba49C7a6EaBa6cD4a96C55a1391070Ac9A/logo.png",
      pairs: []
    },
    {
      asset: "c60_t0xCEBA2a8F6Ec221AEB5f3a7bcd15Cbc7e6a387bfb",
      type: "ERC20",
      address: "0xCEBA2a8F6Ec221AEB5f3a7bcd15Cbc7e6a387bfb",
      name: "Peter Pan",
      symbol: "PAN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xCEBA2a8F6Ec221AEB5f3a7bcd15Cbc7e6a387bfb/logo.png",
      pairs: []
    }
  ],
  version: {
    major: 14,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/localhost.json
var localhost_default = {
  name: "Joint Labs: Localhost",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  tokens: [],
  version: {
    major: 6,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/optimism.json
var optimism_default = {
  name: "Trust Wallet: Optimism Ethereum",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2022-01-30T13:55:46.031276",
  tokens: [
    {
      asset: "0000",
      type: "NATIVE",
      address: "0x4200000000000000000000000000000000000006",
      name: "ETH",
      symbol: "ETH",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/eth.svg"
    },
    {
      asset: "c10000070_t0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6",
      type: "OPTIMISM",
      address: "0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6",
      name: "ChainLink",
      symbol: "LINK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6/logo.png"
    },
    {
      asset: "c10000070_t0x4200000000000000000000000000000000000006",
      type: "OPTIMISM",
      address: "0x4200000000000000000000000000000000000006",
      name: "Wrapped Ether",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x4200000000000000000000000000000000000006/logo.png"
    },
    {
      asset: "c10000070_t0x5029C236320b8f15eF0a657054B84d90bfBEDED3",
      type: "OPTIMISM",
      address: "0x5029C236320b8f15eF0a657054B84d90bfBEDED3",
      name: "BitANT",
      symbol: "BitANT",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x5029C236320b8f15eF0a657054B84d90bfBEDED3/logo.png"
    },
    {
      asset: "c10000070_t0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
      type: "OPTIMISM",
      address: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
      name: "Lyra Finance",
      symbol: "LYRA",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb/logo.png"
    },
    {
      asset: "c10000070_t0x61BAADcF22d2565B0F471b291C475db5555e0b76",
      type: "OPTIMISM",
      address: "0x61BAADcF22d2565B0F471b291C475db5555e0b76",
      name: "Aelin Token",
      symbol: "AELIN",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x61BAADcF22d2565B0F471b291C475db5555e0b76/logo.png"
    },
    {
      asset: "c10000070_t0x9Bcef72be871e61ED4fBbc7630889beE758eb81D",
      type: "OPTIMISM",
      address: "0x9Bcef72be871e61ED4fBbc7630889beE758eb81D",
      name: "Rocket Pool ETH",
      symbol: "rETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x9Bcef72be871e61ED4fBbc7630889beE758eb81D/logo.png"
    },
    {
      asset: "c10000070_t0x9e1028F5F1D5eDE59748FFceE5532509976840E0",
      type: "OPTIMISM",
      address: "0x9e1028F5F1D5eDE59748FFceE5532509976840E0",
      name: "Perpetual",
      symbol: "PERP",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0x9e1028F5F1D5eDE59748FFceE5532509976840E0/logo.png"
    },
    {
      asset: "c10000070_t0xF98dCd95217E15E05d8638da4c91125E59590B07",
      type: "OPTIMISM",
      address: "0xF98dCd95217E15E05d8638da4c91125E59590B07",
      name: "Kromatika",
      symbol: "KROM",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0xF98dCd95217E15E05d8638da4c91125E59590B07/logo.png"
    },
    {
      asset: "c10000070_t0xffD27b572246f35c992EfB28DD8cB730b93Ed301",
      type: "OPTIMISM",
      address: "0xffD27b572246f35c992EfB28DD8cB730b93Ed301",
      name: "Rubicon",
      symbol: "Rubicon",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/optimism/assets/0xffD27b572246f35c992EfB28DD8cB730b93Ed301/logo.png"
    }
  ],
  version: {
    major: 10,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/polygon.json
var polygon_default = {
  name: "Trust Wallet: Polygon",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  tokens: [
    {
      asset: "0000",
      type: "NATIVE",
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      name: "MATIC",
      symbol: "MATIC",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/matic.svg"
    },
    {
      asset: "c966_t0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      type: "POLYGON",
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      name: "Wrapped Ether",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619/logo.png"
    },
    {
      asset: "",
      type: "POLYGON",
      address: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
      name: "(PoS) Wrapped BTC",
      symbol: "WBTC",
      decimals: 8,
      logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoin/info/logo.png"
    },
    {
      asset: "c966_t0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
      type: "POLYGON",
      address: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
      name: "Wrapped MATIC",
      symbol: "WMATIC",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270/logo.png"
    },
    {
      asset: "c966_t0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      type: "POLYGON",
      address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      name: "USD Coin (PoS)",
      symbol: "USDC",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174/logo.png"
    },
    {
      asset: "c966_t0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      type: "POLYGON",
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      name: "(PoS) Tether USD",
      symbol: "USDT",
      decimals: 6,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0xc2132D05D31c914a87C6611C10748AEb04B58e8F/logo.png"
    },
    {
      asset: "c966_t0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      type: "POLYGON",
      address: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      name: "(PoS) Dai Stablecoin",
      symbol: "DAI",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063/logo.png"
    },
    {
      asset: "c966_t0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39",
      type: "POLYGON",
      address: "0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39",
      name: "ChainLink Token",
      symbol: "LINK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39/logo.png",
      pairs: []
    },
    {
      asset: "c966_t0x831753DD7087CaC61aB5644b308642cc1c33Dc13",
      type: "POLYGON",
      address: "0x831753DD7087CaC61aB5644b308642cc1c33Dc13",
      name: "QuickSwap",
      symbol: "QUICK",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0x831753DD7087CaC61aB5644b308642cc1c33Dc13/logo.png",
      pairs: []
    },
    {
      asset: "c966_t0xD6DF932A45C0f255f85145f286eA0b292B21C90B",
      type: "POLYGON",
      address: "0xD6DF932A45C0f255f85145f286eA0b292B21C90B",
      name: "Aave (PoS)",
      symbol: "AAVE",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/polygon/assets/0xD6DF932A45C0f255f85145f286eA0b292B21C90B/logo.png",
      pairs: []
    }
  ],
  version: {
    major: 6,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/sepolia.json
var sepolia_default = {
  name: "Trust Wallet: Sepolia",
  logoURI: "https://trustwallet.com/assets/images/favicon.png",
  timestamp: "2021-10-07T08:50:36.056Z",
  tokens: [
    {
      asset: "0000",
      type: "NATIVE",
      address: "0x4263541D13298963498ff1f83d992812Ef3d2E73",
      name: "ETH",
      symbol: "ETH",
      native: true,
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/eth.svg",
      price: 0
    },
    {
      asset: "0001",
      type: "ERC20",
      address: "0x4263541D13298963498ff1f83d992812Ef3d2E73",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      price: 0
    },
    {
      asset: "0002",
      type: "ERC20",
      address: "0xB556b3a796f5f104Bbaab840567844734e0490a0",
      name: "Joint",
      symbol: "JOIN",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/join.svg",
      price: 0
    }
  ],
  version: {
    major: 6,
    minor: 0,
    patch: 0
  }
};

// src/tokenlist/synthetic.json
var synthetic_default = {
  name: "Joint Protocol: Synthetic",
  logoURI: "",
  timestamp: "2021-10-07T08:50:36.056Z",
  tokens: [
    {
      asset: "0000",
      type: "SYNTHETIC",
      address: "0xEb0149A3eD6ba901Db396b674dF84c8b75fba568",
      name: "NGN",
      symbol: "NGN",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/nigeria.svg"
    },
    {
      asset: "0001",
      type: "SYNTHETIC",
      address: "0xD6F3bb044222cDB85a588542C5dFa3E66cE70d3f",
      name: "USD",
      symbol: "USD",
      decimals: 18,
      logoURI: "https://files.joint.exchange/images/usa.svg"
    }
  ],
  version: {
    major: 1,
    minor: 0,
    patch: 0
  }
};

// src/tokens_list.ts
var TokenLists = {
  ethereum: ethereum_default,
  polygon: polygon_default,
  binance: binance_default,
  optimism: optimism_default,
  synthetic: synthetic_default,
  localhost: localhost_default,
  sepolia: sepolia_default,
  "arbitrum-sepolia": arbitrum_sepolia_default,
  arbitrum: arbitrum_default,
  base: base_default,
  blast: blast_default
};
function getTokenInfo(network, address) {
  const netList = TokenLists[network];
  if (!netList)
    return;
  return _.find(netList.tokens, (x) => isAddressEqual2(x.address, address));
}
function findTokenInLocalhost(address) {
  return TokenLists.localhost.tokens.find((token) => {
    const match = isAddressEqual2(token.address, address);
    if (!match)
      return;
    token.isSynthetic = token.isSynthetic || token.type == "SYNTHETIC";
    return token;
  });
}
function findTokenInSynthetic(address) {
  return TokenLists.synthetic.tokens.find((token) => {
    const match = isAddressEqual2(token.address, address);
    if (!match)
      return;
    token.isSynthetic = token.isSynthetic || token.type == "SYNTHETIC";
    return token;
  });
}
function addTokenToLocalhost(tokens) {
  TokenLists.localhost.tokens.push(...tokens);
}

// src/typechain/index.ts
var typechain_exports = {};
__export(typechain_exports, {
  AssetRegistry__factory: () => AssetRegistry__factory,
  BadgeManager__factory: () => BadgeManager__factory,
  BondCurveDistro__factory: () => BondCurveDistro__factory,
  Core__factory: () => Core__factory,
  DisputeManager__factory: () => DisputeManager__factory,
  ERC20__factory: () => ERC20__factory,
  ERC721__factory: () => ERC721__factory,
  Energon__factory: () => Energon__factory,
  FeePool__factory: () => FeePool__factory,
  LPPool__factory: () => LPPool__factory,
  MarketCore__factory: () => MarketCore__factory,
  MarketManager__factory: () => MarketManager__factory,
  MediatorManager__factory: () => MediatorManager__factory,
  MinerRegistry__factory: () => MinerRegistry__factory,
  NFT__factory: () => NFT__factory,
  PayRouter__factory: () => PayRouter__factory,
  ProviderRegistry__factory: () => ProviderRegistry__factory,
  Router__factory: () => Router__factory,
  TokenPool__factory: () => TokenPool__factory,
  Token__factory: () => Token__factory,
  UniswapV2Router2__factory: () => UniswapV2Router2__factory,
  UniswapV2Router__factory: () => UniswapV2Router__factory,
  UniswapV3Router2__factory: () => UniswapV3Router2__factory,
  UniswapV3RouterUniversal__factory: () => UniswapV3RouterUniversal__factory,
  UniswapV3Router__factory: () => UniswapV3Router__factory,
  WETH__factory: () => WETH__factory,
  factories: () => factories_exports
});

// src/typechain/factories/index.ts
var factories_exports = {};
__export(factories_exports, {
  AssetRegistry__factory: () => AssetRegistry__factory,
  BadgeManager__factory: () => BadgeManager__factory,
  BondCurveDistro__factory: () => BondCurveDistro__factory,
  Core__factory: () => Core__factory,
  DisputeManager__factory: () => DisputeManager__factory,
  ERC20__factory: () => ERC20__factory,
  ERC721__factory: () => ERC721__factory,
  Energon__factory: () => Energon__factory,
  FeePool__factory: () => FeePool__factory,
  LPPool__factory: () => LPPool__factory,
  MarketCore__factory: () => MarketCore__factory,
  MarketManager__factory: () => MarketManager__factory,
  MediatorManager__factory: () => MediatorManager__factory,
  MinerRegistry__factory: () => MinerRegistry__factory,
  NFT__factory: () => NFT__factory,
  PayRouter__factory: () => PayRouter__factory,
  ProviderRegistry__factory: () => ProviderRegistry__factory,
  Router__factory: () => Router__factory,
  TokenPool__factory: () => TokenPool__factory,
  Token__factory: () => Token__factory,
  UniswapV2Router2__factory: () => UniswapV2Router2__factory,
  UniswapV2Router__factory: () => UniswapV2Router__factory,
  UniswapV3Router2__factory: () => UniswapV3Router2__factory,
  UniswapV3RouterUniversal__factory: () => UniswapV3RouterUniversal__factory,
  UniswapV3Router__factory: () => UniswapV3Router__factory,
  WETH__factory: () => WETH__factory
});

// node_modules/ethers/lib.esm/_version.js
var version = "6.13.0";

// node_modules/ethers/lib.esm/utils/properties.js
function checkType(value, type, name) {
  const types = type.split("|").map((t) => t.trim());
  for (let i = 0; i < types.length; i++) {
    switch (type) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof value === type) {
          return;
        }
    }
  }
  const error = new Error(`invalid value for type ${type}`);
  error.code = "INVALID_ARGUMENT";
  error.argument = `value.${name}`;
  error.value = value;
  throw error;
}
async function resolveProperties(value) {
  const keys = Object.keys(value);
  const results = await Promise.all(keys.map((k) => Promise.resolve(value[k])));
  return results.reduce((accum, v, index) => {
    accum[keys[index]] = v;
    return accum;
  }, {});
}
function defineProperties(target, values, types) {
  for (let key in values) {
    let value = values[key];
    const type = types ? types[key] : null;
    if (type) {
      checkType(value, type, key);
    }
    Object.defineProperty(target, key, { enumerable: true, value, writable: false });
  }
}

// node_modules/ethers/lib.esm/utils/errors.js
function stringify(value) {
  if (value == null) {
    return "null";
  }
  if (Array.isArray(value)) {
    return "[ " + value.map(stringify).join(", ") + " ]";
  }
  if (value instanceof Uint8Array) {
    const HEX = "0123456789abcdef";
    let result = "0x";
    for (let i = 0; i < value.length; i++) {
      result += HEX[value[i] >> 4];
      result += HEX[value[i] & 15];
    }
    return result;
  }
  if (typeof value === "object" && typeof value.toJSON === "function") {
    return stringify(value.toJSON());
  }
  switch (typeof value) {
    case "boolean":
    case "symbol":
      return value.toString();
    case "bigint":
      return BigInt(value).toString();
    case "number":
      return value.toString();
    case "string":
      return JSON.stringify(value);
    case "object": {
      const keys = Object.keys(value);
      keys.sort();
      return "{ " + keys.map((k) => `${stringify(k)}: ${stringify(value[k])}`).join(", ") + " }";
    }
  }
  return `[ COULD NOT SERIALIZE ]`;
}
function isError(error, code) {
  return error && error.code === code;
}
function isCallException(error) {
  return isError(error, "CALL_EXCEPTION");
}
function makeError(message, code, info) {
  let shortMessage = message;
  {
    const details = [];
    if (info) {
      if ("message" in info || "code" in info || "name" in info) {
        throw new Error(`value will overwrite populated values: ${stringify(info)}`);
      }
      for (const key in info) {
        if (key === "shortMessage") {
          continue;
        }
        const value = info[key];
        details.push(key + "=" + stringify(value));
      }
    }
    details.push(`code=${code}`);
    details.push(`version=${version}`);
    if (details.length) {
      message += " (" + details.join(", ") + ")";
    }
  }
  let error;
  switch (code) {
    case "INVALID_ARGUMENT":
      error = new TypeError(message);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      error = new RangeError(message);
      break;
    default:
      error = new Error(message);
  }
  defineProperties(error, { code });
  if (info) {
    Object.assign(error, info);
  }
  if (error.shortMessage == null) {
    defineProperties(error, { shortMessage });
  }
  return error;
}
function assert(check, message, code, info) {
  if (!check) {
    throw makeError(message, code, info);
  }
}
function assertArgument(check, message, name, value) {
  assert(check, message, "INVALID_ARGUMENT", { argument: name, value });
}
function assertArgumentCount(count, expectedCount, message) {
  if (message == null) {
    message = "";
  }
  if (message) {
    message = ": " + message;
  }
  assert(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
    count,
    expectedCount
  });
  assert(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
    count,
    expectedCount
  });
}
var _normalizeForms = ["NFD", "NFC", "NFKD", "NFKC"].reduce((accum, form) => {
  try {
    if ("test".normalize(form) !== "test") {
      throw new Error("bad");
    }
    ;
    if (form === "NFD") {
      const check = String.fromCharCode(233).normalize("NFD");
      const expected = String.fromCharCode(101, 769);
      if (check !== expected) {
        throw new Error("broken");
      }
    }
    accum.push(form);
  } catch (error) {
  }
  return accum;
}, []);
function assertNormalize(form) {
  assert(_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
    operation: "String.prototype.normalize",
    info: { form }
  });
}
function assertPrivate(givenGuard, guard, className) {
  if (className == null) {
    className = "";
  }
  if (givenGuard !== guard) {
    let method = className, operation = "new";
    if (className) {
      method += ".";
      operation += " " + className;
    }
    assert(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
      operation
    });
  }
}

// node_modules/ethers/lib.esm/utils/data.js
function _getBytes(value, name, copy) {
  if (value instanceof Uint8Array) {
    if (copy) {
      return new Uint8Array(value);
    }
    return value;
  }
  if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const result = new Uint8Array((value.length - 2) / 2);
    let offset = 2;
    for (let i = 0; i < result.length; i++) {
      result[i] = parseInt(value.substring(offset, offset + 2), 16);
      offset += 2;
    }
    return result;
  }
  assertArgument(false, "invalid BytesLike value", name || "value", value);
}
function getBytes(value, name) {
  return _getBytes(value, name, false);
}
function getBytesCopy(value, name) {
  return _getBytes(value, name, true);
}
function isHexString(value, length) {
  if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
    return false;
  }
  if (typeof length === "number" && value.length !== 2 + 2 * length) {
    return false;
  }
  if (length === true && value.length % 2 !== 0) {
    return false;
  }
  return true;
}
function isBytesLike(value) {
  return isHexString(value, true) || value instanceof Uint8Array;
}
var HexCharacters = "0123456789abcdef";
function hexlify(data) {
  const bytes2 = getBytes(data);
  let result = "0x";
  for (let i = 0; i < bytes2.length; i++) {
    const v = bytes2[i];
    result += HexCharacters[(v & 240) >> 4] + HexCharacters[v & 15];
  }
  return result;
}
function concat(datas) {
  return "0x" + datas.map((d) => hexlify(d).substring(2)).join("");
}
function dataSlice(data, start, end) {
  const bytes2 = getBytes(data);
  if (end != null && end > bytes2.length) {
    assert(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
      buffer: bytes2,
      length: bytes2.length,
      offset: end
    });
  }
  return hexlify(bytes2.slice(start == null ? 0 : start, end == null ? bytes2.length : end));
}
function zeroPad(data, length, left) {
  const bytes2 = getBytes(data);
  assert(length >= bytes2.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(bytes2),
    length,
    offset: length + 1
  });
  const result = new Uint8Array(length);
  result.fill(0);
  if (left) {
    result.set(bytes2, length - bytes2.length);
  } else {
    result.set(bytes2, 0);
  }
  return hexlify(result);
}
function zeroPadValue(data, length) {
  return zeroPad(data, length, true);
}
function zeroPadBytes(data, length) {
  return zeroPad(data, length, false);
}

// node_modules/ethers/lib.esm/utils/maths.js
var BN_0 = BigInt(0);
var BN_1 = BigInt(1);
var maxValue = 9007199254740991;
function fromTwos(_value, _width) {
  const value = getUint(_value, "value");
  const width = BigInt(getNumber(_width, "width"));
  assert(value >> width === BN_0, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: _value
  });
  if (value >> width - BN_1) {
    const mask2 = (BN_1 << width) - BN_1;
    return -((~value & mask2) + BN_1);
  }
  return value;
}
function toTwos(_value, _width) {
  let value = getBigInt(_value, "value");
  const width = BigInt(getNumber(_width, "width"));
  const limit = BN_1 << width - BN_1;
  if (value < BN_0) {
    value = -value;
    assert(value <= limit, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: _value
    });
    const mask2 = (BN_1 << width) - BN_1;
    return (~value & mask2) + BN_1;
  } else {
    assert(value < limit, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: _value
    });
  }
  return value;
}
function mask(_value, _bits) {
  const value = getUint(_value, "value");
  const bits = BigInt(getNumber(_bits, "bits"));
  return value & (BN_1 << bits) - BN_1;
}
function getBigInt(value, name) {
  switch (typeof value) {
    case "bigint":
      return value;
    case "number":
      assertArgument(Number.isInteger(value), "underflow", name || "value", value);
      assertArgument(value >= -maxValue && value <= maxValue, "overflow", name || "value", value);
      return BigInt(value);
    case "string":
      try {
        if (value === "") {
          throw new Error("empty string");
        }
        if (value[0] === "-" && value[1] !== "-") {
          return -BigInt(value.substring(1));
        }
        return BigInt(value);
      } catch (e) {
        assertArgument(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
      }
  }
  assertArgument(false, "invalid BigNumberish value", name || "value", value);
}
function getUint(value, name) {
  const result = getBigInt(value, name);
  assert(result >= BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value
  });
  return result;
}
var Nibbles = "0123456789abcdef";
function toBigInt(value) {
  if (value instanceof Uint8Array) {
    let result = "0x0";
    for (const v of value) {
      result += Nibbles[v >> 4];
      result += Nibbles[v & 15];
    }
    return BigInt(result);
  }
  return getBigInt(value);
}
function getNumber(value, name) {
  switch (typeof value) {
    case "bigint":
      assertArgument(value >= -maxValue && value <= maxValue, "overflow", name || "value", value);
      return Number(value);
    case "number":
      assertArgument(Number.isInteger(value), "underflow", name || "value", value);
      assertArgument(value >= -maxValue && value <= maxValue, "overflow", name || "value", value);
      return value;
    case "string":
      try {
        if (value === "") {
          throw new Error("empty string");
        }
        return getNumber(BigInt(value), name);
      } catch (e) {
        assertArgument(false, `invalid numeric string: ${e.message}`, name || "value", value);
      }
  }
  assertArgument(false, "invalid numeric value", name || "value", value);
}
function toNumber(value) {
  return getNumber(toBigInt(value));
}
function toBeHex(_value, _width) {
  const value = getUint(_value, "value");
  let result = value.toString(16);
  if (_width == null) {
    if (result.length % 2) {
      result = "0" + result;
    }
  } else {
    const width = getNumber(_width, "width");
    assert(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: _value
    });
    while (result.length < width * 2) {
      result = "0" + result;
    }
  }
  return "0x" + result;
}
function toBeArray(_value) {
  const value = getUint(_value, "value");
  if (value === BN_0) {
    return new Uint8Array([]);
  }
  let hex = value.toString(16);
  if (hex.length % 2) {
    hex = "0" + hex;
  }
  const result = new Uint8Array(hex.length / 2);
  for (let i = 0; i < result.length; i++) {
    const offset = i * 2;
    result[i] = parseInt(hex.substring(offset, offset + 2), 16);
  }
  return result;
}

// node_modules/ethers/lib.esm/utils/events.js
var EventPayload = class {
  /**
   *  The event filter.
   */
  filter;
  /**
   *  The **EventEmitterable**.
   */
  emitter;
  #listener;
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(emitter, listener, filter) {
    this.#listener = listener;
    defineProperties(this, { emitter, filter });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    if (this.#listener == null) {
      return;
    }
    await this.emitter.off(this.filter, this.#listener);
  }
};

// node_modules/ethers/lib.esm/utils/utf8.js
function errorFunc(reason, offset, bytes2, output2, badCodepoint) {
  assertArgument(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes2);
}
function ignoreFunc(reason, offset, bytes2, output2, badCodepoint) {
  if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
    let i = 0;
    for (let o = offset + 1; o < bytes2.length; o++) {
      if (bytes2[o] >> 6 !== 2) {
        break;
      }
      i++;
    }
    return i;
  }
  if (reason === "OVERRUN") {
    return bytes2.length - offset - 1;
  }
  return 0;
}
function replaceFunc(reason, offset, bytes2, output2, badCodepoint) {
  if (reason === "OVERLONG") {
    assertArgument(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
    output2.push(badCodepoint);
    return 0;
  }
  output2.push(65533);
  return ignoreFunc(reason, offset, bytes2, output2, badCodepoint);
}
var Utf8ErrorFuncs = Object.freeze({
  error: errorFunc,
  ignore: ignoreFunc,
  replace: replaceFunc
});
function getUtf8CodePoints(_bytes, onError) {
  if (onError == null) {
    onError = Utf8ErrorFuncs.error;
  }
  const bytes2 = getBytes(_bytes, "bytes");
  const result = [];
  let i = 0;
  while (i < bytes2.length) {
    const c = bytes2[i++];
    if (c >> 7 === 0) {
      result.push(c);
      continue;
    }
    let extraLength = null;
    let overlongMask = null;
    if ((c & 224) === 192) {
      extraLength = 1;
      overlongMask = 127;
    } else if ((c & 240) === 224) {
      extraLength = 2;
      overlongMask = 2047;
    } else if ((c & 248) === 240) {
      extraLength = 3;
      overlongMask = 65535;
    } else {
      if ((c & 192) === 128) {
        i += onError("UNEXPECTED_CONTINUE", i - 1, bytes2, result);
      } else {
        i += onError("BAD_PREFIX", i - 1, bytes2, result);
      }
      continue;
    }
    if (i - 1 + extraLength >= bytes2.length) {
      i += onError("OVERRUN", i - 1, bytes2, result);
      continue;
    }
    let res = c & (1 << 8 - extraLength - 1) - 1;
    for (let j = 0; j < extraLength; j++) {
      let nextChar = bytes2[i];
      if ((nextChar & 192) != 128) {
        i += onError("MISSING_CONTINUE", i, bytes2, result);
        res = null;
        break;
      }
      ;
      res = res << 6 | nextChar & 63;
      i++;
    }
    if (res === null) {
      continue;
    }
    if (res > 1114111) {
      i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes2, result, res);
      continue;
    }
    if (res >= 55296 && res <= 57343) {
      i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes2, result, res);
      continue;
    }
    if (res <= overlongMask) {
      i += onError("OVERLONG", i - 1 - extraLength, bytes2, result, res);
      continue;
    }
    result.push(res);
  }
  return result;
}
function toUtf8Bytes(str, form) {
  assertArgument(typeof str === "string", "invalid string value", "str", str);
  if (form != null) {
    assertNormalize(form);
    str = str.normalize(form);
  }
  let result = [];
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    if (c < 128) {
      result.push(c);
    } else if (c < 2048) {
      result.push(c >> 6 | 192);
      result.push(c & 63 | 128);
    } else if ((c & 64512) == 55296) {
      i++;
      const c2 = str.charCodeAt(i);
      assertArgument(i < str.length && (c2 & 64512) === 56320, "invalid surrogate pair", "str", str);
      const pair = 65536 + ((c & 1023) << 10) + (c2 & 1023);
      result.push(pair >> 18 | 240);
      result.push(pair >> 12 & 63 | 128);
      result.push(pair >> 6 & 63 | 128);
      result.push(pair & 63 | 128);
    } else {
      result.push(c >> 12 | 224);
      result.push(c >> 6 & 63 | 128);
      result.push(c & 63 | 128);
    }
  }
  return new Uint8Array(result);
}
function _toUtf8String(codePoints) {
  return codePoints.map((codePoint) => {
    if (codePoint <= 65535) {
      return String.fromCharCode(codePoint);
    }
    codePoint -= 65536;
    return String.fromCharCode((codePoint >> 10 & 1023) + 55296, (codePoint & 1023) + 56320);
  }).join("");
}
function toUtf8String(bytes2, onError) {
  return _toUtf8String(getUtf8CodePoints(bytes2, onError));
}

// node_modules/ethers/lib.esm/abi/coders/abstract-coder.js
var WordSize = 32;
var Padding = new Uint8Array(WordSize);
var passProperties = ["then"];
var _guard = {};
var resultNames = /* @__PURE__ */ new WeakMap();
function getNames(result) {
  return resultNames.get(result);
}
function setNames(result, names) {
  resultNames.set(result, names);
}
function throwError(name, error) {
  const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
  wrapped.error = error;
  throw wrapped;
}
function toObject(names, items, deep) {
  if (names.indexOf(null) >= 0) {
    return items.map((item, index) => {
      if (item instanceof Result) {
        return toObject(getNames(item), item, deep);
      }
      return item;
    });
  }
  return names.reduce((accum, name, index) => {
    let item = items.getValue(name);
    if (!(name in accum)) {
      if (deep && item instanceof Result) {
        item = toObject(getNames(item), item, deep);
      }
      accum[name] = item;
    }
    return accum;
  }, {});
}
var Result = class _Result extends Array {
  // No longer used; but cannot be removed as it will remove the
  // #private field from the .d.ts which may break backwards
  // compatibility
  #names;
  /**
   *  @private
   */
  constructor(...args) {
    const guard = args[0];
    let items = args[1];
    let names = (args[2] || []).slice();
    let wrap = true;
    if (guard !== _guard) {
      items = args;
      names = [];
      wrap = false;
    }
    super(items.length);
    items.forEach((item, index) => {
      this[index] = item;
    });
    const nameCounts = names.reduce((accum, name) => {
      if (typeof name === "string") {
        accum.set(name, (accum.get(name) || 0) + 1);
      }
      return accum;
    }, /* @__PURE__ */ new Map());
    setNames(this, Object.freeze(items.map((item, index) => {
      const name = names[index];
      if (name != null && nameCounts.get(name) === 1) {
        return name;
      }
      return null;
    })));
    this.#names = [];
    if (this.#names == null) {
      void this.#names;
    }
    if (!wrap) {
      return;
    }
    Object.freeze(this);
    const proxy = new Proxy(this, {
      get: (target, prop, receiver) => {
        if (typeof prop === "string") {
          if (prop.match(/^[0-9]+$/)) {
            const index = getNumber(prop, "%index");
            if (index < 0 || index >= this.length) {
              throw new RangeError("out of result range");
            }
            const item = target[index];
            if (item instanceof Error) {
              throwError(`index ${index}`, item);
            }
            return item;
          }
          if (passProperties.indexOf(prop) >= 0) {
            return Reflect.get(target, prop, receiver);
          }
          const value = target[prop];
          if (value instanceof Function) {
            return function(...args2) {
              return value.apply(this === receiver ? target : this, args2);
            };
          } else if (!(prop in target)) {
            return target.getValue.apply(this === receiver ? target : this, [prop]);
          }
        }
        return Reflect.get(target, prop, receiver);
      }
    });
    setNames(proxy, getNames(this));
    return proxy;
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(deep) {
    const result = [];
    this.forEach((item, index) => {
      if (item instanceof Error) {
        throwError(`index ${index}`, item);
      }
      if (deep && item instanceof _Result) {
        item = item.toArray(deep);
      }
      result.push(item);
    });
    return result;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(deep) {
    const names = getNames(this);
    return names.reduce((accum, name, index) => {
      assert(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
        operation: "toObject()"
      });
      return toObject(names, this, deep);
    }, {});
  }
  /**
   *  @_ignore
   */
  slice(start, end) {
    if (start == null) {
      start = 0;
    }
    if (start < 0) {
      start += this.length;
      if (start < 0) {
        start = 0;
      }
    }
    if (end == null) {
      end = this.length;
    }
    if (end < 0) {
      end += this.length;
      if (end < 0) {
        end = 0;
      }
    }
    if (end > this.length) {
      end = this.length;
    }
    const _names = getNames(this);
    const result = [], names = [];
    for (let i = start; i < end; i++) {
      result.push(this[i]);
      names.push(_names[i]);
    }
    return new _Result(_guard, result, names);
  }
  /**
   *  @_ignore
   */
  filter(callback, thisArg) {
    const _names = getNames(this);
    const result = [], names = [];
    for (let i = 0; i < this.length; i++) {
      const item = this[i];
      if (item instanceof Error) {
        throwError(`index ${i}`, item);
      }
      if (callback.call(thisArg, item, i, this)) {
        result.push(item);
        names.push(_names[i]);
      }
    }
    return new _Result(_guard, result, names);
  }
  /**
   *  @_ignore
   */
  map(callback, thisArg) {
    const result = [];
    for (let i = 0; i < this.length; i++) {
      const item = this[i];
      if (item instanceof Error) {
        throwError(`index ${i}`, item);
      }
      result.push(callback.call(thisArg, item, i, this));
    }
    return result;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(name) {
    const index = getNames(this).indexOf(name);
    if (index === -1) {
      return void 0;
    }
    const value = this[index];
    if (value instanceof Error) {
      throwError(`property ${JSON.stringify(name)}`, value.error);
    }
    return value;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(items, keys) {
    return new _Result(_guard, items, keys);
  }
};
function getValue(value) {
  let bytes2 = toBeArray(value);
  assert(bytes2.length <= WordSize, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: bytes2, length: WordSize, offset: bytes2.length });
  if (bytes2.length !== WordSize) {
    bytes2 = getBytesCopy(concat([Padding.slice(bytes2.length % WordSize), bytes2]));
  }
  return bytes2;
}
var Coder = class {
  // The coder name:
  //   - address, uint256, tuple, array, etc.
  name;
  // The fully expanded type, including composite types:
  //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
  type;
  // The localName bound in the signature, in this example it is "baz":
  //   - tuple(address foo, uint bar) baz
  localName;
  // Whether this type is dynamic:
  //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
  //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
  dynamic;
  constructor(name, type, localName, dynamic) {
    defineProperties(this, { name, type, localName, dynamic }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(message, value) {
    assertArgument(false, message, this.localName, value);
  }
};
var Writer = class {
  // An array of WordSize lengthed objects to concatenation
  #data;
  #dataLength;
  constructor() {
    this.#data = [];
    this.#dataLength = 0;
  }
  get data() {
    return concat(this.#data);
  }
  get length() {
    return this.#dataLength;
  }
  #writeData(data) {
    this.#data.push(data);
    this.#dataLength += data.length;
    return data.length;
  }
  appendWriter(writer) {
    return this.#writeData(getBytesCopy(writer.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(value) {
    let bytes2 = getBytesCopy(value);
    const paddingOffset = bytes2.length % WordSize;
    if (paddingOffset) {
      bytes2 = getBytesCopy(concat([bytes2, Padding.slice(paddingOffset)]));
    }
    return this.#writeData(bytes2);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(value) {
    return this.#writeData(getValue(value));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const offset = this.#data.length;
    this.#data.push(Padding);
    this.#dataLength += WordSize;
    return (value) => {
      this.#data[offset] = getValue(value);
    };
  }
};
var Reader = class _Reader {
  // Allows incomplete unpadded data to be read; otherwise an error
  // is raised if attempting to overrun the buffer. This is required
  // to deal with an old Solidity bug, in which event data for
  // external (not public thoguh) was tightly packed.
  allowLoose;
  #data;
  #offset;
  #bytesRead;
  #parent;
  #maxInflation;
  constructor(data, allowLoose, maxInflation) {
    defineProperties(this, { allowLoose: !!allowLoose });
    this.#data = getBytesCopy(data);
    this.#bytesRead = 0;
    this.#parent = null;
    this.#maxInflation = maxInflation != null ? maxInflation : 1024;
    this.#offset = 0;
  }
  get data() {
    return hexlify(this.#data);
  }
  get dataLength() {
    return this.#data.length;
  }
  get consumed() {
    return this.#offset;
  }
  get bytes() {
    return new Uint8Array(this.#data);
  }
  #incrementBytesRead(count) {
    if (this.#parent) {
      return this.#parent.#incrementBytesRead(count);
    }
    this.#bytesRead += count;
    assert(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
      buffer: getBytesCopy(this.#data),
      offset: this.#offset,
      length: count,
      info: {
        bytesRead: this.#bytesRead,
        dataLength: this.dataLength
      }
    });
  }
  #peekBytes(offset, length, loose) {
    let alignedLength = Math.ceil(length / WordSize) * WordSize;
    if (this.#offset + alignedLength > this.#data.length) {
      if (this.allowLoose && loose && this.#offset + length <= this.#data.length) {
        alignedLength = length;
      } else {
        assert(false, "data out-of-bounds", "BUFFER_OVERRUN", {
          buffer: getBytesCopy(this.#data),
          length: this.#data.length,
          offset: this.#offset + alignedLength
        });
      }
    }
    return this.#data.slice(this.#offset, this.#offset + alignedLength);
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(offset) {
    const reader = new _Reader(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
    reader.#parent = this;
    return reader;
  }
  // Read bytes
  readBytes(length, loose) {
    let bytes2 = this.#peekBytes(0, length, !!loose);
    this.#incrementBytesRead(length);
    this.#offset += bytes2.length;
    return bytes2.slice(0, length);
  }
  // Read a numeric values
  readValue() {
    return toBigInt(this.readBytes(WordSize));
  }
  readIndex() {
    return toNumber(this.readBytes(WordSize));
  }
};

// node_modules/ethers/node_modules/@noble/hashes/esm/_assert.js
function number(n2) {
  if (!Number.isSafeInteger(n2) || n2 < 0)
    throw new Error(`Wrong positive integer: ${n2}`);
}
function bytes(b2, ...lengths) {
  if (!(b2 instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (lengths.length > 0 && !lengths.includes(b2.length))
    throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b2.length}`);
}
function exists(instance, checkFinished = true) {
  if (instance.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (checkFinished && instance.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(out, instance) {
  bytes(out);
  const min = instance.outputLen;
  if (out.length < min) {
    throw new Error(`digestInto() expects output buffer of length at least ${min}`);
  }
}

// node_modules/ethers/node_modules/@noble/hashes/esm/_u64.js
var U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
var _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n2, le = false) {
  if (le)
    return { h: Number(n2 & U32_MASK64), l: Number(n2 >> _32n & U32_MASK64) };
  return { h: Number(n2 >> _32n & U32_MASK64) | 0, l: Number(n2 & U32_MASK64) | 0 };
}
function split(lst, le = false) {
  let Ah = new Uint32Array(lst.length);
  let Al = new Uint32Array(lst.length);
  for (let i = 0; i < lst.length; i++) {
    const { h, l } = fromBig(lst[i], le);
    [Ah[i], Al[i]] = [h, l];
  }
  return [Ah, Al];
}
var rotlSH = (h, l, s) => h << s | l >>> 32 - s;
var rotlSL = (h, l, s) => l << s | h >>> 32 - s;
var rotlBH = (h, l, s) => l << s - 32 | h >>> 64 - s;
var rotlBL = (h, l, s) => h << s - 32 | l >>> 64 - s;

// node_modules/ethers/node_modules/@noble/hashes/esm/utils.js
var u8a = (a) => a instanceof Uint8Array;
var u32 = (arr) => new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
var isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!isLE)
  throw new Error("Non little-endian hardware is not supported");
function utf8ToBytes(str) {
  if (typeof str !== "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
  return new Uint8Array(new TextEncoder().encode(str));
}
function toBytes(data) {
  if (typeof data === "string")
    data = utf8ToBytes(data);
  if (!u8a(data))
    throw new Error(`expected Uint8Array, got ${typeof data}`);
  return data;
}
var Hash = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
var toStr = {}.toString;
function wrapConstructor(hashCons) {
  const hashC = (msg) => hashCons().update(toBytes(msg)).digest();
  const tmp = hashCons();
  hashC.outputLen = tmp.outputLen;
  hashC.blockLen = tmp.blockLen;
  hashC.create = () => hashCons();
  return hashC;
}
function wrapXOFConstructorWithOpts(hashCons) {
  const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
  const tmp = hashCons({});
  hashC.outputLen = tmp.outputLen;
  hashC.blockLen = tmp.blockLen;
  hashC.create = (opts) => hashCons(opts);
  return hashC;
}

// node_modules/ethers/node_modules/@noble/hashes/esm/sha3.js
var [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [[], [], []];
var _0n = /* @__PURE__ */ BigInt(0);
var _1n = /* @__PURE__ */ BigInt(1);
var _2n = /* @__PURE__ */ BigInt(2);
var _7n = /* @__PURE__ */ BigInt(7);
var _256n = /* @__PURE__ */ BigInt(256);
var _0x71n = /* @__PURE__ */ BigInt(113);
for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
  [x, y] = [y, (2 * x + 3 * y) % 5];
  SHA3_PI.push(2 * (5 * y + x));
  SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
  let t = _0n;
  for (let j = 0; j < 7; j++) {
    R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
    if (R & _2n)
      t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
  }
  _SHA3_IOTA.push(t);
}
var [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ split(_SHA3_IOTA, true);
var rotlH = (h, l, s) => s > 32 ? rotlBH(h, l, s) : rotlSH(h, l, s);
var rotlL = (h, l, s) => s > 32 ? rotlBL(h, l, s) : rotlSL(h, l, s);
function keccakP(s, rounds = 24) {
  const B = new Uint32Array(5 * 2);
  for (let round = 24 - rounds; round < 24; round++) {
    for (let x = 0; x < 10; x++)
      B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
    for (let x = 0; x < 10; x += 2) {
      const idx1 = (x + 8) % 10;
      const idx0 = (x + 2) % 10;
      const B0 = B[idx0];
      const B1 = B[idx0 + 1];
      const Th = rotlH(B0, B1, 1) ^ B[idx1];
      const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
      for (let y = 0; y < 50; y += 10) {
        s[x + y] ^= Th;
        s[x + y + 1] ^= Tl;
      }
    }
    let curH = s[2];
    let curL = s[3];
    for (let t = 0; t < 24; t++) {
      const shift = SHA3_ROTL[t];
      const Th = rotlH(curH, curL, shift);
      const Tl = rotlL(curH, curL, shift);
      const PI = SHA3_PI[t];
      curH = s[PI];
      curL = s[PI + 1];
      s[PI] = Th;
      s[PI + 1] = Tl;
    }
    for (let y = 0; y < 50; y += 10) {
      for (let x = 0; x < 10; x++)
        B[x] = s[y + x];
      for (let x = 0; x < 10; x++)
        s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
    }
    s[0] ^= SHA3_IOTA_H[round];
    s[1] ^= SHA3_IOTA_L[round];
  }
  B.fill(0);
}
var Keccak = class _Keccak extends Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
    super();
    this.blockLen = blockLen;
    this.suffix = suffix;
    this.outputLen = outputLen;
    this.enableXOF = enableXOF;
    this.rounds = rounds;
    this.pos = 0;
    this.posOut = 0;
    this.finished = false;
    this.destroyed = false;
    number(outputLen);
    if (0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200);
    this.state32 = u32(this.state);
  }
  keccak() {
    keccakP(this.state32, this.rounds);
    this.posOut = 0;
    this.pos = 0;
  }
  update(data) {
    exists(this);
    const { blockLen, state } = this;
    data = toBytes(data);
    const len = data.length;
    for (let pos = 0; pos < len; ) {
      const take = Math.min(blockLen - this.pos, len - pos);
      for (let i = 0; i < take; i++)
        state[this.pos++] ^= data[pos++];
      if (this.pos === blockLen)
        this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = true;
    const { state, suffix, pos, blockLen } = this;
    state[pos] ^= suffix;
    if ((suffix & 128) !== 0 && pos === blockLen - 1)
      this.keccak();
    state[blockLen - 1] ^= 128;
    this.keccak();
  }
  writeInto(out) {
    exists(this, false);
    bytes(out);
    this.finish();
    const bufferOut = this.state;
    const { blockLen } = this;
    for (let pos = 0, len = out.length; pos < len; ) {
      if (this.posOut >= blockLen)
        this.keccak();
      const take = Math.min(blockLen - this.posOut, len - pos);
      out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
      this.posOut += take;
      pos += take;
    }
    return out;
  }
  xofInto(out) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(out);
  }
  xof(bytes2) {
    number(bytes2);
    return this.xofInto(new Uint8Array(bytes2));
  }
  digestInto(out) {
    output(out, this);
    if (this.finished)
      throw new Error("digest() was already called");
    this.writeInto(out);
    this.destroy();
    return out;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = true;
    this.state.fill(0);
  }
  _cloneInto(to) {
    const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
    to || (to = new _Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
    to.state32.set(this.state32);
    to.pos = this.pos;
    to.posOut = this.posOut;
    to.finished = this.finished;
    to.rounds = rounds;
    to.suffix = suffix;
    to.outputLen = outputLen;
    to.enableXOF = enableXOF;
    to.destroyed = this.destroyed;
    return to;
  }
};
var gen = (suffix, blockLen, outputLen) => wrapConstructor(() => new Keccak(blockLen, suffix, outputLen));
var sha3_224 = /* @__PURE__ */ gen(6, 144, 224 / 8);
var sha3_256 = /* @__PURE__ */ gen(6, 136, 256 / 8);
var sha3_384 = /* @__PURE__ */ gen(6, 104, 384 / 8);
var sha3_512 = /* @__PURE__ */ gen(6, 72, 512 / 8);
var keccak_224 = /* @__PURE__ */ gen(1, 144, 224 / 8);
var keccak_256 = /* @__PURE__ */ gen(1, 136, 256 / 8);
var keccak_384 = /* @__PURE__ */ gen(1, 104, 384 / 8);
var keccak_512 = /* @__PURE__ */ gen(1, 72, 512 / 8);
var genShake = (suffix, blockLen, outputLen) => wrapXOFConstructorWithOpts((opts = {}) => new Keccak(blockLen, suffix, opts.dkLen === void 0 ? outputLen : opts.dkLen, true));
var shake128 = /* @__PURE__ */ genShake(31, 168, 128 / 8);
var shake256 = /* @__PURE__ */ genShake(31, 136, 256 / 8);

// node_modules/ethers/lib.esm/crypto/keccak.js
var locked = false;
var _keccak256 = function(data) {
  return keccak_256(data);
};
var __keccak256 = _keccak256;
function keccak256(_data) {
  const data = getBytes(_data, "data");
  return hexlify(__keccak256(data));
}
keccak256._ = _keccak256;
keccak256.lock = function() {
  locked = true;
};
keccak256.register = function(func) {
  if (locked) {
    throw new TypeError("keccak256 is locked");
  }
  __keccak256 = func;
};
Object.freeze(keccak256);

// node_modules/ethers/lib.esm/address/address.js
var BN_02 = BigInt(0);
var BN_36 = BigInt(36);
function getChecksumAddress(address) {
  address = address.toLowerCase();
  const chars = address.substring(2).split("");
  const expanded = new Uint8Array(40);
  for (let i = 0; i < 40; i++) {
    expanded[i] = chars[i].charCodeAt(0);
  }
  const hashed = getBytes(keccak256(expanded));
  for (let i = 0; i < 40; i += 2) {
    if (hashed[i >> 1] >> 4 >= 8) {
      chars[i] = chars[i].toUpperCase();
    }
    if ((hashed[i >> 1] & 15) >= 8) {
      chars[i + 1] = chars[i + 1].toUpperCase();
    }
  }
  return "0x" + chars.join("");
}
var ibanLookup = {};
for (let i = 0; i < 10; i++) {
  ibanLookup[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
  ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
}
var safeDigits = 15;
function ibanChecksum(address) {
  address = address.toUpperCase();
  address = address.substring(4) + address.substring(0, 2) + "00";
  let expanded = address.split("").map((c) => {
    return ibanLookup[c];
  }).join("");
  while (expanded.length >= safeDigits) {
    let block = expanded.substring(0, safeDigits);
    expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
  }
  let checksum = String(98 - parseInt(expanded, 10) % 97);
  while (checksum.length < 2) {
    checksum = "0" + checksum;
  }
  return checksum;
}
var Base36 = function() {
  ;
  const result = {};
  for (let i = 0; i < 36; i++) {
    const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
    result[key] = BigInt(i);
  }
  return result;
}();
function fromBase36(value) {
  value = value.toLowerCase();
  let result = BN_02;
  for (let i = 0; i < value.length; i++) {
    result = result * BN_36 + Base36[value[i]];
  }
  return result;
}
function getAddress(address) {
  assertArgument(typeof address === "string", "invalid address", "address", address);
  if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    if (!address.startsWith("0x")) {
      address = "0x" + address;
    }
    const result = getChecksumAddress(address);
    assertArgument(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
    return result;
  }
  if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    assertArgument(address.substring(2, 4) === ibanChecksum(address), "bad icap checksum", "address", address);
    let result = fromBase36(address.substring(4)).toString(16);
    while (result.length < 40) {
      result = "0" + result;
    }
    return getChecksumAddress("0x" + result);
  }
  assertArgument(false, "invalid address", "address", address);
}

// node_modules/ethers/lib.esm/address/checks.js
function isAddressable(value) {
  return value && typeof value.getAddress === "function";
}
async function checkAddress(target, promise) {
  const result = await promise;
  if (result == null || result === "0x0000000000000000000000000000000000000000") {
    assert(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", { value: target });
    assertArgument(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
  }
  return getAddress(result);
}
function resolveAddress(target, resolver) {
  if (typeof target === "string") {
    if (target.match(/^0x[0-9a-f]{40}$/i)) {
      return getAddress(target);
    }
    assert(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" });
    return checkAddress(target, resolver.resolveName(target));
  } else if (isAddressable(target)) {
    return checkAddress(target, target.getAddress());
  } else if (target && typeof target.then === "function") {
    return checkAddress(target, target);
  }
  assertArgument(false, "unsupported addressable value", "target", target);
}

// node_modules/ethers/lib.esm/abi/typed.js
var _gaurd = {};
function n(value, width) {
  let signed = false;
  if (width < 0) {
    signed = true;
    width *= -1;
  }
  return new Typed(_gaurd, `${signed ? "" : "u"}int${width}`, value, { signed, width });
}
function b(value, size) {
  return new Typed(_gaurd, `bytes${size ? size : ""}`, value, { size });
}
var _typedSymbol = Symbol.for("_ethers_typed");
var Typed = class _Typed {
  /**
   *  The type, as a Solidity-compatible type.
   */
  type;
  /**
   *  The actual value.
   */
  value;
  #options;
  /**
   *  @_ignore:
   */
  _typedSymbol;
  /**
   *  @_ignore:
   */
  constructor(gaurd, type, value, options) {
    if (options == null) {
      options = null;
    }
    assertPrivate(_gaurd, gaurd, "Typed");
    defineProperties(this, { _typedSymbol, type, value });
    this.#options = options;
    this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array") {
      throw new Error("");
    } else if (this.type === "dynamicArray") {
      throw new Error("");
    } else if (this.type === "tuple") {
      return `tuple(${this.value.map((v) => v.format()).join(",")})`;
    }
    return this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple") {
      throw TypeError("not a tuple");
    }
    return this.#options;
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array") {
      throw TypeError("not an array");
    }
    if (this.#options === true) {
      return -1;
    }
    if (this.#options === false) {
      return this.value.length;
    }
    return null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(type, value) {
    return new _Typed(_gaurd, type, value);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(v) {
    return n(v, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(v) {
    return n(v, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(v) {
    return n(v, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(v) {
    return n(v, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(v) {
    return n(v, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(v) {
    return n(v, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(v) {
    return n(v, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(v) {
    return n(v, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(v) {
    return n(v, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(v) {
    return n(v, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(v) {
    return n(v, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(v) {
    return n(v, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(v) {
    return n(v, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(v) {
    return n(v, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(v) {
    return n(v, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(v) {
    return n(v, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(v) {
    return n(v, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(v) {
    return n(v, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(v) {
    return n(v, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(v) {
    return n(v, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(v) {
    return n(v, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(v) {
    return n(v, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(v) {
    return n(v, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(v) {
    return n(v, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(v) {
    return n(v, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(v) {
    return n(v, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(v) {
    return n(v, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(v) {
    return n(v, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(v) {
    return n(v, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(v) {
    return n(v, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(v) {
    return n(v, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(v) {
    return n(v, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(v) {
    return n(v, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(v) {
    return n(v, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(v) {
    return n(v, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(v) {
    return n(v, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(v) {
    return n(v, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(v) {
    return n(v, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(v) {
    return n(v, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(v) {
    return n(v, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(v) {
    return n(v, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(v) {
    return n(v, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(v) {
    return n(v, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(v) {
    return n(v, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(v) {
    return n(v, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(v) {
    return n(v, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(v) {
    return n(v, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(v) {
    return n(v, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(v) {
    return n(v, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(v) {
    return n(v, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(v) {
    return n(v, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(v) {
    return n(v, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(v) {
    return n(v, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(v) {
    return n(v, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(v) {
    return n(v, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(v) {
    return n(v, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(v) {
    return n(v, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(v) {
    return n(v, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(v) {
    return n(v, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(v) {
    return n(v, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(v) {
    return n(v, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(v) {
    return n(v, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(v) {
    return n(v, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(v) {
    return n(v, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(v) {
    return n(v, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(v) {
    return n(v, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(v) {
    return b(v, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(v) {
    return b(v, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(v) {
    return b(v, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(v) {
    return b(v, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(v) {
    return b(v, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(v) {
    return b(v, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(v) {
    return b(v, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(v) {
    return b(v, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(v) {
    return b(v, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(v) {
    return b(v, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(v) {
    return b(v, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(v) {
    return b(v, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(v) {
    return b(v, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(v) {
    return b(v, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(v) {
    return b(v, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(v) {
    return b(v, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(v) {
    return b(v, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(v) {
    return b(v, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(v) {
    return b(v, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(v) {
    return b(v, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(v) {
    return b(v, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(v) {
    return b(v, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(v) {
    return b(v, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(v) {
    return b(v, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(v) {
    return b(v, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(v) {
    return b(v, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(v) {
    return b(v, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(v) {
    return b(v, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(v) {
    return b(v, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(v) {
    return b(v, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(v) {
    return b(v, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(v) {
    return b(v, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(v) {
    return new _Typed(_gaurd, "address", v);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(v) {
    return new _Typed(_gaurd, "bool", !!v);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(v) {
    return new _Typed(_gaurd, "bytes", v);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(v) {
    return new _Typed(_gaurd, "string", v);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(v, dynamic) {
    throw new Error("not implemented yet");
    return new _Typed(_gaurd, "array", v, dynamic);
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(v, name) {
    throw new Error("not implemented yet");
    return new _Typed(_gaurd, "tuple", v, name);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(v) {
    return new _Typed(_gaurd, "overrides", Object.assign({}, v));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(value) {
    return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === _typedSymbol;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(value, type) {
    if (_Typed.isTyped(value)) {
      if (value.type !== type) {
        throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
      }
      return value.value;
    }
    return value;
  }
};

// node_modules/ethers/lib.esm/abi/coders/address.js
var AddressCoder = class extends Coder {
  constructor(localName) {
    super("address", "address", localName, false);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(writer, _value) {
    let value = Typed.dereference(_value, "string");
    try {
      value = getAddress(value);
    } catch (error) {
      return this._throwError(error.message, _value);
    }
    return writer.writeValue(value);
  }
  decode(reader) {
    return getAddress(toBeHex(reader.readValue(), 20));
  }
};

// node_modules/ethers/lib.esm/abi/coders/anonymous.js
var AnonymousCoder = class extends Coder {
  coder;
  constructor(coder) {
    super(coder.name, coder.type, "_", coder.dynamic);
    this.coder = coder;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(writer, value) {
    return this.coder.encode(writer, value);
  }
  decode(reader) {
    return this.coder.decode(reader);
  }
};

// node_modules/ethers/lib.esm/abi/coders/array.js
function pack(writer, coders, values) {
  let arrayValues = [];
  if (Array.isArray(values)) {
    arrayValues = values;
  } else if (values && typeof values === "object") {
    let unique = {};
    arrayValues = coders.map((coder) => {
      const name = coder.localName;
      assert(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder }, value: values });
      assert(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder }, value: values });
      unique[name] = true;
      return values[name];
    });
  } else {
    assertArgument(false, "invalid tuple value", "tuple", values);
  }
  assertArgument(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
  let staticWriter = new Writer();
  let dynamicWriter = new Writer();
  let updateFuncs = [];
  coders.forEach((coder, index) => {
    let value = arrayValues[index];
    if (coder.dynamic) {
      let dynamicOffset = dynamicWriter.length;
      coder.encode(dynamicWriter, value);
      let updateFunc = staticWriter.writeUpdatableValue();
      updateFuncs.push((baseOffset) => {
        updateFunc(baseOffset + dynamicOffset);
      });
    } else {
      coder.encode(staticWriter, value);
    }
  });
  updateFuncs.forEach((func) => {
    func(staticWriter.length);
  });
  let length = writer.appendWriter(staticWriter);
  length += writer.appendWriter(dynamicWriter);
  return length;
}
function unpack(reader, coders) {
  let values = [];
  let keys = [];
  let baseReader = reader.subReader(0);
  coders.forEach((coder) => {
    let value = null;
    if (coder.dynamic) {
      let offset = reader.readIndex();
      let offsetReader = baseReader.subReader(offset);
      try {
        value = coder.decode(offsetReader);
      } catch (error) {
        if (isError(error, "BUFFER_OVERRUN")) {
          throw error;
        }
        value = error;
        value.baseType = coder.name;
        value.name = coder.localName;
        value.type = coder.type;
      }
    } else {
      try {
        value = coder.decode(reader);
      } catch (error) {
        if (isError(error, "BUFFER_OVERRUN")) {
          throw error;
        }
        value = error;
        value.baseType = coder.name;
        value.name = coder.localName;
        value.type = coder.type;
      }
    }
    if (value == void 0) {
      throw new Error("investigate");
    }
    values.push(value);
    keys.push(coder.localName || null);
  });
  return Result.fromItems(values, keys);
}
var ArrayCoder = class extends Coder {
  coder;
  length;
  constructor(coder, length, localName) {
    const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
    const dynamic = length === -1 || coder.dynamic;
    super("array", type, localName, dynamic);
    defineProperties(this, { coder, length });
  }
  defaultValue() {
    const defaultChild = this.coder.defaultValue();
    const result = [];
    for (let i = 0; i < this.length; i++) {
      result.push(defaultChild);
    }
    return result;
  }
  encode(writer, _value) {
    const value = Typed.dereference(_value, "array");
    if (!Array.isArray(value)) {
      this._throwError("expected array value", value);
    }
    let count = this.length;
    if (count === -1) {
      count = value.length;
      writer.writeValue(value.length);
    }
    assertArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
    let coders = [];
    for (let i = 0; i < value.length; i++) {
      coders.push(this.coder);
    }
    return pack(writer, coders, value);
  }
  decode(reader) {
    let count = this.length;
    if (count === -1) {
      count = reader.readIndex();
      assert(count * WordSize <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: reader.bytes, offset: count * WordSize, length: reader.dataLength });
    }
    let coders = [];
    for (let i = 0; i < count; i++) {
      coders.push(new AnonymousCoder(this.coder));
    }
    return unpack(reader, coders);
  }
};

// node_modules/ethers/lib.esm/abi/coders/boolean.js
var BooleanCoder = class extends Coder {
  constructor(localName) {
    super("bool", "bool", localName, false);
  }
  defaultValue() {
    return false;
  }
  encode(writer, _value) {
    const value = Typed.dereference(_value, "bool");
    return writer.writeValue(value ? 1 : 0);
  }
  decode(reader) {
    return !!reader.readValue();
  }
};

// node_modules/ethers/lib.esm/abi/coders/bytes.js
var DynamicBytesCoder = class extends Coder {
  constructor(type, localName) {
    super(type, type, localName, true);
  }
  defaultValue() {
    return "0x";
  }
  encode(writer, value) {
    value = getBytesCopy(value);
    let length = writer.writeValue(value.length);
    length += writer.writeBytes(value);
    return length;
  }
  decode(reader) {
    return reader.readBytes(reader.readIndex(), true);
  }
};
var BytesCoder = class extends DynamicBytesCoder {
  constructor(localName) {
    super("bytes", localName);
  }
  decode(reader) {
    return hexlify(super.decode(reader));
  }
};

// node_modules/ethers/lib.esm/abi/coders/fixed-bytes.js
var FixedBytesCoder = class extends Coder {
  size;
  constructor(size, localName) {
    let name = "bytes" + String(size);
    super(name, name, localName, false);
    defineProperties(this, { size }, { size: "number" });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(writer, _value) {
    let data = getBytesCopy(Typed.dereference(_value, this.type));
    if (data.length !== this.size) {
      this._throwError("incorrect data length", _value);
    }
    return writer.writeBytes(data);
  }
  decode(reader) {
    return hexlify(reader.readBytes(this.size));
  }
};

// node_modules/ethers/lib.esm/abi/coders/null.js
var Empty = new Uint8Array([]);
var NullCoder = class extends Coder {
  constructor(localName) {
    super("null", "", localName, false);
  }
  defaultValue() {
    return null;
  }
  encode(writer, value) {
    if (value != null) {
      this._throwError("not null", value);
    }
    return writer.writeBytes(Empty);
  }
  decode(reader) {
    reader.readBytes(0);
    return null;
  }
};

// node_modules/ethers/lib.esm/abi/coders/number.js
var BN_03 = BigInt(0);
var BN_12 = BigInt(1);
var BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var NumberCoder = class extends Coder {
  size;
  signed;
  constructor(size, signed, localName) {
    const name = (signed ? "int" : "uint") + size * 8;
    super(name, name, localName, false);
    defineProperties(this, { size, signed }, { size: "number", signed: "boolean" });
  }
  defaultValue() {
    return 0;
  }
  encode(writer, _value) {
    let value = getBigInt(Typed.dereference(_value, this.type));
    let maxUintValue = mask(BN_MAX_UINT256, WordSize * 8);
    if (this.signed) {
      let bounds = mask(maxUintValue, this.size * 8 - 1);
      if (value > bounds || value < -(bounds + BN_12)) {
        this._throwError("value out-of-bounds", _value);
      }
      value = toTwos(value, 8 * WordSize);
    } else if (value < BN_03 || value > mask(maxUintValue, this.size * 8)) {
      this._throwError("value out-of-bounds", _value);
    }
    return writer.writeValue(value);
  }
  decode(reader) {
    let value = mask(reader.readValue(), this.size * 8);
    if (this.signed) {
      value = fromTwos(value, this.size * 8);
    }
    return value;
  }
};

// node_modules/ethers/lib.esm/abi/coders/string.js
var StringCoder = class extends DynamicBytesCoder {
  constructor(localName) {
    super("string", localName);
  }
  defaultValue() {
    return "";
  }
  encode(writer, _value) {
    return super.encode(writer, toUtf8Bytes(Typed.dereference(_value, "string")));
  }
  decode(reader) {
    return toUtf8String(super.decode(reader));
  }
};

// node_modules/ethers/lib.esm/abi/coders/tuple.js
var TupleCoder = class extends Coder {
  coders;
  constructor(coders, localName) {
    let dynamic = false;
    const types = [];
    coders.forEach((coder) => {
      if (coder.dynamic) {
        dynamic = true;
      }
      types.push(coder.type);
    });
    const type = "tuple(" + types.join(",") + ")";
    super("tuple", type, localName, dynamic);
    defineProperties(this, { coders: Object.freeze(coders.slice()) });
  }
  defaultValue() {
    const values = [];
    this.coders.forEach((coder) => {
      values.push(coder.defaultValue());
    });
    const uniqueNames = this.coders.reduce((accum, coder) => {
      const name = coder.localName;
      if (name) {
        if (!accum[name]) {
          accum[name] = 0;
        }
        accum[name]++;
      }
      return accum;
    }, {});
    this.coders.forEach((coder, index) => {
      let name = coder.localName;
      if (!name || uniqueNames[name] !== 1) {
        return;
      }
      if (name === "length") {
        name = "_length";
      }
      if (values[name] != null) {
        return;
      }
      values[name] = values[index];
    });
    return Object.freeze(values);
  }
  encode(writer, _value) {
    const value = Typed.dereference(_value, "tuple");
    return pack(writer, this.coders, value);
  }
  decode(reader) {
    return unpack(reader, this.coders);
  }
};

// node_modules/ethers/lib.esm/hash/id.js
function id(value) {
  return keccak256(toUtf8Bytes(value));
}

// node_modules/ethers/lib.esm/transaction/accesslist.js
function accessSetify(addr, storageKeys) {
  return {
    address: getAddress(addr),
    storageKeys: storageKeys.map((storageKey, index) => {
      assertArgument(isHexString(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
      return storageKey.toLowerCase();
    })
  };
}
function accessListify(value) {
  if (Array.isArray(value)) {
    return value.map((set, index) => {
      if (Array.isArray(set)) {
        assertArgument(set.length === 2, "invalid slot set", `value[${index}]`, set);
        return accessSetify(set[0], set[1]);
      }
      assertArgument(set != null && typeof set === "object", "invalid address-slot set", "value", value);
      return accessSetify(set.address, set.storageKeys);
    });
  }
  assertArgument(value != null && typeof value === "object", "invalid access list", "value", value);
  const result = Object.keys(value).map((addr) => {
    const storageKeys = value[addr].reduce((accum, storageKey) => {
      accum[storageKey] = true;
      return accum;
    }, {});
    return accessSetify(addr, Object.keys(storageKeys).sort());
  });
  result.sort((a, b2) => a.address.localeCompare(b2.address));
  return result;
}

// node_modules/ethers/lib.esm/abi/fragments.js
function setify(items) {
  const result = /* @__PURE__ */ new Set();
  items.forEach((k) => result.add(k));
  return Object.freeze(result);
}
var _kwVisibDeploy = "external public payable override";
var KwVisibDeploy = setify(_kwVisibDeploy.split(" "));
var _kwVisib = "constant external internal payable private public pure view override";
var KwVisib = setify(_kwVisib.split(" "));
var _kwTypes = "constructor error event fallback function receive struct";
var KwTypes = setify(_kwTypes.split(" "));
var _kwModifiers = "calldata memory storage payable indexed";
var KwModifiers = setify(_kwModifiers.split(" "));
var _kwOther = "tuple returns";
var _keywords = [_kwTypes, _kwModifiers, _kwOther, _kwVisib].join(" ");
var Keywords = setify(_keywords.split(" "));
var SimpleTokens = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
};
var regexWhitespacePrefix = new RegExp("^(\\s*)");
var regexNumberPrefix = new RegExp("^([0-9]+)");
var regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
var regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
var regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
var TokenString = class _TokenString {
  #offset;
  #tokens;
  get offset() {
    return this.#offset;
  }
  get length() {
    return this.#tokens.length - this.#offset;
  }
  constructor(tokens) {
    this.#offset = 0;
    this.#tokens = tokens.slice();
  }
  clone() {
    return new _TokenString(this.#tokens);
  }
  reset() {
    this.#offset = 0;
  }
  #subTokenString(from = 0, to = 0) {
    return new _TokenString(this.#tokens.slice(from, to).map((t) => {
      return Object.freeze(Object.assign({}, t, {
        match: t.match - from,
        linkBack: t.linkBack - from,
        linkNext: t.linkNext - from
      }));
    }));
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(allowed) {
    const top = this.peek();
    if (top.type !== "KEYWORD" || !allowed.has(top.text)) {
      throw new Error(`expected keyword ${top.text}`);
    }
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(type) {
    if (this.peek().type !== type) {
      const top = this.peek();
      throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const top = this.peek();
    if (top.type !== "OPEN_PAREN") {
      throw new Error("bad start");
    }
    const result = this.#subTokenString(this.#offset + 1, top.match + 1);
    this.#offset = top.match + 1;
    return result;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const top = this.peek();
    if (top.type !== "OPEN_PAREN") {
      throw new Error("bad start");
    }
    const result = [];
    while (this.#offset < top.match - 1) {
      const link = this.peek().linkNext;
      result.push(this.#subTokenString(this.#offset + 1, link));
      this.#offset = link;
    }
    this.#offset = top.match + 1;
    return result;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (this.#offset >= this.#tokens.length) {
      throw new Error("out-of-bounds");
    }
    return this.#tokens[this.#offset];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(allowed) {
    const top = this.peekType("KEYWORD");
    return top != null && allowed.has(top) ? top : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(type) {
    if (this.length === 0) {
      return null;
    }
    const top = this.peek();
    return top.type === type ? top.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const result = this.peek();
    this.#offset++;
    return result;
  }
  toString() {
    const tokens = [];
    for (let i = this.#offset; i < this.#tokens.length; i++) {
      const token = this.#tokens[i];
      tokens.push(`${token.type}:${token.text}`);
    }
    return `<TokenString ${tokens.join(" ")}>`;
  }
};
function lex(text) {
  const tokens = [];
  const throwError2 = (message) => {
    const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
    throw new Error(`invalid token ${token} at ${offset}: ${message}`);
  };
  let brackets = [];
  let commas = [];
  let offset = 0;
  while (offset < text.length) {
    let cur = text.substring(offset);
    let match = cur.match(regexWhitespacePrefix);
    if (match) {
      offset += match[1].length;
      cur = text.substring(offset);
    }
    const token = { depth: brackets.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset, value: -1 };
    tokens.push(token);
    let type = SimpleTokens[cur[0]] || "";
    if (type) {
      token.type = type;
      token.text = cur[0];
      offset++;
      if (type === "OPEN_PAREN") {
        brackets.push(tokens.length - 1);
        commas.push(tokens.length - 1);
      } else if (type == "CLOSE_PAREN") {
        if (brackets.length === 0) {
          throwError2("no matching open bracket");
        }
        token.match = brackets.pop();
        tokens[token.match].match = tokens.length - 1;
        token.depth--;
        token.linkBack = commas.pop();
        tokens[token.linkBack].linkNext = tokens.length - 1;
      } else if (type === "COMMA") {
        token.linkBack = commas.pop();
        tokens[token.linkBack].linkNext = tokens.length - 1;
        commas.push(tokens.length - 1);
      } else if (type === "OPEN_BRACKET") {
        token.type = "BRACKET";
      } else if (type === "CLOSE_BRACKET") {
        let suffix = tokens.pop().text;
        if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
          const value = tokens.pop().text;
          suffix = value + suffix;
          tokens[tokens.length - 1].value = getNumber(value);
        }
        if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") {
          throw new Error("missing opening bracket");
        }
        tokens[tokens.length - 1].text += suffix;
      }
      continue;
    }
    match = cur.match(regexIdPrefix);
    if (match) {
      token.text = match[1];
      offset += token.text.length;
      if (Keywords.has(token.text)) {
        token.type = "KEYWORD";
        continue;
      }
      if (token.text.match(regexType)) {
        token.type = "TYPE";
        continue;
      }
      token.type = "ID";
      continue;
    }
    match = cur.match(regexNumberPrefix);
    if (match) {
      token.text = match[1];
      token.type = "NUMBER";
      offset += token.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
  }
  return new TokenString(tokens.map((t) => Object.freeze(t)));
}
function allowSingle(set, allowed) {
  let included = [];
  for (const key in allowed.keys()) {
    if (set.has(key)) {
      included.push(key);
    }
  }
  if (included.length > 1) {
    throw new Error(`conflicting types: ${included.join(", ")}`);
  }
}
function consumeName(type, tokens) {
  if (tokens.peekKeyword(KwTypes)) {
    const keyword = tokens.pop().text;
    if (keyword !== type) {
      throw new Error(`expected ${type}, got ${keyword}`);
    }
  }
  return tokens.popType("ID");
}
function consumeKeywords(tokens, allowed) {
  const keywords = /* @__PURE__ */ new Set();
  while (true) {
    const keyword = tokens.peekType("KEYWORD");
    if (keyword == null || allowed && !allowed.has(keyword)) {
      break;
    }
    tokens.pop();
    if (keywords.has(keyword)) {
      throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
    }
    keywords.add(keyword);
  }
  return Object.freeze(keywords);
}
function consumeMutability(tokens) {
  let modifiers = consumeKeywords(tokens, KwVisib);
  allowSingle(modifiers, setify("constant payable nonpayable".split(" ")));
  allowSingle(modifiers, setify("pure view payable nonpayable".split(" ")));
  if (modifiers.has("view")) {
    return "view";
  }
  if (modifiers.has("pure")) {
    return "pure";
  }
  if (modifiers.has("payable")) {
    return "payable";
  }
  if (modifiers.has("nonpayable")) {
    return "nonpayable";
  }
  if (modifiers.has("constant")) {
    return "view";
  }
  return "nonpayable";
}
function consumeParams(tokens, allowIndexed) {
  return tokens.popParams().map((t) => ParamType.from(t, allowIndexed));
}
function consumeGas(tokens) {
  if (tokens.peekType("AT")) {
    tokens.pop();
    if (tokens.peekType("NUMBER")) {
      return getBigInt(tokens.pop().text);
    }
    throw new Error("invalid gas");
  }
  return null;
}
function consumeEoi(tokens) {
  if (tokens.length) {
    throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
  }
}
var regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function verifyBasicType(type) {
  const match = type.match(regexType);
  assertArgument(match, "invalid type", "type", type);
  if (type === "uint") {
    return "uint256";
  }
  if (type === "int") {
    return "int256";
  }
  if (match[2]) {
    const length = parseInt(match[2]);
    assertArgument(length !== 0 && length <= 32, "invalid bytes length", "type", type);
  } else if (match[3]) {
    const size = parseInt(match[3]);
    assertArgument(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
  }
  return type;
}
var _guard2 = {};
var internal = Symbol.for("_ethers_internal");
var ParamTypeInternal = "_ParamTypeInternal";
var ErrorFragmentInternal = "_ErrorInternal";
var EventFragmentInternal = "_EventInternal";
var ConstructorFragmentInternal = "_ConstructorInternal";
var FallbackFragmentInternal = "_FallbackInternal";
var FunctionFragmentInternal = "_FunctionInternal";
var StructFragmentInternal = "_StructInternal";
var ParamType = class _ParamType {
  /**
   *  The local name of the parameter (or ``""`` if unbound)
   */
  name;
  /**
   *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
   *  ``"uint256[3][]"``)
   */
  type;
  /**
   *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
   */
  baseType;
  /**
   *  True if the parameters is indexed.
   *
   *  For non-indexable types this is ``null``.
   */
  indexed;
  /**
   *  The components for the tuple.
   *
   *  For non-tuple types this is ``null``.
   */
  components;
  /**
   *  The array length, or ``-1`` for dynamic-lengthed arrays.
   *
   *  For non-array types this is ``null``.
   */
  arrayLength;
  /**
   *  The type of each child in the array.
   *
   *  For non-array types this is ``null``.
   */
  arrayChildren;
  /**
   *  @private
   */
  constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren) {
    assertPrivate(guard, _guard2, "ParamType");
    Object.defineProperty(this, internal, { value: ParamTypeInternal });
    if (components) {
      components = Object.freeze(components.slice());
    }
    if (baseType === "array") {
      if (arrayLength == null || arrayChildren == null) {
        throw new Error("");
      }
    } else if (arrayLength != null || arrayChildren != null) {
      throw new Error("");
    }
    if (baseType === "tuple") {
      if (components == null) {
        throw new Error("");
      }
    } else if (components != null) {
      throw new Error("");
    }
    defineProperties(this, {
      name,
      type,
      baseType,
      indexed,
      components,
      arrayLength,
      arrayChildren
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(format) {
    if (format == null) {
      format = "sighash";
    }
    if (format === "json") {
      const name = this.name || "";
      if (this.isArray()) {
        const result3 = JSON.parse(this.arrayChildren.format("json"));
        result3.name = name;
        result3.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        return JSON.stringify(result3);
      }
      const result2 = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name
      };
      if (typeof this.indexed === "boolean") {
        result2.indexed = this.indexed;
      }
      if (this.isTuple()) {
        result2.components = this.components.map((c) => JSON.parse(c.format(format)));
      }
      return JSON.stringify(result2);
    }
    let result = "";
    if (this.isArray()) {
      result += this.arrayChildren.format(format);
      result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
    } else {
      if (this.isTuple()) {
        result += "(" + this.components.map((comp) => comp.format(format)).join(format === "full" ? ", " : ",") + ")";
      } else {
        result += this.type;
      }
    }
    if (format !== "sighash") {
      if (this.indexed === true) {
        result += " indexed";
      }
      if (format === "full" && this.name) {
        result += " " + this.name;
      }
    }
    return result;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(value, process2) {
    if (this.isArray()) {
      if (!Array.isArray(value)) {
        throw new Error("invalid array value");
      }
      if (this.arrayLength !== -1 && value.length !== this.arrayLength) {
        throw new Error("array is wrong length");
      }
      const _this = this;
      return value.map((v) => _this.arrayChildren.walk(v, process2));
    }
    if (this.isTuple()) {
      if (!Array.isArray(value)) {
        throw new Error("invalid tuple value");
      }
      if (value.length !== this.components.length) {
        throw new Error("array is wrong length");
      }
      const _this = this;
      return value.map((v, i) => _this.components[i].walk(v, process2));
    }
    return process2(this.type, value);
  }
  #walkAsync(promises, value, process2, setValue) {
    if (this.isArray()) {
      if (!Array.isArray(value)) {
        throw new Error("invalid array value");
      }
      if (this.arrayLength !== -1 && value.length !== this.arrayLength) {
        throw new Error("array is wrong length");
      }
      const childType = this.arrayChildren;
      const result2 = value.slice();
      result2.forEach((value2, index) => {
        childType.#walkAsync(promises, value2, process2, (value3) => {
          result2[index] = value3;
        });
      });
      setValue(result2);
      return;
    }
    if (this.isTuple()) {
      const components = this.components;
      let result2;
      if (Array.isArray(value)) {
        result2 = value.slice();
      } else {
        if (value == null || typeof value !== "object") {
          throw new Error("invalid tuple value");
        }
        result2 = components.map((param) => {
          if (!param.name) {
            throw new Error("cannot use object value with unnamed components");
          }
          if (!(param.name in value)) {
            throw new Error(`missing value for component ${param.name}`);
          }
          return value[param.name];
        });
      }
      if (result2.length !== this.components.length) {
        throw new Error("array is wrong length");
      }
      result2.forEach((value2, index) => {
        components[index].#walkAsync(promises, value2, process2, (value3) => {
          result2[index] = value3;
        });
      });
      setValue(result2);
      return;
    }
    const result = process2(this.type, value);
    if (result.then) {
      promises.push(async function() {
        setValue(await result);
      }());
    } else {
      setValue(result);
    }
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS names by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(value, process2) {
    const promises = [];
    const result = [value];
    this.#walkAsync(promises, value, process2, (value2) => {
      result[0] = value2;
    });
    if (promises.length) {
      await Promise.all(promises);
    }
    return result[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(obj, allowIndexed) {
    if (_ParamType.isParamType(obj)) {
      return obj;
    }
    if (typeof obj === "string") {
      try {
        return _ParamType.from(lex(obj), allowIndexed);
      } catch (error) {
        assertArgument(false, "invalid param type", "obj", obj);
      }
    } else if (obj instanceof TokenString) {
      let type2 = "", baseType = "";
      let comps = null;
      if (consumeKeywords(obj, setify(["tuple"])).has("tuple") || obj.peekType("OPEN_PAREN")) {
        baseType = "tuple";
        comps = obj.popParams().map((t) => _ParamType.from(t));
        type2 = `tuple(${comps.map((c) => c.format()).join(",")})`;
      } else {
        type2 = verifyBasicType(obj.popType("TYPE"));
        baseType = type2;
      }
      let arrayChildren = null;
      let arrayLength = null;
      while (obj.length && obj.peekType("BRACKET")) {
        const bracket = obj.pop();
        arrayChildren = new _ParamType(_guard2, "", type2, baseType, null, comps, arrayLength, arrayChildren);
        arrayLength = bracket.value;
        type2 += bracket.text;
        baseType = "array";
        comps = null;
      }
      let indexed2 = null;
      const keywords = consumeKeywords(obj, KwModifiers);
      if (keywords.has("indexed")) {
        if (!allowIndexed) {
          throw new Error("");
        }
        indexed2 = true;
      }
      const name2 = obj.peekType("ID") ? obj.pop().text : "";
      if (obj.length) {
        throw new Error("leftover tokens");
      }
      return new _ParamType(_guard2, name2, type2, baseType, indexed2, comps, arrayLength, arrayChildren);
    }
    const name = obj.name;
    assertArgument(!name || typeof name === "string" && name.match(regexId), "invalid name", "obj.name", name);
    let indexed = obj.indexed;
    if (indexed != null) {
      assertArgument(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
      indexed = !!indexed;
    }
    let type = obj.type;
    let arrayMatch = type.match(regexArrayType);
    if (arrayMatch) {
      const arrayLength = parseInt(arrayMatch[2] || "-1");
      const arrayChildren = _ParamType.from({
        type: arrayMatch[1],
        components: obj.components
      });
      return new _ParamType(_guard2, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
    }
    if (type === "tuple" || type.startsWith(
      "tuple("
      /* fix: ) */
    ) || type.startsWith(
      "("
      /* fix: ) */
    )) {
      const comps = obj.components != null ? obj.components.map((c) => _ParamType.from(c)) : null;
      const tuple = new _ParamType(_guard2, name || "", type, "tuple", indexed, comps, null, null);
      return tuple;
    }
    type = verifyBasicType(obj.type);
    return new _ParamType(_guard2, name || "", type, type, indexed, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(value) {
    return value && value[internal] === ParamTypeInternal;
  }
};
var Fragment = class _Fragment {
  /**
   *  The type of the fragment.
   */
  type;
  /**
   *  The inputs for the fragment.
   */
  inputs;
  /**
   *  @private
   */
  constructor(guard, type, inputs) {
    assertPrivate(guard, _guard2, "Fragment");
    inputs = Object.freeze(inputs.slice());
    defineProperties(this, { type, inputs });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(obj) {
    if (typeof obj === "string") {
      try {
        _Fragment.from(JSON.parse(obj));
      } catch (e) {
      }
      return _Fragment.from(lex(obj));
    }
    if (obj instanceof TokenString) {
      const type = obj.peekKeyword(KwTypes);
      switch (type) {
        case "constructor":
          return ConstructorFragment.from(obj);
        case "error":
          return ErrorFragment.from(obj);
        case "event":
          return EventFragment.from(obj);
        case "fallback":
        case "receive":
          return FallbackFragment.from(obj);
        case "function":
          return FunctionFragment.from(obj);
        case "struct":
          return StructFragment.from(obj);
      }
    } else if (typeof obj === "object") {
      switch (obj.type) {
        case "constructor":
          return ConstructorFragment.from(obj);
        case "error":
          return ErrorFragment.from(obj);
        case "event":
          return EventFragment.from(obj);
        case "fallback":
        case "receive":
          return FallbackFragment.from(obj);
        case "function":
          return FunctionFragment.from(obj);
        case "struct":
          return StructFragment.from(obj);
      }
      assert(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    assertArgument(false, "unsupported frgament object", "obj", obj);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(value) {
    return ConstructorFragment.isFragment(value);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(value) {
    return ErrorFragment.isFragment(value);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(value) {
    return EventFragment.isFragment(value);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(value) {
    return FunctionFragment.isFragment(value);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(value) {
    return StructFragment.isFragment(value);
  }
};
var NamedFragment = class extends Fragment {
  /**
   *  The name of the fragment.
   */
  name;
  /**
   *  @private
   */
  constructor(guard, type, name, inputs) {
    super(guard, type, inputs);
    assertArgument(typeof name === "string" && name.match(regexId), "invalid identifier", "name", name);
    inputs = Object.freeze(inputs.slice());
    defineProperties(this, { name });
  }
};
function joinParams(format, params) {
  return "(" + params.map((p) => p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
var ErrorFragment = class _ErrorFragment extends NamedFragment {
  /**
   *  @private
   */
  constructor(guard, name, inputs) {
    super(guard, "error", name, inputs);
    Object.defineProperty(this, internal, { value: ErrorFragmentInternal });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return id(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(format) {
    if (format == null) {
      format = "sighash";
    }
    if (format === "json") {
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
      });
    }
    const result = [];
    if (format !== "sighash") {
      result.push("error");
    }
    result.push(this.name + joinParams(format, this.inputs));
    return result.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(obj) {
    if (_ErrorFragment.isFragment(obj)) {
      return obj;
    }
    if (typeof obj === "string") {
      return _ErrorFragment.from(lex(obj));
    } else if (obj instanceof TokenString) {
      const name = consumeName("error", obj);
      const inputs = consumeParams(obj);
      consumeEoi(obj);
      return new _ErrorFragment(_guard2, name, inputs);
    }
    return new _ErrorFragment(_guard2, obj.name, obj.inputs ? obj.inputs.map(ParamType.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(value) {
    return value && value[internal] === ErrorFragmentInternal;
  }
};
var EventFragment = class _EventFragment extends NamedFragment {
  /**
   *  Whether this event is anonymous.
   */
  anonymous;
  /**
   *  @private
   */
  constructor(guard, name, inputs, anonymous) {
    super(guard, "event", name, inputs);
    Object.defineProperty(this, internal, { value: EventFragmentInternal });
    defineProperties(this, { anonymous });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return id(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(format) {
    if (format == null) {
      format = "sighash";
    }
    if (format === "json") {
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((i) => JSON.parse(i.format(format)))
      });
    }
    const result = [];
    if (format !== "sighash") {
      result.push("event");
    }
    result.push(this.name + joinParams(format, this.inputs));
    if (format !== "sighash" && this.anonymous) {
      result.push("anonymous");
    }
    return result.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(name, params) {
    params = (params || []).map((p) => ParamType.from(p));
    const fragment = new _EventFragment(_guard2, name, params, false);
    return fragment.topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(obj) {
    if (_EventFragment.isFragment(obj)) {
      return obj;
    }
    if (typeof obj === "string") {
      try {
        return _EventFragment.from(lex(obj));
      } catch (error) {
        assertArgument(false, "invalid event fragment", "obj", obj);
      }
    } else if (obj instanceof TokenString) {
      const name = consumeName("event", obj);
      const inputs = consumeParams(obj, true);
      const anonymous = !!consumeKeywords(obj, setify(["anonymous"])).has("anonymous");
      consumeEoi(obj);
      return new _EventFragment(_guard2, name, inputs, anonymous);
    }
    return new _EventFragment(_guard2, obj.name, obj.inputs ? obj.inputs.map((p) => ParamType.from(p, true)) : [], !!obj.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(value) {
    return value && value[internal] === EventFragmentInternal;
  }
};
var ConstructorFragment = class _ConstructorFragment extends Fragment {
  /**
   *  Whether the constructor can receive an endowment.
   */
  payable;
  /**
   *  The recommended gas limit for deployment or ``null``.
   */
  gas;
  /**
   *  @private
   */
  constructor(guard, type, inputs, payable, gas) {
    super(guard, type, inputs);
    Object.defineProperty(this, internal, { value: ConstructorFragmentInternal });
    defineProperties(this, { payable, gas });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(format) {
    assert(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" });
    if (format === "json") {
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(format)))
      });
    }
    const result = [`constructor${joinParams(format, this.inputs)}`];
    if (this.payable) {
      result.push("payable");
    }
    if (this.gas != null) {
      result.push(`@${this.gas.toString()}`);
    }
    return result.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(obj) {
    if (_ConstructorFragment.isFragment(obj)) {
      return obj;
    }
    if (typeof obj === "string") {
      try {
        return _ConstructorFragment.from(lex(obj));
      } catch (error) {
        assertArgument(false, "invalid constuctor fragment", "obj", obj);
      }
    } else if (obj instanceof TokenString) {
      consumeKeywords(obj, setify(["constructor"]));
      const inputs = consumeParams(obj);
      const payable = !!consumeKeywords(obj, KwVisibDeploy).has("payable");
      const gas = consumeGas(obj);
      consumeEoi(obj);
      return new _ConstructorFragment(_guard2, "constructor", inputs, payable, gas);
    }
    return new _ConstructorFragment(_guard2, "constructor", obj.inputs ? obj.inputs.map(ParamType.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(value) {
    return value && value[internal] === ConstructorFragmentInternal;
  }
};
var FallbackFragment = class _FallbackFragment extends Fragment {
  /**
   *  If the function can be sent value during invocation.
   */
  payable;
  constructor(guard, inputs, payable) {
    super(guard, "fallback", inputs);
    Object.defineProperty(this, internal, { value: FallbackFragmentInternal });
    defineProperties(this, { payable });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(format) {
    const type = this.inputs.length === 0 ? "receive" : "fallback";
    if (format === "json") {
      const stateMutability = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({ type, stateMutability });
    }
    return `${type}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(obj) {
    if (_FallbackFragment.isFragment(obj)) {
      return obj;
    }
    if (typeof obj === "string") {
      try {
        return _FallbackFragment.from(lex(obj));
      } catch (error) {
        assertArgument(false, "invalid fallback fragment", "obj", obj);
      }
    } else if (obj instanceof TokenString) {
      const errorObj = obj.toString();
      const topIsValid = obj.peekKeyword(setify(["fallback", "receive"]));
      assertArgument(topIsValid, "type must be fallback or receive", "obj", errorObj);
      const type = obj.popKeyword(setify(["fallback", "receive"]));
      if (type === "receive") {
        const inputs2 = consumeParams(obj);
        assertArgument(inputs2.length === 0, `receive cannot have arguments`, "obj.inputs", inputs2);
        consumeKeywords(obj, setify(["payable"]));
        consumeEoi(obj);
        return new _FallbackFragment(_guard2, [], true);
      }
      let inputs = consumeParams(obj);
      if (inputs.length) {
        assertArgument(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i) => i.format("minimal")).join(", "));
      } else {
        inputs = [ParamType.from("bytes")];
      }
      const mutability = consumeMutability(obj);
      assertArgument(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
      if (consumeKeywords(obj, setify(["returns"])).has("returns")) {
        const outputs = consumeParams(obj);
        assertArgument(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i) => i.format("minimal")).join(", "));
      }
      consumeEoi(obj);
      return new _FallbackFragment(_guard2, inputs, mutability === "payable");
    }
    if (obj.type === "receive") {
      return new _FallbackFragment(_guard2, [], true);
    }
    if (obj.type === "fallback") {
      const inputs = [ParamType.from("bytes")];
      const payable = obj.stateMutability === "payable";
      return new _FallbackFragment(_guard2, inputs, payable);
    }
    assertArgument(false, "invalid fallback description", "obj", obj);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(value) {
    return value && value[internal] === FallbackFragmentInternal;
  }
};
var FunctionFragment = class _FunctionFragment extends NamedFragment {
  /**
   *  If the function is constant (e.g. ``pure`` or ``view`` functions).
   */
  constant;
  /**
   *  The returned types for the result of calling this function.
   */
  outputs;
  /**
   *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
   *  or ``pure``)
   */
  stateMutability;
  /**
   *  If the function can be sent value during invocation.
   */
  payable;
  /**
   *  The recommended gas limit to send when calling this function.
   */
  gas;
  /**
   *  @private
   */
  constructor(guard, name, stateMutability, inputs, outputs, gas) {
    super(guard, "function", name, inputs);
    Object.defineProperty(this, internal, { value: FunctionFragmentInternal });
    outputs = Object.freeze(outputs.slice());
    const constant = stateMutability === "view" || stateMutability === "pure";
    const payable = stateMutability === "payable";
    defineProperties(this, { constant, gas, outputs, payable, stateMutability });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return id(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(format) {
    if (format == null) {
      format = "sighash";
    }
    if (format === "json") {
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(format))),
        outputs: this.outputs.map((o) => JSON.parse(o.format(format)))
      });
    }
    const result = [];
    if (format !== "sighash") {
      result.push("function");
    }
    result.push(this.name + joinParams(format, this.inputs));
    if (format !== "sighash") {
      if (this.stateMutability !== "nonpayable") {
        result.push(this.stateMutability);
      }
      if (this.outputs && this.outputs.length) {
        result.push("returns");
        result.push(joinParams(format, this.outputs));
      }
      if (this.gas != null) {
        result.push(`@${this.gas.toString()}`);
      }
    }
    return result.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(name, params) {
    params = (params || []).map((p) => ParamType.from(p));
    const fragment = new _FunctionFragment(_guard2, name, "view", params, [], null);
    return fragment.selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(obj) {
    if (_FunctionFragment.isFragment(obj)) {
      return obj;
    }
    if (typeof obj === "string") {
      try {
        return _FunctionFragment.from(lex(obj));
      } catch (error) {
        assertArgument(false, "invalid function fragment", "obj", obj);
      }
    } else if (obj instanceof TokenString) {
      const name = consumeName("function", obj);
      const inputs = consumeParams(obj);
      const mutability = consumeMutability(obj);
      let outputs = [];
      if (consumeKeywords(obj, setify(["returns"])).has("returns")) {
        outputs = consumeParams(obj);
      }
      const gas = consumeGas(obj);
      consumeEoi(obj);
      return new _FunctionFragment(_guard2, name, mutability, inputs, outputs, gas);
    }
    let stateMutability = obj.stateMutability;
    if (stateMutability == null) {
      stateMutability = "payable";
      if (typeof obj.constant === "boolean") {
        stateMutability = "view";
        if (!obj.constant) {
          stateMutability = "payable";
          if (typeof obj.payable === "boolean" && !obj.payable) {
            stateMutability = "nonpayable";
          }
        }
      } else if (typeof obj.payable === "boolean" && !obj.payable) {
        stateMutability = "nonpayable";
      }
    }
    return new _FunctionFragment(_guard2, obj.name, stateMutability, obj.inputs ? obj.inputs.map(ParamType.from) : [], obj.outputs ? obj.outputs.map(ParamType.from) : [], obj.gas != null ? obj.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(value) {
    return value && value[internal] === FunctionFragmentInternal;
  }
};
var StructFragment = class _StructFragment extends NamedFragment {
  /**
   *  @private
   */
  constructor(guard, name, inputs) {
    super(guard, "struct", name, inputs);
    Object.defineProperty(this, internal, { value: StructFragmentInternal });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(obj) {
    if (typeof obj === "string") {
      try {
        return _StructFragment.from(lex(obj));
      } catch (error) {
        assertArgument(false, "invalid struct fragment", "obj", obj);
      }
    } else if (obj instanceof TokenString) {
      const name = consumeName("struct", obj);
      const inputs = consumeParams(obj);
      consumeEoi(obj);
      return new _StructFragment(_guard2, name, inputs);
    }
    return new _StructFragment(_guard2, obj.name, obj.inputs ? obj.inputs.map(ParamType.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(value) {
    return value && value[internal] === StructFragmentInternal;
  }
};

// node_modules/ethers/lib.esm/abi/abi-coder.js
var PanicReasons = /* @__PURE__ */ new Map();
PanicReasons.set(0, "GENERIC_PANIC");
PanicReasons.set(1, "ASSERT_FALSE");
PanicReasons.set(17, "OVERFLOW");
PanicReasons.set(18, "DIVIDE_BY_ZERO");
PanicReasons.set(33, "ENUM_RANGE_ERROR");
PanicReasons.set(34, "BAD_STORAGE_DATA");
PanicReasons.set(49, "STACK_UNDERFLOW");
PanicReasons.set(50, "ARRAY_RANGE_ERROR");
PanicReasons.set(65, "OUT_OF_MEMORY");
PanicReasons.set(81, "UNINITIALIZED_FUNCTION_CALL");
var paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var defaultCoder = null;
var defaultMaxInflation = 1024;
function getBuiltinCallException(action, tx, data, abiCoder) {
  let message = "missing revert data";
  let reason = null;
  const invocation = null;
  let revert = null;
  if (data) {
    message = "execution reverted";
    const bytes2 = getBytes(data);
    data = hexlify(data);
    if (bytes2.length === 0) {
      message += " (no data present; likely require(false) occurred";
      reason = "require(false)";
    } else if (bytes2.length % 32 !== 4) {
      message += " (could not decode reason; invalid data length)";
    } else if (hexlify(bytes2.slice(0, 4)) === "0x08c379a0") {
      try {
        reason = abiCoder.decode(["string"], bytes2.slice(4))[0];
        revert = {
          signature: "Error(string)",
          name: "Error",
          args: [reason]
        };
        message += `: ${JSON.stringify(reason)}`;
      } catch (error) {
        message += " (could not decode reason; invalid string data)";
      }
    } else if (hexlify(bytes2.slice(0, 4)) === "0x4e487b71") {
      try {
        const code = Number(abiCoder.decode(["uint256"], bytes2.slice(4))[0]);
        revert = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [code]
        };
        reason = `Panic due to ${PanicReasons.get(code) || "UNKNOWN"}(${code})`;
        message += `: ${reason}`;
      } catch (error) {
        message += " (could not decode panic code)";
      }
    } else {
      message += " (unknown custom error)";
    }
  }
  const transaction = {
    to: tx.to ? getAddress(tx.to) : null,
    data: tx.data || "0x"
  };
  if (tx.from) {
    transaction.from = getAddress(tx.from);
  }
  return makeError(message, "CALL_EXCEPTION", {
    action,
    data,
    reason,
    transaction,
    invocation,
    revert
  });
}
var AbiCoder = class _AbiCoder {
  #getCoder(param) {
    if (param.isArray()) {
      return new ArrayCoder(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
    }
    if (param.isTuple()) {
      return new TupleCoder(param.components.map((c) => this.#getCoder(c)), param.name);
    }
    switch (param.baseType) {
      case "address":
        return new AddressCoder(param.name);
      case "bool":
        return new BooleanCoder(param.name);
      case "string":
        return new StringCoder(param.name);
      case "bytes":
        return new BytesCoder(param.name);
      case "":
        return new NullCoder(param.name);
    }
    let match = param.type.match(paramTypeNumber);
    if (match) {
      let size = parseInt(match[2] || "256");
      assertArgument(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
      return new NumberCoder(size / 8, match[1] === "int", param.name);
    }
    match = param.type.match(paramTypeBytes);
    if (match) {
      let size = parseInt(match[1]);
      assertArgument(size !== 0 && size <= 32, "invalid bytes length", "param", param);
      return new FixedBytesCoder(size, param.name);
    }
    assertArgument(false, "invalid type", "type", param.type);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(types) {
    const coders = types.map((type) => this.#getCoder(ParamType.from(type)));
    const coder = new TupleCoder(coders, "_");
    return coder.defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(types, values) {
    assertArgumentCount(values.length, types.length, "types/values length mismatch");
    const coders = types.map((type) => this.#getCoder(ParamType.from(type)));
    const coder = new TupleCoder(coders, "_");
    const writer = new Writer();
    coder.encode(writer, values);
    return writer.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(types, data, loose) {
    const coders = types.map((type) => this.#getCoder(ParamType.from(type)));
    const coder = new TupleCoder(coders, "_");
    return coder.decode(new Reader(data, loose, defaultMaxInflation));
  }
  static _setDefaultMaxInflation(value) {
    assertArgument(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
    defaultMaxInflation = value;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    if (defaultCoder == null) {
      defaultCoder = new _AbiCoder();
    }
    return defaultCoder;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(action, tx, data) {
    return getBuiltinCallException(action, tx, data, _AbiCoder.defaultAbiCoder());
  }
};

// node_modules/ethers/lib.esm/abi/interface.js
var LogDescription = class {
  /**
   *  The matching fragment for the ``topic0``.
   */
  fragment;
  /**
   *  The name of the Event.
   */
  name;
  /**
   *  The full Event signature.
   */
  signature;
  /**
   *  The topic hash for the Event.
   */
  topic;
  /**
   *  The arguments passed into the Event with ``emit``.
   */
  args;
  /**
   *  @_ignore:
   */
  constructor(fragment, topic, args) {
    const name = fragment.name, signature = fragment.format();
    defineProperties(this, {
      fragment,
      name,
      signature,
      topic,
      args
    });
  }
};
var TransactionDescription = class {
  /**
   *  The matching fragment from the transaction ``data``.
   */
  fragment;
  /**
   *  The name of the Function from the transaction ``data``.
   */
  name;
  /**
   *  The arguments passed to the Function from the transaction ``data``.
   */
  args;
  /**
   *  The full Function signature from the transaction ``data``.
   */
  signature;
  /**
   *  The selector for the Function from the transaction ``data``.
   */
  selector;
  /**
   *  The ``value`` (in wei) from the transaction.
   */
  value;
  /**
   *  @_ignore:
   */
  constructor(fragment, selector, args, value) {
    const name = fragment.name, signature = fragment.format();
    defineProperties(this, {
      fragment,
      name,
      args,
      signature,
      selector,
      value
    });
  }
};
var ErrorDescription = class {
  /**
   *  The matching fragment.
   */
  fragment;
  /**
   *  The name of the Error.
   */
  name;
  /**
   *  The arguments passed to the Error with ``revert``.
   */
  args;
  /**
   *  The full Error signature.
   */
  signature;
  /**
   *  The selector for the Error.
   */
  selector;
  /**
   *  @_ignore:
   */
  constructor(fragment, selector, args) {
    const name = fragment.name, signature = fragment.format();
    defineProperties(this, {
      fragment,
      name,
      args,
      signature,
      selector
    });
  }
};
var Indexed = class {
  /**
   *  The ``keccak256`` of the value logged.
   */
  hash;
  /**
   *  @_ignore:
   */
  _isIndexed;
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(value) {
    return !!(value && value._isIndexed);
  }
  /**
   *  @_ignore:
   */
  constructor(hash) {
    defineProperties(this, { hash, _isIndexed: true });
  }
};
var PanicReasons2 = {
  "0": "generic panic",
  "1": "assert(false)",
  "17": "arithmetic overflow",
  "18": "division or modulo by zero",
  "33": "enum overflow",
  "34": "invalid encoded storage byte array accessed",
  "49": "out-of-bounds array access; popping on an empty array",
  "50": "out-of-bounds access of an array or bytesN",
  "65": "out of memory",
  "81": "uninitialized function"
};
var BuiltinErrors = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: ["string"],
    reason: (message) => {
      return `reverted with reason string ${JSON.stringify(message)}`;
    }
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: ["uint256"],
    reason: (code) => {
      let reason = "unknown panic code";
      if (code >= 0 && code <= 255 && PanicReasons2[code.toString()]) {
        reason = PanicReasons2[code.toString()];
      }
      return `reverted with panic code 0x${code.toString(16)} (${reason})`;
    }
  }
};
var Interface = class _Interface {
  /**
   *  All the Contract ABI members (i.e. methods, events, errors, etc).
   */
  fragments;
  /**
   *  The Contract constructor.
   */
  deploy;
  /**
   *  The Fallback method, if any.
   */
  fallback;
  /**
   *  If receiving ether is supported.
   */
  receive;
  #errors;
  #events;
  #functions;
  //    #structs: Map<string, StructFragment>;
  #abiCoder;
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(fragments) {
    let abi = [];
    if (typeof fragments === "string") {
      abi = JSON.parse(fragments);
    } else {
      abi = fragments;
    }
    this.#functions = /* @__PURE__ */ new Map();
    this.#errors = /* @__PURE__ */ new Map();
    this.#events = /* @__PURE__ */ new Map();
    const frags = [];
    for (const a of abi) {
      try {
        frags.push(Fragment.from(a));
      } catch (error) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
      }
    }
    defineProperties(this, {
      fragments: Object.freeze(frags)
    });
    let fallback = null;
    let receive = false;
    this.#abiCoder = this.getAbiCoder();
    this.fragments.forEach((fragment, index) => {
      let bucket;
      switch (fragment.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          defineProperties(this, { deploy: fragment });
          return;
        case "fallback":
          if (fragment.inputs.length === 0) {
            receive = true;
          } else {
            assertArgument(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
            fallback = fragment;
            receive = fallback.payable;
          }
          return;
        case "function":
          bucket = this.#functions;
          break;
        case "event":
          bucket = this.#events;
          break;
        case "error":
          bucket = this.#errors;
          break;
        default:
          return;
      }
      const signature = fragment.format();
      if (bucket.has(signature)) {
        return;
      }
      bucket.set(signature, fragment);
    });
    if (!this.deploy) {
      defineProperties(this, {
        deploy: ConstructorFragment.from("constructor()")
      });
    }
    defineProperties(this, { fallback, receive });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(minimal) {
    const format = minimal ? "minimal" : "full";
    const abi = this.fragments.map((f) => f.format(format));
    return abi;
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const abi = this.fragments.map((f) => f.format("json"));
    return JSON.stringify(abi.map((j) => JSON.parse(j)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return AbiCoder.defaultAbiCoder();
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  #getFunction(key, values, forceUnique) {
    if (isHexString(key)) {
      const selector = key.toLowerCase();
      for (const fragment of this.#functions.values()) {
        if (selector === fragment.selector) {
          return fragment;
        }
      }
      return null;
    }
    if (key.indexOf("(") === -1) {
      const matching = [];
      for (const [name, fragment] of this.#functions) {
        if (name.split(
          "("
          /* fix:) */
        )[0] === key) {
          matching.push(fragment);
        }
      }
      if (values) {
        const lastValue = values.length > 0 ? values[values.length - 1] : null;
        let valueLength = values.length;
        let allowOptions = true;
        if (Typed.isTyped(lastValue) && lastValue.type === "overrides") {
          allowOptions = false;
          valueLength--;
        }
        for (let i = matching.length - 1; i >= 0; i--) {
          const inputs = matching[i].inputs.length;
          if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) {
            matching.splice(i, 1);
          }
        }
        for (let i = matching.length - 1; i >= 0; i--) {
          const inputs = matching[i].inputs;
          for (let j = 0; j < values.length; j++) {
            if (!Typed.isTyped(values[j])) {
              continue;
            }
            if (j >= inputs.length) {
              if (values[j].type === "overrides") {
                continue;
              }
              matching.splice(i, 1);
              break;
            }
            if (values[j].type !== inputs[j].baseType) {
              matching.splice(i, 1);
              break;
            }
          }
        }
      }
      if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
        const lastArg = values[values.length - 1];
        if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") {
          matching.splice(0, 1);
        }
      }
      if (matching.length === 0) {
        return null;
      }
      if (matching.length > 1 && forceUnique) {
        const matchStr = matching.map((m) => JSON.stringify(m.format())).join(", ");
        assertArgument(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
      }
      return matching[0];
    }
    const result = this.#functions.get(FunctionFragment.from(key).format());
    if (result) {
      return result;
    }
    return null;
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(key) {
    const fragment = this.#getFunction(key, null, false);
    assertArgument(fragment, "no matching function", "key", key);
    return fragment.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(key) {
    return !!this.#getFunction(key, null, false);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(key, values) {
    return this.#getFunction(key, values || null, true);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(callback) {
    const names = Array.from(this.#functions.keys());
    names.sort((a, b2) => a.localeCompare(b2));
    for (let i = 0; i < names.length; i++) {
      const name = names[i];
      callback(this.#functions.get(name), i);
    }
  }
  // Find an event definition by any means necessary (unless it is ambiguous)
  #getEvent(key, values, forceUnique) {
    if (isHexString(key)) {
      const eventTopic = key.toLowerCase();
      for (const fragment of this.#events.values()) {
        if (eventTopic === fragment.topicHash) {
          return fragment;
        }
      }
      return null;
    }
    if (key.indexOf("(") === -1) {
      const matching = [];
      for (const [name, fragment] of this.#events) {
        if (name.split(
          "("
          /* fix:) */
        )[0] === key) {
          matching.push(fragment);
        }
      }
      if (values) {
        for (let i = matching.length - 1; i >= 0; i--) {
          if (matching[i].inputs.length < values.length) {
            matching.splice(i, 1);
          }
        }
        for (let i = matching.length - 1; i >= 0; i--) {
          const inputs = matching[i].inputs;
          for (let j = 0; j < values.length; j++) {
            if (!Typed.isTyped(values[j])) {
              continue;
            }
            if (values[j].type !== inputs[j].baseType) {
              matching.splice(i, 1);
              break;
            }
          }
        }
      }
      if (matching.length === 0) {
        return null;
      }
      if (matching.length > 1 && forceUnique) {
        const matchStr = matching.map((m) => JSON.stringify(m.format())).join(", ");
        assertArgument(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
      }
      return matching[0];
    }
    const result = this.#events.get(EventFragment.from(key).format());
    if (result) {
      return result;
    }
    return null;
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(key) {
    const fragment = this.#getEvent(key, null, false);
    assertArgument(fragment, "no matching event", "key", key);
    return fragment.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(key) {
    return !!this.#getEvent(key, null, false);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(key, values) {
    return this.#getEvent(key, values || null, true);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(callback) {
    const names = Array.from(this.#events.keys());
    names.sort((a, b2) => a.localeCompare(b2));
    for (let i = 0; i < names.length; i++) {
      const name = names[i];
      callback(this.#events.get(name), i);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(key, values) {
    if (isHexString(key)) {
      const selector = key.toLowerCase();
      if (BuiltinErrors[selector]) {
        return ErrorFragment.from(BuiltinErrors[selector].signature);
      }
      for (const fragment of this.#errors.values()) {
        if (selector === fragment.selector) {
          return fragment;
        }
      }
      return null;
    }
    if (key.indexOf("(") === -1) {
      const matching = [];
      for (const [name, fragment] of this.#errors) {
        if (name.split(
          "("
          /* fix:) */
        )[0] === key) {
          matching.push(fragment);
        }
      }
      if (matching.length === 0) {
        if (key === "Error") {
          return ErrorFragment.from("error Error(string)");
        }
        if (key === "Panic") {
          return ErrorFragment.from("error Panic(uint256)");
        }
        return null;
      } else if (matching.length > 1) {
        const matchStr = matching.map((m) => JSON.stringify(m.format())).join(", ");
        assertArgument(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
      }
      return matching[0];
    }
    key = ErrorFragment.from(key).format();
    if (key === "Error(string)") {
      return ErrorFragment.from("error Error(string)");
    }
    if (key === "Panic(uint256)") {
      return ErrorFragment.from("error Panic(uint256)");
    }
    const result = this.#errors.get(key);
    if (result) {
      return result;
    }
    return null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(callback) {
    const names = Array.from(this.#errors.keys());
    names.sort((a, b2) => a.localeCompare(b2));
    for (let i = 0; i < names.length; i++) {
      const name = names[i];
      callback(this.#errors.get(name), i);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];
  
          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }
  
          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }
  
          fragment = matches[0];
      }
  
      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(params, data) {
    return this.#abiCoder.decode(params, data);
  }
  _encodeParams(params, values) {
    return this.#abiCoder.encode(params, values);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(values) {
    return this._encodeParams(this.deploy.inputs, values || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(fragment, data) {
    if (typeof fragment === "string") {
      const f = this.getError(fragment);
      assertArgument(f, "unknown error", "fragment", fragment);
      fragment = f;
    }
    assertArgument(dataSlice(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
    return this._decodeParams(fragment.inputs, dataSlice(data, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(fragment, values) {
    if (typeof fragment === "string") {
      const f = this.getError(fragment);
      assertArgument(f, "unknown error", "fragment", fragment);
      fragment = f;
    }
    return concat([
      fragment.selector,
      this._encodeParams(fragment.inputs, values || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(fragment, data) {
    if (typeof fragment === "string") {
      const f = this.getFunction(fragment);
      assertArgument(f, "unknown function", "fragment", fragment);
      fragment = f;
    }
    assertArgument(dataSlice(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
    return this._decodeParams(fragment.inputs, dataSlice(data, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(fragment, values) {
    if (typeof fragment === "string") {
      const f = this.getFunction(fragment);
      assertArgument(f, "unknown function", "fragment", fragment);
      fragment = f;
    }
    return concat([
      fragment.selector,
      this._encodeParams(fragment.inputs, values || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(fragment, data) {
    if (typeof fragment === "string") {
      const f = this.getFunction(fragment);
      assertArgument(f, "unknown function", "fragment", fragment);
      fragment = f;
    }
    let message = "invalid length for result data";
    const bytes2 = getBytesCopy(data);
    if (bytes2.length % 32 === 0) {
      try {
        return this.#abiCoder.decode(fragment.outputs, bytes2);
      } catch (error) {
        message = "could not decode result data";
      }
    }
    assert(false, message, "BAD_DATA", {
      value: hexlify(bytes2),
      info: { method: fragment.name, signature: fragment.format() }
    });
  }
  makeError(_data, tx) {
    const data = getBytes(_data, "data");
    const error = AbiCoder.getBuiltinCallException("call", tx, data);
    const customPrefix = "execution reverted (unknown custom error)";
    if (error.message.startsWith(customPrefix)) {
      const selector = hexlify(data.slice(0, 4));
      const ef = this.getError(selector);
      if (ef) {
        try {
          const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
          error.revert = {
            name: ef.name,
            signature: ef.format(),
            args
          };
          error.reason = error.revert.signature;
          error.message = `execution reverted: ${error.reason}`;
        } catch (e) {
          error.message = `execution reverted (coult not decode custom error)`;
        }
      }
    }
    const parsed = this.parseTransaction(tx);
    if (parsed) {
      error.invocation = {
        method: parsed.name,
        signature: parsed.signature,
        args: parsed.args
      };
    }
    return error;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(fragment, values) {
    if (typeof fragment === "string") {
      const f = this.getFunction(fragment);
      assertArgument(f, "unknown function", "fragment", fragment);
      fragment = f;
    }
    return hexlify(this.#abiCoder.encode(fragment.outputs, values || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };
  
          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }
              
          };
  
          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(fragment, values) {
    if (typeof fragment === "string") {
      const f = this.getEvent(fragment);
      assertArgument(f, "unknown event", "eventFragment", fragment);
      fragment = f;
    }
    assert(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", { count: values.length, expectedCount: fragment.inputs.length });
    const topics = [];
    if (!fragment.anonymous) {
      topics.push(fragment.topicHash);
    }
    const encodeTopic = (param, value) => {
      if (param.type === "string") {
        return id(value);
      } else if (param.type === "bytes") {
        return keccak256(hexlify(value));
      }
      if (param.type === "bool" && typeof value === "boolean") {
        value = value ? "0x01" : "0x00";
      } else if (param.type.match(/^u?int/)) {
        value = toBeHex(value);
      } else if (param.type.match(/^bytes/)) {
        value = zeroPadBytes(value, 32);
      } else if (param.type === "address") {
        this.#abiCoder.encode(["address"], [value]);
      }
      return zeroPadValue(hexlify(value), 32);
    };
    values.forEach((value, index) => {
      const param = fragment.inputs[index];
      if (!param.indexed) {
        assertArgument(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
        return;
      }
      if (value == null) {
        topics.push(null);
      } else if (param.baseType === "array" || param.baseType === "tuple") {
        assertArgument(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
      } else if (Array.isArray(value)) {
        topics.push(value.map((value2) => encodeTopic(param, value2)));
      } else {
        topics.push(encodeTopic(param, value));
      }
    });
    while (topics.length && topics[topics.length - 1] === null) {
      topics.pop();
    }
    return topics;
  }
  encodeEventLog(fragment, values) {
    if (typeof fragment === "string") {
      const f = this.getEvent(fragment);
      assertArgument(f, "unknown event", "eventFragment", fragment);
      fragment = f;
    }
    const topics = [];
    const dataTypes = [];
    const dataValues = [];
    if (!fragment.anonymous) {
      topics.push(fragment.topicHash);
    }
    assertArgument(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
    fragment.inputs.forEach((param, index) => {
      const value = values[index];
      if (param.indexed) {
        if (param.type === "string") {
          topics.push(id(value));
        } else if (param.type === "bytes") {
          topics.push(keccak256(value));
        } else if (param.baseType === "tuple" || param.baseType === "array") {
          throw new Error("not implemented");
        } else {
          topics.push(this.#abiCoder.encode([param.type], [value]));
        }
      } else {
        dataTypes.push(param);
        dataValues.push(value);
      }
    });
    return {
      data: this.#abiCoder.encode(dataTypes, dataValues),
      topics
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(fragment, data, topics) {
    if (typeof fragment === "string") {
      const f = this.getEvent(fragment);
      assertArgument(f, "unknown event", "eventFragment", fragment);
      fragment = f;
    }
    if (topics != null && !fragment.anonymous) {
      const eventTopic = fragment.topicHash;
      assertArgument(isHexString(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
      topics = topics.slice(1);
    }
    const indexed = [];
    const nonIndexed = [];
    const dynamic = [];
    fragment.inputs.forEach((param, index) => {
      if (param.indexed) {
        if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
          indexed.push(ParamType.from({ type: "bytes32", name: param.name }));
          dynamic.push(true);
        } else {
          indexed.push(param);
          dynamic.push(false);
        }
      } else {
        nonIndexed.push(param);
        dynamic.push(false);
      }
    });
    const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, concat(topics)) : null;
    const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
    const values = [];
    const keys = [];
    let nonIndexedIndex = 0, indexedIndex = 0;
    fragment.inputs.forEach((param, index) => {
      let value = null;
      if (param.indexed) {
        if (resultIndexed == null) {
          value = new Indexed(null);
        } else if (dynamic[index]) {
          value = new Indexed(resultIndexed[indexedIndex++]);
        } else {
          try {
            value = resultIndexed[indexedIndex++];
          } catch (error) {
            value = error;
          }
        }
      } else {
        try {
          value = resultNonIndexed[nonIndexedIndex++];
        } catch (error) {
          value = error;
        }
      }
      values.push(value);
      keys.push(param.name || null);
    });
    return Result.fromItems(values, keys);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(tx) {
    const data = getBytes(tx.data, "tx.data");
    const value = getBigInt(tx.value != null ? tx.value : 0, "tx.value");
    const fragment = this.getFunction(hexlify(data.slice(0, 4)));
    if (!fragment) {
      return null;
    }
    const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
    return new TransactionDescription(fragment, fragment.selector, args, value);
  }
  parseCallResult(data) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(log) {
    const fragment = this.getEvent(log.topics[0]);
    if (!fragment || fragment.anonymous) {
      return null;
    }
    return new LogDescription(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(data) {
    const hexData = hexlify(data);
    const fragment = this.getError(dataSlice(hexData, 0, 4));
    if (!fragment) {
      return null;
    }
    const args = this.#abiCoder.decode(fragment.inputs, dataSlice(hexData, 4));
    return new ErrorDescription(fragment, fragment.selector, args);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(value) {
    if (value instanceof _Interface) {
      return value;
    }
    if (typeof value === "string") {
      return new _Interface(JSON.parse(value));
    }
    if (typeof value.formatJson === "function") {
      return new _Interface(value.formatJson());
    }
    if (typeof value.format === "function") {
      return new _Interface(value.format("json"));
    }
    return new _Interface(value);
  }
};

// node_modules/ethers/lib.esm/providers/provider.js
var BN_04 = BigInt(0);
function getValue2(value) {
  if (value == null) {
    return null;
  }
  return value;
}
function toJson(value) {
  if (value == null) {
    return null;
  }
  return value.toString();
}
function copyRequest(req) {
  const result = {};
  if (req.to) {
    result.to = req.to;
  }
  if (req.from) {
    result.from = req.from;
  }
  if (req.data) {
    result.data = hexlify(req.data);
  }
  const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const key of bigIntKeys) {
    if (!(key in req) || req[key] == null) {
      continue;
    }
    result[key] = getBigInt(req[key], `request.${key}`);
  }
  const numberKeys = "type,nonce".split(/,/);
  for (const key of numberKeys) {
    if (!(key in req) || req[key] == null) {
      continue;
    }
    result[key] = getNumber(req[key], `request.${key}`);
  }
  if (req.accessList) {
    result.accessList = accessListify(req.accessList);
  }
  if ("blockTag" in req) {
    result.blockTag = req.blockTag;
  }
  if ("enableCcipRead" in req) {
    result.enableCcipRead = !!req.enableCcipRead;
  }
  if ("customData" in req) {
    result.customData = req.customData;
  }
  if ("blobVersionedHashes" in req && req.blobVersionedHashes) {
    result.blobVersionedHashes = req.blobVersionedHashes.slice();
  }
  if ("kzg" in req) {
    result.kzg = req.kzg;
  }
  if ("blobs" in req && req.blobs) {
    result.blobs = req.blobs.map((b2) => {
      if (isBytesLike(b2)) {
        return hexlify(b2);
      }
      return Object.assign({}, b2);
    });
  }
  return result;
}
var Block = class {
  /**
   *  The provider connected to the block used to fetch additional details
   *  if necessary.
   */
  provider;
  /**
   *  The block number, sometimes called the block height. This is a
   *  sequential number that is one higher than the parent block.
   */
  number;
  /**
   *  The block hash.
   *
   *  This hash includes all properties, so can be safely used to identify
   *  an exact set of block properties.
   */
  hash;
  /**
   *  The timestamp for this block, which is the number of seconds since
   *  epoch that this block was included.
   */
  timestamp;
  /**
   *  The block hash of the parent block.
   */
  parentHash;
  /**
   *  The hash tree root of the parent beacon block for the given
   *  execution block. See [[link-eip-4788]].
   */
  parentBeaconBlockRoot;
  /**
   *  The nonce.
   *
   *  On legacy networks, this is the random number inserted which
   *  permitted the difficulty target to be reached.
   */
  nonce;
  /**
   *  The difficulty target.
   *
   *  On legacy networks, this is the proof-of-work target required
   *  for a block to meet the protocol rules to be included.
   *
   *  On modern networks, this is a random number arrived at using
   *  randao.  @TODO: Find links?
   */
  difficulty;
  /**
   *  The total gas limit for this block.
   */
  gasLimit;
  /**
   *  The total gas used in this block.
   */
  gasUsed;
  /**
   *  The root hash for the global state after applying changes
   *  in this block.
   */
  stateRoot;
  /**
   *  The hash of the transaction receipts trie.
   */
  receiptsRoot;
  /**
   *  The total amount of blob gas consumed by the transactions
   *  within the block. See [[link-eip-4844]].
   */
  blobGasUsed;
  /**
   *  The running total of blob gas consumed in excess of the
   *  target, prior to the block. See [[link-eip-4844]].
   */
  excessBlobGas;
  /**
   *  The miner coinbase address, wihch receives any subsidies for
   *  including this block.
   */
  miner;
  /**
   *  The latest RANDAO mix of the post beacon state of
   *  the previous block.
   */
  prevRandao;
  /**
   *  Any extra data the validator wished to include.
   */
  extraData;
  /**
   *  The base fee per gas that all transactions in this block were
   *  charged.
   *
   *  This adjusts after each block, depending on how congested the network
   *  is.
   */
  baseFeePerGas;
  #transactions;
  /**
   *  Create a new **Block** object.
   *
   *  This should generally not be necessary as the unless implementing a
   *  low-level library.
   */
  constructor(block, provider) {
    this.#transactions = block.transactions.map((tx) => {
      if (typeof tx !== "string") {
        return new TransactionResponse(tx, provider);
      }
      return tx;
    });
    defineProperties(this, {
      provider,
      hash: getValue2(block.hash),
      number: block.number,
      timestamp: block.timestamp,
      parentHash: block.parentHash,
      parentBeaconBlockRoot: block.parentBeaconBlockRoot,
      nonce: block.nonce,
      difficulty: block.difficulty,
      gasLimit: block.gasLimit,
      gasUsed: block.gasUsed,
      blobGasUsed: block.blobGasUsed,
      excessBlobGas: block.excessBlobGas,
      miner: block.miner,
      prevRandao: getValue2(block.prevRandao),
      extraData: block.extraData,
      baseFeePerGas: getValue2(block.baseFeePerGas),
      stateRoot: block.stateRoot,
      receiptsRoot: block.receiptsRoot
    });
  }
  /**
   *  Returns the list of transaction hashes, in the order
   *  they were executed within the block.
   */
  get transactions() {
    return this.#transactions.map((tx) => {
      if (typeof tx === "string") {
        return tx;
      }
      return tx.hash;
    });
  }
  /**
   *  Returns the complete transactions, in the order they
   *  were executed within the block.
   *
   *  This is only available for blocks which prefetched
   *  transactions, by passing ``true`` to %%prefetchTxs%%
   *  into [[Provider-getBlock]].
   */
  get prefetchedTransactions() {
    const txs = this.#transactions.slice();
    if (txs.length === 0) {
      return [];
    }
    assert(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
      operation: "transactionResponses()"
    });
    return txs;
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { baseFeePerGas, difficulty, extraData, gasLimit, gasUsed, hash, miner, prevRandao, nonce, number: number2, parentHash, parentBeaconBlockRoot, stateRoot, receiptsRoot, timestamp, transactions } = this;
    return {
      _type: "Block",
      baseFeePerGas: toJson(baseFeePerGas),
      difficulty: toJson(difficulty),
      extraData,
      gasLimit: toJson(gasLimit),
      gasUsed: toJson(gasUsed),
      blobGasUsed: toJson(this.blobGasUsed),
      excessBlobGas: toJson(this.excessBlobGas),
      hash,
      miner,
      prevRandao,
      nonce,
      number: number2,
      parentHash,
      timestamp,
      parentBeaconBlockRoot,
      stateRoot,
      receiptsRoot,
      transactions
    };
  }
  [Symbol.iterator]() {
    let index = 0;
    const txs = this.transactions;
    return {
      next: () => {
        if (index < this.length) {
          return {
            value: txs[index++],
            done: false
          };
        }
        return { value: void 0, done: true };
      }
    };
  }
  /**
   *  The number of transactions in this block.
   */
  get length() {
    return this.#transactions.length;
  }
  /**
   *  The [[link-js-date]] this block was included at.
   */
  get date() {
    if (this.timestamp == null) {
      return null;
    }
    return new Date(this.timestamp * 1e3);
  }
  /**
   *  Get the transaction at %%indexe%% within this block.
   */
  async getTransaction(indexOrHash) {
    let tx = void 0;
    if (typeof indexOrHash === "number") {
      tx = this.#transactions[indexOrHash];
    } else {
      const hash = indexOrHash.toLowerCase();
      for (const v of this.#transactions) {
        if (typeof v === "string") {
          if (v !== hash) {
            continue;
          }
          tx = v;
          break;
        } else {
          if (v.hash === hash) {
            continue;
          }
          tx = v;
          break;
        }
      }
    }
    if (tx == null) {
      throw new Error("no such tx");
    }
    if (typeof tx === "string") {
      return await this.provider.getTransaction(tx);
    } else {
      return tx;
    }
  }
  /**
   *  If a **Block** was fetched with a request to include the transactions
   *  this will allow synchronous access to those transactions.
   *
   *  If the transactions were not prefetched, this will throw.
   */
  getPrefetchedTransaction(indexOrHash) {
    const txs = this.prefetchedTransactions;
    if (typeof indexOrHash === "number") {
      return txs[indexOrHash];
    }
    indexOrHash = indexOrHash.toLowerCase();
    for (const tx of txs) {
      if (tx.hash === indexOrHash) {
        return tx;
      }
    }
    assertArgument(false, "no matching transaction", "indexOrHash", indexOrHash);
  }
  /**
   *  Returns true if this block been mined. This provides a type guard
   *  for all properties on a [[MinedBlock]].
   */
  isMined() {
    return !!this.hash;
  }
  /**
   *  Returns true if this block is an [[link-eip-2930]] block.
   */
  isLondon() {
    return !!this.baseFeePerGas;
  }
  /**
   *  @_ignore:
   */
  orphanedEvent() {
    if (!this.isMined()) {
      throw new Error("");
    }
    return createOrphanedBlockFilter(this);
  }
};
var Log = class {
  /**
   *  The provider connected to the log used to fetch additional details
   *  if necessary.
   */
  provider;
  /**
   *  The transaction hash of the transaction this log occurred in. Use the
   *  [[Log-getTransaction]] to get the [[TransactionResponse]].
   */
  transactionHash;
  /**
   *  The block hash of the block this log occurred in. Use the
   *  [[Log-getBlock]] to get the [[Block]].
   */
  blockHash;
  /**
   *  The block number of the block this log occurred in. It is preferred
   *  to use the [[Block-hash]] when fetching the related [[Block]],
   *  since in the case of an orphaned block, the block at that height may
   *  have changed.
   */
  blockNumber;
  /**
   *  If the **Log** represents a block that was removed due to an orphaned
   *  block, this will be true.
   *
   *  This can only happen within an orphan event listener.
   */
  removed;
  /**
   *  The address of the contract that emitted this log.
   */
  address;
  /**
   *  The data included in this log when it was emitted.
   */
  data;
  /**
   *  The indexed topics included in this log when it was emitted.
   *
   *  All topics are included in the bloom filters, so they can be
   *  efficiently filtered using the [[Provider-getLogs]] method.
   */
  topics;
  /**
   *  The index within the block this log occurred at. This is generally
   *  not useful to developers, but can be used with the various roots
   *  to proof inclusion within a block.
   */
  index;
  /**
   *  The index within the transaction of this log.
   */
  transactionIndex;
  /**
   *  @_ignore:
   */
  constructor(log, provider) {
    this.provider = provider;
    const topics = Object.freeze(log.topics.slice());
    defineProperties(this, {
      transactionHash: log.transactionHash,
      blockHash: log.blockHash,
      blockNumber: log.blockNumber,
      removed: log.removed,
      address: log.address,
      data: log.data,
      topics,
      index: log.index,
      transactionIndex: log.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address, blockHash, blockNumber, data, index, removed, topics, transactionHash, transactionIndex } = this;
    return {
      _type: "log",
      address,
      blockHash,
      blockNumber,
      data,
      index,
      removed,
      topics,
      transactionHash,
      transactionIndex
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const block = await this.provider.getBlock(this.blockHash);
    assert(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
    return block;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const tx = await this.provider.getTransaction(this.transactionHash);
    assert(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
    return tx;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
    assert(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
    return receipt;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return createRemovedLogFilter(this);
  }
};
var TransactionReceipt = class {
  /**
   *  The provider connected to the log used to fetch additional details
   *  if necessary.
   */
  provider;
  /**
   *  The address the transaction was sent to.
   */
  to;
  /**
   *  The sender of the transaction.
   */
  from;
  /**
   *  The address of the contract if the transaction was directly
   *  responsible for deploying one.
   *
   *  This is non-null **only** if the ``to`` is empty and the ``data``
   *  was successfully executed as initcode.
   */
  contractAddress;
  /**
   *  The transaction hash.
   */
  hash;
  /**
   *  The index of this transaction within the block transactions.
   */
  index;
  /**
   *  The block hash of the [[Block]] this transaction was included in.
   */
  blockHash;
  /**
   *  The block number of the [[Block]] this transaction was included in.
   */
  blockNumber;
  /**
   *  The bloom filter bytes that represent all logs that occurred within
   *  this transaction. This is generally not useful for most developers,
   *  but can be used to validate the included logs.
   */
  logsBloom;
  /**
   *  The actual amount of gas used by this transaction.
   *
   *  When creating a transaction, the amount of gas that will be used can
   *  only be approximated, but the sender must pay the gas fee for the
   *  entire gas limit. After the transaction, the difference is refunded.
   */
  gasUsed;
  /**
   *  The gas used for BLObs. See [[link-eip-4844]].
   */
  blobGasUsed;
  /**
   *  The amount of gas used by all transactions within the block for this
   *  and all transactions with a lower ``index``.
   *
   *  This is generally not useful for developers but can be used to
   *  validate certain aspects of execution.
   */
  cumulativeGasUsed;
  /**
   *  The actual gas price used during execution.
   *
   *  Due to the complexity of [[link-eip-1559]] this value can only
   *  be caluclated after the transaction has been mined, snce the base
   *  fee is protocol-enforced.
   */
  gasPrice;
  /**
   *  The price paid per BLOB in gas. See [[link-eip-4844]].
   */
  blobGasPrice;
  /**
   *  The [[link-eip-2718]] transaction type.
   */
  type;
  //readonly byzantium!: boolean;
  /**
   *  The status of this transaction, indicating success (i.e. ``1``) or
   *  a revert (i.e. ``0``).
   *
   *  This is available in post-byzantium blocks, but some backends may
   *  backfill this value.
   */
  status;
  /**
   *  The root hash of this transaction.
   *
   *  This is no present and was only included in pre-byzantium blocks, but
   *  could be used to validate certain parts of the receipt.
   */
  root;
  #logs;
  /**
   *  @_ignore:
   */
  constructor(tx, provider) {
    this.#logs = Object.freeze(tx.logs.map((log) => {
      return new Log(log, provider);
    }));
    let gasPrice = BN_04;
    if (tx.effectiveGasPrice != null) {
      gasPrice = tx.effectiveGasPrice;
    } else if (tx.gasPrice != null) {
      gasPrice = tx.gasPrice;
    }
    defineProperties(this, {
      provider,
      to: tx.to,
      from: tx.from,
      contractAddress: tx.contractAddress,
      hash: tx.hash,
      index: tx.index,
      blockHash: tx.blockHash,
      blockNumber: tx.blockNumber,
      logsBloom: tx.logsBloom,
      gasUsed: tx.gasUsed,
      cumulativeGasUsed: tx.cumulativeGasUsed,
      blobGasUsed: tx.blobGasUsed,
      gasPrice,
      blobGasPrice: tx.blobGasPrice,
      type: tx.type,
      //byzantium: tx.byzantium,
      status: tx.status,
      root: tx.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return this.#logs;
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const {
      to,
      from,
      contractAddress,
      hash,
      index,
      blockHash,
      blockNumber,
      logsBloom,
      logs,
      //byzantium, 
      status,
      root
    } = this;
    return {
      _type: "TransactionReceipt",
      blockHash,
      blockNumber,
      //byzantium, 
      contractAddress,
      cumulativeGasUsed: toJson(this.cumulativeGasUsed),
      from,
      gasPrice: toJson(this.gasPrice),
      blobGasUsed: toJson(this.blobGasUsed),
      blobGasPrice: toJson(this.blobGasPrice),
      gasUsed: toJson(this.gasUsed),
      hash,
      index,
      logs,
      logsBloom,
      root,
      status,
      to
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let index = 0;
    return {
      next: () => {
        if (index < this.length) {
          return { value: this.logs[index++], done: false };
        }
        return { value: void 0, done: true };
      }
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const block = await this.provider.getBlock(this.blockHash);
    if (block == null) {
      throw new Error("TODO");
    }
    return block;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const tx = await this.provider.getTransaction(this.hash);
    if (tx == null) {
      throw new Error("TODO");
    }
    return tx;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return createRemovedTransactionFilter(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(other) {
    assert(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" });
    return createReorderedTransactionFilter(this, other);
  }
};
var TransactionResponse = class _TransactionResponse {
  /**
   *  The provider this is connected to, which will influence how its
   *  methods will resolve its async inspection methods.
   */
  provider;
  /**
   *  The block number of the block that this transaction was included in.
   *
   *  This is ``null`` for pending transactions.
   */
  blockNumber;
  /**
   *  The blockHash of the block that this transaction was included in.
   *
   *  This is ``null`` for pending transactions.
   */
  blockHash;
  /**
   *  The index within the block that this transaction resides at.
   */
  index;
  /**
   *  The transaction hash.
   */
  hash;
  /**
   *  The [[link-eip-2718]] transaction envelope type. This is
   *  ``0`` for legacy transactions types.
   */
  type;
  /**
   *  The receiver of this transaction.
   *
   *  If ``null``, then the transaction is an initcode transaction.
   *  This means the result of executing the [[data]] will be deployed
   *  as a new contract on chain (assuming it does not revert) and the
   *  address may be computed using [[getCreateAddress]].
   */
  to;
  /**
   *  The sender of this transaction. It is implicitly computed
   *  from the transaction pre-image hash (as the digest) and the
   *  [[signature]] using ecrecover.
   */
  from;
  /**
   *  The nonce, which is used to prevent replay attacks and offer
   *  a method to ensure transactions from a given sender are explicitly
   *  ordered.
   *
   *  When sending a transaction, this must be equal to the number of
   *  transactions ever sent by [[from]].
   */
  nonce;
  /**
   *  The maximum units of gas this transaction can consume. If execution
   *  exceeds this, the entries transaction is reverted and the sender
   *  is charged for the full amount, despite not state changes being made.
   */
  gasLimit;
  /**
   *  The gas price can have various values, depending on the network.
   *
   *  In modern networks, for transactions that are included this is
   *  the //effective gas price// (the fee per gas that was actually
   *  charged), while for transactions that have not been included yet
   *  is the [[maxFeePerGas]].
   *
   *  For legacy transactions, or transactions on legacy networks, this
   *  is the fee that will be charged per unit of gas the transaction
   *  consumes.
   */
  gasPrice;
  /**
   *  The maximum priority fee (per unit of gas) to allow a
   *  validator to charge the sender. This is inclusive of the
   *  [[maxFeeFeePerGas]].
   */
  maxPriorityFeePerGas;
  /**
   *  The maximum fee (per unit of gas) to allow this transaction
   *  to charge the sender.
   */
  maxFeePerGas;
  /**
   *  The [[link-eip-4844]] max fee per BLOb gas.
   */
  maxFeePerBlobGas;
  /**
   *  The data.
   */
  data;
  /**
   *  The value, in wei. Use [[formatEther]] to format this value
   *  as ether.
   */
  value;
  /**
   *  The chain ID.
   */
  chainId;
  /**
   *  The signature.
   */
  signature;
  /**
   *  The [[link-eip-2930]] access list for transaction types that
   *  support it, otherwise ``null``.
   */
  accessList;
  /**
   *  The [[link-eip-4844]] BLOb versioned hashes.
   */
  blobVersionedHashes;
  #startBlock;
  /**
   *  @_ignore:
   */
  constructor(tx, provider) {
    this.provider = provider;
    this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
    this.blockHash = tx.blockHash != null ? tx.blockHash : null;
    this.hash = tx.hash;
    this.index = tx.index;
    this.type = tx.type;
    this.from = tx.from;
    this.to = tx.to || null;
    this.gasLimit = tx.gasLimit;
    this.nonce = tx.nonce;
    this.data = tx.data;
    this.value = tx.value;
    this.gasPrice = tx.gasPrice;
    this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
    this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
    this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
    this.chainId = tx.chainId;
    this.signature = tx.signature;
    this.accessList = tx.accessList != null ? tx.accessList : null;
    this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
    this.#startBlock = -1;
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber, blockHash, index, hash, type, to, from, nonce, data, signature, accessList, blobVersionedHashes } = this;
    return {
      _type: "TransactionResponse",
      accessList,
      blockNumber,
      blockHash,
      blobVersionedHashes,
      chainId: toJson(this.chainId),
      data,
      from,
      gasLimit: toJson(this.gasLimit),
      gasPrice: toJson(this.gasPrice),
      hash,
      maxFeePerGas: toJson(this.maxFeePerGas),
      maxPriorityFeePerGas: toJson(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: toJson(this.maxFeePerBlobGas),
      nonce,
      signature,
      to,
      index,
      type,
      value: toJson(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let blockNumber = this.blockNumber;
    if (blockNumber == null) {
      const tx = await this.getTransaction();
      if (tx) {
        blockNumber = tx.blockNumber;
      }
    }
    if (blockNumber == null) {
      return null;
    }
    const block = this.provider.getBlock(blockNumber);
    if (block == null) {
      throw new Error("TODO");
    }
    return block;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx, blockNumber: blockNumber2 } = await resolveProperties({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      if (tx == null || tx.blockNumber == null) {
        return 0;
      }
      return blockNumber2 - tx.blockNumber + 1;
    }
    const blockNumber = await this.provider.getBlockNumber();
    return blockNumber - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(_confirms, _timeout) {
    const confirms = _confirms == null ? 1 : _confirms;
    const timeout = _timeout == null ? 0 : _timeout;
    let startBlock = this.#startBlock;
    let nextScan = -1;
    let stopScanning = startBlock === -1 ? true : false;
    const checkReplacement = async () => {
      if (stopScanning) {
        return null;
      }
      const { blockNumber, nonce } = await resolveProperties({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (nonce < this.nonce) {
        startBlock = blockNumber;
        return;
      }
      if (stopScanning) {
        return null;
      }
      const mined = await this.getTransaction();
      if (mined && mined.blockNumber != null) {
        return;
      }
      if (nextScan === -1) {
        nextScan = startBlock - 3;
        if (nextScan < this.#startBlock) {
          nextScan = this.#startBlock;
        }
      }
      while (nextScan <= blockNumber) {
        if (stopScanning) {
          return null;
        }
        const block = await this.provider.getBlock(nextScan, true);
        if (block == null) {
          return;
        }
        for (const hash of block) {
          if (hash === this.hash) {
            return;
          }
        }
        for (let i = 0; i < block.length; i++) {
          const tx = await block.getTransaction(i);
          if (tx.from === this.from && tx.nonce === this.nonce) {
            if (stopScanning) {
              return null;
            }
            const receipt2 = await this.provider.getTransactionReceipt(tx.hash);
            if (receipt2 == null) {
              return;
            }
            if (blockNumber - receipt2.blockNumber + 1 < confirms) {
              return;
            }
            let reason = "replaced";
            if (tx.data === this.data && tx.to === this.to && tx.value === this.value) {
              reason = "repriced";
            } else if (tx.data === "0x" && tx.from === tx.to && tx.value === BN_04) {
              reason = "cancelled";
            }
            assert(false, "transaction was replaced", "TRANSACTION_REPLACED", {
              cancelled: reason === "replaced" || reason === "cancelled",
              reason,
              replacement: tx.replaceableTransaction(startBlock),
              hash: tx.hash,
              receipt: receipt2
            });
          }
        }
        nextScan++;
      }
      return;
    };
    const checkReceipt = (receipt2) => {
      if (receipt2 == null || receipt2.status !== 0) {
        return receipt2;
      }
      assert(false, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: receipt2.to,
          from: receipt2.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: receipt2
      });
    };
    const receipt = await this.provider.getTransactionReceipt(this.hash);
    if (confirms === 0) {
      return checkReceipt(receipt);
    }
    if (receipt) {
      if (await receipt.confirmations() >= confirms) {
        return checkReceipt(receipt);
      }
    } else {
      await checkReplacement();
      if (confirms === 0) {
        return null;
      }
    }
    const waiter = new Promise((resolve, reject) => {
      const cancellers = [];
      const cancel = () => {
        cancellers.forEach((c) => c());
      };
      cancellers.push(() => {
        stopScanning = true;
      });
      if (timeout > 0) {
        const timer = setTimeout(() => {
          cancel();
          reject(makeError("wait for transaction timeout", "TIMEOUT"));
        }, timeout);
        cancellers.push(() => {
          clearTimeout(timer);
        });
      }
      const txListener = async (receipt2) => {
        if (await receipt2.confirmations() >= confirms) {
          cancel();
          try {
            resolve(checkReceipt(receipt2));
          } catch (error) {
            reject(error);
          }
        }
      };
      cancellers.push(() => {
        this.provider.off(this.hash, txListener);
      });
      this.provider.on(this.hash, txListener);
      if (startBlock >= 0) {
        const replaceListener = async () => {
          try {
            await checkReplacement();
          } catch (error) {
            if (isError(error, "TRANSACTION_REPLACED")) {
              cancel();
              reject(error);
              return;
            }
          }
          if (!stopScanning) {
            this.provider.once("block", replaceListener);
          }
        };
        cancellers.push(() => {
          this.provider.off("block", replaceListener);
        });
        this.provider.once("block", replaceListener);
      }
    });
    return await waiter;
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    assert(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" });
    return createRemovedTransactionFilter(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(other) {
    assert(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" });
    assert(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" });
    return createReorderedTransactionFilter(this, other);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(startBlock) {
    assertArgument(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
    const tx = new _TransactionResponse(this, this.provider);
    tx.#startBlock = startBlock;
    return tx;
  }
};
function createOrphanedBlockFilter(block) {
  return { orphan: "drop-block", hash: block.hash, number: block.number };
}
function createReorderedTransactionFilter(tx, other) {
  return { orphan: "reorder-transaction", tx, other };
}
function createRemovedTransactionFilter(tx) {
  return { orphan: "drop-transaction", tx };
}
function createRemovedLogFilter(log) {
  return { orphan: "drop-log", log: {
    transactionHash: log.transactionHash,
    blockHash: log.blockHash,
    blockNumber: log.blockNumber,
    address: log.address,
    data: log.data,
    topics: Object.freeze(log.topics.slice()),
    index: log.index
  } };
}

// node_modules/ethers/lib.esm/contract/wrappers.js
var EventLog = class extends Log {
  /**
   *  The Contract Interface.
   */
  interface;
  /**
   *  The matching event.
   */
  fragment;
  /**
   *  The parsed arguments passed to the event by ``emit``.
   */
  args;
  /**
   * @_ignore:
   */
  constructor(log, iface, fragment) {
    super(log, log.provider);
    const args = iface.decodeEventLog(fragment, log.data, log.topics);
    defineProperties(this, { args, fragment, interface: iface });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
};
var UndecodedEventLog = class extends Log {
  /**
   *  The error encounted when trying to decode the log.
   */
  error;
  /**
   * @_ignore:
   */
  constructor(log, error) {
    super(log, log.provider);
    defineProperties(this, { error });
  }
};
var ContractTransactionReceipt = class extends TransactionReceipt {
  #iface;
  /**
   *  @_ignore:
   */
  constructor(iface, provider, tx) {
    super(tx, provider);
    this.#iface = iface;
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((log) => {
      const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
      if (fragment) {
        try {
          return new EventLog(log, this.#iface, fragment);
        } catch (error) {
          return new UndecodedEventLog(log, error);
        }
      }
      return log;
    });
  }
};
var ContractTransactionResponse = class extends TransactionResponse {
  #iface;
  /**
   *  @_ignore:
   */
  constructor(iface, provider, tx) {
    super(tx, provider);
    this.#iface = iface;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(confirms, timeout) {
    const receipt = await super.wait(confirms, timeout);
    if (receipt == null) {
      return null;
    }
    return new ContractTransactionReceipt(this.#iface, this.provider, receipt);
  }
};
var ContractUnknownEventPayload = class extends EventPayload {
  /**
   *  The log with no matching events.
   */
  log;
  /**
   *  @_event:
   */
  constructor(contract, listener, filter, log) {
    super(contract, listener, filter);
    defineProperties(this, { log });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
};
var ContractEventPayload = class extends ContractUnknownEventPayload {
  /**
   *  @_ignore:
   */
  constructor(contract, listener, filter, fragment, _log) {
    super(contract, listener, filter, new EventLog(_log, contract.interface, fragment));
    const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
    defineProperties(this, { args, fragment });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
};

// node_modules/ethers/lib.esm/contract/contract.js
var BN_05 = BigInt(0);
function canCall(value) {
  return value && typeof value.call === "function";
}
function canEstimate(value) {
  return value && typeof value.estimateGas === "function";
}
function canResolve(value) {
  return value && typeof value.resolveName === "function";
}
function canSend(value) {
  return value && typeof value.sendTransaction === "function";
}
function getResolver(value) {
  if (value != null) {
    if (canResolve(value)) {
      return value;
    }
    if (value.provider) {
      return value.provider;
    }
  }
  return void 0;
}
var PreparedTopicFilter = class {
  #filter;
  fragment;
  constructor(contract, fragment, args) {
    defineProperties(this, { fragment });
    if (fragment.inputs.length < args.length) {
      throw new Error("too many arguments");
    }
    const runner = getRunner(contract.runner, "resolveName");
    const resolver = canResolve(runner) ? runner : null;
    this.#filter = async function() {
      const resolvedArgs = await Promise.all(fragment.inputs.map((param, index) => {
        const arg = args[index];
        if (arg == null) {
          return null;
        }
        return param.walkAsync(args[index], (type, value) => {
          if (type === "address") {
            if (Array.isArray(value)) {
              return Promise.all(value.map((v) => resolveAddress(v, resolver)));
            }
            return resolveAddress(value, resolver);
          }
          return value;
        });
      }));
      return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
    }();
  }
  getTopicFilter() {
    return this.#filter;
  }
};
function getRunner(value, feature) {
  if (value == null) {
    return null;
  }
  if (typeof value[feature] === "function") {
    return value;
  }
  if (value.provider && typeof value.provider[feature] === "function") {
    return value.provider;
  }
  return null;
}
function getProvider(value) {
  if (value == null) {
    return null;
  }
  return value.provider || null;
}
async function copyOverrides(arg, allowed) {
  const _overrides = Typed.dereference(arg, "overrides");
  assertArgument(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
  const overrides = copyRequest(_overrides);
  assertArgument(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
  assertArgument(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
  if (overrides.from) {
    overrides.from = overrides.from;
  }
  return overrides;
}
async function resolveArgs(_runner, inputs, args) {
  const runner = getRunner(_runner, "resolveName");
  const resolver = canResolve(runner) ? runner : null;
  return await Promise.all(inputs.map((param, index) => {
    return param.walkAsync(args[index], (type, value) => {
      value = Typed.dereference(value, type);
      if (type === "address") {
        return resolveAddress(value, resolver);
      }
      return value;
    });
  }));
}
function buildWrappedFallback(contract) {
  const populateTransaction = async function(overrides) {
    const tx = await copyOverrides(overrides, ["data"]);
    tx.to = await contract.getAddress();
    if (tx.from) {
      tx.from = await resolveAddress(tx.from, getResolver(contract.runner));
    }
    const iface = contract.interface;
    const noValue = getBigInt(tx.value || BN_05, "overrides.value") === BN_05;
    const noData = (tx.data || "0x") === "0x";
    if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) {
      assertArgument(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
    }
    assertArgument(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
    const payable = iface.receive || iface.fallback && iface.fallback.payable;
    assertArgument(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
    assertArgument(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
    return tx;
  };
  const staticCall = async function(overrides) {
    const runner = getRunner(contract.runner, "call");
    assert(canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const tx = await populateTransaction(overrides);
    try {
      return await runner.call(tx);
    } catch (error) {
      if (isCallException(error) && error.data) {
        throw contract.interface.makeError(error.data, tx);
      }
      throw error;
    }
  };
  const send = async function(overrides) {
    const runner = contract.runner;
    assert(canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const tx = await runner.sendTransaction(await populateTransaction(overrides));
    const provider = getProvider(contract.runner);
    return new ContractTransactionResponse(contract.interface, provider, tx);
  };
  const estimateGas = async function(overrides) {
    const runner = getRunner(contract.runner, "estimateGas");
    assert(canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" });
    return await runner.estimateGas(await populateTransaction(overrides));
  };
  const method = async (overrides) => {
    return await send(overrides);
  };
  defineProperties(method, {
    _contract: contract,
    estimateGas,
    populateTransaction,
    send,
    staticCall
  });
  return method;
}
function buildWrappedMethod(contract, key) {
  const getFragment = function(...args) {
    const fragment = contract.interface.getFunction(key, args);
    assert(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key, args }
    });
    return fragment;
  };
  const populateTransaction = async function(...args) {
    const fragment = getFragment(...args);
    let overrides = {};
    if (fragment.inputs.length + 1 === args.length) {
      overrides = await copyOverrides(args.pop());
      if (overrides.from) {
        overrides.from = await resolveAddress(overrides.from, getResolver(contract.runner));
      }
    }
    if (fragment.inputs.length !== args.length) {
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    }
    const resolvedArgs = await resolveArgs(contract.runner, fragment.inputs, args);
    return Object.assign({}, overrides, await resolveProperties({
      to: contract.getAddress(),
      data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
    }));
  };
  const staticCall = async function(...args) {
    const result = await staticCallResult(...args);
    if (result.length === 1) {
      return result[0];
    }
    return result;
  };
  const send = async function(...args) {
    const runner = contract.runner;
    assert(canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const tx = await runner.sendTransaction(await populateTransaction(...args));
    const provider = getProvider(contract.runner);
    return new ContractTransactionResponse(contract.interface, provider, tx);
  };
  const estimateGas = async function(...args) {
    const runner = getRunner(contract.runner, "estimateGas");
    assert(canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" });
    return await runner.estimateGas(await populateTransaction(...args));
  };
  const staticCallResult = async function(...args) {
    const runner = getRunner(contract.runner, "call");
    assert(canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const tx = await populateTransaction(...args);
    let result = "0x";
    try {
      result = await runner.call(tx);
    } catch (error) {
      if (isCallException(error) && error.data) {
        throw contract.interface.makeError(error.data, tx);
      }
      throw error;
    }
    const fragment = getFragment(...args);
    return contract.interface.decodeFunctionResult(fragment, result);
  };
  const method = async (...args) => {
    const fragment = getFragment(...args);
    if (fragment.constant) {
      return await staticCall(...args);
    }
    return await send(...args);
  };
  defineProperties(method, {
    name: contract.interface.getFunctionName(key),
    _contract: contract,
    _key: key,
    getFragment,
    estimateGas,
    populateTransaction,
    send,
    staticCall,
    staticCallResult
  });
  Object.defineProperty(method, "fragment", {
    configurable: false,
    enumerable: true,
    get: () => {
      const fragment = contract.interface.getFunction(key);
      assert(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key }
      });
      return fragment;
    }
  });
  return method;
}
function buildWrappedEvent(contract, key) {
  const getFragment = function(...args) {
    const fragment = contract.interface.getEvent(key, args);
    assert(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key, args }
    });
    return fragment;
  };
  const method = function(...args) {
    return new PreparedTopicFilter(contract, getFragment(...args), args);
  };
  defineProperties(method, {
    name: contract.interface.getEventName(key),
    _contract: contract,
    _key: key,
    getFragment
  });
  Object.defineProperty(method, "fragment", {
    configurable: false,
    enumerable: true,
    get: () => {
      const fragment = contract.interface.getEvent(key);
      assert(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key }
      });
      return fragment;
    }
  });
  return method;
}
var internal2 = Symbol.for("_ethersInternal_contract");
var internalValues = /* @__PURE__ */ new WeakMap();
function setInternal(contract, values) {
  internalValues.set(contract[internal2], values);
}
function getInternal(contract) {
  return internalValues.get(contract[internal2]);
}
function isDeferred(value) {
  return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function getSubInfo(contract, event) {
  let topics;
  let fragment = null;
  if (Array.isArray(event)) {
    const topicHashify = function(name) {
      if (isHexString(name, 32)) {
        return name;
      }
      const fragment2 = contract.interface.getEvent(name);
      assertArgument(fragment2, "unknown fragment", "name", name);
      return fragment2.topicHash;
    };
    topics = event.map((e) => {
      if (e == null) {
        return null;
      }
      if (Array.isArray(e)) {
        return e.map(topicHashify);
      }
      return topicHashify(e);
    });
  } else if (event === "*") {
    topics = [null];
  } else if (typeof event === "string") {
    if (isHexString(event, 32)) {
      topics = [event];
    } else {
      fragment = contract.interface.getEvent(event);
      assertArgument(fragment, "unknown fragment", "event", event);
      topics = [fragment.topicHash];
    }
  } else if (isDeferred(event)) {
    topics = await event.getTopicFilter();
  } else if ("fragment" in event) {
    fragment = event.fragment;
    topics = [fragment.topicHash];
  } else {
    assertArgument(false, "unknown event name", "event", event);
  }
  topics = topics.map((t) => {
    if (t == null) {
      return null;
    }
    if (Array.isArray(t)) {
      const items = Array.from(new Set(t.map((t2) => t2.toLowerCase())).values());
      if (items.length === 1) {
        return items[0];
      }
      items.sort();
      return items;
    }
    return t.toLowerCase();
  });
  const tag = topics.map((t) => {
    if (t == null) {
      return "null";
    }
    if (Array.isArray(t)) {
      return t.join("|");
    }
    return t;
  }).join("&");
  return { fragment, tag, topics };
}
async function hasSub(contract, event) {
  const { subs } = getInternal(contract);
  return subs.get((await getSubInfo(contract, event)).tag) || null;
}
async function getSub(contract, operation, event) {
  const provider = getProvider(contract.runner);
  assert(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation });
  const { fragment, tag, topics } = await getSubInfo(contract, event);
  const { addr, subs } = getInternal(contract);
  let sub = subs.get(tag);
  if (!sub) {
    const address = addr ? addr : contract;
    const filter = { address, topics };
    const listener = (log) => {
      let foundFragment = fragment;
      if (foundFragment == null) {
        try {
          foundFragment = contract.interface.getEvent(log.topics[0]);
        } catch (error) {
        }
      }
      if (foundFragment) {
        const _foundFragment = foundFragment;
        const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
        emit(contract, event, args, (listener2) => {
          return new ContractEventPayload(contract, listener2, event, _foundFragment, log);
        });
      } else {
        emit(contract, event, [], (listener2) => {
          return new ContractUnknownEventPayload(contract, listener2, event, log);
        });
      }
    };
    let starting = [];
    const start = () => {
      if (starting.length) {
        return;
      }
      starting.push(provider.on(filter, listener));
    };
    const stop = async () => {
      if (starting.length == 0) {
        return;
      }
      let started = starting;
      starting = [];
      await Promise.all(started);
      provider.off(filter, listener);
    };
    sub = { tag, listeners: [], start, stop };
    subs.set(tag, sub);
  }
  return sub;
}
var lastEmit = Promise.resolve();
async function _emit(contract, event, args, payloadFunc) {
  await lastEmit;
  const sub = await hasSub(contract, event);
  if (!sub) {
    return false;
  }
  const count = sub.listeners.length;
  sub.listeners = sub.listeners.filter(({ listener, once }) => {
    const passArgs = Array.from(args);
    if (payloadFunc) {
      passArgs.push(payloadFunc(once ? null : listener));
    }
    try {
      listener.call(contract, ...passArgs);
    } catch (error) {
    }
    return !once;
  });
  if (sub.listeners.length === 0) {
    sub.stop();
    getInternal(contract).subs.delete(sub.tag);
  }
  return count > 0;
}
async function emit(contract, event, args, payloadFunc) {
  try {
    await lastEmit;
  } catch (error) {
  }
  const resultPromise = _emit(contract, event, args, payloadFunc);
  lastEmit = resultPromise;
  return await resultPromise;
}
var passProperties2 = ["then"];
var BaseContract = class _BaseContract {
  /**
   *  The target to connect to.
   *
   *  This can be an address, ENS name or any [[Addressable]], such as
   *  another contract. To get the resovled address, use the ``getAddress``
   *  method.
   */
  target;
  /**
   *  The contract Interface.
   */
  interface;
  /**
   *  The connected runner. This is generally a [[Provider]] or a
   *  [[Signer]], which dictates what operations are supported.
   *
   *  For example, a **Contract** connected to a [[Provider]] may
   *  only execute read-only operations.
   */
  runner;
  /**
   *  All the Events available on this contract.
   */
  filters;
  /**
   *  @_ignore:
   */
  [internal2];
  /**
   *  The fallback or receive function if any.
   */
  fallback;
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(target, abi, runner, _deployTx) {
    assertArgument(typeof target === "string" || isAddressable(target), "invalid value for Contract target", "target", target);
    if (runner == null) {
      runner = null;
    }
    const iface = Interface.from(abi);
    defineProperties(this, { target, runner, interface: iface });
    Object.defineProperty(this, internal2, { value: {} });
    let addrPromise;
    let addr = null;
    let deployTx = null;
    if (_deployTx) {
      const provider = getProvider(runner);
      deployTx = new ContractTransactionResponse(this.interface, provider, _deployTx);
    }
    let subs = /* @__PURE__ */ new Map();
    if (typeof target === "string") {
      if (isHexString(target)) {
        addr = target;
        addrPromise = Promise.resolve(target);
      } else {
        const resolver = getRunner(runner, "resolveName");
        if (!canResolve(resolver)) {
          throw makeError("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        }
        addrPromise = resolver.resolveName(target).then((addr2) => {
          if (addr2 == null) {
            throw makeError("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: target
            });
          }
          getInternal(this).addr = addr2;
          return addr2;
        });
      }
    } else {
      addrPromise = target.getAddress().then((addr2) => {
        if (addr2 == null) {
          throw new Error("TODO");
        }
        getInternal(this).addr = addr2;
        return addr2;
      });
    }
    setInternal(this, { addrPromise, addr, deployTx, subs });
    const filters = new Proxy({}, {
      get: (target2, prop, receiver) => {
        if (typeof prop === "symbol" || passProperties2.indexOf(prop) >= 0) {
          return Reflect.get(target2, prop, receiver);
        }
        try {
          return this.getEvent(prop);
        } catch (error) {
          if (!isError(error, "INVALID_ARGUMENT") || error.argument !== "key") {
            throw error;
          }
        }
        return void 0;
      },
      has: (target2, prop) => {
        if (passProperties2.indexOf(prop) >= 0) {
          return Reflect.has(target2, prop);
        }
        return Reflect.has(target2, prop) || this.interface.hasEvent(String(prop));
      }
    });
    defineProperties(this, { filters });
    defineProperties(this, {
      fallback: iface.receive || iface.fallback ? buildWrappedFallback(this) : null
    });
    return new Proxy(this, {
      get: (target2, prop, receiver) => {
        if (typeof prop === "symbol" || prop in target2 || passProperties2.indexOf(prop) >= 0) {
          return Reflect.get(target2, prop, receiver);
        }
        try {
          return target2.getFunction(prop);
        } catch (error) {
          if (!isError(error, "INVALID_ARGUMENT") || error.argument !== "key") {
            throw error;
          }
        }
        return void 0;
      },
      has: (target2, prop) => {
        if (typeof prop === "symbol" || prop in target2 || passProperties2.indexOf(prop) >= 0) {
          return Reflect.has(target2, prop);
        }
        return target2.interface.hasFunction(prop);
      }
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(runner) {
    return new _BaseContract(this.target, this.interface, runner);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(target) {
    return new _BaseContract(target, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await getInternal(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const provider = getProvider(this.runner);
    assert(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
    const code = await provider.getCode(await this.getAddress());
    if (code === "0x") {
      return null;
    }
    return code;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const deployTx = this.deploymentTransaction();
    if (deployTx) {
      await deployTx.wait();
      return this;
    }
    const code = await this.getDeployedCode();
    if (code != null) {
      return this;
    }
    const provider = getProvider(this.runner);
    assert(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" });
    return new Promise((resolve, reject) => {
      const checkCode = async () => {
        try {
          const code2 = await this.getDeployedCode();
          if (code2 != null) {
            return resolve(this);
          }
          provider.once("block", checkCode);
        } catch (error) {
          reject(error);
        }
      };
      checkCode();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return getInternal(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(key) {
    if (typeof key !== "string") {
      key = key.format();
    }
    const func = buildWrappedMethod(this, key);
    return func;
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(key) {
    if (typeof key !== "string") {
      key = key.format();
    }
    return buildWrappedEvent(this, key);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(hash) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
  
          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }
  
          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
   *  Provide historic access to event data for %%event%% in the range
   *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
   *  inclusive.
   */
  async queryFilter(event, fromBlock, toBlock) {
    if (fromBlock == null) {
      fromBlock = 0;
    }
    if (toBlock == null) {
      toBlock = "latest";
    }
    const { addr, addrPromise } = getInternal(this);
    const address = addr ? addr : await addrPromise;
    const { fragment, topics } = await getSubInfo(this, event);
    const filter = { address, topics, fromBlock, toBlock };
    const provider = getProvider(this.runner);
    assert(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" });
    return (await provider.getLogs(filter)).map((log) => {
      let foundFragment = fragment;
      if (foundFragment == null) {
        try {
          foundFragment = this.interface.getEvent(log.topics[0]);
        } catch (error) {
        }
      }
      if (foundFragment) {
        try {
          return new EventLog(log, this.interface, foundFragment);
        } catch (error) {
          return new UndecodedEventLog(log, error);
        }
      }
      return new Log(log, provider);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(event, listener) {
    const sub = await getSub(this, "on", event);
    sub.listeners.push({ listener, once: false });
    sub.start();
    return this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(event, listener) {
    const sub = await getSub(this, "once", event);
    sub.listeners.push({ listener, once: true });
    sub.start();
    return this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(event, ...args) {
    return await emit(this, event, args, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(event) {
    if (event) {
      const sub = await hasSub(this, event);
      if (!sub) {
        return 0;
      }
      return sub.listeners.length;
    }
    const { subs } = getInternal(this);
    let total = 0;
    for (const { listeners } of subs.values()) {
      total += listeners.length;
    }
    return total;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(event) {
    if (event) {
      const sub = await hasSub(this, event);
      if (!sub) {
        return [];
      }
      return sub.listeners.map(({ listener }) => listener);
    }
    const { subs } = getInternal(this);
    let result = [];
    for (const { listeners } of subs.values()) {
      result = result.concat(listeners.map(({ listener }) => listener));
    }
    return result;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(event, listener) {
    const sub = await hasSub(this, event);
    if (!sub) {
      return this;
    }
    if (listener) {
      const index = sub.listeners.map(({ listener: listener2 }) => listener2).indexOf(listener);
      if (index >= 0) {
        sub.listeners.splice(index, 1);
      }
    }
    if (listener == null || sub.listeners.length === 0) {
      sub.stop();
      getInternal(this).subs.delete(sub.tag);
    }
    return this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(event) {
    if (event) {
      const sub = await hasSub(this, event);
      if (!sub) {
        return this;
      }
      sub.stop();
      getInternal(this).subs.delete(sub.tag);
    } else {
      const { subs } = getInternal(this);
      for (const { tag, stop } of subs.values()) {
        stop();
        subs.delete(tag);
      }
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(event, listener) {
    return await this.on(event, listener);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(event, listener) {
    return await this.off(event, listener);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(abi) {
    class CustomContract extends _BaseContract {
      constructor(address, runner = null) {
        super(address, abi, runner);
      }
    }
    return CustomContract;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(target, abi, runner) {
    if (runner == null) {
      runner = null;
    }
    const contract = new this(target, abi, runner);
    return contract;
  }
};
function _ContractBase() {
  return BaseContract;
}
var Contract = class extends _ContractBase() {
};

// src/typechain/factories/AssetRegistry__factory.ts
var _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "curRate",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "verified",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "stable",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    name: "AssetRegistryUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "assets",
    outputs: [
      {
        internalType: "uint256",
        name: "curRate",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "stable",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "get",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "curRate",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "feeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "feeFixed",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "verified",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "stable",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "sharable",
            type: "bool"
          }
        ],
        internalType: "struct Info",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "curRate",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "stable",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    name: "set",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeFixed",
        type: "uint256"
      }
    ],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "rate",
        type: "uint256"
      }
    ],
    name: "setRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "sharable",
        type: "bool"
      }
    ],
    name: "setSharable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "stable",
        type: "bool"
      }
    ],
    name: "setStable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool"
      }
    ],
    name: "setVerified",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "toCur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var AssetRegistry__factory = class {
  static abi = _abi;
  static createInterface() {
    return new Interface(_abi);
  }
  static connect(address, runner) {
    return new Contract(address, _abi, runner);
  }
};

// src/typechain/factories/BadgeManager__factory.ts
var _abi2 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coIssuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      }
    ],
    name: "AddedCoIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "AddedIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "BadgeMetaUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "BadgeOwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "address",
        name: "grantee",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    name: "GrantedBadge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "grantee",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "GranteeBadgeMetaUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "PathRegistered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "coIssuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      }
    ],
    name: "RemovedCoIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldIssuer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newIssuer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      }
    ],
    name: "ReplacedIssuer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        indexed: false,
        internalType: "address",
        name: "grantee",
        type: "address"
      }
    ],
    name: "RevokedBadge",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "badgeCoIssuers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "badgeIssuer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "badgeMetadata",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "badgeMetadataKeys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "badgePaths",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getGrantId",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getGranteeMetaKeys",
    outputs: [
      {
        internalType: "string[]",
        name: "",
        type: "string[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      }
    ],
    name: "getGranteeMetaValue",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      }
    ],
    name: "getMetaKeys",
    outputs: [
      {
        internalType: "string[]",
        name: "",
        type: "string[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      }
    ],
    name: "getMetaValue",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      }
    ],
    name: "getPathId",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "grantBadge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "string[]",
        name: "metaKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metaValues",
        type: "string[]"
      },
      {
        internalType: "uint256",
        name: "sigExpireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "grantBadgeBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "granted",
    outputs: [
      {
        internalType: "uint256",
        name: "grantedAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "granteeMetadata",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "granteeMetadataKeys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      }
    ],
    name: "hasBadge",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "issuerBadge",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "pathMetadata",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "pathMetadataKeys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "address",
        name: "coIssuer",
        type: "address"
      }
    ],
    name: "registerCoIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "issuer",
        type: "address"
      },
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "registerIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "string[]",
        name: "metadataKeys",
        type: "string[]"
      },
      {
        internalType: "string[]",
        name: "metadataValues",
        type: "string[]"
      }
    ],
    name: "registerPath",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "address",
        name: "coIssuer",
        type: "address"
      }
    ],
    name: "removeCoIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "address",
        name: "newIssuer",
        type: "address"
      }
    ],
    name: "replaceIssuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "revokeBadge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "revokeBadgeBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferBadgeOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "upsertGranteeMeta",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "upsertGranteeMetaBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "badge",
        type: "string"
      },
      {
        internalType: "string",
        name: "path",
        type: "string"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "upsertMeta",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "usedSig",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var BadgeManager__factory = class {
  static abi = _abi2;
  static createInterface() {
    return new Interface(_abi2);
  }
  static connect(address, runner) {
    return new Contract(address, _abi2, runner);
  }
};

// src/typechain/factories/BondCurveDistro__factory.ts
var _abi3 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_airdropAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_bondingCurveAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devFeeBp",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowBuyTransfer",
        type: "bool"
      }
    ],
    name: "AllowBuyTransfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowClaim",
        type: "bool"
      }
    ],
    name: "AllowClaim",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowSell",
        type: "bool"
      }
    ],
    name: "AllowSell",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowTrade",
        type: "bool"
      }
    ],
    name: "AllowTrade",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowWithdraw",
        type: "bool"
      }
    ],
    name: "AllowWithdraw",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "input",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "output",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "Buy",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newSigner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oldSigner",
        type: "address"
      }
    ],
    name: "ClaimSignerUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ClaimWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "claimId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "allocation",
        type: "uint256"
      }
    ],
    name: "Claimed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "airdropAlloc",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "devAlloc",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bondingCurveAlloc",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "devFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "k",
        type: "uint256"
      }
    ],
    name: "ReInitialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "input",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "output",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "Sell",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "devFeeBp",
        type: "uint256"
      }
    ],
    name: "UpdatedDevFeeBp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnDevFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnEth",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnToken",
    type: "event"
  },
  {
    inputs: [],
    name: "airdropAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowBuyTransfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowClaim",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowSell",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowTrade",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowWithdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bondingCurveAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bondingCurveEthBal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "maxPrice",
        type: "uint256"
      }
    ],
    name: "buy",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "supply",
        type: "uint256"
      }
    ],
    name: "buyPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "circulatingSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "claimId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes"
      }
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "signatures",
        type: "bytes[]"
      },
      {
        internalType: "uint256[]",
        name: "claimIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "nonces",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "allocations",
        type: "uint256[]"
      }
    ],
    name: "claimMulti",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "claimSigner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "claimedBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "claims",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devFeeBp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devFeeEthBal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialBondingCurveAlloc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "k",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_airdropAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_bondingCurveAlloc",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_devFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_k",
        type: "uint256"
      }
    ],
    name: "reInit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "minPrice",
        type: "uint256"
      }
    ],
    name: "sell",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "supply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountToSell",
        type: "uint256"
      }
    ],
    name: "sellPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_claimSigner",
        type: "address"
      }
    ],
    name: "setClaimSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_devFeeBp",
        type: "uint256"
      }
    ],
    name: "setDevFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowBuyTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowSell",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowTrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "usedClaimNonces",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawDevFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawEth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var BondCurveDistro__factory = class {
  static abi = _abi3;
  static createInterface() {
    return new Interface(_abi3);
  }
  static connect(address, runner) {
    return new Contract(address, _abi3, runner);
  }
};

// src/typechain/factories/Core__factory.ts
var _abi4 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_minTimeToPay",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_orderGraceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxOpenOrders",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxOpenDisputes",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "finalizer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "action",
        type: "uint256"
      }
    ],
    name: "FinalizedByManagerSig",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bp",
        type: "uint256"
      }
    ],
    name: "NFTDiscountUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "offerer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expireDuration",
        type: "uint256"
      }
    ],
    name: "NewOffer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "acceptor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "executeAt",
        type: "uint256"
      }
    ],
    name: "OfferAccepted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "canceller",
        type: "address"
      }
    ],
    name: "OfferCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "executor",
        type: "address"
      }
    ],
    name: "OfferExecuted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "unacceptor",
        type: "address"
      }
    ],
    name: "OfferUnaccepted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "offerer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "execDelayDur",
        type: "uint256"
      }
    ],
    name: "OfferUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "canceller",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bool",
        name: "byDispute",
        type: "bool"
      }
    ],
    name: "OrderCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "inventor",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shared",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      }
    ],
    name: "ProtocolFeeSplitUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "instantSwapFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "synthSwapFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableSwapFeeBp",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedSynthSwapFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedNFTSwapFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "instantNFTSwapFeeBp",
        type: "uint256"
      }
    ],
    name: "ProtocolFeeUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "mid",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "swapper",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "releaser",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[6]",
        name: "numTypeInfo",
        type: "uint256[6]"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "byDispute",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromProvider",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromTaker",
        type: "uint256[]"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "mid",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "swapper",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[7]",
        name: "numTypeInfo",
        type: "uint256[7]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromProvider",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "idsFromTaker",
        type: "uint256[]"
      }
    ],
    name: "SwapOrder",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeDelayDur",
        type: "uint256"
      }
    ],
    name: "SwapOrderPaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      }
    ],
    name: "TogglePause",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TransferInventorBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TransferOperatorBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "convAsset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "convAmount",
        type: "uint256"
      }
    ],
    name: "TransferredToFeePool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "swapRouter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "ethErc20Addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "UpdatedAMMInfo",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "input",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "output",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "UpdatedAMMPoolInfo",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedAssetRegistry",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedDisputeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedFeePool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "interval",
        type: "uint256"
      }
    ],
    name: "UpdatedFeePoolConfig",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedFeePurse",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liq",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minSwap",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxSwap",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeToPay",
        type: "uint256"
      }
    ],
    name: "UpdatedFungibleLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedInventor",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oldManager",
        type: "address"
      }
    ],
    name: "UpdatedLiquidityManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "market",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liq",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "UpdatedLiquiditySwapBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMarketCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxOpenDisputes",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxOpenOrders",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedMinTimeToPay",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMinerRegistry",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNFT",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timeToPay",
        type: "uint256"
      }
    ],
    name: "UpdatedNonFungibleLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedOperator",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedOrderGraceDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "UpdatedPrice",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "delay",
        type: "uint256"
      }
    ],
    name: "acceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canCreateDispute",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      }
    ],
    name: "cancelOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelOrderByDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "cancelOrderByManagerSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "mid",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "taker",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "orderAmt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "orderPrice",
        type: "uint256"
      }
    ],
    name: "computeSwapFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256"
      }
    ],
    name: "configureFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      }
    ],
    name: "createOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "txDeadline",
        type: "uint256"
      }
    ],
    name: "executeOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address"
      }
    ],
    name: "feeBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getFeeBPs",
    outputs: [
      {
        internalType: "uint256[3]",
        name: "",
        type: "uint256[3]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mid",
        type: "address"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_lid",
        type: "uint256"
      }
    ],
    name: "getLiquidity",
    outputs: [
      {
        components: [
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minSwap",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxSwap",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "timeToPay",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "openOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "openDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "protoFeePurseId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "mktCreatorFeePurseId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "protoFeeRate",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "mktCreatorFeeRate",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "wantOrIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "wantAndIds",
            type: "uint256[]"
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool"
          },
          {
            internalType: "address",
            name: "target",
            type: "address"
          }
        ],
        internalType: "struct Structs.Liquidity",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      }
    ],
    name: "getLiquidityManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "getMarket",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numLiquidity",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "commission",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "disputeDelayDur",
                type: "uint256"
              }
            ],
            internalType: "struct Structs.MarketDur",
            name: "dur",
            type: "tuple"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "manager",
            type: "address"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "base",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "quote",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "put",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "swap",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "offerOnly",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "allowZeroOfferPrice",
                type: "bool"
              }
            ],
            internalType: "struct Structs.MarketPerms",
            name: "perms",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Market",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getOffer",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "liq",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "execAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "accepted",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "cancelled",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "executed",
            type: "bool"
          }
        ],
        internalType: "struct Structs.Offer",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getOrder",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "taker",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "address",
            name: "finalizer",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "payDeadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "cancelAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "disputeFrom",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "offerId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "takerIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "providerIds",
            type: "uint256[]"
          },
          {
            internalType: "bool",
            name: "paid",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "released",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "disputed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "cancelled",
            type: "bool"
          }
        ],
        internalType: "struct Structs.Order",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getReqSwapBadges",
    outputs: [
      {
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mid",
        type: "address"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_lid",
        type: "uint256"
      }
    ],
    name: "hasLiquidity",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "hasOrder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "inventorBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "isVerified",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "markAsDisputed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "markOrderAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "markOrderAsPaidByManagerSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "operatorBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "releaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "releaseOrderByDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "releaseOrderByManagerSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "swapRouter",
        type: "address"
      },
      {
        internalType: "address",
        name: "ethErc20Addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "setAmmInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "input",
        type: "address"
      },
      {
        internalType: "address",
        name: "out",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "poolFee",
        type: "uint256"
      }
    ],
    name: "setAmmPoolInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setAssetRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "setBadgeMgr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bp",
        type: "uint256"
      }
    ],
    name: "setDiscountForNFTHolder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setDisputeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "setFeePurse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setInventor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "manager",
        type: "address"
      }
    ],
    name: "setLiquidityManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMarketCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setMaxOpenDisputes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setMaxOpenOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setMinTimeToPay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMinerRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setOrderGraceDur",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_instantSwapFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_synthSwapFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_stableSwapFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fixedSynthSwapFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fixedNFTSwapFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_instantNFTSwapFeeBp",
        type: "uint256"
      }
    ],
    name: "setProtoFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "inventorBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "sharedBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "operatorBP",
        type: "uint256"
      }
    ],
    name: "setProtoFeeSplit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "string[2][]",
        name: "badgeIds",
        type: "string[2][]"
      }
    ],
    name: "setSwapBadgeForLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "shareablesBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "state",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "instantSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "synthSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stableSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "instantNFTSwapFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "fixedSynthSwapFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "fixedNFTSwapFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxOpenOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxOpenDisputes",
            type: "uint256"
          }
        ],
        internalType: "struct StructsLib.IntSlotState",
        name: "ints",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "minTimeToPay",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "orderGraceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numOrders",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feePoolTxInterval",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "inventor",
        type: "address"
      },
      {
        internalType: "address",
        name: "ammSwapRouter",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "state2",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "nftDiscountBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "ammEthPoolFee",
            type: "uint256"
          }
        ],
        internalType: "struct StructsLib.UintSlotState2",
        name: "ints",
        type: "tuple"
      },
      {
        internalType: "address",
        name: "disputeManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "nft",
        type: "address"
      },
      {
        internalType: "address",
        name: "ammEth",
        type: "address"
      },
      {
        internalType: "contract IAssetRegistry",
        name: "assetReg",
        type: "address"
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address"
      },
      {
        internalType: "contract IMarketCore",
        name: "marketCore",
        type: "address"
      },
      {
        internalType: "contract IFeePool",
        name: "feePool",
        type: "address"
      },
      {
        internalType: "contract IFeePurse",
        name: "feePurse",
        type: "address"
      },
      {
        internalType: "contract IBadge",
        name: "badge",
        type: "address"
      },
      {
        internalType: "contract IOperator",
        name: "operatorMgr",
        type: "address"
      },
      {
        internalType: "contract IMinerRegistry",
        name: "minerReg",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxPrice",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "txDeadline",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      }
    ],
    name: "swapQuoteForBase",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    name: "togglePause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "transferToFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      }
    ],
    name: "unacceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        internalType: "uint256[2]",
        name: "amountAndPrice",
        type: "uint256[2]"
      },
      {
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[5]",
        name: "limits",
        type: "uint256[5]"
      }
    ],
    name: "updateFungibleLiquidity",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_lid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_expireAt",
        type: "uint256"
      }
    ],
    name: "updateLiquidityPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "deduct",
        type: "bool"
      },
      {
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "wantOrIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "wantAndIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[3]",
        name: "limits",
        type: "uint256[3]"
      }
    ],
    name: "updateNonFungibleLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "offerId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "updateOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "lid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "incr",
        type: "bool"
      }
    ],
    name: "updateOpenDisputesCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "withdrawFeeBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "withdrawInventorBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "withdrawOperatorBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Core__factory = class {
  static abi = _abi4;
  static createInterface() {
    return new Interface(_abi4);
  }
  static connect(address, runner) {
    return new Contract(address, _abi4, runner);
  }
};

// src/typechain/factories/DisputeManager__factory.ts
var _abi5 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      },
      {
        internalType: "address",
        name: "_core",
        type: "address"
      },
      {
        internalType: "address",
        name: "_medMgrAddr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_predictDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_evidenceDur",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "committer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketIdx",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "Committed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "executor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "abandoned",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bytes1",
        name: "winningVote",
        type: "bytes1"
      }
    ],
    name: "DecisionExecuted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "wantRelease",
        type: "bool"
      }
    ],
    name: "DisputeCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "drafter",
        type: "address"
      }
    ],
    name: "Drafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "mediator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "drafter",
        type: "address"
      }
    ],
    name: "DraftedMediator",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "revealer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketIdx",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes1",
        name: "vote",
        type: "bytes1"
      }
    ],
    name: "Revealed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "slashed",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "address",
        name: "undrafter",
        type: "address"
      }
    ],
    name: "Undrafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedEvidenceDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMarketCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMediatorManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMinerRegistry",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedPredictDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "dest",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amt",
        type: "uint256"
      }
    ],
    name: "WithdrawnBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "claimer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnReward",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketIdx",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      }
    ],
    name: "commitVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "countDisputes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "wantRelease",
        type: "bool"
      }
    ],
    name: "createDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "disputes",
    outputs: [
      {
        internalType: "uint256",
        name: "commitEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "predictEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "evidenceEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "nRelease",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "nCancel",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "undrafted",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "address",
        name: "defendant",
        type: "address"
      },
      {
        internalType: "bool",
        name: "executed",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "wantRelease",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "abandoned",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "draftMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "evidenceDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dispIdx",
        type: "uint256"
      }
    ],
    name: "executeDecision",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dispIdx",
        type: "uint256"
      }
    ],
    name: "getDispute",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "commitEndAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "predictEndAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "evidenceEndAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "nRelease",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "nCancel",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "undrafted",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ticketIndexes",
            type: "uint256[]"
          },
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "defendant",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "ticketOwners",
            type: "address[]"
          },
          {
            internalType: "bool",
            name: "executed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "wantRelease",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "abandoned",
            type: "bool"
          }
        ],
        internalType: "struct Dispute",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "marketCore",
    outputs: [
      {
        internalType: "contract IMarketCore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mediatorMgr",
    outputs: [
      {
        internalType: "contract IMediatorManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minerReg",
    outputs: [
      {
        internalType: "contract IMinerRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "predictDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "predictions",
    outputs: [
      {
        internalType: "bool",
        name: "revealed",
        type: "bool"
      },
      {
        internalType: "bytes32",
        name: "committed",
        type: "bytes32"
      },
      {
        internalType: "bytes1",
        name: "vote",
        type: "bytes1"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketIdx",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "_vote",
        type: "string"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      }
    ],
    name: "revealVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "rewardBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "seenCommits",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setEvidenceDur",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMarketCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMediatorManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMinerRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setPredictDur",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dispIdx",
        type: "uint256"
      }
    ],
    name: "undraftMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address"
      }
    ],
    name: "withdrawBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var DisputeManager__factory = class {
  static abi = _abi5;
  static createInterface() {
    return new Interface(_abi5);
  }
  static connect(address, runner) {
    return new Contract(address, _abi5, runner);
  }
};

// src/typechain/factories/ERC20__factory.ts
var _abi6 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var ERC20__factory = class {
  static abi = _abi6;
  static createInterface() {
    return new Interface(_abi6);
  }
  static connect(address, runner) {
    return new Contract(address, _abi6, runner);
  }
};

// src/typechain/factories/ERC721__factory.ts
var _abi7 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var ERC721__factory = class {
  static abi = _abi7;
  static createInterface() {
    return new Interface(_abi7);
  }
  static connect(address, runner) {
    return new Contract(address, _abi7, runner);
  }
};

// src/typechain/factories/Energon__factory.ts
var _abi8 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_initialSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AddRecipient",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "AddedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "AllocationDisabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      }
    ],
    name: "Claimed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "RemovedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedAllocator",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]"
      }
    ],
    name: "addMinters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "addRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "allocDisabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allocator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      },
      {
        internalType: "uint8",
        name: "_sigNonce",
        type: "uint8"
      }
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "disableAllocation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "disableRecipientBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "minters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numMinters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "recipientsAllowlist",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "recipientsBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setAllocator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    name: "usedNonce",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var Energon__factory = class {
  static abi = _abi8;
  static createInterface() {
    return new Interface(_abi8);
  }
  static connect(address, runner) {
    return new Contract(address, _abi8, runner);
  }
};

// src/typechain/factories/FeePool__factory.ts
var _abi9 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenPool",
        type: "address"
      },
      {
        internalType: "address",
        name: "_notifier",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Recovered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardNFTWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "StakedNFT",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadgeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNFT",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNotifier",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "UpdatedReqBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "dur",
        type: "uint256"
      }
    ],
    name: "UpdatedRewardDuration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedTokenPool",
    type: "event"
  },
  {
    inputs: [],
    name: "badge",
    outputs: [
      {
        internalType: "contract IBadge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canStake",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getAddressOfNFT",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "getRewardForDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nft",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "nftBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "nftEarned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "notifier",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "notifyFeeDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "notifyStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "notifyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requiredBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      }
    ],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewardRates",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setBadgeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNotifier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "setRequiredBadges",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dur",
        type: "uint256"
      }
    ],
    name: "setRewardDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setTokenPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "stakeNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "tokenBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawNFTReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var FeePool__factory = class {
  static abi = _abi9;
  static createInterface() {
    return new Interface(_abi9);
  }
  static connect(address, runner) {
    return new Contract(address, _abi9, runner);
  }
};

// src/typechain/factories/LPPool__factory.ts
var _abi10 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_poolToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Locked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Recovered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Unlocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRewardForDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_rewardAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_rewardsDuration",
        type: "uint256"
      }
    ],
    name: "notifyRewardDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "poolToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setPoolToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var LPPool__factory = class {
  static abi = _abi10;
  static createInterface() {
    return new Interface(_abi10);
  }
  static connect(address, runner) {
    return new Contract(address, _abi10, runner);
  }
};

// src/typechain/factories/MarketCore__factory.ts
var _abi11 = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_defaultDisputeDelayDur",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AllowedPut",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AllowedSwap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "EnabledZeroOfferPrice",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "base",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "quote",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum Structs.AssetType",
        name: "baseType",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "enum Structs.AssetType",
        name: "quoteType",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "permPut",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "permSwap",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "commission",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mediatePoolId",
        type: "uint256"
      }
    ],
    name: "NewMarket",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "OfferOnlyEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "RenouncedMarket",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "RevokedPut",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "RevokedSwap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "TransferredOwnership",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadgeAddr",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedCommission",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "UpdatedDefaultDisputeDelayDur",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeDelayDur",
        type: "uint256"
      }
    ],
    name: "UpdatedDisputeDelayDuration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      },
      {
        indexed: false,
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      }
    ],
    name: "UpdatedMarketBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "mgr",
        type: "address"
      }
    ],
    name: "UpdatedMarketManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedMediatorManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedNativeAssetAddr",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "added",
        type: "bool"
      }
    ],
    name: "WriterUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "allowZeroOfferPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "badge",
    outputs: [
      {
        internalType: "contract IBadge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "base",
        type: "address"
      },
      {
        internalType: "address",
        name: "quote",
        type: "address"
      },
      {
        internalType: "enum Structs.AssetType",
        name: "baseType",
        type: "uint8"
      },
      {
        internalType: "enum Structs.AssetType",
        name: "quoteType",
        type: "uint8"
      },
      {
        internalType: "bool",
        name: "permPut",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "permSwap",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "commission",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "mediatePoolId",
        type: "uint256"
      }
    ],
    name: "createMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultDisputeDelayDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "getMarket",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numLiquidity",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "commission",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "disputeDelayDur",
                type: "uint256"
              }
            ],
            internalType: "struct Structs.MarketDur",
            name: "dur",
            type: "tuple"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "manager",
            type: "address"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "base",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "quote",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "put",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "swap",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "offerOnly",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "allowZeroOfferPrice",
                type: "bool"
              }
            ],
            internalType: "struct Structs.MarketPerms",
            name: "perms",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Market",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getNativeAssetAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "getReqBadges",
    outputs: [
      {
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      },
      {
        internalType: "string[2][]",
        name: "",
        type: "string[2][]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "hasMarket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "isPutPermitted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "isSwapPermitted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "markAsOfferOnly",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "markets",
    outputs: [
      {
        internalType: "uint256",
        name: "createdAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numOrders",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numDisputes",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numLiquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "commission",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "disputeDelayDur",
            type: "uint256"
          }
        ],
        internalType: "struct Structs.MarketDur",
        name: "dur",
        type: "tuple"
      },
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "address",
        name: "manager",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "base",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "quote",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "put",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "swap",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "offerOnly",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "allowZeroOfferPrice",
            type: "bool"
          }
        ],
        internalType: "struct Structs.MarketPerms",
        name: "perms",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mediatorManager",
    outputs: [
      {
        internalType: "contract IMediatorManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nativeAssetAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "permitPut",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "permitSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "putAllowList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      }
    ],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "renouncedMarkets",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "reqPutBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "reqSwapBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "revokePut",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "revokeSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setBadgeMgr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setCommission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "bool",
        name: "numOrders",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "numDisputes",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "numLiquidity",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "setCounters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "val",
        type: "uint256"
      }
    ],
    name: "setDefaultDisputeDelayDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "setDisputeDelayDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "mgr",
        type: "address"
      }
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numOrders",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDisputes",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numLiquidity",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "commission",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "disputeDelayDur",
                type: "uint256"
              }
            ],
            internalType: "struct Structs.MarketDur",
            name: "dur",
            type: "tuple"
          },
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "manager",
            type: "address"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "base",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address"
              },
              {
                internalType: "enum Structs.AssetType",
                name: "assetType",
                type: "uint8"
              }
            ],
            internalType: "struct Structs.Asset",
            name: "quote",
            type: "tuple"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "put",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "swap",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "offerOnly",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "allowZeroOfferPrice",
                type: "bool"
              }
            ],
            internalType: "struct Structs.MarketPerms",
            name: "perms",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Market",
        name: "upd",
        type: "tuple"
      }
    ],
    name: "setMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setMediatorManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setNativeAssetAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "string[2][]",
        name: "put",
        type: "string[2][]"
      },
      {
        internalType: "string[2][]",
        name: "swap",
        type: "string[2][]"
      }
    ],
    name: "setRequiredBadges",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "swapAllowList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "id",
        type: "address"
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "updateWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "writers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var MarketCore__factory = class {
  static abi = _abi11;
  static createInterface() {
    return new Interface(_abi11);
  }
  static connect(address, runner) {
    return new Contract(address, _abi11, runner);
  }
};

// src/typechain/factories/MarketManager__factory.ts
var _abi12 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      },
      {
        internalType: "address",
        name: "_payRouter",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "core",
        type: "address"
      }
    ],
    name: "CoreUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "payRouter",
        type: "address"
      }
    ],
    name: "PayRouterUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestPaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "RequestReleased",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "TransferredRequestBond",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "TransferredRequestSource",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isDelegate",
        type: "bool"
      }
    ],
    name: "UpdatedDelegate",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "addDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxPrice",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "expireAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "marketMgrData",
            type: "bytes"
          }
        ],
        internalType: "struct StructsLib.SwapQuoteForBaseParams",
        name: "params",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "afterSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "marketId",
            type: "address"
          },
          {
            internalType: "address",
            name: "provider",
            type: "address"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "lid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxPrice",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "ids",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "expireAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "marketMgrData",
            type: "bytes"
          }
        ],
        internalType: "struct StructsLib.SwapQuoteForBaseParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "beforeSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "delegates",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "markOrderAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "onCancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "onPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "onRelease",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "payRouter",
    outputs: [
      {
        internalType: "contract IPayRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    name: "releaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address"
      }
    ],
    name: "removeDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requestInfo",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      }
    ],
    name: "setCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_payRouter",
        type: "address"
      }
    ],
    name: "setPayRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      }
    ],
    name: "setRequesterFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "setRequesterValueLockDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "transferRequestBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawRequesterFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var MarketManager__factory = class {
  static abi = _abi12;
  static createInterface() {
    return new Interface(_abi12);
  }
  static connect(address, runner) {
    return new Contract(address, _abi12, runner);
  }
};

// src/typechain/factories/MediatorManager__factory.ts
var _abi13 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      },
      {
        internalType: "address",
        name: "_randAddr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_ticketCancelDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketMatureDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketExpireDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketPauseDur",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "disputeID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "drafter",
        type: "address"
      }
    ],
    name: "Drafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "JoinedPool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "PoolMarketApproval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "PoolMediatorApproval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "blocked",
        type: "bool"
      }
    ],
    name: "TicketBlocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "TicketCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TicketDrained",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "paused",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pauseDur",
        type: "uint256"
      }
    ],
    name: "TicketPaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "matureAt",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "joinBy",
        type: "uint256"
      }
    ],
    name: "TicketPurchased",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "voted",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "winSide",
        type: "bool"
      }
    ],
    name: "TicketSlashed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "TicketSlashedByOwner",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "slashed",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "address",
        name: "undrafter",
        type: "address"
      }
    ],
    name: "Undrafted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "UpdatedDisputeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "UpdatedMarketCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "maxPause",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxPause",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "val",
        type: "address"
      }
    ],
    name: "UpdatedRandomnessProvider",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketCancelDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketMatureDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketExpireDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketPauseDur",
        type: "uint256"
      }
    ],
    name: "UpdatedTicketDurations",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "baseTicketPrice",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "windowDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketsPerWindow",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseTicketSupply",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "priceSupplyDeltaBP",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minInactiveWindowBeforeReset",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "soldOutBP",
        type: "uint256"
      }
    ],
    name: "UpdatedTicketParams",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reqBond",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "draftReward",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "winReward",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "noVoteSlashBP",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "loseVoteSlashBP",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "numDraftees",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "evidenceDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "predictDur",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approvedMediatorOnly",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approvedMarketOnly",
        type: "bool"
      }
    ],
    name: "UpdatedTicketPool",
    type: "event"
  },
  {
    inputs: [],
    name: "baseTicketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "disputeManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketId",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "orderID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "disputeID",
        type: "uint256"
      }
    ],
    name: "draft",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "idx",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bond",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "matureAt",
            type: "uint256"
          },
          {
            internalType: "int256",
            name: "poolIdx",
            type: "int256"
          },
          {
            internalType: "uint256",
            name: "cancelAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "joinBy",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numPaused",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "drafted",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "joined",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "blocked",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "slashed",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "paused",
                type: "bool"
              }
            ],
            internalType: "struct Structs.TicketStatus",
            name: "status",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Ticket",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "drainTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "getTicket",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "idx",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bond",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "matureAt",
            type: "uint256"
          },
          {
            internalType: "int256",
            name: "poolIdx",
            type: "int256"
          },
          {
            internalType: "uint256",
            name: "cancelAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "joinBy",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numPaused",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            components: [
              {
                internalType: "bool",
                name: "drafted",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "joined",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "blocked",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "slashed",
                type: "bool"
              },
              {
                internalType: "bool",
                name: "paused",
                type: "bool"
              }
            ],
            internalType: "struct Structs.TicketStatus",
            name: "status",
            type: "tuple"
          }
        ],
        internalType: "struct Structs.Ticket",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      }
    ],
    name: "getTicketPool",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "exists",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "approvedMediatorOnly",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "approvedMarketOnly",
            type: "bool"
          },
          {
            internalType: "uint256",
            name: "reqBond",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "draftReward",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "winReward",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "noVoteSlashBP",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "loseVoteSlashBP",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numDraftees",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "evidenceDur",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "predictDur",
            type: "uint256"
          }
        ],
        internalType: "struct Structs.TicketPool",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTicketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "marketAddr",
        type: "address"
      }
    ],
    name: "isApprovedMarket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "isApprovedMediator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "join",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "marketCore",
    outputs: [
      {
        internalType: "contract IMarketCore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxPause",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minInactiveWindowBeforeReset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numWindows",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "poolApprovals",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      }
    ],
    name: "poolExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "poolMarketApprovals",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "poolOwners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "poolTickets",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "pools",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "approvedMediatorOnly",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "approvedMarketOnly",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "reqBond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "draftReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "winReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "noVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "loseVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numDraftees",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "evidenceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "predictDur",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "priceSupplyDeltaBP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      }
    ],
    name: "purchaseTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "randomness",
    outputs: [
      {
        internalType: "contract IRandomness",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_disputeManager",
        type: "address"
      }
    ],
    name: "setDisputeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketCore",
        type: "address"
      }
    ],
    name: "setMarketCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxPause",
        type: "uint256"
      }
    ],
    name: "setMaxPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "provider",
        type: "address"
      }
    ],
    name: "setRandomnessProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_ticketCancelDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketMatureDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketExpireDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketPauseDur",
        type: "uint256"
      }
    ],
    name: "setTicketDurations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_baseTicketPrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_windowDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_ticketsPerWindow",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_baseTicketSupply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_priceSupplyDeltaBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minInactiveWindowBeforeReset",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_soldOutBP",
        type: "uint256"
      }
    ],
    name: "setTicketMarketParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "slash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "soldOutBP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketCancelDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketExpireDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketMatureDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketPauseDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketSold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "tickets",
    outputs: [
      {
        internalType: "uint256",
        name: "idx",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "matureAt",
        type: "uint256"
      },
      {
        internalType: "int256",
        name: "poolIdx",
        type: "int256"
      },
      {
        internalType: "uint256",
        name: "cancelAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "joinBy",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numPaused",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "drafted",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "joined",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "blocked",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "slashed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool"
          }
        ],
        internalType: "struct Structs.TicketStatus",
        name: "status",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ticketsPerWindow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "marketAddr",
        type: "address"
      }
    ],
    name: "toggleApproveMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "toggleApproveMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "toggleBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      }
    ],
    name: "togglePause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ticketOwner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "voted",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "winSide",
        type: "bool"
      }
    ],
    name: "undraft",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reqBond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "draftReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "winReward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "noVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "loseVoteSlashBP",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numDraftees",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "evidenceDur",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "predictDur",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approvedMediatorOnly",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "approvedMarketOnly",
        type: "bool"
      }
    ],
    name: "updateTicketPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "windowDur",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "windows",
    outputs: [
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numPurchases",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "supply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var MediatorManager__factory = class {
  static abi = _abi13;
  static createInterface() {
    return new Interface(_abi13);
  }
  static connect(address, runner) {
    return new Contract(address, _abi13, runner);
  }
};

// src/typechain/factories/MinerRegistry__factory.ts
var _abi14 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_minerBond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_matureDuration",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_cancelDuration",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "AddedReward",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "blocked",
        type: "bool"
      }
    ],
    name: "Blocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cancelDuration",
        type: "uint256"
      }
    ],
    name: "Cancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Drained",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "Registered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Slashed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "matureDuration",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cancelDuration",
        type: "uint256"
      }
    ],
    name: "UpdatedDurations",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "UpdatedMinerBond",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "UpdatedOpReward",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum MinerOperation[]",
        name: "ops",
        type: "uint8[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "UpdatedOpsReward",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnBalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "added",
        type: "bool"
      }
    ],
    name: "WriterUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "miner",
        type: "address"
      }
    ],
    name: "addReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "drain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "isMiner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "matureDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minerBond",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "miners",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "matureAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "cancelAt",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "blocked",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation",
        name: "",
        type: "uint8"
      }
    ],
    name: "opRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "miner",
        type: "address"
      }
    ],
    name: "rewardBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_matureDuration",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_cancelDuration",
        type: "uint256"
      }
    ],
    name: "setDurations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "miner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "slash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "miner",
        type: "address"
      }
    ],
    name: "toggleBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minerBond",
        type: "uint256"
      }
    ],
    name: "updateMinerBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation",
        name: "op",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "updateOpReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MinerOperation[]",
        name: "ops",
        type: "uint8[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "updateOpsReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "updateWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address"
      }
    ],
    name: "withdrawBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "writers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var MinerRegistry__factory = class {
  static abi = _abi14;
  static createInterface() {
    return new Interface(_abi14);
  }
  static connect(address, runner) {
    return new Contract(address, _abi14, runner);
  }
};

// src/typechain/factories/NFT__factory.ts
var _abi15 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "string",
        name: "_initBaseURI",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_treasuryEditionSupply",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_feePool",
        type: "address"
      },
      {
        internalType: "address",
        name: "_allocator",
        type: "address"
      },
      {
        internalType: "address",
        name: "_energon",
        type: "address"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "OperatorNotAllowed",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Allocated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "AllocatorUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "slot",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "AllowAddr",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allow",
        type: "bool"
      }
    ],
    name: "AllowAlloc",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allow",
        type: "bool"
      }
    ],
    name: "AllowBurn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allow",
        type: "bool"
      }
    ],
    name: "AllowMint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "_burner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "BurnAllowance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "_purpose",
        type: "bytes"
      }
    ],
    name: "BurnedEnergon",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "DepositedEnergon",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "EnergonUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "TokenUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_new",
        type: "string"
      }
    ],
    name: "UpdatedBaseExtension",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_new",
        type: "string"
      }
    ],
    name: "UpdatedBaseURI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_new",
        type: "string"
      }
    ],
    name: "UpdatedContractURI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_new",
        type: "uint256"
      }
    ],
    name: "UpdatedCost",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_new",
        type: "uint256"
      }
    ],
    name: "UpdatedMaxMintAmount",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_new",
        type: "uint256"
      }
    ],
    name: "UpdatedMintCost",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amt",
        type: "uint256"
      }
    ],
    name: "Withdrawal",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "withdrawer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnEnergon",
    type: "event"
  },
  {
    inputs: [],
    name: "OPERATOR_FILTER_REGISTRY",
    outputs: [
      {
        internalType: "contract IOperatorFilterRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "_contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_alloc",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    name: "allocate",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "allocator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "slot",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "allowAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "allowAlloc",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowEnergonOps",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "allowMint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "allowlist",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "baseExtension",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_burner",
        type: "address"
      }
    ],
    name: "burnAllowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "burnAllowances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_burner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "burnApprove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_purpose",
        type: "bytes"
      }
    ],
    name: "burnEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "cost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "depositEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "energon",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "engBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "engBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feePool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_mintAmount",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "_noEnergon",
        type: "bool"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "expireAt",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fromId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_mintAmount",
        type: "uint256"
      }
    ],
    name: "mintTE",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedByAllowlist",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedByOwner",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintedByTreasury",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "p2pBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "p2pBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_salePrice",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_allocator",
        type: "address"
      }
    ],
    name: "setAllocator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_newBaseExtension",
        type: "string"
      }
    ],
    name: "setBaseExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_newBaseURI",
        type: "string"
      }
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "setCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "feeNumerator",
        type: "uint96"
      }
    ],
    name: "setDefaultRoyalty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_energon",
        type: "address"
      }
    ],
    name: "setEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "setMintCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "setToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowAlloc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowEnergonOps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleAllowMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256"
      }
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256"
      }
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      }
    ],
    name: "tokensOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalAllocated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "treasuryEditionSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "usedNonce",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawEnergon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var NFT__factory = class {
  static abi = _abi15;
  static createInterface() {
    return new Interface(_abi15);
  }
  static connect(address, runner) {
    return new Contract(address, _abi15, runner);
  }
};

// src/typechain/factories/PayRouter__factory.ts
var _abi16 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_bondToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "ApprovedRequester",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "BondReturned",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "BondTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "DepositedBond",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orgId",
        type: "uint256"
      }
    ],
    name: "OrgCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "OrgSourcePaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ProtocolFeeWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "RequestClosed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "routeIds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "bonds",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sourceAmt",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "valueLockDuration",
        type: "uint256"
      }
    ],
    name: "RequestCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "RequestPaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RequesterFeeWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum SourceType",
        name: "source",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "address",
        name: "sourceToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sourceOrgId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "destOrgId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    name: "RouteCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "SourceReturned",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "SourceTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "UnapprovedRequester",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bondToken",
        type: "address"
      }
    ],
    name: "UpdatedBondToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "protocolFeeBp",
        type: "uint256"
      }
    ],
    name: "UpdatedProtocolFeeBp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      }
    ],
    name: "UpdatedRequesterFeeBp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "requester",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "UpdatedValueLockDuration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "withdrawer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnBond",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "approveRequester",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "approvedRouteRequesters",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bondToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "cancelRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "closeRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "createOrg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_routeIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_bonds",
        type: "uint256[]"
      },
      {
        internalType: "uint256",
        name: "_sourceAmt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_valueLockDuration",
        type: "uint256"
      }
    ],
    name: "createRequest",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            internalType: "enum SourceType",
            name: "source",
            type: "uint8"
          },
          {
            internalType: "address",
            name: "sourceToken",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "sourceOrgId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "destOrgId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bond",
            type: "uint256"
          },
          {
            internalType: "address[]",
            name: "requesters",
            type: "address[]"
          }
        ],
        internalType: "struct Route",
        name: "route",
        type: "tuple"
      }
    ],
    name: "createRoute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "depositBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "feeBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "getRequest",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "creator",
            type: "address"
          },
          {
            internalType: "address",
            name: "sourceToken",
            type: "address"
          },
          {
            internalType: "uint256[]",
            name: "routeIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "bonds",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "sourceAmt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "sourceAmtLeft",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "requesterFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "protocolFeeBp",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "valueLockDuration",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "valueUnlockAt",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "numRoutersPaid",
            type: "uint256"
          },
          {
            internalType: "bool[]",
            name: "paid",
            type: "bool[]"
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "cancelled",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "orgSrcPaid",
            type: "bool"
          }
        ],
        internalType: "struct Request",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "isRequesterApproved",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      }
    ],
    name: "markOrgSourceAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      }
    ],
    name: "markRequestAsPaid",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "numOrgs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numRequests",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numRoutes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "orgs",
    outputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "protocolFeeBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "protocolFeeBp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "requesterValueLockDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "requestersBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "requestersFeeBp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "address",
        name: "sourceToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "sourceAmt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "sourceAmtLeft",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "requesterFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "protocolFeeBp",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "valueLockDuration",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "valueUnlockAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "numRoutersPaid",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "closed",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "cancelled",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "orgSrcPaid",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "routes",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "enum SourceType",
        name: "source",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "sourceToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "sourceOrgId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "destOrgId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "bond",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bondToken",
        type: "address"
      }
    ],
    name: "setBondToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_protocolFeeBp",
        type: "uint256"
      }
    ],
    name: "setProtocolFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "feeBp",
        type: "uint256"
      }
    ],
    name: "setRequesterFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "setRequesterValueLockDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "transferRequestBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "transferRequestSource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "requester",
        type: "address"
      }
    ],
    name: "unapproveRequester",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "userHasOrg",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "userOrgs",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "routeId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawBond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawProtocolFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "withdrawRequesterFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var PayRouter__factory = class {
  static abi = _abi16;
  static createInterface() {
    return new Interface(_abi16);
  }
  static connect(address, runner) {
    return new Contract(address, _abi16, runner);
  }
};

// src/typechain/factories/ProviderRegistry__factory.ts
var _abi17 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "idx",
        type: "uint256"
      }
    ],
    name: "ProviderRegistered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "added",
        type: "bool"
      }
    ],
    name: "WriterUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "get",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getByAddr",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nextId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "providerIdx",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "providers",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool"
      }
    ],
    name: "updateWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "writers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var ProviderRegistry__factory = class {
  static abi = _abi17;
  static createInterface() {
    return new Interface(_abi17);
  }
  static connect(address, runner) {
    return new Contract(address, _abi17, runner);
  }
};

// src/typechain/factories/Router__factory.ts
var _abi18 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      },
      {
        internalType: "address",
        name: "_provReg",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "operator",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "routeCount",
        type: "uint256"
      }
    ],
    name: "Routed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedCore",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedProvReg",
    type: "event"
  },
  {
    inputs: [],
    name: "core",
    outputs: [
      {
        internalType: "contract ICore",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "asset",
        type: "tuple"
      }
    ],
    name: "isERC20",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address"
          },
          {
            internalType: "enum Structs.AssetType",
            name: "assetType",
            type: "uint8"
          }
        ],
        internalType: "struct Structs.Asset",
        name: "asset",
        type: "tuple"
      }
    ],
    name: "isNative",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "provReg",
    outputs: [
      {
        internalType: "contract IProviderRegistry",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "operator",
            type: "uint256"
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "provider",
                    type: "uint256"
                  },
                  {
                    internalType: "uint256",
                    name: "lid",
                    type: "uint256"
                  },
                  {
                    internalType: "uint256",
                    name: "amount",
                    type: "uint256"
                  },
                  {
                    internalType: "uint256",
                    name: "maxPrice",
                    type: "uint256"
                  }
                ],
                internalType: "struct Liquidity[]",
                name: "liqs",
                type: "tuple[]"
              },
              {
                internalType: "address",
                name: "market",
                type: "address"
              }
            ],
            internalType: "struct Route[]",
            name: "routes",
            type: "tuple[]"
          },
          {
            internalType: "address",
            name: "target",
            type: "address"
          }
        ],
        internalType: "struct RouteParams",
        name: "routeParams",
        type: "tuple"
      }
    ],
    name: "route",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_core",
        type: "address"
      }
    ],
    name: "setCore",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_provReg",
        type: "address"
      }
    ],
    name: "setProviderRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var Router__factory = class {
  static abi = _abi18;
  static createInterface() {
    return new Interface(_abi18);
  }
  static connect(address, runner) {
    return new Contract(address, _abi18, runner);
  }
};

// src/typechain/factories/Token__factory.ts
var _abi19 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_initialSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "AddedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      }
    ],
    name: "RemovedMinter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]"
      }
    ],
    name: "addMinters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "minters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "numMinters",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Token__factory = class {
  static abi = _abi19;
  static createInterface() {
    return new Interface(_abi19);
  }
  static connect(address, runner) {
    return new Contract(address, _abi19, runner);
  }
};

// src/typechain/factories/TokenPool__factory.ts
var _abi20 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_stakingToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Recovered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "RewardWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "StakeWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Staked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedBadgeManager",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "UpdatedFeePool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "UpdatedReqBadges",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "VestStaked",
    type: "event"
  },
  {
    inputs: [],
    name: "badge",
    outputs: [
      {
        internalType: "contract IBadge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "canStake",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "exit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "feePool",
    outputs: [
      {
        internalType: "contract IFeePool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRewardForDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_reward",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_rewardsDuration",
        type: "uint256"
      }
    ],
    name: "notifyRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requiredBadges",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setBadgeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setFeePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string[2][]",
        name: "badges",
        type: "string[2][]"
      }
    ],
    name: "setRequiredBadges",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_cliffEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_vestedAt",
        type: "uint256"
      }
    ],
    name: "stakeVested",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "vesting",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "cliffEndAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "vestedAt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "withdrawn",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "withdrawReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var TokenPool__factory = class {
  static abi = _abi20;
  static createInterface() {
    return new Interface(_abi20);
  }
  static connect(address, runner) {
    return new Contract(address, _abi20, runner);
  }
};

// src/typechain/factories/UniswapV2Router__factory.ts
var _abi21 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];
var UniswapV2Router__factory = class {
  static abi = _abi21;
  static createInterface() {
    return new Interface(_abi21);
  }
  static connect(address, runner) {
    return new Contract(address, _abi21, runner);
  }
};

// src/typechain/factories/UniswapV2Router2__factory.ts
var _abi22 = [
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];
var UniswapV2Router2__factory = class {
  static abi = _abi22;
  static createInterface() {
    return new Interface(_abi22);
  }
  static connect(address, runner) {
    return new Contract(address, _abi22, runner);
  }
};

// src/typechain/factories/UniswapV3Router__factory.ts
var _abi23 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH9",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          }
        ],
        internalType: "struct ISwapRouter.ExactInputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct ISwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          }
        ],
        internalType: "struct ISwapRouter.ExactOutputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct ISwapRouter.ExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowed",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowedIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];
var UniswapV3Router__factory = class {
  static abi = _abi23;
  static createInterface() {
    return new Interface(_abi23);
  }
  static connect(address, runner) {
    return new Contract(address, _abi23, runner);
  }
};

// src/typechain/factories/UniswapV3Router2__factory.ts
var _abi24 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factoryV2",
        type: "address"
      },
      {
        internalType: "address",
        name: "factoryV3",
        type: "address"
      },
      {
        internalType: "address",
        name: "_positionManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH9",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveMax",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveMaxMinusOne",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveZeroThenMax",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveZeroThenMaxMinusOne",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "callPositionManager",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "paths",
        type: "bytes[]"
      },
      {
        internalType: "uint128[]",
        name: "amounts",
        type: "uint128[]"
      },
      {
        internalType: "uint24",
        name: "maximumTickDivergence",
        type: "uint24"
      },
      {
        internalType: "uint32",
        name: "secondsAgo",
        type: "uint32"
      }
    ],
    name: "checkOracleSlippage",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      },
      {
        internalType: "uint24",
        name: "maximumTickDivergence",
        type: "uint24"
      },
      {
        internalType: "uint32",
        name: "secondsAgo",
        type: "uint32"
      }
    ],
    name: "checkOracleSlippage",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactInputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactOutputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factoryV2",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "getApprovalType",
    outputs: [
      {
        internalType: "enum IApproveAndCall.ApprovalType",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address"
          },
          {
            internalType: "address",
            name: "token1",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256"
          }
        ],
        internalType: "struct IApproveAndCall.IncreaseLiquidityParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "increaseLiquidity",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address"
          },
          {
            internalType: "address",
            name: "token1",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "tickLower",
            type: "int24"
          },
          {
            internalType: "int24",
            name: "tickUpper",
            type: "int24"
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          }
        ],
        internalType: "struct IApproveAndCall.MintParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "previousBlockhash",
        type: "bytes32"
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "positionManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "pull",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowed",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowedIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "wrapETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];
var UniswapV3Router2__factory = class {
  static abi = _abi24;
  static createInterface() {
    return new Interface(_abi24);
  }
  static connect(address, runner) {
    return new Contract(address, _abi24, runner);
  }
};

// src/typechain/factories/UniswapV3RouterUniversal__factory.ts
var _abi25 = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "permit2",
            type: "address"
          },
          {
            internalType: "address",
            name: "weth9",
            type: "address"
          },
          {
            internalType: "address",
            name: "seaportV1_5",
            type: "address"
          },
          {
            internalType: "address",
            name: "seaportV1_4",
            type: "address"
          },
          {
            internalType: "address",
            name: "openseaConduit",
            type: "address"
          },
          {
            internalType: "address",
            name: "nftxZap",
            type: "address"
          },
          {
            internalType: "address",
            name: "x2y2",
            type: "address"
          },
          {
            internalType: "address",
            name: "foundation",
            type: "address"
          },
          {
            internalType: "address",
            name: "sudoswap",
            type: "address"
          },
          {
            internalType: "address",
            name: "elementMarket",
            type: "address"
          },
          {
            internalType: "address",
            name: "nft20Zap",
            type: "address"
          },
          {
            internalType: "address",
            name: "cryptopunks",
            type: "address"
          },
          {
            internalType: "address",
            name: "looksRareV2",
            type: "address"
          },
          {
            internalType: "address",
            name: "routerRewardsDistributor",
            type: "address"
          },
          {
            internalType: "address",
            name: "looksRareRewardsDistributor",
            type: "address"
          },
          {
            internalType: "address",
            name: "looksRareToken",
            type: "address"
          },
          {
            internalType: "address",
            name: "v2Factory",
            type: "address"
          },
          {
            internalType: "address",
            name: "v3Factory",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "pairInitCodeHash",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "poolInitCodeHash",
            type: "bytes32"
          }
        ],
        internalType: "struct RouterParameters",
        name: "params",
        type: "tuple"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "BalanceTooLow",
    type: "error"
  },
  {
    inputs: [],
    name: "BuyPunkFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "ContractLocked",
    type: "error"
  },
  {
    inputs: [],
    name: "ETHNotAccepted",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "commandIndex",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes"
      }
    ],
    name: "ExecutionFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "FromAddressIsNotOwner",
    type: "error"
  },
  {
    inputs: [],
    name: "InsufficientETH",
    type: "error"
  },
  {
    inputs: [],
    name: "InsufficientToken",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidBips",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "commandType",
        type: "uint256"
      }
    ],
    name: "InvalidCommandType",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidOwnerERC1155",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidOwnerERC721",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidPath",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidReserves",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidSpender",
    type: "error"
  },
  {
    inputs: [],
    name: "LengthMismatch",
    type: "error"
  },
  {
    inputs: [],
    name: "SliceOutOfBounds",
    type: "error"
  },
  {
    inputs: [],
    name: "TransactionDeadlinePassed",
    type: "error"
  },
  {
    inputs: [],
    name: "UnableToClaim",
    type: "error"
  },
  {
    inputs: [],
    name: "UnsafeCast",
    type: "error"
  },
  {
    inputs: [],
    name: "V2InvalidPath",
    type: "error"
  },
  {
    inputs: [],
    name: "V2TooLittleReceived",
    type: "error"
  },
  {
    inputs: [],
    name: "V2TooMuchRequested",
    type: "error"
  },
  {
    inputs: [],
    name: "V3InvalidAmountOut",
    type: "error"
  },
  {
    inputs: [],
    name: "V3InvalidCaller",
    type: "error"
  },
  {
    inputs: [],
    name: "V3InvalidSwap",
    type: "error"
  },
  {
    inputs: [],
    name: "V3TooLittleReceived",
    type: "error"
  },
  {
    inputs: [],
    name: "V3TooMuchRequested",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RewardsSent",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "looksRareClaim",
        type: "bytes"
      }
    ],
    name: "collectRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "commands",
        type: "bytes"
      },
      {
        internalType: "bytes[]",
        name: "inputs",
        type: "bytes[]"
      }
    ],
    name: "execute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "commands",
        type: "bytes"
      },
      {
        internalType: "bytes[]",
        name: "inputs",
        type: "bytes[]"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "execute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  }
];
var UniswapV3RouterUniversal__factory = class {
  static abi = _abi25;
  static createInterface() {
    return new Interface(_abi25);
  }
  static connect(address, runner) {
    return new Contract(
      address,
      _abi25,
      runner
    );
  }
};

// src/typechain/factories/WETH__factory.ts
var _abi26 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "guy",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Withdrawal",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "guy",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var WETH__factory = class {
  static abi = _abi26;
  static createInterface() {
    return new Interface(_abi26);
  }
  static connect(address, runner) {
    return new Contract(address, _abi26, runner);
  }
};

// src/types/contract.ts
var contract_exports = {};

// src/payment_methods.ts
var PaymentMethodType = /* @__PURE__ */ ((PaymentMethodType2) => {
  PaymentMethodType2[PaymentMethodType2["Bank"] = 1] = "Bank";
  PaymentMethodType2[PaymentMethodType2["Wallet"] = 2] = "Wallet";
  PaymentMethodType2[PaymentMethodType2["GiftCard"] = 3] = "GiftCard";
  return PaymentMethodType2;
})(PaymentMethodType || {});
var PaymentMethods = [
  {
    id: 1,
    name: "Chase Bank",
    type: 1,
    regions: ["US"],
    shortName: "Chase",
    logoUrl: "https://files.joint.exchange/images/banks/chase.svg",
    currency: "USD"
  },
  { id: 2, name: "Bank of America", type: 1, regions: ["US"], shortName: "BofA", currency: "USD" },
  { id: 3, name: "Wells Fargo", type: 1, regions: ["US"], shortName: "Wells", currency: "USD" },
  { id: 4, name: "CitiBank (US)", type: 1, regions: ["US"], shortName: "Citi", currency: "USD" },
  { id: 5, name: "CitiBank (GB)", type: 1, regions: ["GB"], shortName: "Citi", currency: "GBP" },
  { id: 6, name: "CitiBank (AU)", type: 1, regions: ["AU"], shortName: "Citi", currency: "AUD" },
  { id: 7, name: "CitiBank (IN)", type: 1, regions: ["IN"], shortName: "Citi", currency: "INR" },
  { id: 8, name: "CitiBank (SG)", type: 1, regions: ["SG"], shortName: "Citi", currency: "SGD" },
  { id: 9, name: "Capital One", type: 1, regions: ["US"], shortName: "CapOne", currency: "USD" },
  { id: 10, name: "HSBC (GB)", type: 1, regions: ["GB"], shortName: "HSBC", currency: "GBP" },
  { id: 11, name: "HSBC (US)", type: 1, regions: ["US"], shortName: "HSBC", currency: "USD" },
  { id: 12, name: "HSBC (HK)", type: 1, regions: ["HK"], shortName: "HSBC", currency: "HKD" },
  { id: 13, name: "HSBC (AU)", type: 1, regions: ["AU"], shortName: "HSBC", currency: "AUD" },
  { id: 14, name: "HSBC (IN)", type: 1, regions: ["IN"], shortName: "HSBC", currency: "INR" },
  { id: 15, name: "Barclays (GB)", type: 1, regions: ["GB"], shortName: "Barclays", currency: "GBP" },
  { id: 16, name: "Barclays (US)", type: 1, regions: ["US"], shortName: "Barclays", currency: "USD" },
  { id: 17, name: "Barclays (ZA)", type: 1, regions: ["ZA"], shortName: "Barclays", currency: "ZAR" },
  { id: 18, name: "Lloyds Bank", type: 1, regions: ["GB"], shortName: "Lloyds", currency: "GBP" },
  { id: 19, name: "Santander (ES)", type: 1, regions: ["ES"], shortName: "Santander", currency: "EUR" },
  { id: 20, name: "Santander (GB)", type: 1, regions: ["GB"], shortName: "Santander", currency: "GBP" },
  { id: 21, name: "Santander (US)", type: 1, regions: ["US"], shortName: "Santander", currency: "USD" },
  { id: 22, name: "Santander (MX)", type: 1, regions: ["MX"], shortName: "Santander", currency: "MXN" },
  { id: 23, name: "NatWest", type: 1, regions: ["GB"], shortName: "NatWest", currency: "GBP" },
  { id: 24, name: "Deutsche Bank (DE)", type: 1, regions: ["DE"], shortName: "Deutsche", currency: "EUR" },
  { id: 25, name: "Deutsche Bank (US)", type: 1, regions: ["US"], shortName: "Deutsche", currency: "USD" },
  { id: 26, name: "Deutsche Bank (GB)", type: 1, regions: ["GB"], shortName: "Deutsche", currency: "GBP" },
  { id: 27, name: "Deutsche Bank (IN)", type: 1, regions: ["IN"], shortName: "Deutsche", currency: "INR" },
  { id: 28, name: "Deutsche Bank (CN)", type: 1, regions: ["CN"], shortName: "Deutsche", currency: "CNY" },
  { id: 29, name: "BNP Paribas (FR)", type: 1, regions: ["FR"], shortName: "BNP Paribas", currency: "EUR" },
  { id: 30, name: "BNP Paribas (US)", type: 1, regions: ["US"], shortName: "BNP Paribas", currency: "USD" },
  { id: 31, name: "BNP Paribas (BE)", type: 1, regions: ["BE"], shortName: "BNP Paribas", currency: "EUR" },
  { id: 32, name: "BNP Paribas (IT)", type: 1, regions: ["IT"], shortName: "BNP Paribas", currency: "EUR" },
  { id: 33, name: "BNP Paribas (NG)", type: 1, regions: ["NG"], shortName: "BNP Paribas", currency: "NGN" },
  { id: 34, name: "Soci\xE9t\xE9 G\xE9n\xE9rale (FR)", type: 1, regions: ["FR"], shortName: "SocGen", currency: "EUR" },
  { id: 35, name: "Soci\xE9t\xE9 G\xE9n\xE9rale (US)", type: 1, regions: ["US"], shortName: "SocGen", currency: "USD" },
  { id: 36, name: "Soci\xE9t\xE9 G\xE9n\xE9rale (BE)", type: 1, regions: ["BE"], shortName: "SocGen", currency: "EUR" },
  { id: 37, name: "Soci\xE9t\xE9 G\xE9n\xE9rale (DZ)", type: 1, regions: ["DZ"], shortName: "SocGen", currency: "DZD" },
  { id: 38, name: "Cr\xE9dit Agricole (FR)", type: 1, regions: ["FR"], shortName: "CA", currency: "EUR" },
  { id: 39, name: "Cr\xE9dit Agricole (IT)", type: 1, regions: ["IT"], shortName: "CA", currency: "EUR" },
  { id: 40, name: "Cr\xE9dit Agricole (US)", type: 1, regions: ["US"], shortName: "CA", currency: "USD" },
  { id: 41, name: "Cr\xE9dit Agricole (DZ)", type: 1, regions: ["DZ"], shortName: "CA", currency: "DZD" },
  { id: 42, name: "ING Bank (NL)", type: 1, regions: ["NL"], shortName: "ING", currency: "EUR" },
  { id: 43, name: "ING Bank (BE)", type: 1, regions: ["BE"], shortName: "ING", currency: "EUR" },
  { id: 44, name: "ING Bank (US)", type: 1, regions: ["US"], shortName: "ING", currency: "USD" },
  { id: 45, name: "ING Bank (PL)", type: 1, regions: ["PL"], shortName: "ING", currency: "PLN" },
  { id: 46, name: "ING Bank (HU)", type: 1, regions: ["HU"], shortName: "ING", currency: "HUF" },
  { id: 47, name: "Rabobank", type: 1, regions: ["NL"], shortName: "Rabobank", currency: "EUR" },
  { id: 48, name: "ABN AMRO", type: 1, regions: ["NL"], shortName: "ABN AMRO", currency: "EUR" },
  { id: 49, name: "Standard Chartered (GB)", type: 1, regions: ["GB"], shortName: "SC", currency: "GBP" },
  { id: 50, name: "Standard Chartered (SG)", type: 1, regions: ["SG"], shortName: "SC", currency: "SGD" },
  { id: 51, name: "Standard Chartered (HK)", type: 1, regions: ["HK"], shortName: "SC", currency: "HKD" },
  { id: 52, name: "Standard Chartered (IN)", type: 1, regions: ["IN"], shortName: "SC", currency: "INR" },
  { id: 53, name: "Standard Chartered (ZA)", type: 1, regions: ["ZA"], shortName: "SC", currency: "ZAR" },
  { id: 54, name: "UBS (CH)", type: 1, regions: ["CH"], shortName: "UBS", currency: "CHF" },
  { id: 55, name: "UBS (US)", type: 1, regions: ["US"], shortName: "UBS", currency: "USD" },
  { id: 56, name: "UBS (GB)", type: 1, regions: ["GB"], shortName: "UBS", currency: "GBP" },
  { id: 57, name: "UBS (DE)", type: 1, regions: ["DE"], shortName: "UBS", currency: "EUR" },
  { id: 58, name: "Credit Suisse (CH)", type: 1, regions: ["CH"], shortName: "CS", currency: "CHF" },
  { id: 59, name: "Credit Suisse (US)", type: 1, regions: ["US"], shortName: "CS", currency: "USD" },
  { id: 60, name: "Credit Suisse (GB)", type: 1, regions: ["GB"], shortName: "CS", currency: "GBP" },
  { id: 61, name: "Credit Suisse (DE)", type: 1, regions: ["DE"], shortName: "CS", currency: "EUR" },
  { id: 62, name: "Royal Bank of Canada", type: 1, regions: ["CA"], shortName: "RBC", currency: "CAD" },
  { id: 63, name: "TD Bank (CA)", type: 1, regions: ["CA"], shortName: "TD", currency: "CAD" },
  { id: 64, name: "TD Bank (US)", type: 1, regions: ["US"], shortName: "TD", currency: "USD" },
  { id: 65, name: "Scotiabank (CA)", type: 1, regions: ["CA"], shortName: "Scotiabank", currency: "CAD" },
  { id: 66, name: "Scotiabank (US)", type: 1, regions: ["US"], shortName: "Scotiabank", currency: "USD" },
  { id: 67, name: "Scotiabank (MX)", type: 1, regions: ["MX"], shortName: "Scotiabank", currency: "MXN" },
  { id: 68, name: "Scotiabank (CL)", type: 1, regions: ["CL"], shortName: "Scotiabank", currency: "CLP" },
  { id: 69, name: "BMO Bank of Montreal", type: 1, regions: ["CA"], shortName: "BMO", currency: "CAD" },
  { id: 70, name: "Westpac", type: 1, regions: ["AU"], shortName: "Westpac", currency: "AUD" },
  { id: 71, name: "Commonwealth Bank", type: 1, regions: ["AU"], shortName: "CBA", currency: "AUD" },
  { id: 72, name: "ANZ Bank (AU)", type: 1, regions: ["AU"], shortName: "ANZ", currency: "AUD" },
  { id: 73, name: "ANZ Bank (NZ)", type: 1, regions: ["NZ"], shortName: "ANZ", currency: "NZD" },
  { id: 74, name: "National Australia Bank", type: 1, regions: ["AU"], shortName: "NAB", currency: "AUD" },
  { id: 75, name: "ICICI Bank", type: 1, regions: ["IN"], shortName: "ICICI", currency: "INR" },
  { id: 76, name: "HDFC Bank", type: 1, regions: ["IN"], shortName: "HDFC", currency: "INR" },
  { id: 77, name: "Axis Bank", type: 1, regions: ["IN"], shortName: "Axis", currency: "INR" },
  { id: 78, name: "State Bank of India", type: 1, regions: ["IN"], shortName: "SBI", currency: "INR" },
  { id: 79, name: "Bank of China (CN)", type: 1, regions: ["CN"], shortName: "BOC", currency: "CNY" },
  { id: 80, name: "Bank of China (HK)", type: 1, regions: ["HK"], shortName: "BOC", currency: "HKD" },
  { id: 81, name: "Bank of China (US)", type: 1, regions: ["US"], shortName: "BOC", currency: "USD" },
  { id: 82, name: "China Construction Bank (CN)", type: 1, regions: ["CN"], shortName: "CCB", currency: "CNY" },
  { id: 83, name: "China Construction Bank (HK)", type: 1, regions: ["HK"], shortName: "CCB", currency: "HKD" },
  {
    id: 84,
    name: "Industrial and Commercial Bank of China (CN)",
    type: 1,
    regions: ["CN"],
    shortName: "ICBC",
    currency: "CNY"
  },
  {
    id: 85,
    name: "Industrial and Commercial Bank of China (HK)",
    type: 1,
    regions: ["HK"],
    shortName: "ICBC",
    currency: "HKD"
  },
  { id: 86, name: "Agricultural Bank of China (CN)", type: 1, regions: ["CN"], shortName: "ABC", currency: "CNY" },
  { id: 87, name: "Agricultural Bank of China (HK)", type: 1, regions: ["HK"], shortName: "ABC", currency: "HKD" },
  { id: 88, name: "Sumitomo Mitsui Banking Corporation", type: 1, regions: ["JP"], shortName: "SMBC", currency: "JPY" },
  { id: 89, name: "Mizuho Bank", type: 1, regions: ["JP"], shortName: "Mizuho", currency: "JPY" },
  { id: 90, name: "Mitsubishi UFJ Financial Group", type: 1, regions: ["JP"], shortName: "MUFG", currency: "JPY" },
  { id: 91, name: "Shinsei Bank", type: 1, regions: ["JP"], shortName: "Shinsei", currency: "JPY" },
  { id: 92, name: "Korea Development Bank", type: 1, regions: ["KR"], shortName: "KDB", currency: "KRW" },
  { id: 93, name: "Kookmin Bank", type: 1, regions: ["KR"], shortName: "Kookmin", currency: "KRW" },
  { id: 94, name: "Hana Bank", type: 1, regions: ["KR"], shortName: "Hana", currency: "KRW" },
  { id: 95, name: "Shinhan Bank", type: 1, regions: ["KR"], shortName: "Shinhan", currency: "KRW" },
  { id: 96, name: "Maybank", type: 1, regions: ["MY"], shortName: "Maybank", currency: "MYR" },
  { id: 97, name: "CIMB Bank", type: 1, regions: ["MY"], shortName: "CIMB", currency: "MYR" },
  { id: 98, name: "DBS Bank", type: 1, regions: ["SG"], shortName: "DBS", currency: "SGD" },
  { id: 99, name: "OCBC Bank", type: 1, regions: ["SG"], shortName: "OCBC", currency: "SGD" },
  { id: 100, name: "United Overseas Bank", type: 1, regions: ["SG"], shortName: "UOB", currency: "SGD" },
  { id: 101, name: "Bangkok Bank", type: 1, regions: ["TH"], shortName: "Bangkok", currency: "THB" },
  { id: 102, name: "Siam Commercial Bank", type: 1, regions: ["TH"], shortName: "SCB", currency: "THB" },
  { id: 103, name: "Bank of the Philippine Islands", type: 1, regions: ["PH"], shortName: "BPI", currency: "PHP" },
  { id: 104, name: "Philippine National Bank", type: 1, regions: ["PH"], shortName: "PNB", currency: "PHP" },
  { id: 105, name: "Standard Bank", type: 1, regions: ["ZA"], shortName: "Standard", currency: "ZAR" },
  { id: 106, name: "Absa Bank", type: 1, regions: ["ZA"], shortName: "Absa", currency: "ZAR" },
  { id: 107, name: "First National Bank", type: 1, regions: ["ZA"], shortName: "FNB", currency: "ZAR" },
  { id: 108, name: "Nedbank", type: 1, regions: ["ZA"], shortName: "Nedbank", currency: "ZAR" },
  {
    id: 109,
    name: "Ecobank (NG)",
    type: 1,
    regions: ["NG"],
    shortName: "Ecobank",
    logoUrl: "https://files.joint.exchange/images/banks/ecobank.svg",
    currency: "NGN"
  },
  {
    id: 110,
    name: "Ecobank (GH)",
    type: 1,
    regions: ["GH"],
    shortName: "Ecobank",
    logoUrl: "https://files.joint.exchange/images/banks/ecobank.svg",
    currency: "GHS"
  },
  {
    id: 111,
    name: "Ecobank (CI)",
    type: 1,
    regions: ["CI"],
    shortName: "Ecobank",
    logoUrl: "https://files.joint.exchange/images/banks/ecobank.svg",
    currency: "XOF"
  },
  {
    id: 112,
    name: "Ecobank (TZ)",
    type: 1,
    regions: ["TZ"],
    shortName: "Ecobank",
    logoUrl: "https://files.joint.exchange/images/banks/ecobank.svg",
    currency: "TZS"
  },
  {
    id: 113,
    name: "Ecobank (UG)",
    type: 1,
    regions: ["UG"],
    shortName: "Ecobank",
    logoUrl: "https://files.joint.exchange/images/banks/ecobank.svg",
    currency: "UGX"
  },
  { id: 114, name: "United Bank for Africa (NG)", type: 1, regions: ["NG"], shortName: "UBA", currency: "NGN" },
  { id: 115, name: "United Bank for Africa (GH)", type: 1, regions: ["GH"], shortName: "UBA", currency: "GHS" },
  { id: 116, name: "United Bank for Africa (UG)", type: 1, regions: ["UG"], shortName: "UBA", currency: "UGX" },
  { id: 117, name: "United Bank for Africa (KE)", type: 1, regions: ["KE"], shortName: "UBA", currency: "KES" },
  { id: 118, name: "United Bank for Africa (ZA)", type: 1, regions: ["ZA"], shortName: "UBA", currency: "ZAR" },
  { id: 119, name: "Zenith Bank", type: 1, regions: ["NG"], shortName: "Zenith", currency: "NGN" },
  {
    id: 120,
    name: "Guaranty Trust Bank",
    type: 1,
    regions: ["NG"],
    shortName: "GTB",
    logoUrl: "https://files.joint.exchange/images/banks/gtb.svg",
    currency: "NGN"
  },
  {
    id: 121,
    name: "Access Bank",
    type: 1,
    regions: ["NG"],
    shortName: "Access",
    logoUrl: "https://files.joint.exchange/images/banks/access.svg",
    currency: "NGN"
  },
  { id: 122, name: "Equity Bank", type: 1, regions: ["KE"], shortName: "Equity", currency: "KES" },
  { id: 123, name: "KCB Bank", type: 1, regions: ["KE"], shortName: "KCB", currency: "KES" },
  { id: 124, name: "National Bank of Egypt", type: 1, regions: ["EG"], shortName: "NBE", currency: "EGP" },
  { id: 125, name: "Commercial International Bank", type: 1, regions: ["EG"], shortName: "CIB", currency: "EGP" },
  { id: 126, name: "Attijariwafa Bank", type: 1, regions: ["MA"], shortName: "Attijariwafa", currency: "MAD" },
  { id: 127, name: "Banque Populaire", type: 1, regions: ["MA"], shortName: "BP", currency: "MAD" },
  { id: 128, name: "BMCE Bank", type: 1, regions: ["MA"], shortName: "BMCE", currency: "MAD" },
  { id: 129, name: "Banque Misr", type: 1, regions: ["EG"], shortName: "Banque Misr", currency: "EGP" },
  { id: 130, name: "PayPal (US)", type: 2, regions: ["US"], shortName: "PayPal", currency: "USD" },
  { id: 131, name: "PayPal (GB)", type: 2, regions: ["GB"], shortName: "PayPal", currency: "GBP" },
  { id: 132, name: "PayPal (AU)", type: 2, regions: ["AU"], shortName: "PayPal", currency: "AUD" },
  { id: 133, name: "PayPal (IN)", type: 2, regions: ["IN"], shortName: "PayPal", currency: "INR" },
  { id: 134, name: "PayPal (ZA)", type: 2, regions: ["ZA"], shortName: "PayPal", currency: "ZAR" },
  { id: 135, name: "PayPal (NG)", type: 2, regions: ["NG"], shortName: "PayPal", currency: "NGN" },
  { id: 136, name: "PayPal (KE)", type: 2, regions: ["KE"], shortName: "PayPal", currency: "KES" },
  { id: 137, name: "PayPal (EG)", type: 2, regions: ["EG"], shortName: "PayPal", currency: "EGP" },
  { id: 138, name: "Venmo", type: 2, regions: ["US"], shortName: "Venmo", currency: "USD" },
  { id: 139, name: "Zelle", type: 2, regions: ["US"], shortName: "Zelle", currency: "USD" },
  { id: 140, name: "Cash App", type: 2, regions: ["US"], shortName: "Cash App", currency: "USD" },
  { id: 141, name: "Apple Pay (US)", type: 2, regions: ["US"], shortName: "Apple Pay", currency: "USD" },
  { id: 142, name: "Apple Pay (GB)", type: 2, regions: ["GB"], shortName: "Apple Pay", currency: "GBP" },
  { id: 143, name: "Apple Pay (AU)", type: 2, regions: ["AU"], shortName: "Apple Pay", currency: "AUD" },
  { id: 144, name: "Apple Pay (IN)", type: 2, regions: ["IN"], shortName: "Apple Pay", currency: "INR" },
  { id: 145, name: "Apple Pay (JP)", type: 2, regions: ["JP"], shortName: "Apple Pay", currency: "JPY" },
  { id: 146, name: "Apple Pay (SG)", type: 2, regions: ["SG"], shortName: "Apple Pay", currency: "SGD" },
  { id: 147, name: "Google Pay (US)", type: 2, regions: ["US"], shortName: "Google Pay", currency: "USD" },
  { id: 148, name: "Google Pay (GB)", type: 2, regions: ["GB"], shortName: "Google Pay", currency: "GBP" },
  { id: 149, name: "Google Pay (AU)", type: 2, regions: ["AU"], shortName: "Google Pay", currency: "AUD" },
  { id: 150, name: "Google Pay (IN)", type: 2, regions: ["IN"], shortName: "Google Pay", currency: "INR" },
  { id: 151, name: "Google Pay (JP)", type: 2, regions: ["JP"], shortName: "Google Pay", currency: "JPY" },
  { id: 152, name: "Google Pay (SG)", type: 2, regions: ["SG"], shortName: "Google Pay", currency: "SGD" },
  { id: 153, name: "Google Pay (ZA)", type: 2, regions: ["ZA"], shortName: "Google Pay", currency: "ZAR" },
  { id: 154, name: "Google Pay (NG)", type: 2, regions: ["NG"], shortName: "Google Pay", currency: "NGN" },
  { id: 155, name: "Samsung Pay (US)", type: 2, regions: ["US"], shortName: "Samsung Pay", currency: "USD" },
  { id: 156, name: "Samsung Pay (GB)", type: 2, regions: ["GB"], shortName: "Samsung Pay", currency: "GBP" },
  { id: 157, name: "Samsung Pay (AU)", type: 2, regions: ["AU"], shortName: "Samsung Pay", currency: "AUD" },
  { id: 158, name: "Samsung Pay (KR)", type: 2, regions: ["KR"], shortName: "Samsung Pay", currency: "KRW" },
  { id: 159, name: "Samsung Pay (IN)", type: 2, regions: ["IN"], shortName: "Samsung Pay", currency: "INR" },
  { id: 160, name: "Samsung Pay (SG)", type: 2, regions: ["SG"], shortName: "Samsung Pay", currency: "SGD" },
  { id: 161, name: "WeChat Pay (CN)", type: 2, regions: ["CN"], shortName: "WeChat Pay", currency: "CNY" },
  { id: 162, name: "WeChat Pay (HK)", type: 2, regions: ["HK"], shortName: "WeChat Pay", currency: "HKD" },
  { id: 163, name: "WeChat Pay (SG)", type: 2, regions: ["SG"], shortName: "WeChat Pay", currency: "SGD" },
  { id: 164, name: "WeChat Pay (MY)", type: 2, regions: ["MY"], shortName: "WeChat Pay", currency: "MYR" },
  {
    id: 165,
    name: "Alipay (CN)",
    type: 2,
    regions: ["CN"],
    shortName: "Alipay",
    logoUrl: "https://files.joint.exchange/images/banks/alipay.svg",
    currency: "CNY"
  },
  {
    id: 166,
    name: "Alipay (HK)",
    type: 2,
    regions: ["HK"],
    shortName: "Alipay",
    logoUrl: "https://files.joint.exchange/images/banks/alipay.svg",
    currency: "HKD"
  },
  {
    id: 167,
    name: "Alipay (SG)",
    type: 2,
    regions: ["SG"],
    shortName: "Alipay",
    logoUrl: "https://files.joint.exchange/images/banks/alipay.svg",
    currency: "SGD"
  },
  {
    id: 168,
    name: "Alipay (MY)",
    type: 2,
    regions: ["MY"],
    shortName: "Alipay",
    logoUrl: "https://files.joint.exchange/images/banks/alipay.svg",
    currency: "MYR"
  },
  { id: 169, name: "M-Pesa (KE)", type: 2, regions: ["KE"], shortName: "M-Pesa", currency: "KES" },
  { id: 170, name: "M-Pesa (TZ)", type: 2, regions: ["TZ"], shortName: "M-Pesa", currency: "TZS" },
  { id: 171, name: "M-Pesa (UG)", type: 2, regions: ["UG"], shortName: "M-Pesa", currency: "UGX" },
  { id: 172, name: "M-Pesa (ZP)", type: 2, regions: ["ZP"], shortName: "M-Pesa", currency: "ZMW" },
  { id: 173, name: "M-Pesa (RO)", type: 2, regions: ["RO"], shortName: "M-Pesa", currency: "RON" },
  { id: 174, name: "Paytm", type: 2, regions: ["IN"], shortName: "Paytm", currency: "INR" },
  { id: 175, name: "PhonePe", type: 2, regions: ["IN"], shortName: "PhonePe", currency: "INR" },
  { id: 176, name: "BharatPe", type: 2, regions: ["IN"], shortName: "BharatPe", currency: "INR" },
  { id: 177, name: "GCash", type: 2, regions: ["PH"], shortName: "GCash", currency: "PHP" },
  { id: 178, name: "Paymaya", type: 2, regions: ["PH"], shortName: "Paymaya", currency: "PHP" },
  { id: 179, name: "Tigo Money (TZ)", type: 2, regions: ["TZ"], shortName: "Tigo Money", currency: "TZS" },
  { id: 180, name: "Tigo Money (GH)", type: 2, regions: ["GH"], shortName: "Tigo Money", currency: "GHS" },
  { id: 181, name: "Paga", type: 2, regions: ["NG"], shortName: "Paga", currency: "NGN" },
  { id: 182, name: "Chipper Cash (NG)", type: 2, regions: ["NG"], shortName: "Chipper Cash", currency: "NGN" },
  { id: 183, name: "Chipper Cash (GH)", type: 2, regions: ["GH"], shortName: "Chipper Cash", currency: "GHS" },
  { id: 184, name: "Chipper Cash (KE)", type: 2, regions: ["KE"], shortName: "Chipper Cash", currency: "KES" },
  { id: 185, name: "Chipper Cash (UG)", type: 2, regions: ["UG"], shortName: "Chipper Cash", currency: "UGX" },
  { id: 186, name: "Chipper Cash (TZ)", type: 2, regions: ["TZ"], shortName: "Chipper Cash", currency: "TZS" },
  { id: 187, name: "Orange Money (FR)", type: 2, regions: ["FR"], shortName: "Orange Money", currency: "EUR" },
  { id: 188, name: "Orange Money (SN)", type: 2, regions: ["SN"], shortName: "Orange Money", currency: "XOF" },
  { id: 189, name: "Orange Money (CI)", type: 2, regions: ["CI"], shortName: "Orange Money", currency: "XOF" },
  { id: 190, name: "Orange Money (MA)", type: 2, regions: ["MA"], shortName: "Orange Money", currency: "MAD" },
  { id: 191, name: "Orange Money (CM)", type: 2, regions: ["CM"], shortName: "Orange Money", currency: "XAF" },
  { id: 192, name: "Airtel Money", type: 2, regions: ["KE"], shortName: "Airtel Money", currency: "KES" },
  { id: 193, name: "Wave Mobile Money (SN)", type: 2, regions: ["SN"], shortName: "Wave", currency: "XOF" },
  { id: 194, name: "Wave Mobile Money (CI)", type: 2, regions: ["CI"], shortName: "Wave", currency: "XOF" },
  { id: 195, name: "Wave Mobile Money (MA)", type: 2, regions: ["MA"], shortName: "Wave", currency: "MAD" },
  { id: 196, name: "MTN Mobile Money (GH)", type: 2, regions: ["GH"], shortName: "MTN", currency: "GHS" },
  { id: 197, name: "MTN Mobile Money (UG)", type: 2, regions: ["UG"], shortName: "MTN", currency: "UGX" },
  { id: 198, name: "MTN Mobile Money (CM)", type: 2, regions: ["CM"], shortName: "MTN", currency: "XAF" },
  { id: 199, name: "MTN Mobile Money (CI)", type: 2, regions: ["CI"], shortName: "MTN", currency: "XOF" }
];
function getPaymentMethod(name) {
  return PaymentMethods.find((method) => method.name === name);
}
function getShortName(name) {
  var _a;
  return (_a = PaymentMethods.find((method) => method.name === name)) == null ? void 0 : _a.shortName;
}
function getLogoUrl(name) {
  var _a;
  return (_a = PaymentMethods.find((method) => method.name === name)) == null ? void 0 : _a.logoUrl;
}
function getCurrency(name) {
  var _a;
  return (_a = PaymentMethods.find((method) => method.name === name)) == null ? void 0 : _a.currency;
}
function getRegions(name) {
  var _a;
  return (_a = PaymentMethods.find((method) => method.name === name)) == null ? void 0 : _a.regions;
}

// src/index.ts
var src_default = chains_default;
export {
  Abi,
  typechain_exports as AbiTypes,
  BadgeManifests,
  contract_exports as ContractParamTypes,
  MediatorPools,
  PaymentMethodType,
  PaymentMethods,
  TokenLists,
  addTokenToLocalhost,
  contractsParams,
  src_default as default,
  findTokenInLocalhost,
  findTokenInSynthetic,
  getChain,
  getChainByName,
  getChainID,
  getChainNames,
  getChains,
  getChainsID,
  getContractsParams,
  getCurrency,
  getLogoUrl,
  getPaymentMethod,
  getRegions,
  getShortName,
  getTokenInfo,
  isValidChain,
  parseBadgeLocals
};
/*! Bundled license information:

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)
*/
//# sourceMappingURL=index.js.map